// (function() {

// })();




(function() {

      var Tc = { exports: {} },
        Un = {};
      /**
       * @license React
       * react-jsx-runtime.production.js
       *
       * Copyright (c) Meta Platforms, Inc. and affiliates.
       *
       * This source code is licensed under the MIT license found in the
       * LICENSE file in the root directory of this source tree.
       */ var Hd;
      function $m() {
        if (Hd) return Un;
        Hd = 1;
        var r = Symbol.for('react.transitional.element'),
          u = Symbol.for('react.fragment');
        function c(s, o, h) {
          var m = null;
          if (
            (h !== void 0 && (m = '' + h),
            o.key !== void 0 && (m = '' + o.key),
            'key' in o)
          ) {
            h = {};
            for (var p in o) p !== 'key' && (h[p] = o[p]);
          } else h = o;
          return (
            (o = h.ref),
            {
              $$typeof: r,
              type: s,
              key: m,
              ref: o !== void 0 ? o : null,
              props: h,
            }
          );
        }
        return ((Un.Fragment = u), (Un.jsx = c), (Un.jsxs = c), Un);
      }
      var Bd;
      function Jm() {
        return (Bd || ((Bd = 1), (Tc.exports = $m())), Tc.exports);
      }
      var C = Jm(),
        Ec = { exports: {} },
        jn = {},
        Oc = { exports: {} },
        Mc = {};
      /**
       * @license React
       * scheduler.production.js
       *
       * Copyright (c) Meta Platforms, Inc. and affiliates.
       *
       * This source code is licensed under the MIT license found in the
       * LICENSE file in the root directory of this source tree.
       */ var qd;
      function km() {
        return (
          qd ||
            ((qd = 1),
            (function (r) {
              function u(_, j) {
                var V = _.length;
                _.push(j);
                t: for (; 0 < V; ) {
                  var ft = (V - 1) >>> 1,
                    v = _[ft];
                  if (0 < o(v, j)) ((_[ft] = j), (_[V] = v), (V = ft));
                  else break t;
                }
              }
              function c(_) {
                return _.length === 0 ? null : _[0];
              }
              function s(_) {
                if (_.length === 0) return null;
                var j = _[0],
                  V = _.pop();
                if (V !== j) {
                  _[0] = V;
                  t: for (var ft = 0, v = _.length, D = v >>> 1; ft < D; ) {
                    var B = 2 * (ft + 1) - 1,
                      H = _[B],
                      X = B + 1,
                      ot = _[X];
                    if (0 > o(H, V))
                      X < v && 0 > o(ot, H)
                        ? ((_[ft] = ot), (_[X] = V), (ft = X))
                        : ((_[ft] = H), (_[B] = V), (ft = B));
                    else if (X < v && 0 > o(ot, V))
                      ((_[ft] = ot), (_[X] = V), (ft = X));
                    else break t;
                  }
                }
                return j;
              }
              function o(_, j) {
                var V = _.sortIndex - j.sortIndex;
                return V !== 0 ? V : _.id - j.id;
              }
              if (
                ((r.unstable_now = void 0),
                typeof performance == 'object' &&
                  typeof performance.now == 'function')
              ) {
                var h = performance;
                r.unstable_now = function () {
                  return h.now();
                };
              } else {
                var m = Date,
                  p = m.now();
                r.unstable_now = function () {
                  return m.now() - p;
                };
              }
              var b = [],
                g = [],
                A = 1,
                N = null,
                L = 3,
                K = !1,
                q = !1,
                Q = !1,
                P = !1,
                ht = typeof setTimeout == 'function' ? setTimeout : null,
                tt = typeof clearTimeout == 'function' ? clearTimeout : null,
                W = typeof setImmediate < 'u' ? setImmediate : null;
              function I(_) {
                for (var j = c(g); j !== null; ) {
                  if (j.callback === null) s(g);
                  else if (j.startTime <= _)
                    (s(g), (j.sortIndex = j.expirationTime), u(b, j));
                  else break;
                  j = c(g);
                }
              }
              function w(_) {
                if (((Q = !1), I(_), !q))
                  if (c(b) !== null) ((q = !0), st || ((st = !0), Rt()));
                  else {
                    var j = c(g);
                    j !== null && Dt(w, j.startTime - _);
                  }
              }
              var st = !1,
                ut = -1,
                Mt = 5,
                Et = -1;
              function Lt() {
                return P ? !0 : !(r.unstable_now() - Et < Mt);
              }
              function te() {
                if (((P = !1), st)) {
                  var _ = r.unstable_now();
                  Et = _;
                  var j = !0;
                  try {
                    t: {
                      ((q = !1), Q && ((Q = !1), tt(ut), (ut = -1)), (K = !0));
                      var V = L;
                      try {
                        e: {
                          for (
                            I(_), N = c(b);
                            N !== null && !(N.expirationTime > _ && Lt());
                          ) {
                            var ft = N.callback;
                            if (typeof ft == 'function') {
                              ((N.callback = null), (L = N.priorityLevel));
                              var v = ft(N.expirationTime <= _);
                              if (
                                ((_ = r.unstable_now()), typeof v == 'function')
                              ) {
                                ((N.callback = v), I(_), (j = !0));
                                break e;
                              }
                              (N === c(b) && s(b), I(_));
                            } else s(b);
                            N = c(b);
                          }
                          if (N !== null) j = !0;
                          else {
                            var D = c(g);
                            (D !== null && Dt(w, D.startTime - _), (j = !1));
                          }
                        }
                        break t;
                      } finally {
                        ((N = null), (L = V), (K = !1));
                      }
                      j = void 0;
                    }
                  } finally {
                    j ? Rt() : (st = !1);
                  }
                }
              }
              var Rt;
              if (typeof W == 'function')
                Rt = function () {
                  W(te);
                };
              else if (typeof MessageChannel < 'u') {
                var zt = new MessageChannel(),
                  Ht = zt.port2;
                ((zt.port1.onmessage = te),
                  (Rt = function () {
                    Ht.postMessage(null);
                  }));
              } else
                Rt = function () {
                  ht(te, 0);
                };
              function Dt(_, j) {
                ut = ht(function () {
                  _(r.unstable_now());
                }, j);
              }
              ((r.unstable_IdlePriority = 5),
                (r.unstable_ImmediatePriority = 1),
                (r.unstable_LowPriority = 4),
                (r.unstable_NormalPriority = 3),
                (r.unstable_Profiling = null),
                (r.unstable_UserBlockingPriority = 2),
                (r.unstable_cancelCallback = function (_) {
                  _.callback = null;
                }),
                (r.unstable_forceFrameRate = function (_) {
                  0 > _ || 125 < _
                    ? console.error(
                        'forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported'
                      )
                    : (Mt = 0 < _ ? Math.floor(1e3 / _) : 5);
                }),
                (r.unstable_getCurrentPriorityLevel = function () {
                  return L;
                }),
                (r.unstable_next = function (_) {
                  switch (L) {
                    case 1:
                    case 2:
                    case 3:
                      var j = 3;
                      break;
                    default:
                      j = L;
                  }
                  var V = L;
                  L = j;
                  try {
                    return _();
                  } finally {
                    L = V;
                  }
                }),
                (r.unstable_requestPaint = function () {
                  P = !0;
                }),
                (r.unstable_runWithPriority = function (_, j) {
                  switch (_) {
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                    case 5:
                      break;
                    default:
                      _ = 3;
                  }
                  var V = L;
                  L = _;
                  try {
                    return j();
                  } finally {
                    L = V;
                  }
                }),
                (r.unstable_scheduleCallback = function (_, j, V) {
                  var ft = r.unstable_now();
                  switch (
                    (typeof V == 'object' && V !== null
                      ? ((V = V.delay),
                        (V = typeof V == 'number' && 0 < V ? ft + V : ft))
                      : (V = ft),
                    _)
                  ) {
                    case 1:
                      var v = -1;
                      break;
                    case 2:
                      v = 250;
                      break;
                    case 5:
                      v = 1073741823;
                      break;
                    case 4:
                      v = 1e4;
                      break;
                    default:
                      v = 5e3;
                  }
                  return (
                    (v = V + v),
                    (_ = {
                      id: A++,
                      callback: j,
                      priorityLevel: _,
                      startTime: V,
                      expirationTime: v,
                      sortIndex: -1,
                    }),
                    V > ft
                      ? ((_.sortIndex = V),
                        u(g, _),
                        c(b) === null &&
                          _ === c(g) &&
                          (Q ? (tt(ut), (ut = -1)) : (Q = !0), Dt(w, V - ft)))
                      : ((_.sortIndex = v),
                        u(b, _),
                        q || K || ((q = !0), st || ((st = !0), Rt()))),
                    _
                  );
                }),
                (r.unstable_shouldYield = Lt),
                (r.unstable_wrapCallback = function (_) {
                  var j = L;
                  return function () {
                    var V = L;
                    L = j;
                    try {
                      return _.apply(this, arguments);
                    } finally {
                      L = V;
                    }
                  };
                }));
            })(Mc)),
          Mc
        );
      }
      var Kd;
      function Wm() {
        return (Kd || ((Kd = 1), (Oc.exports = km())), Oc.exports);
      }
      var _c = { exports: {} },
        et = {};
      /**
       * @license React
       * react.production.js
       *
       * Copyright (c) Meta Platforms, Inc. and affiliates.
       *
       * This source code is licensed under the MIT license found in the
       * LICENSE file in the root directory of this source tree.
       */ var Yd;
      function Fm() {
        if (Yd) return et;
        Yd = 1;
        var r = Symbol.for('react.transitional.element'),
          u = Symbol.for('react.portal'),
          c = Symbol.for('react.fragment'),
          s = Symbol.for('react.strict_mode'),
          o = Symbol.for('react.profiler'),
          h = Symbol.for('react.consumer'),
          m = Symbol.for('react.context'),
          p = Symbol.for('react.forward_ref'),
          b = Symbol.for('react.suspense'),
          g = Symbol.for('react.memo'),
          A = Symbol.for('react.lazy'),
          N = Symbol.iterator;
        function L(v) {
          return v === null || typeof v != 'object'
            ? null
            : ((v = (N && v[N]) || v['@@iterator']),
              typeof v == 'function' ? v : null);
        }
        var K = {
            isMounted: function () {
              return !1;
            },
            enqueueForceUpdate: function () {},
            enqueueReplaceState: function () {},
            enqueueSetState: function () {},
          },
          q = Object.assign,
          Q = {};
        function P(v, D, B) {
          ((this.props = v),
            (this.context = D),
            (this.refs = Q),
            (this.updater = B || K));
        }
        ((P.prototype.isReactComponent = {}),
          (P.prototype.setState = function (v, D) {
            if (typeof v != 'object' && typeof v != 'function' && v != null)
              throw Error(
                'takes an object of state variables to update or a function which returns an object of state variables.'
              );
            this.updater.enqueueSetState(this, v, D, 'setState');
          }),
          (P.prototype.forceUpdate = function (v) {
            this.updater.enqueueForceUpdate(this, v, 'forceUpdate');
          }));
        function ht() {}
        ht.prototype = P.prototype;
        function tt(v, D, B) {
          ((this.props = v),
            (this.context = D),
            (this.refs = Q),
            (this.updater = B || K));
        }
        var W = (tt.prototype = new ht());
        ((W.constructor = tt),
          q(W, P.prototype),
          (W.isPureReactComponent = !0));
        var I = Array.isArray,
          w = { H: null, A: null, T: null, S: null, V: null },
          st = Object.prototype.hasOwnProperty;
        function ut(v, D, B, H, X, ot) {
          return (
            (B = ot.ref),
            {
              $$typeof: r,
              type: v,
              key: D,
              ref: B !== void 0 ? B : null,
              props: ot,
            }
          );
        }
        function Mt(v, D) {
          return ut(v.type, D, void 0, void 0, void 0, v.props);
        }
        function Et(v) {
          return typeof v == 'object' && v !== null && v.$$typeof === r;
        }
        function Lt(v) {
          var D = { '=': '=0', ':': '=2' };
          return (
            '$' +
            v.replace(/[=:]/g, function (B) {
              return D[B];
            })
          );
        }
        var te = /\/+/g;
        function Rt(v, D) {
          return typeof v == 'object' && v !== null && v.key != null
            ? Lt('' + v.key)
            : D.toString(36);
        }
        function zt() {}
        function Ht(v) {
          switch (v.status) {
            case 'fulfilled':
              return v.value;
            case 'rejected':
              throw v.reason;
            default:
              switch (
                (typeof v.status == 'string'
                  ? v.then(zt, zt)
                  : ((v.status = 'pending'),
                    v.then(
                      function (D) {
                        v.status === 'pending' &&
                          ((v.status = 'fulfilled'), (v.value = D));
                      },
                      function (D) {
                        v.status === 'pending' &&
                          ((v.status = 'rejected'), (v.reason = D));
                      }
                    )),
                v.status)
              ) {
                case 'fulfilled':
                  return v.value;
                case 'rejected':
                  throw v.reason;
              }
          }
          throw v;
        }
        function Dt(v, D, B, H, X) {
          var ot = typeof v;
          (ot === 'undefined' || ot === 'boolean') && (v = null);
          var F = !1;
          if (v === null) F = !0;
          else
            switch (ot) {
              case 'bigint':
              case 'string':
              case 'number':
                F = !0;
                break;
              case 'object':
                switch (v.$$typeof) {
                  case r:
                  case u:
                    F = !0;
                    break;
                  case A:
                    return ((F = v._init), Dt(F(v._payload), D, B, H, X));
                }
            }
          if (F)
            return (
              (X = X(v)),
              (F = H === '' ? '.' + Rt(v, 0) : H),
              I(X)
                ? ((B = ''),
                  F != null && (B = F.replace(te, '$&/') + '/'),
                  Dt(X, D, B, '', function (ea) {
                    return ea;
                  }))
                : X != null &&
                  (Et(X) &&
                    (X = Mt(
                      X,
                      B +
                        (X.key == null || (v && v.key === X.key)
                          ? ''
                          : ('' + X.key).replace(te, '$&/') + '/') +
                        F
                    )),
                  D.push(X)),
              1
            );
          F = 0;
          var se = H === '' ? '.' : H + ':';
          if (I(v))
            for (var At = 0; At < v.length; At++)
              ((H = v[At]), (ot = se + Rt(H, At)), (F += Dt(H, D, B, ot, X)));
          else if (((At = L(v)), typeof At == 'function'))
            for (v = At.call(v), At = 0; !(H = v.next()).done; )
              ((H = H.value),
                (ot = se + Rt(H, At++)),
                (F += Dt(H, D, B, ot, X)));
          else if (ot === 'object') {
            if (typeof v.then == 'function') return Dt(Ht(v), D, B, H, X);
            throw (
              (D = String(v)),
              Error(
                'Objects are not valid as a React child (found: ' +
                  (D === '[object Object]'
                    ? 'object with keys {' + Object.keys(v).join(', ') + '}'
                    : D) +
                  '). If you meant to render a collection of children, use an array instead.'
              )
            );
          }
          return F;
        }
        function _(v, D, B) {
          if (v == null) return v;
          var H = [],
            X = 0;
          return (
            Dt(v, H, '', '', function (ot) {
              return D.call(B, ot, X++);
            }),
            H
          );
        }
        function j(v) {
          if (v._status === -1) {
            var D = v._result;
            ((D = D()),
              D.then(
                function (B) {
                  (v._status === 0 || v._status === -1) &&
                    ((v._status = 1), (v._result = B));
                },
                function (B) {
                  (v._status === 0 || v._status === -1) &&
                    ((v._status = 2), (v._result = B));
                }
              ),
              v._status === -1 && ((v._status = 0), (v._result = D)));
          }
          if (v._status === 1) return v._result.default;
          throw v._result;
        }
        var V =
          typeof reportError == 'function'
            ? reportError
            : function (v) {
                if (
                  typeof window == 'object' &&
                  typeof window.ErrorEvent == 'function'
                ) {
                  var D = new window.ErrorEvent('error', {
                    bubbles: !0,
                    cancelable: !0,
                    message:
                      typeof v == 'object' &&
                      v !== null &&
                      typeof v.message == 'string'
                        ? String(v.message)
                        : String(v),
                    error: v,
                  });
                  if (!window.dispatchEvent(D)) return;
                } else if (
                  typeof process == 'object' &&
                  typeof process.emit == 'function'
                ) {
                  process.emit('uncaughtException', v);
                  return;
                }
                console.error(v);
              };
        function ft() {}
        return (
          (et.Children = {
            map: _,
            forEach: function (v, D, B) {
              _(
                v,
                function () {
                  D.apply(this, arguments);
                },
                B
              );
            },
            count: function (v) {
              var D = 0;
              return (
                _(v, function () {
                  D++;
                }),
                D
              );
            },
            toArray: function (v) {
              return (
                _(v, function (D) {
                  return D;
                }) || []
              );
            },
            only: function (v) {
              if (!Et(v))
                throw Error(
                  'React.Children.only expected to receive a single React element child.'
                );
              return v;
            },
          }),
          (et.Component = P),
          (et.Fragment = c),
          (et.Profiler = o),
          (et.PureComponent = tt),
          (et.StrictMode = s),
          (et.Suspense = b),
          (et.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE =
            w),
          (et.__COMPILER_RUNTIME = {
            __proto__: null,
            c: function (v) {
              return w.H.useMemoCache(v);
            },
          }),
          (et.cache = function (v) {
            return function () {
              return v.apply(null, arguments);
            };
          }),
          (et.cloneElement = function (v, D, B) {
            if (v == null)
              throw Error(
                'The argument must be a React element, but you passed ' +
                  v +
                  '.'
              );
            var H = q({}, v.props),
              X = v.key,
              ot = void 0;
            if (D != null)
              for (F in (D.ref !== void 0 && (ot = void 0),
              D.key !== void 0 && (X = '' + D.key),
              D))
                !st.call(D, F) ||
                  F === 'key' ||
                  F === '__self' ||
                  F === '__source' ||
                  (F === 'ref' && D.ref === void 0) ||
                  (H[F] = D[F]);
            var F = arguments.length - 2;
            if (F === 1) H.children = B;
            else if (1 < F) {
              for (var se = Array(F), At = 0; At < F; At++)
                se[At] = arguments[At + 2];
              H.children = se;
            }
            return ut(v.type, X, void 0, void 0, ot, H);
          }),
          (et.createContext = function (v) {
            return (
              (v = {
                $$typeof: m,
                _currentValue: v,
                _currentValue2: v,
                _threadCount: 0,
                Provider: null,
                Consumer: null,
              }),
              (v.Provider = v),
              (v.Consumer = { $$typeof: h, _context: v }),
              v
            );
          }),
          (et.createElement = function (v, D, B) {
            var H,
              X = {},
              ot = null;
            if (D != null)
              for (H in (D.key !== void 0 && (ot = '' + D.key), D))
                st.call(D, H) &&
                  H !== 'key' &&
                  H !== '__self' &&
                  H !== '__source' &&
                  (X[H] = D[H]);
            var F = arguments.length - 2;
            if (F === 1) X.children = B;
            else if (1 < F) {
              for (var se = Array(F), At = 0; At < F; At++)
                se[At] = arguments[At + 2];
              X.children = se;
            }
            if (v && v.defaultProps)
              for (H in ((F = v.defaultProps), F))
                X[H] === void 0 && (X[H] = F[H]);
            return ut(v, ot, void 0, void 0, null, X);
          }),
          (et.createRef = function () {
            return { current: null };
          }),
          (et.forwardRef = function (v) {
            return { $$typeof: p, render: v };
          }),
          (et.isValidElement = Et),
          (et.lazy = function (v) {
            return {
              $$typeof: A,
              _payload: { _status: -1, _result: v },
              _init: j,
            };
          }),
          (et.memo = function (v, D) {
            return { $$typeof: g, type: v, compare: D === void 0 ? null : D };
          }),
          (et.startTransition = function (v) {
            var D = w.T,
              B = {};
            w.T = B;
            try {
              var H = v(),
                X = w.S;
              (X !== null && X(B, H),
                typeof H == 'object' &&
                  H !== null &&
                  typeof H.then == 'function' &&
                  H.then(ft, V));
            } catch (ot) {
              V(ot);
            } finally {
              w.T = D;
            }
          }),
          (et.unstable_useCacheRefresh = function () {
            return w.H.useCacheRefresh();
          }),
          (et.use = function (v) {
            return w.H.use(v);
          }),
          (et.useActionState = function (v, D, B) {
            return w.H.useActionState(v, D, B);
          }),
          (et.useCallback = function (v, D) {
            return w.H.useCallback(v, D);
          }),
          (et.useContext = function (v) {
            return w.H.useContext(v);
          }),
          (et.useDebugValue = function () {}),
          (et.useDeferredValue = function (v, D) {
            return w.H.useDeferredValue(v, D);
          }),
          (et.useEffect = function (v, D, B) {
            var H = w.H;
            if (typeof B == 'function')
              throw Error(
                'useEffect CRUD overload is not enabled in this build of React.'
              );
            return H.useEffect(v, D);
          }),
          (et.useId = function () {
            return w.H.useId();
          }),
          (et.useImperativeHandle = function (v, D, B) {
            return w.H.useImperativeHandle(v, D, B);
          }),
          (et.useInsertionEffect = function (v, D) {
            return w.H.useInsertionEffect(v, D);
          }),
          (et.useLayoutEffect = function (v, D) {
            return w.H.useLayoutEffect(v, D);
          }),
          (et.useMemo = function (v, D) {
            return w.H.useMemo(v, D);
          }),
          (et.useOptimistic = function (v, D) {
            return w.H.useOptimistic(v, D);
          }),
          (et.useReducer = function (v, D, B) {
            return w.H.useReducer(v, D, B);
          }),
          (et.useRef = function (v) {
            return w.H.useRef(v);
          }),
          (et.useState = function (v) {
            return w.H.useState(v);
          }),
          (et.useSyncExternalStore = function (v, D, B) {
            return w.H.useSyncExternalStore(v, D, B);
          }),
          (et.useTransition = function () {
            return w.H.useTransition();
          }),
          (et.version = '19.1.1'),
          et
        );
      }
      var Gd;
      function Kc() {
        return (Gd || ((Gd = 1), (_c.exports = Fm())), _c.exports);
      }
      var Nc = { exports: {} },
        Ft = {};
      /**
       * @license React
       * react-dom.production.js
       *
       * Copyright (c) Meta Platforms, Inc. and affiliates.
       *
       * This source code is licensed under the MIT license found in the
       * LICENSE file in the root directory of this source tree.
       */ var wd;
      function Pm() {
        if (wd) return Ft;
        wd = 1;
        var r = Kc();
        function u(b) {
          var g = 'https://react.dev/errors/' + b;
          if (1 < arguments.length) {
            g += '?args[]=' + encodeURIComponent(arguments[1]);
            for (var A = 2; A < arguments.length; A++)
              g += '&args[]=' + encodeURIComponent(arguments[A]);
          }
          return (
            'Minified React error #' +
            b +
            '; visit ' +
            g +
            ' for the full message or use the non-minified dev environment for full errors and additional helpful warnings.'
          );
        }
        function c() {}
        var s = {
            d: {
              f: c,
              r: function () {
                throw Error(u(522));
              },
              D: c,
              C: c,
              L: c,
              m: c,
              X: c,
              S: c,
              M: c,
            },
            p: 0,
            findDOMNode: null,
          },
          o = Symbol.for('react.portal');
        function h(b, g, A) {
          var N =
            3 < arguments.length && arguments[3] !== void 0
              ? arguments[3]
              : null;
          return {
            $$typeof: o,
            key: N == null ? null : '' + N,
            children: b,
            containerInfo: g,
            implementation: A,
          };
        }
        var m =
          r.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
        function p(b, g) {
          if (b === 'font') return '';
          if (typeof g == 'string') return g === 'use-credentials' ? g : '';
        }
        return (
          (Ft.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = s),
          (Ft.createPortal = function (b, g) {
            var A =
              2 < arguments.length && arguments[2] !== void 0
                ? arguments[2]
                : null;
            if (
              !g ||
              (g.nodeType !== 1 && g.nodeType !== 9 && g.nodeType !== 11)
            )
              throw Error(u(299));
            return h(b, g, null, A);
          }),
          (Ft.flushSync = function (b) {
            var g = m.T,
              A = s.p;
            try {
              if (((m.T = null), (s.p = 2), b)) return b();
            } finally {
              ((m.T = g), (s.p = A), s.d.f());
            }
          }),
          (Ft.preconnect = function (b, g) {
            typeof b == 'string' &&
              (g
                ? ((g = g.crossOrigin),
                  (g =
                    typeof g == 'string'
                      ? g === 'use-credentials'
                        ? g
                        : ''
                      : void 0))
                : (g = null),
              s.d.C(b, g));
          }),
          (Ft.prefetchDNS = function (b) {
            typeof b == 'string' && s.d.D(b);
          }),
          (Ft.preinit = function (b, g) {
            if (typeof b == 'string' && g && typeof g.as == 'string') {
              var A = g.as,
                N = p(A, g.crossOrigin),
                L = typeof g.integrity == 'string' ? g.integrity : void 0,
                K =
                  typeof g.fetchPriority == 'string' ? g.fetchPriority : void 0;
              A === 'style'
                ? s.d.S(
                    b,
                    typeof g.precedence == 'string' ? g.precedence : void 0,
                    { crossOrigin: N, integrity: L, fetchPriority: K }
                  )
                : A === 'script' &&
                  s.d.X(b, {
                    crossOrigin: N,
                    integrity: L,
                    fetchPriority: K,
                    nonce: typeof g.nonce == 'string' ? g.nonce : void 0,
                  });
            }
          }),
          (Ft.preinitModule = function (b, g) {
            if (typeof b == 'string')
              if (typeof g == 'object' && g !== null) {
                if (g.as == null || g.as === 'script') {
                  var A = p(g.as, g.crossOrigin);
                  s.d.M(b, {
                    crossOrigin: A,
                    integrity:
                      typeof g.integrity == 'string' ? g.integrity : void 0,
                    nonce: typeof g.nonce == 'string' ? g.nonce : void 0,
                  });
                }
              } else g == null && s.d.M(b);
          }),
          (Ft.preload = function (b, g) {
            if (
              typeof b == 'string' &&
              typeof g == 'object' &&
              g !== null &&
              typeof g.as == 'string'
            ) {
              var A = g.as,
                N = p(A, g.crossOrigin);
              s.d.L(b, A, {
                crossOrigin: N,
                integrity:
                  typeof g.integrity == 'string' ? g.integrity : void 0,
                nonce: typeof g.nonce == 'string' ? g.nonce : void 0,
                type: typeof g.type == 'string' ? g.type : void 0,
                fetchPriority:
                  typeof g.fetchPriority == 'string' ? g.fetchPriority : void 0,
                referrerPolicy:
                  typeof g.referrerPolicy == 'string'
                    ? g.referrerPolicy
                    : void 0,
                imageSrcSet:
                  typeof g.imageSrcSet == 'string' ? g.imageSrcSet : void 0,
                imageSizes:
                  typeof g.imageSizes == 'string' ? g.imageSizes : void 0,
                media: typeof g.media == 'string' ? g.media : void 0,
              });
            }
          }),
          (Ft.preloadModule = function (b, g) {
            if (typeof b == 'string')
              if (g) {
                var A = p(g.as, g.crossOrigin);
                s.d.m(b, {
                  as:
                    typeof g.as == 'string' && g.as !== 'script'
                      ? g.as
                      : void 0,
                  crossOrigin: A,
                  integrity:
                    typeof g.integrity == 'string' ? g.integrity : void 0,
                });
              } else s.d.m(b);
          }),
          (Ft.requestFormReset = function (b) {
            s.d.r(b);
          }),
          (Ft.unstable_batchedUpdates = function (b, g) {
            return b(g);
          }),
          (Ft.useFormState = function (b, g, A) {
            return m.H.useFormState(b, g, A);
          }),
          (Ft.useFormStatus = function () {
            return m.H.useHostTransitionStatus();
          }),
          (Ft.version = '19.1.1'),
          Ft
        );
      }
      var Vd;
      function Im() {
        if (Vd) return Nc.exports;
        Vd = 1;
        function r() {
          if (
            !(
              typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > 'u' ||
              typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != 'function'
            )
          )
            try {
              __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(r);
            } catch (u) {
              console.error(u);
            }
        }
        return (r(), (Nc.exports = Pm()), Nc.exports);
      }
      /**
       * @license React
       * react-dom-client.production.js
       *
       * Copyright (c) Meta Platforms, Inc. and affiliates.
       *
       * This source code is licensed under the MIT license found in the
       * LICENSE file in the root directory of this source tree.
       */ var Xd;
      function ty() {
        if (Xd) return jn;
        Xd = 1;
        var r = Wm(),
          u = Kc(),
          c = Im();
        function s(t) {
          var e = 'https://react.dev/errors/' + t;
          if (1 < arguments.length) {
            e += '?args[]=' + encodeURIComponent(arguments[1]);
            for (var a = 2; a < arguments.length; a++)
              e += '&args[]=' + encodeURIComponent(arguments[a]);
          }
          return (
            'Minified React error #' +
            t +
            '; visit ' +
            e +
            ' for the full message or use the non-minified dev environment for full errors and additional helpful warnings.'
          );
        }
        function o(t) {
          return !(
            !t ||
            (t.nodeType !== 1 && t.nodeType !== 9 && t.nodeType !== 11)
          );
        }
        function h(t) {
          var e = t,
            a = t;
          if (t.alternate) for (; e.return; ) e = e.return;
          else {
            t = e;
            do
              ((e = t),
                (e.flags & 4098) !== 0 && (a = e.return),
                (t = e.return));
            while (t);
          }
          return e.tag === 3 ? a : null;
        }
        function m(t) {
          if (t.tag === 13) {
            var e = t.memoizedState;
            if (
              (e === null &&
                ((t = t.alternate), t !== null && (e = t.memoizedState)),
              e !== null)
            )
              return e.dehydrated;
          }
          return null;
        }
        function p(t) {
          if (h(t) !== t) throw Error(s(188));
        }
        function b(t) {
          var e = t.alternate;
          if (!e) {
            if (((e = h(t)), e === null)) throw Error(s(188));
            return e !== t ? null : t;
          }
          for (var a = t, l = e; ; ) {
            var n = a.return;
            if (n === null) break;
            var i = n.alternate;
            if (i === null) {
              if (((l = n.return), l !== null)) {
                a = l;
                continue;
              }
              break;
            }
            if (n.child === i.child) {
              for (i = n.child; i; ) {
                if (i === a) return (p(n), t);
                if (i === l) return (p(n), e);
                i = i.sibling;
              }
              throw Error(s(188));
            }
            if (a.return !== l.return) ((a = n), (l = i));
            else {
              for (var f = !1, d = n.child; d; ) {
                if (d === a) {
                  ((f = !0), (a = n), (l = i));
                  break;
                }
                if (d === l) {
                  ((f = !0), (l = n), (a = i));
                  break;
                }
                d = d.sibling;
              }
              if (!f) {
                for (d = i.child; d; ) {
                  if (d === a) {
                    ((f = !0), (a = i), (l = n));
                    break;
                  }
                  if (d === l) {
                    ((f = !0), (l = i), (a = n));
                    break;
                  }
                  d = d.sibling;
                }
                if (!f) throw Error(s(189));
              }
            }
            if (a.alternate !== l) throw Error(s(190));
          }
          if (a.tag !== 3) throw Error(s(188));
          return a.stateNode.current === a ? t : e;
        }
        function g(t) {
          var e = t.tag;
          if (e === 5 || e === 26 || e === 27 || e === 6) return t;
          for (t = t.child; t !== null; ) {
            if (((e = g(t)), e !== null)) return e;
            t = t.sibling;
          }
          return null;
        }
        var A = Object.assign,
          N = Symbol.for('react.element'),
          L = Symbol.for('react.transitional.element'),
          K = Symbol.for('react.portal'),
          q = Symbol.for('react.fragment'),
          Q = Symbol.for('react.strict_mode'),
          P = Symbol.for('react.profiler'),
          ht = Symbol.for('react.provider'),
          tt = Symbol.for('react.consumer'),
          W = Symbol.for('react.context'),
          I = Symbol.for('react.forward_ref'),
          w = Symbol.for('react.suspense'),
          st = Symbol.for('react.suspense_list'),
          ut = Symbol.for('react.memo'),
          Mt = Symbol.for('react.lazy'),
          Et = Symbol.for('react.activity'),
          Lt = Symbol.for('react.memo_cache_sentinel'),
          te = Symbol.iterator;
        function Rt(t) {
          return t === null || typeof t != 'object'
            ? null
            : ((t = (te && t[te]) || t['@@iterator']),
              typeof t == 'function' ? t : null);
        }
        var zt = Symbol.for('react.client.reference');
        function Ht(t) {
          if (t == null) return null;
          if (typeof t == 'function')
            return t.$$typeof === zt ? null : t.displayName || t.name || null;
          if (typeof t == 'string') return t;
          switch (t) {
            case q:
              return 'Fragment';
            case P:
              return 'Profiler';
            case Q:
              return 'StrictMode';
            case w:
              return 'Suspense';
            case st:
              return 'SuspenseList';
            case Et:
              return 'Activity';
          }
          if (typeof t == 'object')
            switch (t.$$typeof) {
              case K:
                return 'Portal';
              case W:
                return (t.displayName || 'Context') + '.Provider';
              case tt:
                return (t._context.displayName || 'Context') + '.Consumer';
              case I:
                var e = t.render;
                return (
                  (t = t.displayName),
                  t ||
                    ((t = e.displayName || e.name || ''),
                    (t = t !== '' ? 'ForwardRef(' + t + ')' : 'ForwardRef')),
                  t
                );
              case ut:
                return (
                  (e = t.displayName || null),
                  e !== null ? e : Ht(t.type) || 'Memo'
                );
              case Mt:
                ((e = t._payload), (t = t._init));
                try {
                  return Ht(t(e));
                } catch {}
            }
          return null;
        }
        var Dt = Array.isArray,
          _ = u.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE,
          j = c.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE,
          V = { pending: !1, data: null, method: null, action: null },
          ft = [],
          v = -1;
        function D(t) {
          return { current: t };
        }
        function B(t) {
          0 > v || ((t.current = ft[v]), (ft[v] = null), v--);
        }
        function H(t, e) {
          (v++, (ft[v] = t.current), (t.current = e));
        }
        var X = D(null),
          ot = D(null),
          F = D(null),
          se = D(null);
        function At(t, e) {
          switch ((H(F, e), H(ot, t), H(X, null), e.nodeType)) {
            case 9:
            case 11:
              t = (t = e.documentElement) && (t = t.namespaceURI) ? od(t) : 0;
              break;
            default:
              if (((t = e.tagName), (e = e.namespaceURI)))
                ((e = od(e)), (t = rd(e, t)));
              else
                switch (t) {
                  case 'svg':
                    t = 1;
                    break;
                  case 'math':
                    t = 2;
                    break;
                  default:
                    t = 0;
                }
          }
          (B(X), H(X, t));
        }
        function ea() {
          (B(X), B(ot), B(F));
        }
        function cu(t) {
          t.memoizedState !== null && H(se, t);
          var e = X.current,
            a = rd(e, t.type);
          e !== a && (H(ot, t), H(X, a));
        }
        function Kn(t) {
          (ot.current === t && (B(X), B(ot)),
            se.current === t && (B(se), (Nn._currentValue = V)));
        }
        var fu = Object.prototype.hasOwnProperty,
          ou = r.unstable_scheduleCallback,
          ru = r.unstable_cancelCallback,
          Oh = r.unstable_shouldYield,
          Mh = r.unstable_requestPaint,
          Ue = r.unstable_now,
          _h = r.unstable_getCurrentPriorityLevel,
          wc = r.unstable_ImmediatePriority,
          Vc = r.unstable_UserBlockingPriority,
          Yn = r.unstable_NormalPriority,
          Nh = r.unstable_LowPriority,
          Xc = r.unstable_IdlePriority,
          Rh = r.log,
          zh = r.unstable_setDisableYieldValue,
          Ll = null,
          ce = null;
        function aa(t) {
          if (
            (typeof Rh == 'function' && zh(t),
            ce && typeof ce.setStrictMode == 'function')
          )
            try {
              ce.setStrictMode(Ll, t);
            } catch {}
        }
        var fe = Math.clz32 ? Math.clz32 : Uh,
          Dh = Math.log,
          Ch = Math.LN2;
        function Uh(t) {
          return ((t >>>= 0), t === 0 ? 32 : (31 - ((Dh(t) / Ch) | 0)) | 0);
        }
        var Gn = 256,
          wn = 4194304;
        function Ma(t) {
          var e = t & 42;
          if (e !== 0) return e;
          switch (t & -t) {
            case 1:
              return 1;
            case 2:
              return 2;
            case 4:
              return 4;
            case 8:
              return 8;
            case 16:
              return 16;
            case 32:
              return 32;
            case 64:
              return 64;
            case 128:
              return 128;
            case 256:
            case 512:
            case 1024:
            case 2048:
            case 4096:
            case 8192:
            case 16384:
            case 32768:
            case 65536:
            case 131072:
            case 262144:
            case 524288:
            case 1048576:
            case 2097152:
              return t & 4194048;
            case 4194304:
            case 8388608:
            case 16777216:
            case 33554432:
              return t & 62914560;
            case 67108864:
              return 67108864;
            case 134217728:
              return 134217728;
            case 268435456:
              return 268435456;
            case 536870912:
              return 536870912;
            case 1073741824:
              return 0;
            default:
              return t;
          }
        }
        function Vn(t, e, a) {
          var l = t.pendingLanes;
          if (l === 0) return 0;
          var n = 0,
            i = t.suspendedLanes,
            f = t.pingedLanes;
          t = t.warmLanes;
          var d = l & 134217727;
          return (
            d !== 0
              ? ((l = d & ~i),
                l !== 0
                  ? (n = Ma(l))
                  : ((f &= d),
                    f !== 0
                      ? (n = Ma(f))
                      : a || ((a = d & ~t), a !== 0 && (n = Ma(a)))))
              : ((d = l & ~i),
                d !== 0
                  ? (n = Ma(d))
                  : f !== 0
                    ? (n = Ma(f))
                    : a || ((a = l & ~t), a !== 0 && (n = Ma(a)))),
            n === 0
              ? 0
              : e !== 0 &&
                  e !== n &&
                  (e & i) === 0 &&
                  ((i = n & -n),
                  (a = e & -e),
                  i >= a || (i === 32 && (a & 4194048) !== 0))
                ? e
                : n
          );
        }
        function Hl(t, e) {
          return (
            (t.pendingLanes & ~(t.suspendedLanes & ~t.pingedLanes) & e) === 0
          );
        }
        function jh(t, e) {
          switch (t) {
            case 1:
            case 2:
            case 4:
            case 8:
            case 64:
              return e + 250;
            case 16:
            case 32:
            case 128:
            case 256:
            case 512:
            case 1024:
            case 2048:
            case 4096:
            case 8192:
            case 16384:
            case 32768:
            case 65536:
            case 131072:
            case 262144:
            case 524288:
            case 1048576:
            case 2097152:
              return e + 5e3;
            case 4194304:
            case 8388608:
            case 16777216:
            case 33554432:
              return -1;
            case 67108864:
            case 134217728:
            case 268435456:
            case 536870912:
            case 1073741824:
              return -1;
            default:
              return -1;
          }
        }
        function Qc() {
          var t = Gn;
          return ((Gn <<= 1), (Gn & 4194048) === 0 && (Gn = 256), t);
        }
        function Zc() {
          var t = wn;
          return ((wn <<= 1), (wn & 62914560) === 0 && (wn = 4194304), t);
        }
        function du(t) {
          for (var e = [], a = 0; 31 > a; a++) e.push(t);
          return e;
        }
        function Bl(t, e) {
          ((t.pendingLanes |= e),
            e !== 268435456 &&
              ((t.suspendedLanes = 0), (t.pingedLanes = 0), (t.warmLanes = 0)));
        }
        function Lh(t, e, a, l, n, i) {
          var f = t.pendingLanes;
          ((t.pendingLanes = a),
            (t.suspendedLanes = 0),
            (t.pingedLanes = 0),
            (t.warmLanes = 0),
            (t.expiredLanes &= a),
            (t.entangledLanes &= a),
            (t.errorRecoveryDisabledLanes &= a),
            (t.shellSuspendCounter = 0));
          var d = t.entanglements,
            y = t.expirationTimes,
            E = t.hiddenUpdates;
          for (a = f & ~a; 0 < a; ) {
            var R = 31 - fe(a),
              U = 1 << R;
            ((d[R] = 0), (y[R] = -1));
            var O = E[R];
            if (O !== null)
              for (E[R] = null, R = 0; R < O.length; R++) {
                var M = O[R];
                M !== null && (M.lane &= -536870913);
              }
            a &= ~U;
          }
          (l !== 0 && $c(t, l, 0),
            i !== 0 &&
              n === 0 &&
              t.tag !== 0 &&
              (t.suspendedLanes |= i & ~(f & ~e)));
        }
        function $c(t, e, a) {
          ((t.pendingLanes |= e), (t.suspendedLanes &= ~e));
          var l = 31 - fe(e);
          ((t.entangledLanes |= e),
            (t.entanglements[l] =
              t.entanglements[l] | 1073741824 | (a & 4194090)));
        }
        function Jc(t, e) {
          var a = (t.entangledLanes |= e);
          for (t = t.entanglements; a; ) {
            var l = 31 - fe(a),
              n = 1 << l;
            ((n & e) | (t[l] & e) && (t[l] |= e), (a &= ~n));
          }
        }
        function hu(t) {
          switch (t) {
            case 2:
              t = 1;
              break;
            case 8:
              t = 4;
              break;
            case 32:
              t = 16;
              break;
            case 256:
            case 512:
            case 1024:
            case 2048:
            case 4096:
            case 8192:
            case 16384:
            case 32768:
            case 65536:
            case 131072:
            case 262144:
            case 524288:
            case 1048576:
            case 2097152:
            case 4194304:
            case 8388608:
            case 16777216:
            case 33554432:
              t = 128;
              break;
            case 268435456:
              t = 134217728;
              break;
            default:
              t = 0;
          }
          return t;
        }
        function gu(t) {
          return (
            (t &= -t),
            2 < t ? (8 < t ? ((t & 134217727) !== 0 ? 32 : 268435456) : 8) : 2
          );
        }
        function kc() {
          var t = j.p;
          return t !== 0
            ? t
            : ((t = window.event), t === void 0 ? 32 : zd(t.type));
        }
        function Hh(t, e) {
          var a = j.p;
          try {
            return ((j.p = t), e());
          } finally {
            j.p = a;
          }
        }
        var la = Math.random().toString(36).slice(2),
          kt = '__reactFiber$' + la,
          ee = '__reactProps$' + la,
          $a = '__reactContainer$' + la,
          mu = '__reactEvents$' + la,
          Bh = '__reactListeners$' + la,
          qh = '__reactHandles$' + la,
          Wc = '__reactResources$' + la,
          ql = '__reactMarker$' + la;
        function yu(t) {
          (delete t[kt],
            delete t[ee],
            delete t[mu],
            delete t[Bh],
            delete t[qh]);
        }
        function Ja(t) {
          var e = t[kt];
          if (e) return e;
          for (var a = t.parentNode; a; ) {
            if ((e = a[$a] || a[kt])) {
              if (
                ((a = e.alternate),
                e.child !== null || (a !== null && a.child !== null))
              )
                for (t = md(t); t !== null; ) {
                  if ((a = t[kt])) return a;
                  t = md(t);
                }
              return e;
            }
            ((t = a), (a = t.parentNode));
          }
          return null;
        }
        function ka(t) {
          if ((t = t[kt] || t[$a])) {
            var e = t.tag;
            if (
              e === 5 ||
              e === 6 ||
              e === 13 ||
              e === 26 ||
              e === 27 ||
              e === 3
            )
              return t;
          }
          return null;
        }
        function Kl(t) {
          var e = t.tag;
          if (e === 5 || e === 26 || e === 27 || e === 6) return t.stateNode;
          throw Error(s(33));
        }
        function Wa(t) {
          var e = t[Wc];
          return (
            e ||
              (e = t[Wc] =
                { hoistableStyles: new Map(), hoistableScripts: new Map() }),
            e
          );
        }
        function Gt(t) {
          t[ql] = !0;
        }
        var Fc = new Set(),
          Pc = {};
        function _a(t, e) {
          (Fa(t, e), Fa(t + 'Capture', e));
        }
        function Fa(t, e) {
          for (Pc[t] = e, t = 0; t < e.length; t++) Fc.add(e[t]);
        }
        var Kh = RegExp(
            '^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$'
          ),
          Ic = {},
          tf = {};
        function Yh(t) {
          return fu.call(tf, t)
            ? !0
            : fu.call(Ic, t)
              ? !1
              : Kh.test(t)
                ? (tf[t] = !0)
                : ((Ic[t] = !0), !1);
        }
        function Xn(t, e, a) {
          if (Yh(e))
            if (a === null) t.removeAttribute(e);
            else {
              switch (typeof a) {
                case 'undefined':
                case 'function':
                case 'symbol':
                  t.removeAttribute(e);
                  return;
                case 'boolean':
                  var l = e.toLowerCase().slice(0, 5);
                  if (l !== 'data-' && l !== 'aria-') {
                    t.removeAttribute(e);
                    return;
                  }
              }
              t.setAttribute(e, '' + a);
            }
        }
        function Qn(t, e, a) {
          if (a === null) t.removeAttribute(e);
          else {
            switch (typeof a) {
              case 'undefined':
              case 'function':
              case 'symbol':
              case 'boolean':
                t.removeAttribute(e);
                return;
            }
            t.setAttribute(e, '' + a);
          }
        }
        function Ye(t, e, a, l) {
          if (l === null) t.removeAttribute(a);
          else {
            switch (typeof l) {
              case 'undefined':
              case 'function':
              case 'symbol':
              case 'boolean':
                t.removeAttribute(a);
                return;
            }
            t.setAttributeNS(e, a, '' + l);
          }
        }
        var pu, ef;
        function Pa(t) {
          if (pu === void 0)
            try {
              throw Error();
            } catch (a) {
              var e = a.stack.trim().match(/\n( *(at )?)/);
              ((pu = (e && e[1]) || ''),
                (ef =
                  -1 <
                  a.stack.indexOf(`
    at`)
                    ? ' (<anonymous>)'
                    : -1 < a.stack.indexOf('@')
                      ? '@unknown:0:0'
                      : ''));
            }
          return (
            `
` +
            pu +
            t +
            ef
          );
        }
        var vu = !1;
        function bu(t, e) {
          if (!t || vu) return '';
          vu = !0;
          var a = Error.prepareStackTrace;
          Error.prepareStackTrace = void 0;
          try {
            var l = {
              DetermineComponentFrameRoot: function () {
                try {
                  if (e) {
                    var U = function () {
                      throw Error();
                    };
                    if (
                      (Object.defineProperty(U.prototype, 'props', {
                        set: function () {
                          throw Error();
                        },
                      }),
                      typeof Reflect == 'object' && Reflect.construct)
                    ) {
                      try {
                        Reflect.construct(U, []);
                      } catch (M) {
                        var O = M;
                      }
                      Reflect.construct(t, [], U);
                    } else {
                      try {
                        U.call();
                      } catch (M) {
                        O = M;
                      }
                      t.call(U.prototype);
                    }
                  } else {
                    try {
                      throw Error();
                    } catch (M) {
                      O = M;
                    }
                    (U = t()) &&
                      typeof U.catch == 'function' &&
                      U.catch(function () {});
                  }
                } catch (M) {
                  if (M && O && typeof M.stack == 'string')
                    return [M.stack, O.stack];
                }
                return [null, null];
              },
            };
            l.DetermineComponentFrameRoot.displayName =
              'DetermineComponentFrameRoot';
            var n = Object.getOwnPropertyDescriptor(
              l.DetermineComponentFrameRoot,
              'name'
            );
            n &&
              n.configurable &&
              Object.defineProperty(l.DetermineComponentFrameRoot, 'name', {
                value: 'DetermineComponentFrameRoot',
              });
            var i = l.DetermineComponentFrameRoot(),
              f = i[0],
              d = i[1];
            if (f && d) {
              var y = f.split(`
`),
                E = d.split(`
`);
              for (
                n = l = 0;
                l < y.length && !y[l].includes('DetermineComponentFrameRoot');
              )
                l++;
              for (
                ;
                n < E.length && !E[n].includes('DetermineComponentFrameRoot');
              )
                n++;
              if (l === y.length || n === E.length)
                for (
                  l = y.length - 1, n = E.length - 1;
                  1 <= l && 0 <= n && y[l] !== E[n];
                )
                  n--;
              for (; 1 <= l && 0 <= n; l--, n--)
                if (y[l] !== E[n]) {
                  if (l !== 1 || n !== 1)
                    do
                      if ((l--, n--, 0 > n || y[l] !== E[n])) {
                        var R =
                          `
` + y[l].replace(' at new ', ' at ');
                        return (
                          t.displayName &&
                            R.includes('<anonymous>') &&
                            (R = R.replace('<anonymous>', t.displayName)),
                          R
                        );
                      }
                    while (1 <= l && 0 <= n);
                  break;
                }
            }
          } finally {
            ((vu = !1), (Error.prepareStackTrace = a));
          }
          return (a = t ? t.displayName || t.name : '') ? Pa(a) : '';
        }
        function Gh(t) {
          switch (t.tag) {
            case 26:
            case 27:
            case 5:
              return Pa(t.type);
            case 16:
              return Pa('Lazy');
            case 13:
              return Pa('Suspense');
            case 19:
              return Pa('SuspenseList');
            case 0:
            case 15:
              return bu(t.type, !1);
            case 11:
              return bu(t.type.render, !1);
            case 1:
              return bu(t.type, !0);
            case 31:
              return Pa('Activity');
            default:
              return '';
          }
        }
        function af(t) {
          try {
            var e = '';
            do ((e += Gh(t)), (t = t.return));
            while (t);
            return e;
          } catch (a) {
            return (
              `
Error generating stack: ` +
              a.message +
              `
` +
              a.stack
            );
          }
        }
        function pe(t) {
          switch (typeof t) {
            case 'bigint':
            case 'boolean':
            case 'number':
            case 'string':
            case 'undefined':
              return t;
            case 'object':
              return t;
            default:
              return '';
          }
        }
        function lf(t) {
          var e = t.type;
          return (
            (t = t.nodeName) &&
            t.toLowerCase() === 'input' &&
            (e === 'checkbox' || e === 'radio')
          );
        }
        function wh(t) {
          var e = lf(t) ? 'checked' : 'value',
            a = Object.getOwnPropertyDescriptor(t.constructor.prototype, e),
            l = '' + t[e];
          if (
            !t.hasOwnProperty(e) &&
            typeof a < 'u' &&
            typeof a.get == 'function' &&
            typeof a.set == 'function'
          ) {
            var n = a.get,
              i = a.set;
            return (
              Object.defineProperty(t, e, {
                configurable: !0,
                get: function () {
                  return n.call(this);
                },
                set: function (f) {
                  ((l = '' + f), i.call(this, f));
                },
              }),
              Object.defineProperty(t, e, { enumerable: a.enumerable }),
              {
                getValue: function () {
                  return l;
                },
                setValue: function (f) {
                  l = '' + f;
                },
                stopTracking: function () {
                  ((t._valueTracker = null), delete t[e]);
                },
              }
            );
          }
        }
        function Zn(t) {
          t._valueTracker || (t._valueTracker = wh(t));
        }
        function nf(t) {
          if (!t) return !1;
          var e = t._valueTracker;
          if (!e) return !0;
          var a = e.getValue(),
            l = '';
          return (
            t && (l = lf(t) ? (t.checked ? 'true' : 'false') : t.value),
            (t = l),
            t !== a ? (e.setValue(t), !0) : !1
          );
        }
        function $n(t) {
          if (
            ((t = t || (typeof document < 'u' ? document : void 0)),
            typeof t > 'u')
          )
            return null;
          try {
            return t.activeElement || t.body;
          } catch {
            return t.body;
          }
        }
        var Vh = /[\n"\\]/g;
        function ve(t) {
          return t.replace(Vh, function (e) {
            return '\\' + e.charCodeAt(0).toString(16) + ' ';
          });
        }
        function Su(t, e, a, l, n, i, f, d) {
          ((t.name = ''),
            f != null &&
            typeof f != 'function' &&
            typeof f != 'symbol' &&
            typeof f != 'boolean'
              ? (t.type = f)
              : t.removeAttribute('type'),
            e != null
              ? f === 'number'
                ? ((e === 0 && t.value === '') || t.value != e) &&
                  (t.value = '' + pe(e))
                : t.value !== '' + pe(e) && (t.value = '' + pe(e))
              : (f !== 'submit' && f !== 'reset') || t.removeAttribute('value'),
            e != null
              ? xu(t, f, pe(e))
              : a != null
                ? xu(t, f, pe(a))
                : l != null && t.removeAttribute('value'),
            n == null && i != null && (t.defaultChecked = !!i),
            n != null &&
              (t.checked = n && typeof n != 'function' && typeof n != 'symbol'),
            d != null &&
            typeof d != 'function' &&
            typeof d != 'symbol' &&
            typeof d != 'boolean'
              ? (t.name = '' + pe(d))
              : t.removeAttribute('name'));
        }
        function uf(t, e, a, l, n, i, f, d) {
          if (
            (i != null &&
              typeof i != 'function' &&
              typeof i != 'symbol' &&
              typeof i != 'boolean' &&
              (t.type = i),
            e != null || a != null)
          ) {
            if (!((i !== 'submit' && i !== 'reset') || e != null)) return;
            ((a = a != null ? '' + pe(a) : ''),
              (e = e != null ? '' + pe(e) : a),
              d || e === t.value || (t.value = e),
              (t.defaultValue = e));
          }
          ((l = l ?? n),
            (l = typeof l != 'function' && typeof l != 'symbol' && !!l),
            (t.checked = d ? t.checked : !!l),
            (t.defaultChecked = !!l),
            f != null &&
              typeof f != 'function' &&
              typeof f != 'symbol' &&
              typeof f != 'boolean' &&
              (t.name = f));
        }
        function xu(t, e, a) {
          (e === 'number' && $n(t.ownerDocument) === t) ||
            t.defaultValue === '' + a ||
            (t.defaultValue = '' + a);
        }
        function Ia(t, e, a, l) {
          if (((t = t.options), e)) {
            e = {};
            for (var n = 0; n < a.length; n++) e['$' + a[n]] = !0;
            for (a = 0; a < t.length; a++)
              ((n = e.hasOwnProperty('$' + t[a].value)),
                t[a].selected !== n && (t[a].selected = n),
                n && l && (t[a].defaultSelected = !0));
          } else {
            for (a = '' + pe(a), e = null, n = 0; n < t.length; n++) {
              if (t[n].value === a) {
                ((t[n].selected = !0), l && (t[n].defaultSelected = !0));
                return;
              }
              e !== null || t[n].disabled || (e = t[n]);
            }
            e !== null && (e.selected = !0);
          }
        }
        function sf(t, e, a) {
          if (
            e != null &&
            ((e = '' + pe(e)), e !== t.value && (t.value = e), a == null)
          ) {
            t.defaultValue !== e && (t.defaultValue = e);
            return;
          }
          t.defaultValue = a != null ? '' + pe(a) : '';
        }
        function cf(t, e, a, l) {
          if (e == null) {
            if (l != null) {
              if (a != null) throw Error(s(92));
              if (Dt(l)) {
                if (1 < l.length) throw Error(s(93));
                l = l[0];
              }
              a = l;
            }
            (a == null && (a = ''), (e = a));
          }
          ((a = pe(e)),
            (t.defaultValue = a),
            (l = t.textContent),
            l === a && l !== '' && l !== null && (t.value = l));
        }
        function tl(t, e) {
          if (e) {
            var a = t.firstChild;
            if (a && a === t.lastChild && a.nodeType === 3) {
              a.nodeValue = e;
              return;
            }
          }
          t.textContent = e;
        }
        var Xh = new Set(
          'animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp'.split(
            ' '
          )
        );
        function ff(t, e, a) {
          var l = e.indexOf('--') === 0;
          a == null || typeof a == 'boolean' || a === ''
            ? l
              ? t.setProperty(e, '')
              : e === 'float'
                ? (t.cssFloat = '')
                : (t[e] = '')
            : l
              ? t.setProperty(e, a)
              : typeof a != 'number' || a === 0 || Xh.has(e)
                ? e === 'float'
                  ? (t.cssFloat = a)
                  : (t[e] = ('' + a).trim())
                : (t[e] = a + 'px');
        }
        function of(t, e, a) {
          if (e != null && typeof e != 'object') throw Error(s(62));
          if (((t = t.style), a != null)) {
            for (var l in a)
              !a.hasOwnProperty(l) ||
                (e != null && e.hasOwnProperty(l)) ||
                (l.indexOf('--') === 0
                  ? t.setProperty(l, '')
                  : l === 'float'
                    ? (t.cssFloat = '')
                    : (t[l] = ''));
            for (var n in e)
              ((l = e[n]), e.hasOwnProperty(n) && a[n] !== l && ff(t, n, l));
          } else for (var i in e) e.hasOwnProperty(i) && ff(t, i, e[i]);
        }
        function Au(t) {
          if (t.indexOf('-') === -1) return !1;
          switch (t) {
            case 'annotation-xml':
            case 'color-profile':
            case 'font-face':
            case 'font-face-src':
            case 'font-face-uri':
            case 'font-face-format':
            case 'font-face-name':
            case 'missing-glyph':
              return !1;
            default:
              return !0;
          }
        }
        var Qh = new Map([
            ['acceptCharset', 'accept-charset'],
            ['htmlFor', 'for'],
            ['httpEquiv', 'http-equiv'],
            ['crossOrigin', 'crossorigin'],
            ['accentHeight', 'accent-height'],
            ['alignmentBaseline', 'alignment-baseline'],
            ['arabicForm', 'arabic-form'],
            ['baselineShift', 'baseline-shift'],
            ['capHeight', 'cap-height'],
            ['clipPath', 'clip-path'],
            ['clipRule', 'clip-rule'],
            ['colorInterpolation', 'color-interpolation'],
            ['colorInterpolationFilters', 'color-interpolation-filters'],
            ['colorProfile', 'color-profile'],
            ['colorRendering', 'color-rendering'],
            ['dominantBaseline', 'dominant-baseline'],
            ['enableBackground', 'enable-background'],
            ['fillOpacity', 'fill-opacity'],
            ['fillRule', 'fill-rule'],
            ['floodColor', 'flood-color'],
            ['floodOpacity', 'flood-opacity'],
            ['fontFamily', 'font-family'],
            ['fontSize', 'font-size'],
            ['fontSizeAdjust', 'font-size-adjust'],
            ['fontStretch', 'font-stretch'],
            ['fontStyle', 'font-style'],
            ['fontVariant', 'font-variant'],
            ['fontWeight', 'font-weight'],
            ['glyphName', 'glyph-name'],
            ['glyphOrientationHorizontal', 'glyph-orientation-horizontal'],
            ['glyphOrientationVertical', 'glyph-orientation-vertical'],
            ['horizAdvX', 'horiz-adv-x'],
            ['horizOriginX', 'horiz-origin-x'],
            ['imageRendering', 'image-rendering'],
            ['letterSpacing', 'letter-spacing'],
            ['lightingColor', 'lighting-color'],
            ['markerEnd', 'marker-end'],
            ['markerMid', 'marker-mid'],
            ['markerStart', 'marker-start'],
            ['overlinePosition', 'overline-position'],
            ['overlineThickness', 'overline-thickness'],
            ['paintOrder', 'paint-order'],
            ['panose-1', 'panose-1'],
            ['pointerEvents', 'pointer-events'],
            ['renderingIntent', 'rendering-intent'],
            ['shapeRendering', 'shape-rendering'],
            ['stopColor', 'stop-color'],
            ['stopOpacity', 'stop-opacity'],
            ['strikethroughPosition', 'strikethrough-position'],
            ['strikethroughThickness', 'strikethrough-thickness'],
            ['strokeDasharray', 'stroke-dasharray'],
            ['strokeDashoffset', 'stroke-dashoffset'],
            ['strokeLinecap', 'stroke-linecap'],
            ['strokeLinejoin', 'stroke-linejoin'],
            ['strokeMiterlimit', 'stroke-miterlimit'],
            ['strokeOpacity', 'stroke-opacity'],
            ['strokeWidth', 'stroke-width'],
            ['textAnchor', 'text-anchor'],
            ['textDecoration', 'text-decoration'],
            ['textRendering', 'text-rendering'],
            ['transformOrigin', 'transform-origin'],
            ['underlinePosition', 'underline-position'],
            ['underlineThickness', 'underline-thickness'],
            ['unicodeBidi', 'unicode-bidi'],
            ['unicodeRange', 'unicode-range'],
            ['unitsPerEm', 'units-per-em'],
            ['vAlphabetic', 'v-alphabetic'],
            ['vHanging', 'v-hanging'],
            ['vIdeographic', 'v-ideographic'],
            ['vMathematical', 'v-mathematical'],
            ['vectorEffect', 'vector-effect'],
            ['vertAdvY', 'vert-adv-y'],
            ['vertOriginX', 'vert-origin-x'],
            ['vertOriginY', 'vert-origin-y'],
            ['wordSpacing', 'word-spacing'],
            ['writingMode', 'writing-mode'],
            ['xmlnsXlink', 'xmlns:xlink'],
            ['xHeight', 'x-height'],
          ]),
          Zh =
            /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
        function Jn(t) {
          return Zh.test('' + t)
            ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')"
            : t;
        }
        var Tu = null;
        function Eu(t) {
          return (
            (t = t.target || t.srcElement || window),
            t.correspondingUseElement && (t = t.correspondingUseElement),
            t.nodeType === 3 ? t.parentNode : t
          );
        }
        var el = null,
          al = null;
        function rf(t) {
          var e = ka(t);
          if (e && (t = e.stateNode)) {
            var a = t[ee] || null;
            t: switch (((t = e.stateNode), e.type)) {
              case 'input':
                if (
                  (Su(
                    t,
                    a.value,
                    a.defaultValue,
                    a.defaultValue,
                    a.checked,
                    a.defaultChecked,
                    a.type,
                    a.name
                  ),
                  (e = a.name),
                  a.type === 'radio' && e != null)
                ) {
                  for (a = t; a.parentNode; ) a = a.parentNode;
                  for (
                    a = a.querySelectorAll(
                      'input[name="' + ve('' + e) + '"][type="radio"]'
                    ),
                      e = 0;
                    e < a.length;
                    e++
                  ) {
                    var l = a[e];
                    if (l !== t && l.form === t.form) {
                      var n = l[ee] || null;
                      if (!n) throw Error(s(90));
                      Su(
                        l,
                        n.value,
                        n.defaultValue,
                        n.defaultValue,
                        n.checked,
                        n.defaultChecked,
                        n.type,
                        n.name
                      );
                    }
                  }
                  for (e = 0; e < a.length; e++)
                    ((l = a[e]), l.form === t.form && nf(l));
                }
                break t;
              case 'textarea':
                sf(t, a.value, a.defaultValue);
                break t;
              case 'select':
                ((e = a.value), e != null && Ia(t, !!a.multiple, e, !1));
            }
          }
        }
        var Ou = !1;
        function df(t, e, a) {
          if (Ou) return t(e, a);
          Ou = !0;
          try {
            var l = t(e);
            return l;
          } finally {
            if (
              ((Ou = !1),
              (el !== null || al !== null) &&
                (Ui(), el && ((e = el), (t = al), (al = el = null), rf(e), t)))
            )
              for (e = 0; e < t.length; e++) rf(t[e]);
          }
        }
        function Yl(t, e) {
          var a = t.stateNode;
          if (a === null) return null;
          var l = a[ee] || null;
          if (l === null) return null;
          a = l[e];
          t: switch (e) {
            case 'onClick':
            case 'onClickCapture':
            case 'onDoubleClick':
            case 'onDoubleClickCapture':
            case 'onMouseDown':
            case 'onMouseDownCapture':
            case 'onMouseMove':
            case 'onMouseMoveCapture':
            case 'onMouseUp':
            case 'onMouseUpCapture':
            case 'onMouseEnter':
              ((l = !l.disabled) ||
                ((t = t.type),
                (l = !(
                  t === 'button' ||
                  t === 'input' ||
                  t === 'select' ||
                  t === 'textarea'
                ))),
                (t = !l));
              break t;
            default:
              t = !1;
          }
          if (t) return null;
          if (a && typeof a != 'function') throw Error(s(231, e, typeof a));
          return a;
        }
        var Ge = !(
            typeof window > 'u' ||
            typeof window.document > 'u' ||
            typeof window.document.createElement > 'u'
          ),
          Mu = !1;
        if (Ge)
          try {
            var Gl = {};
            (Object.defineProperty(Gl, 'passive', {
              get: function () {
                Mu = !0;
              },
            }),
              window.addEventListener('test', Gl, Gl),
              window.removeEventListener('test', Gl, Gl));
          } catch {
            Mu = !1;
          }
        var na = null,
          _u = null,
          kn = null;
        function hf() {
          if (kn) return kn;
          var t,
            e = _u,
            a = e.length,
            l,
            n = 'value' in na ? na.value : na.textContent,
            i = n.length;
          for (t = 0; t < a && e[t] === n[t]; t++);
          var f = a - t;
          for (l = 1; l <= f && e[a - l] === n[i - l]; l++);
          return (kn = n.slice(t, 1 < l ? 1 - l : void 0));
        }
        function Wn(t) {
          var e = t.keyCode;
          return (
            'charCode' in t
              ? ((t = t.charCode), t === 0 && e === 13 && (t = 13))
              : (t = e),
            t === 10 && (t = 13),
            32 <= t || t === 13 ? t : 0
          );
        }
        function Fn() {
          return !0;
        }
        function gf() {
          return !1;
        }
        function ae(t) {
          function e(a, l, n, i, f) {
            ((this._reactName = a),
              (this._targetInst = n),
              (this.type = l),
              (this.nativeEvent = i),
              (this.target = f),
              (this.currentTarget = null));
            for (var d in t)
              t.hasOwnProperty(d) && ((a = t[d]), (this[d] = a ? a(i) : i[d]));
            return (
              (this.isDefaultPrevented = (
                i.defaultPrevented != null
                  ? i.defaultPrevented
                  : i.returnValue === !1
              )
                ? Fn
                : gf),
              (this.isPropagationStopped = gf),
              this
            );
          }
          return (
            A(e.prototype, {
              preventDefault: function () {
                this.defaultPrevented = !0;
                var a = this.nativeEvent;
                a &&
                  (a.preventDefault
                    ? a.preventDefault()
                    : typeof a.returnValue != 'unknown' && (a.returnValue = !1),
                  (this.isDefaultPrevented = Fn));
              },
              stopPropagation: function () {
                var a = this.nativeEvent;
                a &&
                  (a.stopPropagation
                    ? a.stopPropagation()
                    : typeof a.cancelBubble != 'unknown' &&
                      (a.cancelBubble = !0),
                  (this.isPropagationStopped = Fn));
              },
              persist: function () {},
              isPersistent: Fn,
            }),
            e
          );
        }
        var Na = {
            eventPhase: 0,
            bubbles: 0,
            cancelable: 0,
            timeStamp: function (t) {
              return t.timeStamp || Date.now();
            },
            defaultPrevented: 0,
            isTrusted: 0,
          },
          Pn = ae(Na),
          wl = A({}, Na, { view: 0, detail: 0 }),
          $h = ae(wl),
          Nu,
          Ru,
          Vl,
          In = A({}, wl, {
            screenX: 0,
            screenY: 0,
            clientX: 0,
            clientY: 0,
            pageX: 0,
            pageY: 0,
            ctrlKey: 0,
            shiftKey: 0,
            altKey: 0,
            metaKey: 0,
            getModifierState: Du,
            button: 0,
            buttons: 0,
            relatedTarget: function (t) {
              return t.relatedTarget === void 0
                ? t.fromElement === t.srcElement
                  ? t.toElement
                  : t.fromElement
                : t.relatedTarget;
            },
            movementX: function (t) {
              return 'movementX' in t
                ? t.movementX
                : (t !== Vl &&
                    (Vl && t.type === 'mousemove'
                      ? ((Nu = t.screenX - Vl.screenX),
                        (Ru = t.screenY - Vl.screenY))
                      : (Ru = Nu = 0),
                    (Vl = t)),
                  Nu);
            },
            movementY: function (t) {
              return 'movementY' in t ? t.movementY : Ru;
            },
          }),
          mf = ae(In),
          Jh = A({}, In, { dataTransfer: 0 }),
          kh = ae(Jh),
          Wh = A({}, wl, { relatedTarget: 0 }),
          zu = ae(Wh),
          Fh = A({}, Na, {
            animationName: 0,
            elapsedTime: 0,
            pseudoElement: 0,
          }),
          Ph = ae(Fh),
          Ih = A({}, Na, {
            clipboardData: function (t) {
              return 'clipboardData' in t
                ? t.clipboardData
                : window.clipboardData;
            },
          }),
          tg = ae(Ih),
          eg = A({}, Na, { data: 0 }),
          yf = ae(eg),
          ag = {
            Esc: 'Escape',
            Spacebar: ' ',
            Left: 'ArrowLeft',
            Up: 'ArrowUp',
            Right: 'ArrowRight',
            Down: 'ArrowDown',
            Del: 'Delete',
            Win: 'OS',
            Menu: 'ContextMenu',
            Apps: 'ContextMenu',
            Scroll: 'ScrollLock',
            MozPrintableKey: 'Unidentified',
          },
          lg = {
            8: 'Backspace',
            9: 'Tab',
            12: 'Clear',
            13: 'Enter',
            16: 'Shift',
            17: 'Control',
            18: 'Alt',
            19: 'Pause',
            20: 'CapsLock',
            27: 'Escape',
            32: ' ',
            33: 'PageUp',
            34: 'PageDown',
            35: 'End',
            36: 'Home',
            37: 'ArrowLeft',
            38: 'ArrowUp',
            39: 'ArrowRight',
            40: 'ArrowDown',
            45: 'Insert',
            46: 'Delete',
            112: 'F1',
            113: 'F2',
            114: 'F3',
            115: 'F4',
            116: 'F5',
            117: 'F6',
            118: 'F7',
            119: 'F8',
            120: 'F9',
            121: 'F10',
            122: 'F11',
            123: 'F12',
            144: 'NumLock',
            145: 'ScrollLock',
            224: 'Meta',
          },
          ng = {
            Alt: 'altKey',
            Control: 'ctrlKey',
            Meta: 'metaKey',
            Shift: 'shiftKey',
          };
        function ig(t) {
          var e = this.nativeEvent;
          return e.getModifierState
            ? e.getModifierState(t)
            : (t = ng[t])
              ? !!e[t]
              : !1;
        }
        function Du() {
          return ig;
        }
        var ug = A({}, wl, {
            key: function (t) {
              if (t.key) {
                var e = ag[t.key] || t.key;
                if (e !== 'Unidentified') return e;
              }
              return t.type === 'keypress'
                ? ((t = Wn(t)), t === 13 ? 'Enter' : String.fromCharCode(t))
                : t.type === 'keydown' || t.type === 'keyup'
                  ? lg[t.keyCode] || 'Unidentified'
                  : '';
            },
            code: 0,
            location: 0,
            ctrlKey: 0,
            shiftKey: 0,
            altKey: 0,
            metaKey: 0,
            repeat: 0,
            locale: 0,
            getModifierState: Du,
            charCode: function (t) {
              return t.type === 'keypress' ? Wn(t) : 0;
            },
            keyCode: function (t) {
              return t.type === 'keydown' || t.type === 'keyup' ? t.keyCode : 0;
            },
            which: function (t) {
              return t.type === 'keypress'
                ? Wn(t)
                : t.type === 'keydown' || t.type === 'keyup'
                  ? t.keyCode
                  : 0;
            },
          }),
          sg = ae(ug),
          cg = A({}, In, {
            pointerId: 0,
            width: 0,
            height: 0,
            pressure: 0,
            tangentialPressure: 0,
            tiltX: 0,
            tiltY: 0,
            twist: 0,
            pointerType: 0,
            isPrimary: 0,
          }),
          pf = ae(cg),
          fg = A({}, wl, {
            touches: 0,
            targetTouches: 0,
            changedTouches: 0,
            altKey: 0,
            metaKey: 0,
            ctrlKey: 0,
            shiftKey: 0,
            getModifierState: Du,
          }),
          og = ae(fg),
          rg = A({}, Na, { propertyName: 0, elapsedTime: 0, pseudoElement: 0 }),
          dg = ae(rg),
          hg = A({}, In, {
            deltaX: function (t) {
              return 'deltaX' in t
                ? t.deltaX
                : 'wheelDeltaX' in t
                  ? -t.wheelDeltaX
                  : 0;
            },
            deltaY: function (t) {
              return 'deltaY' in t
                ? t.deltaY
                : 'wheelDeltaY' in t
                  ? -t.wheelDeltaY
                  : 'wheelDelta' in t
                    ? -t.wheelDelta
                    : 0;
            },
            deltaZ: 0,
            deltaMode: 0,
          }),
          gg = ae(hg),
          mg = A({}, Na, { newState: 0, oldState: 0 }),
          yg = ae(mg),
          pg = [9, 13, 27, 32],
          Cu = Ge && 'CompositionEvent' in window,
          Xl = null;
        Ge && 'documentMode' in document && (Xl = document.documentMode);
        var vg = Ge && 'TextEvent' in window && !Xl,
          vf = Ge && (!Cu || (Xl && 8 < Xl && 11 >= Xl)),
          bf = ' ',
          Sf = !1;
        function xf(t, e) {
          switch (t) {
            case 'keyup':
              return pg.indexOf(e.keyCode) !== -1;
            case 'keydown':
              return e.keyCode !== 229;
            case 'keypress':
            case 'mousedown':
            case 'focusout':
              return !0;
            default:
              return !1;
          }
        }
        function Af(t) {
          return (
            (t = t.detail),
            typeof t == 'object' && 'data' in t ? t.data : null
          );
        }
        var ll = !1;
        function bg(t, e) {
          switch (t) {
            case 'compositionend':
              return Af(e);
            case 'keypress':
              return e.which !== 32 ? null : ((Sf = !0), bf);
            case 'textInput':
              return ((t = e.data), t === bf && Sf ? null : t);
            default:
              return null;
          }
        }
        function Sg(t, e) {
          if (ll)
            return t === 'compositionend' || (!Cu && xf(t, e))
              ? ((t = hf()), (kn = _u = na = null), (ll = !1), t)
              : null;
          switch (t) {
            case 'paste':
              return null;
            case 'keypress':
              if (
                !(e.ctrlKey || e.altKey || e.metaKey) ||
                (e.ctrlKey && e.altKey)
              ) {
                if (e.char && 1 < e.char.length) return e.char;
                if (e.which) return String.fromCharCode(e.which);
              }
              return null;
            case 'compositionend':
              return vf && e.locale !== 'ko' ? null : e.data;
            default:
              return null;
          }
        }
        var xg = {
          color: !0,
          date: !0,
          datetime: !0,
          'datetime-local': !0,
          email: !0,
          month: !0,
          number: !0,
          password: !0,
          range: !0,
          search: !0,
          tel: !0,
          text: !0,
          time: !0,
          url: !0,
          week: !0,
        };
        function Tf(t) {
          var e = t && t.nodeName && t.nodeName.toLowerCase();
          return e === 'input' ? !!xg[t.type] : e === 'textarea';
        }
        function Ef(t, e, a, l) {
          (el ? (al ? al.push(l) : (al = [l])) : (el = l),
            (e = Ki(e, 'onChange')),
            0 < e.length &&
              ((a = new Pn('onChange', 'change', null, a, l)),
              t.push({ event: a, listeners: e })));
        }
        var Ql = null,
          Zl = null;
        function Ag(t) {
          id(t, 0);
        }
        function ti(t) {
          var e = Kl(t);
          if (nf(e)) return t;
        }
        function Of(t, e) {
          if (t === 'change') return e;
        }
        var Mf = !1;
        if (Ge) {
          var Uu;
          if (Ge) {
            var ju = 'oninput' in document;
            if (!ju) {
              var _f = document.createElement('div');
              (_f.setAttribute('oninput', 'return;'),
                (ju = typeof _f.oninput == 'function'));
            }
            Uu = ju;
          } else Uu = !1;
          Mf = Uu && (!document.documentMode || 9 < document.documentMode);
        }
        function Nf() {
          Ql && (Ql.detachEvent('onpropertychange', Rf), (Zl = Ql = null));
        }
        function Rf(t) {
          if (t.propertyName === 'value' && ti(Zl)) {
            var e = [];
            (Ef(e, Zl, t, Eu(t)), df(Ag, e));
          }
        }
        function Tg(t, e, a) {
          t === 'focusin'
            ? (Nf(), (Ql = e), (Zl = a), Ql.attachEvent('onpropertychange', Rf))
            : t === 'focusout' && Nf();
        }
        function Eg(t) {
          if (t === 'selectionchange' || t === 'keyup' || t === 'keydown')
            return ti(Zl);
        }
        function Og(t, e) {
          if (t === 'click') return ti(e);
        }
        function Mg(t, e) {
          if (t === 'input' || t === 'change') return ti(e);
        }
        function _g(t, e) {
          return (
            (t === e && (t !== 0 || 1 / t === 1 / e)) || (t !== t && e !== e)
          );
        }
        var oe = typeof Object.is == 'function' ? Object.is : _g;
        function $l(t, e) {
          if (oe(t, e)) return !0;
          if (
            typeof t != 'object' ||
            t === null ||
            typeof e != 'object' ||
            e === null
          )
            return !1;
          var a = Object.keys(t),
            l = Object.keys(e);
          if (a.length !== l.length) return !1;
          for (l = 0; l < a.length; l++) {
            var n = a[l];
            if (!fu.call(e, n) || !oe(t[n], e[n])) return !1;
          }
          return !0;
        }
        function zf(t) {
          for (; t && t.firstChild; ) t = t.firstChild;
          return t;
        }
        function Df(t, e) {
          var a = zf(t);
          t = 0;
          for (var l; a; ) {
            if (a.nodeType === 3) {
              if (((l = t + a.textContent.length), t <= e && l >= e))
                return { node: a, offset: e - t };
              t = l;
            }
            t: {
              for (; a; ) {
                if (a.nextSibling) {
                  a = a.nextSibling;
                  break t;
                }
                a = a.parentNode;
              }
              a = void 0;
            }
            a = zf(a);
          }
        }
        function Cf(t, e) {
          return t && e
            ? t === e
              ? !0
              : t && t.nodeType === 3
                ? !1
                : e && e.nodeType === 3
                  ? Cf(t, e.parentNode)
                  : 'contains' in t
                    ? t.contains(e)
                    : t.compareDocumentPosition
                      ? !!(t.compareDocumentPosition(e) & 16)
                      : !1
            : !1;
        }
        function Uf(t) {
          t =
            t != null &&
            t.ownerDocument != null &&
            t.ownerDocument.defaultView != null
              ? t.ownerDocument.defaultView
              : window;
          for (var e = $n(t.document); e instanceof t.HTMLIFrameElement; ) {
            try {
              var a = typeof e.contentWindow.location.href == 'string';
            } catch {
              a = !1;
            }
            if (a) t = e.contentWindow;
            else break;
            e = $n(t.document);
          }
          return e;
        }
        function Lu(t) {
          var e = t && t.nodeName && t.nodeName.toLowerCase();
          return (
            e &&
            ((e === 'input' &&
              (t.type === 'text' ||
                t.type === 'search' ||
                t.type === 'tel' ||
                t.type === 'url' ||
                t.type === 'password')) ||
              e === 'textarea' ||
              t.contentEditable === 'true')
          );
        }
        var Ng =
            Ge && 'documentMode' in document && 11 >= document.documentMode,
          nl = null,
          Hu = null,
          Jl = null,
          Bu = !1;
        function jf(t, e, a) {
          var l =
            a.window === a
              ? a.document
              : a.nodeType === 9
                ? a
                : a.ownerDocument;
          Bu ||
            nl == null ||
            nl !== $n(l) ||
            ((l = nl),
            'selectionStart' in l && Lu(l)
              ? (l = { start: l.selectionStart, end: l.selectionEnd })
              : ((l = (
                  (l.ownerDocument && l.ownerDocument.defaultView) ||
                  window
                ).getSelection()),
                (l = {
                  anchorNode: l.anchorNode,
                  anchorOffset: l.anchorOffset,
                  focusNode: l.focusNode,
                  focusOffset: l.focusOffset,
                })),
            (Jl && $l(Jl, l)) ||
              ((Jl = l),
              (l = Ki(Hu, 'onSelect')),
              0 < l.length &&
                ((e = new Pn('onSelect', 'select', null, e, a)),
                t.push({ event: e, listeners: l }),
                (e.target = nl))));
        }
        function Ra(t, e) {
          var a = {};
          return (
            (a[t.toLowerCase()] = e.toLowerCase()),
            (a['Webkit' + t] = 'webkit' + e),
            (a['Moz' + t] = 'moz' + e),
            a
          );
        }
        var il = {
            animationend: Ra('Animation', 'AnimationEnd'),
            animationiteration: Ra('Animation', 'AnimationIteration'),
            animationstart: Ra('Animation', 'AnimationStart'),
            transitionrun: Ra('Transition', 'TransitionRun'),
            transitionstart: Ra('Transition', 'TransitionStart'),
            transitioncancel: Ra('Transition', 'TransitionCancel'),
            transitionend: Ra('Transition', 'TransitionEnd'),
          },
          qu = {},
          Lf = {};
        Ge &&
          ((Lf = document.createElement('div').style),
          'AnimationEvent' in window ||
            (delete il.animationend.animation,
            delete il.animationiteration.animation,
            delete il.animationstart.animation),
          'TransitionEvent' in window || delete il.transitionend.transition);
        function za(t) {
          if (qu[t]) return qu[t];
          if (!il[t]) return t;
          var e = il[t],
            a;
          for (a in e)
            if (e.hasOwnProperty(a) && a in Lf) return (qu[t] = e[a]);
          return t;
        }
        var Hf = za('animationend'),
          Bf = za('animationiteration'),
          qf = za('animationstart'),
          Rg = za('transitionrun'),
          zg = za('transitionstart'),
          Dg = za('transitioncancel'),
          Kf = za('transitionend'),
          Yf = new Map(),
          Ku =
            'abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel'.split(
              ' '
            );
        Ku.push('scrollEnd');
        function Re(t, e) {
          (Yf.set(t, e), _a(e, [t]));
        }
        var Gf = new WeakMap();
        function be(t, e) {
          if (typeof t == 'object' && t !== null) {
            var a = Gf.get(t);
            return a !== void 0
              ? a
              : ((e = { value: t, source: e, stack: af(e) }), Gf.set(t, e), e);
          }
          return { value: t, source: e, stack: af(e) };
        }
        var Se = [],
          ul = 0,
          Yu = 0;
        function ei() {
          for (var t = ul, e = (Yu = ul = 0); e < t; ) {
            var a = Se[e];
            Se[e++] = null;
            var l = Se[e];
            Se[e++] = null;
            var n = Se[e];
            Se[e++] = null;
            var i = Se[e];
            if (((Se[e++] = null), l !== null && n !== null)) {
              var f = l.pending;
              (f === null ? (n.next = n) : ((n.next = f.next), (f.next = n)),
                (l.pending = n));
            }
            i !== 0 && wf(a, n, i);
          }
        }
        function ai(t, e, a, l) {
          ((Se[ul++] = t),
            (Se[ul++] = e),
            (Se[ul++] = a),
            (Se[ul++] = l),
            (Yu |= l),
            (t.lanes |= l),
            (t = t.alternate),
            t !== null && (t.lanes |= l));
        }
        function Gu(t, e, a, l) {
          return (ai(t, e, a, l), li(t));
        }
        function sl(t, e) {
          return (ai(t, null, null, e), li(t));
        }
        function wf(t, e, a) {
          t.lanes |= a;
          var l = t.alternate;
          l !== null && (l.lanes |= a);
          for (var n = !1, i = t.return; i !== null; )
            ((i.childLanes |= a),
              (l = i.alternate),
              l !== null && (l.childLanes |= a),
              i.tag === 22 &&
                ((t = i.stateNode),
                t === null || t._visibility & 1 || (n = !0)),
              (t = i),
              (i = i.return));
          return t.tag === 3
            ? ((i = t.stateNode),
              n &&
                e !== null &&
                ((n = 31 - fe(a)),
                (t = i.hiddenUpdates),
                (l = t[n]),
                l === null ? (t[n] = [e]) : l.push(e),
                (e.lane = a | 536870912)),
              i)
            : null;
        }
        function li(t) {
          if (50 < Sn) throw ((Sn = 0), ($s = null), Error(s(185)));
          for (var e = t.return; e !== null; ) ((t = e), (e = t.return));
          return t.tag === 3 ? t.stateNode : null;
        }
        var cl = {};
        function Cg(t, e, a, l) {
          ((this.tag = t),
            (this.key = a),
            (this.sibling =
              this.child =
              this.return =
              this.stateNode =
              this.type =
              this.elementType =
                null),
            (this.index = 0),
            (this.refCleanup = this.ref = null),
            (this.pendingProps = e),
            (this.dependencies =
              this.memoizedState =
              this.updateQueue =
              this.memoizedProps =
                null),
            (this.mode = l),
            (this.subtreeFlags = this.flags = 0),
            (this.deletions = null),
            (this.childLanes = this.lanes = 0),
            (this.alternate = null));
        }
        function re(t, e, a, l) {
          return new Cg(t, e, a, l);
        }
        function wu(t) {
          return ((t = t.prototype), !(!t || !t.isReactComponent));
        }
        function we(t, e) {
          var a = t.alternate;
          return (
            a === null
              ? ((a = re(t.tag, e, t.key, t.mode)),
                (a.elementType = t.elementType),
                (a.type = t.type),
                (a.stateNode = t.stateNode),
                (a.alternate = t),
                (t.alternate = a))
              : ((a.pendingProps = e),
                (a.type = t.type),
                (a.flags = 0),
                (a.subtreeFlags = 0),
                (a.deletions = null)),
            (a.flags = t.flags & 65011712),
            (a.childLanes = t.childLanes),
            (a.lanes = t.lanes),
            (a.child = t.child),
            (a.memoizedProps = t.memoizedProps),
            (a.memoizedState = t.memoizedState),
            (a.updateQueue = t.updateQueue),
            (e = t.dependencies),
            (a.dependencies =
              e === null
                ? null
                : { lanes: e.lanes, firstContext: e.firstContext }),
            (a.sibling = t.sibling),
            (a.index = t.index),
            (a.ref = t.ref),
            (a.refCleanup = t.refCleanup),
            a
          );
        }
        function Vf(t, e) {
          t.flags &= 65011714;
          var a = t.alternate;
          return (
            a === null
              ? ((t.childLanes = 0),
                (t.lanes = e),
                (t.child = null),
                (t.subtreeFlags = 0),
                (t.memoizedProps = null),
                (t.memoizedState = null),
                (t.updateQueue = null),
                (t.dependencies = null),
                (t.stateNode = null))
              : ((t.childLanes = a.childLanes),
                (t.lanes = a.lanes),
                (t.child = a.child),
                (t.subtreeFlags = 0),
                (t.deletions = null),
                (t.memoizedProps = a.memoizedProps),
                (t.memoizedState = a.memoizedState),
                (t.updateQueue = a.updateQueue),
                (t.type = a.type),
                (e = a.dependencies),
                (t.dependencies =
                  e === null
                    ? null
                    : { lanes: e.lanes, firstContext: e.firstContext })),
            t
          );
        }
        function ni(t, e, a, l, n, i) {
          var f = 0;
          if (((l = t), typeof t == 'function')) wu(t) && (f = 1);
          else if (typeof t == 'string')
            f = jm(t, a, X.current)
              ? 26
              : t === 'html' || t === 'head' || t === 'body'
                ? 27
                : 5;
          else
            t: switch (t) {
              case Et:
                return (
                  (t = re(31, a, e, n)),
                  (t.elementType = Et),
                  (t.lanes = i),
                  t
                );
              case q:
                return Da(a.children, n, i, e);
              case Q:
                ((f = 8), (n |= 24));
                break;
              case P:
                return (
                  (t = re(12, a, e, n | 2)),
                  (t.elementType = P),
                  (t.lanes = i),
                  t
                );
              case w:
                return (
                  (t = re(13, a, e, n)),
                  (t.elementType = w),
                  (t.lanes = i),
                  t
                );
              case st:
                return (
                  (t = re(19, a, e, n)),
                  (t.elementType = st),
                  (t.lanes = i),
                  t
                );
              default:
                if (typeof t == 'object' && t !== null)
                  switch (t.$$typeof) {
                    case ht:
                    case W:
                      f = 10;
                      break t;
                    case tt:
                      f = 9;
                      break t;
                    case I:
                      f = 11;
                      break t;
                    case ut:
                      f = 14;
                      break t;
                    case Mt:
                      ((f = 16), (l = null));
                      break t;
                  }
                ((f = 29),
                  (a = Error(s(130, t === null ? 'null' : typeof t, ''))),
                  (l = null));
            }
          return (
            (e = re(f, a, e, n)),
            (e.elementType = t),
            (e.type = l),
            (e.lanes = i),
            e
          );
        }
        function Da(t, e, a, l) {
          return ((t = re(7, t, l, e)), (t.lanes = a), t);
        }
        function Vu(t, e, a) {
          return ((t = re(6, t, null, e)), (t.lanes = a), t);
        }
        function Xu(t, e, a) {
          return (
            (e = re(4, t.children !== null ? t.children : [], t.key, e)),
            (e.lanes = a),
            (e.stateNode = {
              containerInfo: t.containerInfo,
              pendingChildren: null,
              implementation: t.implementation,
            }),
            e
          );
        }
        var fl = [],
          ol = 0,
          ii = null,
          ui = 0,
          xe = [],
          Ae = 0,
          Ca = null,
          Ve = 1,
          Xe = '';
        function Ua(t, e) {
          ((fl[ol++] = ui), (fl[ol++] = ii), (ii = t), (ui = e));
        }
        function Xf(t, e, a) {
          ((xe[Ae++] = Ve), (xe[Ae++] = Xe), (xe[Ae++] = Ca), (Ca = t));
          var l = Ve;
          t = Xe;
          var n = 32 - fe(l) - 1;
          ((l &= ~(1 << n)), (a += 1));
          var i = 32 - fe(e) + n;
          if (30 < i) {
            var f = n - (n % 5);
            ((i = (l & ((1 << f) - 1)).toString(32)),
              (l >>= f),
              (n -= f),
              (Ve = (1 << (32 - fe(e) + n)) | (a << n) | l),
              (Xe = i + t));
          } else ((Ve = (1 << i) | (a << n) | l), (Xe = t));
        }
        function Qu(t) {
          t.return !== null && (Ua(t, 1), Xf(t, 1, 0));
        }
        function Zu(t) {
          for (; t === ii; )
            ((ii = fl[--ol]),
              (fl[ol] = null),
              (ui = fl[--ol]),
              (fl[ol] = null));
          for (; t === Ca; )
            ((Ca = xe[--Ae]),
              (xe[Ae] = null),
              (Xe = xe[--Ae]),
              (xe[Ae] = null),
              (Ve = xe[--Ae]),
              (xe[Ae] = null));
        }
        var Pt = null,
          _t = null,
          dt = !1,
          ja = null,
          je = !1,
          $u = Error(s(519));
        function La(t) {
          var e = Error(s(418, ''));
          throw (Fl(be(e, t)), $u);
        }
        function Qf(t) {
          var e = t.stateNode,
            a = t.type,
            l = t.memoizedProps;
          switch (((e[kt] = t), (e[ee] = l), a)) {
            case 'dialog':
              (it('cancel', e), it('close', e));
              break;
            case 'iframe':
            case 'object':
            case 'embed':
              it('load', e);
              break;
            case 'video':
            case 'audio':
              for (a = 0; a < An.length; a++) it(An[a], e);
              break;
            case 'source':
              it('error', e);
              break;
            case 'img':
            case 'image':
            case 'link':
              (it('error', e), it('load', e));
              break;
            case 'details':
              it('toggle', e);
              break;
            case 'input':
              (it('invalid', e),
                uf(
                  e,
                  l.value,
                  l.defaultValue,
                  l.checked,
                  l.defaultChecked,
                  l.type,
                  l.name,
                  !0
                ),
                Zn(e));
              break;
            case 'select':
              it('invalid', e);
              break;
            case 'textarea':
              (it('invalid', e),
                cf(e, l.value, l.defaultValue, l.children),
                Zn(e));
          }
          ((a = l.children),
            (typeof a != 'string' &&
              typeof a != 'number' &&
              typeof a != 'bigint') ||
            e.textContent === '' + a ||
            l.suppressHydrationWarning === !0 ||
            fd(e.textContent, a)
              ? (l.popover != null && (it('beforetoggle', e), it('toggle', e)),
                l.onScroll != null && it('scroll', e),
                l.onScrollEnd != null && it('scrollend', e),
                l.onClick != null && (e.onclick = Yi),
                (e = !0))
              : (e = !1),
            e || La(t));
        }
        function Zf(t) {
          for (Pt = t.return; Pt; )
            switch (Pt.tag) {
              case 5:
              case 13:
                je = !1;
                return;
              case 27:
              case 3:
                je = !0;
                return;
              default:
                Pt = Pt.return;
            }
        }
        function kl(t) {
          if (t !== Pt) return !1;
          if (!dt) return (Zf(t), (dt = !0), !1);
          var e = t.tag,
            a;
          if (
            ((a = e !== 3 && e !== 27) &&
              ((a = e === 5) &&
                ((a = t.type),
                (a =
                  !(a !== 'form' && a !== 'button') ||
                  fc(t.type, t.memoizedProps))),
              (a = !a)),
            a && _t && La(t),
            Zf(t),
            e === 13)
          ) {
            if (
              ((t = t.memoizedState),
              (t = t !== null ? t.dehydrated : null),
              !t)
            )
              throw Error(s(317));
            t: {
              for (t = t.nextSibling, e = 0; t; ) {
                if (t.nodeType === 8)
                  if (((a = t.data), a === '/$')) {
                    if (e === 0) {
                      _t = De(t.nextSibling);
                      break t;
                    }
                    e--;
                  } else (a !== '$' && a !== '$!' && a !== '$?') || e++;
                t = t.nextSibling;
              }
              _t = null;
            }
          } else
            e === 27
              ? ((e = _t),
                Sa(t.type) ? ((t = hc), (hc = null), (_t = t)) : (_t = e))
              : (_t = Pt ? De(t.stateNode.nextSibling) : null);
          return !0;
        }
        function Wl() {
          ((_t = Pt = null), (dt = !1));
        }
        function $f() {
          var t = ja;
          return (
            t !== null &&
              (ie === null ? (ie = t) : ie.push.apply(ie, t), (ja = null)),
            t
          );
        }
        function Fl(t) {
          ja === null ? (ja = [t]) : ja.push(t);
        }
        var Ju = D(null),
          Ha = null,
          Qe = null;
        function ia(t, e, a) {
          (H(Ju, e._currentValue), (e._currentValue = a));
        }
        function Ze(t) {
          ((t._currentValue = Ju.current), B(Ju));
        }
        function ku(t, e, a) {
          for (; t !== null; ) {
            var l = t.alternate;
            if (
              ((t.childLanes & e) !== e
                ? ((t.childLanes |= e), l !== null && (l.childLanes |= e))
                : l !== null && (l.childLanes & e) !== e && (l.childLanes |= e),
              t === a)
            )
              break;
            t = t.return;
          }
        }
        function Wu(t, e, a, l) {
          var n = t.child;
          for (n !== null && (n.return = t); n !== null; ) {
            var i = n.dependencies;
            if (i !== null) {
              var f = n.child;
              i = i.firstContext;
              t: for (; i !== null; ) {
                var d = i;
                i = n;
                for (var y = 0; y < e.length; y++)
                  if (d.context === e[y]) {
                    ((i.lanes |= a),
                      (d = i.alternate),
                      d !== null && (d.lanes |= a),
                      ku(i.return, a, t),
                      l || (f = null));
                    break t;
                  }
                i = d.next;
              }
            } else if (n.tag === 18) {
              if (((f = n.return), f === null)) throw Error(s(341));
              ((f.lanes |= a),
                (i = f.alternate),
                i !== null && (i.lanes |= a),
                ku(f, a, t),
                (f = null));
            } else f = n.child;
            if (f !== null) f.return = n;
            else
              for (f = n; f !== null; ) {
                if (f === t) {
                  f = null;
                  break;
                }
                if (((n = f.sibling), n !== null)) {
                  ((n.return = f.return), (f = n));
                  break;
                }
                f = f.return;
              }
            n = f;
          }
        }
        function Pl(t, e, a, l) {
          t = null;
          for (var n = e, i = !1; n !== null; ) {
            if (!i) {
              if ((n.flags & 524288) !== 0) i = !0;
              else if ((n.flags & 262144) !== 0) break;
            }
            if (n.tag === 10) {
              var f = n.alternate;
              if (f === null) throw Error(s(387));
              if (((f = f.memoizedProps), f !== null)) {
                var d = n.type;
                oe(n.pendingProps.value, f.value) ||
                  (t !== null ? t.push(d) : (t = [d]));
              }
            } else if (n === se.current) {
              if (((f = n.alternate), f === null)) throw Error(s(387));
              f.memoizedState.memoizedState !== n.memoizedState.memoizedState &&
                (t !== null ? t.push(Nn) : (t = [Nn]));
            }
            n = n.return;
          }
          (t !== null && Wu(e, t, a, l), (e.flags |= 262144));
        }
        function si(t) {
          for (t = t.firstContext; t !== null; ) {
            if (!oe(t.context._currentValue, t.memoizedValue)) return !0;
            t = t.next;
          }
          return !1;
        }
        function Ba(t) {
          ((Ha = t),
            (Qe = null),
            (t = t.dependencies),
            t !== null && (t.firstContext = null));
        }
        function Wt(t) {
          return Jf(Ha, t);
        }
        function ci(t, e) {
          return (Ha === null && Ba(t), Jf(t, e));
        }
        function Jf(t, e) {
          var a = e._currentValue;
          if (
            ((e = { context: e, memoizedValue: a, next: null }), Qe === null)
          ) {
            if (t === null) throw Error(s(308));
            ((Qe = e),
              (t.dependencies = { lanes: 0, firstContext: e }),
              (t.flags |= 524288));
          } else Qe = Qe.next = e;
          return a;
        }
        var Ug =
            typeof AbortController < 'u'
              ? AbortController
              : function () {
                  var t = [],
                    e = (this.signal = {
                      aborted: !1,
                      addEventListener: function (a, l) {
                        t.push(l);
                      },
                    });
                  this.abort = function () {
                    ((e.aborted = !0),
                      t.forEach(function (a) {
                        return a();
                      }));
                  };
                },
          jg = r.unstable_scheduleCallback,
          Lg = r.unstable_NormalPriority,
          Kt = {
            $$typeof: W,
            Consumer: null,
            Provider: null,
            _currentValue: null,
            _currentValue2: null,
            _threadCount: 0,
          };
        function Fu() {
          return { controller: new Ug(), data: new Map(), refCount: 0 };
        }
        function Il(t) {
          (t.refCount--,
            t.refCount === 0 &&
              jg(Lg, function () {
                t.controller.abort();
              }));
        }
        var tn = null,
          Pu = 0,
          rl = 0,
          dl = null;
        function Hg(t, e) {
          if (tn === null) {
            var a = (tn = []);
            ((Pu = 0),
              (rl = tc()),
              (dl = {
                status: 'pending',
                value: void 0,
                then: function (l) {
                  a.push(l);
                },
              }));
          }
          return (Pu++, e.then(kf, kf), e);
        }
        function kf() {
          if (--Pu === 0 && tn !== null) {
            dl !== null && (dl.status = 'fulfilled');
            var t = tn;
            ((tn = null), (rl = 0), (dl = null));
            for (var e = 0; e < t.length; e++) (0, t[e])();
          }
        }
        function Bg(t, e) {
          var a = [],
            l = {
              status: 'pending',
              value: null,
              reason: null,
              then: function (n) {
                a.push(n);
              },
            };
          return (
            t.then(
              function () {
                ((l.status = 'fulfilled'), (l.value = e));
                for (var n = 0; n < a.length; n++) (0, a[n])(e);
              },
              function (n) {
                for (
                  l.status = 'rejected', l.reason = n, n = 0;
                  n < a.length;
                  n++
                )
                  (0, a[n])(void 0);
              }
            ),
            l
          );
        }
        var Wf = _.S;
        _.S = function (t, e) {
          (typeof e == 'object' &&
            e !== null &&
            typeof e.then == 'function' &&
            Hg(t, e),
            Wf !== null && Wf(t, e));
        };
        var qa = D(null);
        function Iu() {
          var t = qa.current;
          return t !== null ? t : xt.pooledCache;
        }
        function fi(t, e) {
          e === null ? H(qa, qa.current) : H(qa, e.pool);
        }
        function Ff() {
          var t = Iu();
          return t === null ? null : { parent: Kt._currentValue, pool: t };
        }
        var en = Error(s(460)),
          Pf = Error(s(474)),
          oi = Error(s(542)),
          ts = { then: function () {} };
        function If(t) {
          return ((t = t.status), t === 'fulfilled' || t === 'rejected');
        }
        function ri() {}
        function to(t, e, a) {
          switch (
            ((a = t[a]),
            a === void 0 ? t.push(e) : a !== e && (e.then(ri, ri), (e = a)),
            e.status)
          ) {
            case 'fulfilled':
              return e.value;
            case 'rejected':
              throw ((t = e.reason), ao(t), t);
            default:
              if (typeof e.status == 'string') e.then(ri, ri);
              else {
                if (((t = xt), t !== null && 100 < t.shellSuspendCounter))
                  throw Error(s(482));
                ((t = e),
                  (t.status = 'pending'),
                  t.then(
                    function (l) {
                      if (e.status === 'pending') {
                        var n = e;
                        ((n.status = 'fulfilled'), (n.value = l));
                      }
                    },
                    function (l) {
                      if (e.status === 'pending') {
                        var n = e;
                        ((n.status = 'rejected'), (n.reason = l));
                      }
                    }
                  ));
              }
              switch (e.status) {
                case 'fulfilled':
                  return e.value;
                case 'rejected':
                  throw ((t = e.reason), ao(t), t);
              }
              throw ((an = e), en);
          }
        }
        var an = null;
        function eo() {
          if (an === null) throw Error(s(459));
          var t = an;
          return ((an = null), t);
        }
        function ao(t) {
          if (t === en || t === oi) throw Error(s(483));
        }
        var ua = !1;
        function es(t) {
          t.updateQueue = {
            baseState: t.memoizedState,
            firstBaseUpdate: null,
            lastBaseUpdate: null,
            shared: { pending: null, lanes: 0, hiddenCallbacks: null },
            callbacks: null,
          };
        }
        function as(t, e) {
          ((t = t.updateQueue),
            e.updateQueue === t &&
              (e.updateQueue = {
                baseState: t.baseState,
                firstBaseUpdate: t.firstBaseUpdate,
                lastBaseUpdate: t.lastBaseUpdate,
                shared: t.shared,
                callbacks: null,
              }));
        }
        function sa(t) {
          return { lane: t, tag: 0, payload: null, callback: null, next: null };
        }
        function ca(t, e, a) {
          var l = t.updateQueue;
          if (l === null) return null;
          if (((l = l.shared), (gt & 2) !== 0)) {
            var n = l.pending;
            return (
              n === null ? (e.next = e) : ((e.next = n.next), (n.next = e)),
              (l.pending = e),
              (e = li(t)),
              wf(t, null, a),
              e
            );
          }
          return (ai(t, l, e, a), li(t));
        }
        function ln(t, e, a) {
          if (
            ((e = e.updateQueue),
            e !== null && ((e = e.shared), (a & 4194048) !== 0))
          ) {
            var l = e.lanes;
            ((l &= t.pendingLanes), (a |= l), (e.lanes = a), Jc(t, a));
          }
        }
        function ls(t, e) {
          var a = t.updateQueue,
            l = t.alternate;
          if (l !== null && ((l = l.updateQueue), a === l)) {
            var n = null,
              i = null;
            if (((a = a.firstBaseUpdate), a !== null)) {
              do {
                var f = {
                  lane: a.lane,
                  tag: a.tag,
                  payload: a.payload,
                  callback: null,
                  next: null,
                };
                (i === null ? (n = i = f) : (i = i.next = f), (a = a.next));
              } while (a !== null);
              i === null ? (n = i = e) : (i = i.next = e);
            } else n = i = e;
            ((a = {
              baseState: l.baseState,
              firstBaseUpdate: n,
              lastBaseUpdate: i,
              shared: l.shared,
              callbacks: l.callbacks,
            }),
              (t.updateQueue = a));
            return;
          }
          ((t = a.lastBaseUpdate),
            t === null ? (a.firstBaseUpdate = e) : (t.next = e),
            (a.lastBaseUpdate = e));
        }
        var ns = !1;
        function nn() {
          if (ns) {
            var t = dl;
            if (t !== null) throw t;
          }
        }
        function un(t, e, a, l) {
          ns = !1;
          var n = t.updateQueue;
          ua = !1;
          var i = n.firstBaseUpdate,
            f = n.lastBaseUpdate,
            d = n.shared.pending;
          if (d !== null) {
            n.shared.pending = null;
            var y = d,
              E = y.next;
            ((y.next = null), f === null ? (i = E) : (f.next = E), (f = y));
            var R = t.alternate;
            R !== null &&
              ((R = R.updateQueue),
              (d = R.lastBaseUpdate),
              d !== f &&
                (d === null ? (R.firstBaseUpdate = E) : (d.next = E),
                (R.lastBaseUpdate = y)));
          }
          if (i !== null) {
            var U = n.baseState;
            ((f = 0), (R = E = y = null), (d = i));
            do {
              var O = d.lane & -536870913,
                M = O !== d.lane;
              if (M ? (ct & O) === O : (l & O) === O) {
                (O !== 0 && O === rl && (ns = !0),
                  R !== null &&
                    (R = R.next =
                      {
                        lane: 0,
                        tag: d.tag,
                        payload: d.payload,
                        callback: null,
                        next: null,
                      }));
                t: {
                  var J = t,
                    Z = d;
                  O = e;
                  var bt = a;
                  switch (Z.tag) {
                    case 1:
                      if (((J = Z.payload), typeof J == 'function')) {
                        U = J.call(bt, U, O);
                        break t;
                      }
                      U = J;
                      break t;
                    case 3:
                      J.flags = (J.flags & -65537) | 128;
                    case 0:
                      if (
                        ((J = Z.payload),
                        (O = typeof J == 'function' ? J.call(bt, U, O) : J),
                        O == null)
                      )
                        break t;
                      U = A({}, U, O);
                      break t;
                    case 2:
                      ua = !0;
                  }
                }
                ((O = d.callback),
                  O !== null &&
                    ((t.flags |= 64),
                    M && (t.flags |= 8192),
                    (M = n.callbacks),
                    M === null ? (n.callbacks = [O]) : M.push(O)));
              } else
                ((M = {
                  lane: O,
                  tag: d.tag,
                  payload: d.payload,
                  callback: d.callback,
                  next: null,
                }),
                  R === null ? ((E = R = M), (y = U)) : (R = R.next = M),
                  (f |= O));
              if (((d = d.next), d === null)) {
                if (((d = n.shared.pending), d === null)) break;
                ((M = d),
                  (d = M.next),
                  (M.next = null),
                  (n.lastBaseUpdate = M),
                  (n.shared.pending = null));
              }
            } while (!0);
            (R === null && (y = U),
              (n.baseState = y),
              (n.firstBaseUpdate = E),
              (n.lastBaseUpdate = R),
              i === null && (n.shared.lanes = 0),
              (ya |= f),
              (t.lanes = f),
              (t.memoizedState = U));
          }
        }
        function lo(t, e) {
          if (typeof t != 'function') throw Error(s(191, t));
          t.call(e);
        }
        function no(t, e) {
          var a = t.callbacks;
          if (a !== null)
            for (t.callbacks = null, t = 0; t < a.length; t++) lo(a[t], e);
        }
        var hl = D(null),
          di = D(0);
        function io(t, e) {
          ((t = Ie), H(di, t), H(hl, e), (Ie = t | e.baseLanes));
        }
        function is() {
          (H(di, Ie), H(hl, hl.current));
        }
        function us() {
          ((Ie = di.current), B(hl), B(di));
        }
        var fa = 0,
          at = null,
          pt = null,
          Bt = null,
          hi = !1,
          gl = !1,
          Ka = !1,
          gi = 0,
          sn = 0,
          ml = null,
          qg = 0;
        function Ct() {
          throw Error(s(321));
        }
        function ss(t, e) {
          if (e === null) return !1;
          for (var a = 0; a < e.length && a < t.length; a++)
            if (!oe(t[a], e[a])) return !1;
          return !0;
        }
        function cs(t, e, a, l, n, i) {
          return (
            (fa = i),
            (at = e),
            (e.memoizedState = null),
            (e.updateQueue = null),
            (e.lanes = 0),
            (_.H = t === null || t.memoizedState === null ? Vo : Xo),
            (Ka = !1),
            (i = a(l, n)),
            (Ka = !1),
            gl && (i = so(e, a, l, n)),
            uo(t),
            i
          );
        }
        function uo(t) {
          _.H = Si;
          var e = pt !== null && pt.next !== null;
          if (
            ((fa = 0),
            (Bt = pt = at = null),
            (hi = !1),
            (sn = 0),
            (ml = null),
            e)
          )
            throw Error(s(300));
          t === null ||
            wt ||
            ((t = t.dependencies), t !== null && si(t) && (wt = !0));
        }
        function so(t, e, a, l) {
          at = t;
          var n = 0;
          do {
            if ((gl && (ml = null), (sn = 0), (gl = !1), 25 <= n))
              throw Error(s(301));
            if (((n += 1), (Bt = pt = null), t.updateQueue != null)) {
              var i = t.updateQueue;
              ((i.lastEffect = null),
                (i.events = null),
                (i.stores = null),
                i.memoCache != null && (i.memoCache.index = 0));
            }
            ((_.H = Qg), (i = e(a, l)));
          } while (gl);
          return i;
        }
        function Kg() {
          var t = _.H,
            e = t.useState()[0];
          return (
            (e = typeof e.then == 'function' ? cn(e) : e),
            (t = t.useState()[0]),
            (pt !== null ? pt.memoizedState : null) !== t && (at.flags |= 1024),
            e
          );
        }
        function fs() {
          var t = gi !== 0;
          return ((gi = 0), t);
        }
        function os(t, e, a) {
          ((e.updateQueue = t.updateQueue),
            (e.flags &= -2053),
            (t.lanes &= ~a));
        }
        function rs(t) {
          if (hi) {
            for (t = t.memoizedState; t !== null; ) {
              var e = t.queue;
              (e !== null && (e.pending = null), (t = t.next));
            }
            hi = !1;
          }
          ((fa = 0),
            (Bt = pt = at = null),
            (gl = !1),
            (sn = gi = 0),
            (ml = null));
        }
        function le() {
          var t = {
            memoizedState: null,
            baseState: null,
            baseQueue: null,
            queue: null,
            next: null,
          };
          return (
            Bt === null ? (at.memoizedState = Bt = t) : (Bt = Bt.next = t),
            Bt
          );
        }
        function qt() {
          if (pt === null) {
            var t = at.alternate;
            t = t !== null ? t.memoizedState : null;
          } else t = pt.next;
          var e = Bt === null ? at.memoizedState : Bt.next;
          if (e !== null) ((Bt = e), (pt = t));
          else {
            if (t === null)
              throw at.alternate === null ? Error(s(467)) : Error(s(310));
            ((pt = t),
              (t = {
                memoizedState: pt.memoizedState,
                baseState: pt.baseState,
                baseQueue: pt.baseQueue,
                queue: pt.queue,
                next: null,
              }),
              Bt === null ? (at.memoizedState = Bt = t) : (Bt = Bt.next = t));
          }
          return Bt;
        }
        function ds() {
          return {
            lastEffect: null,
            events: null,
            stores: null,
            memoCache: null,
          };
        }
        function cn(t) {
          var e = sn;
          return (
            (sn += 1),
            ml === null && (ml = []),
            (t = to(ml, t, e)),
            (e = at),
            (Bt === null ? e.memoizedState : Bt.next) === null &&
              ((e = e.alternate),
              (_.H = e === null || e.memoizedState === null ? Vo : Xo)),
            t
          );
        }
        function mi(t) {
          if (t !== null && typeof t == 'object') {
            if (typeof t.then == 'function') return cn(t);
            if (t.$$typeof === W) return Wt(t);
          }
          throw Error(s(438, String(t)));
        }
        function hs(t) {
          var e = null,
            a = at.updateQueue;
          if ((a !== null && (e = a.memoCache), e == null)) {
            var l = at.alternate;
            l !== null &&
              ((l = l.updateQueue),
              l !== null &&
                ((l = l.memoCache),
                l != null &&
                  (e = {
                    data: l.data.map(function (n) {
                      return n.slice();
                    }),
                    index: 0,
                  })));
          }
          if (
            (e == null && (e = { data: [], index: 0 }),
            a === null && ((a = ds()), (at.updateQueue = a)),
            (a.memoCache = e),
            (a = e.data[e.index]),
            a === void 0)
          )
            for (a = e.data[e.index] = Array(t), l = 0; l < t; l++) a[l] = Lt;
          return (e.index++, a);
        }
        function $e(t, e) {
          return typeof e == 'function' ? e(t) : e;
        }
        function yi(t) {
          var e = qt();
          return gs(e, pt, t);
        }
        function gs(t, e, a) {
          var l = t.queue;
          if (l === null) throw Error(s(311));
          l.lastRenderedReducer = a;
          var n = t.baseQueue,
            i = l.pending;
          if (i !== null) {
            if (n !== null) {
              var f = n.next;
              ((n.next = i.next), (i.next = f));
            }
            ((e.baseQueue = n = i), (l.pending = null));
          }
          if (((i = t.baseState), n === null)) t.memoizedState = i;
          else {
            e = n.next;
            var d = (f = null),
              y = null,
              E = e,
              R = !1;
            do {
              var U = E.lane & -536870913;
              if (U !== E.lane ? (ct & U) === U : (fa & U) === U) {
                var O = E.revertLane;
                if (O === 0)
                  (y !== null &&
                    (y = y.next =
                      {
                        lane: 0,
                        revertLane: 0,
                        action: E.action,
                        hasEagerState: E.hasEagerState,
                        eagerState: E.eagerState,
                        next: null,
                      }),
                    U === rl && (R = !0));
                else if ((fa & O) === O) {
                  ((E = E.next), O === rl && (R = !0));
                  continue;
                } else
                  ((U = {
                    lane: 0,
                    revertLane: E.revertLane,
                    action: E.action,
                    hasEagerState: E.hasEagerState,
                    eagerState: E.eagerState,
                    next: null,
                  }),
                    y === null ? ((d = y = U), (f = i)) : (y = y.next = U),
                    (at.lanes |= O),
                    (ya |= O));
                ((U = E.action),
                  Ka && a(i, U),
                  (i = E.hasEagerState ? E.eagerState : a(i, U)));
              } else
                ((O = {
                  lane: U,
                  revertLane: E.revertLane,
                  action: E.action,
                  hasEagerState: E.hasEagerState,
                  eagerState: E.eagerState,
                  next: null,
                }),
                  y === null ? ((d = y = O), (f = i)) : (y = y.next = O),
                  (at.lanes |= U),
                  (ya |= U));
              E = E.next;
            } while (E !== null && E !== e);
            if (
              (y === null ? (f = i) : (y.next = d),
              !oe(i, t.memoizedState) &&
                ((wt = !0), R && ((a = dl), a !== null)))
            )
              throw a;
            ((t.memoizedState = i),
              (t.baseState = f),
              (t.baseQueue = y),
              (l.lastRenderedState = i));
          }
          return (n === null && (l.lanes = 0), [t.memoizedState, l.dispatch]);
        }
        function ms(t) {
          var e = qt(),
            a = e.queue;
          if (a === null) throw Error(s(311));
          a.lastRenderedReducer = t;
          var l = a.dispatch,
            n = a.pending,
            i = e.memoizedState;
          if (n !== null) {
            a.pending = null;
            var f = (n = n.next);
            do ((i = t(i, f.action)), (f = f.next));
            while (f !== n);
            (oe(i, e.memoizedState) || (wt = !0),
              (e.memoizedState = i),
              e.baseQueue === null && (e.baseState = i),
              (a.lastRenderedState = i));
          }
          return [i, l];
        }
        function co(t, e, a) {
          var l = at,
            n = qt(),
            i = dt;
          if (i) {
            if (a === void 0) throw Error(s(407));
            a = a();
          } else a = e();
          var f = !oe((pt || n).memoizedState, a);
          (f && ((n.memoizedState = a), (wt = !0)), (n = n.queue));
          var d = ro.bind(null, l, n, t);
          if (
            (fn(2048, 8, d, [t]),
            n.getSnapshot !== e ||
              f ||
              (Bt !== null && Bt.memoizedState.tag & 1))
          ) {
            if (
              ((l.flags |= 2048),
              yl(9, pi(), oo.bind(null, l, n, a, e), null),
              xt === null)
            )
              throw Error(s(349));
            i || (fa & 124) !== 0 || fo(l, e, a);
          }
          return a;
        }
        function fo(t, e, a) {
          ((t.flags |= 16384),
            (t = { getSnapshot: e, value: a }),
            (e = at.updateQueue),
            e === null
              ? ((e = ds()), (at.updateQueue = e), (e.stores = [t]))
              : ((a = e.stores), a === null ? (e.stores = [t]) : a.push(t)));
        }
        function oo(t, e, a, l) {
          ((e.value = a), (e.getSnapshot = l), ho(e) && go(t));
        }
        function ro(t, e, a) {
          return a(function () {
            ho(e) && go(t);
          });
        }
        function ho(t) {
          var e = t.getSnapshot;
          t = t.value;
          try {
            var a = e();
            return !oe(t, a);
          } catch {
            return !0;
          }
        }
        function go(t) {
          var e = sl(t, 2);
          e !== null && ye(e, t, 2);
        }
        function ys(t) {
          var e = le();
          if (typeof t == 'function') {
            var a = t;
            if (((t = a()), Ka)) {
              aa(!0);
              try {
                a();
              } finally {
                aa(!1);
              }
            }
          }
          return (
            (e.memoizedState = e.baseState = t),
            (e.queue = {
              pending: null,
              lanes: 0,
              dispatch: null,
              lastRenderedReducer: $e,
              lastRenderedState: t,
            }),
            e
          );
        }
        function mo(t, e, a, l) {
          return (
            (t.baseState = a),
            gs(t, pt, typeof l == 'function' ? l : $e)
          );
        }
        function Yg(t, e, a, l, n) {
          if (bi(t)) throw Error(s(485));
          if (((t = e.action), t !== null)) {
            var i = {
              payload: n,
              action: t,
              next: null,
              isTransition: !0,
              status: 'pending',
              value: null,
              reason: null,
              listeners: [],
              then: function (f) {
                i.listeners.push(f);
              },
            };
            (_.T !== null ? a(!0) : (i.isTransition = !1),
              l(i),
              (a = e.pending),
              a === null
                ? ((i.next = e.pending = i), yo(e, i))
                : ((i.next = a.next), (e.pending = a.next = i)));
          }
        }
        function yo(t, e) {
          var a = e.action,
            l = e.payload,
            n = t.state;
          if (e.isTransition) {
            var i = _.T,
              f = {};
            _.T = f;
            try {
              var d = a(n, l),
                y = _.S;
              (y !== null && y(f, d), po(t, e, d));
            } catch (E) {
              ps(t, e, E);
            } finally {
              _.T = i;
            }
          } else
            try {
              ((i = a(n, l)), po(t, e, i));
            } catch (E) {
              ps(t, e, E);
            }
        }
        function po(t, e, a) {
          a !== null && typeof a == 'object' && typeof a.then == 'function'
            ? a.then(
                function (l) {
                  vo(t, e, l);
                },
                function (l) {
                  return ps(t, e, l);
                }
              )
            : vo(t, e, a);
        }
        function vo(t, e, a) {
          ((e.status = 'fulfilled'),
            (e.value = a),
            bo(e),
            (t.state = a),
            (e = t.pending),
            e !== null &&
              ((a = e.next),
              a === e
                ? (t.pending = null)
                : ((a = a.next), (e.next = a), yo(t, a))));
        }
        function ps(t, e, a) {
          var l = t.pending;
          if (((t.pending = null), l !== null)) {
            l = l.next;
            do ((e.status = 'rejected'), (e.reason = a), bo(e), (e = e.next));
            while (e !== l);
          }
          t.action = null;
        }
        function bo(t) {
          t = t.listeners;
          for (var e = 0; e < t.length; e++) (0, t[e])();
        }
        function So(t, e) {
          return e;
        }
        function xo(t, e) {
          if (dt) {
            var a = xt.formState;
            if (a !== null) {
              t: {
                var l = at;
                if (dt) {
                  if (_t) {
                    e: {
                      for (var n = _t, i = je; n.nodeType !== 8; ) {
                        if (!i) {
                          n = null;
                          break e;
                        }
                        if (((n = De(n.nextSibling)), n === null)) {
                          n = null;
                          break e;
                        }
                      }
                      ((i = n.data), (n = i === 'F!' || i === 'F' ? n : null));
                    }
                    if (n) {
                      ((_t = De(n.nextSibling)), (l = n.data === 'F!'));
                      break t;
                    }
                  }
                  La(l);
                }
                l = !1;
              }
              l && (e = a[0]);
            }
          }
          return (
            (a = le()),
            (a.memoizedState = a.baseState = e),
            (l = {
              pending: null,
              lanes: 0,
              dispatch: null,
              lastRenderedReducer: So,
              lastRenderedState: e,
            }),
            (a.queue = l),
            (a = Yo.bind(null, at, l)),
            (l.dispatch = a),
            (l = ys(!1)),
            (i = As.bind(null, at, !1, l.queue)),
            (l = le()),
            (n = { state: e, dispatch: null, action: t, pending: null }),
            (l.queue = n),
            (a = Yg.bind(null, at, n, i, a)),
            (n.dispatch = a),
            (l.memoizedState = t),
            [e, a, !1]
          );
        }
        function Ao(t) {
          var e = qt();
          return To(e, pt, t);
        }
        function To(t, e, a) {
          if (
            ((e = gs(t, e, So)[0]),
            (t = yi($e)[0]),
            typeof e == 'object' && e !== null && typeof e.then == 'function')
          )
            try {
              var l = cn(e);
            } catch (f) {
              throw f === en ? oi : f;
            }
          else l = e;
          e = qt();
          var n = e.queue,
            i = n.dispatch;
          return (
            a !== e.memoizedState &&
              ((at.flags |= 2048), yl(9, pi(), Gg.bind(null, n, a), null)),
            [l, i, t]
          );
        }
        function Gg(t, e) {
          t.action = e;
        }
        function Eo(t) {
          var e = qt(),
            a = pt;
          if (a !== null) return To(e, a, t);
          (qt(), (e = e.memoizedState), (a = qt()));
          var l = a.queue.dispatch;
          return ((a.memoizedState = t), [e, l, !1]);
        }
        function yl(t, e, a, l) {
          return (
            (t = { tag: t, create: a, deps: l, inst: e, next: null }),
            (e = at.updateQueue),
            e === null && ((e = ds()), (at.updateQueue = e)),
            (a = e.lastEffect),
            a === null
              ? (e.lastEffect = t.next = t)
              : ((l = a.next), (a.next = t), (t.next = l), (e.lastEffect = t)),
            t
          );
        }
        function pi() {
          return { destroy: void 0, resource: void 0 };
        }
        function Oo() {
          return qt().memoizedState;
        }
        function vi(t, e, a, l) {
          var n = le();
          ((l = l === void 0 ? null : l),
            (at.flags |= t),
            (n.memoizedState = yl(1 | e, pi(), a, l)));
        }
        function fn(t, e, a, l) {
          var n = qt();
          l = l === void 0 ? null : l;
          var i = n.memoizedState.inst;
          pt !== null && l !== null && ss(l, pt.memoizedState.deps)
            ? (n.memoizedState = yl(e, i, a, l))
            : ((at.flags |= t), (n.memoizedState = yl(1 | e, i, a, l)));
        }
        function Mo(t, e) {
          vi(8390656, 8, t, e);
        }
        function _o(t, e) {
          fn(2048, 8, t, e);
        }
        function No(t, e) {
          return fn(4, 2, t, e);
        }
        function Ro(t, e) {
          return fn(4, 4, t, e);
        }
        function zo(t, e) {
          if (typeof e == 'function') {
            t = t();
            var a = e(t);
            return function () {
              typeof a == 'function' ? a() : e(null);
            };
          }
          if (e != null)
            return (
              (t = t()),
              (e.current = t),
              function () {
                e.current = null;
              }
            );
        }
        function Do(t, e, a) {
          ((a = a != null ? a.concat([t]) : null),
            fn(4, 4, zo.bind(null, e, t), a));
        }
        function vs() {}
        function Co(t, e) {
          var a = qt();
          e = e === void 0 ? null : e;
          var l = a.memoizedState;
          return e !== null && ss(e, l[1])
            ? l[0]
            : ((a.memoizedState = [t, e]), t);
        }
        function Uo(t, e) {
          var a = qt();
          e = e === void 0 ? null : e;
          var l = a.memoizedState;
          if (e !== null && ss(e, l[1])) return l[0];
          if (((l = t()), Ka)) {
            aa(!0);
            try {
              t();
            } finally {
              aa(!1);
            }
          }
          return ((a.memoizedState = [l, e]), l);
        }
        function bs(t, e, a) {
          return a === void 0 || (fa & 1073741824) !== 0
            ? (t.memoizedState = e)
            : ((t.memoizedState = a),
              (t = Hr()),
              (at.lanes |= t),
              (ya |= t),
              a);
        }
        function jo(t, e, a, l) {
          return oe(a, e)
            ? a
            : hl.current !== null
              ? ((t = bs(t, a, l)), oe(t, e) || (wt = !0), t)
              : (fa & 42) === 0
                ? ((wt = !0), (t.memoizedState = a))
                : ((t = Hr()), (at.lanes |= t), (ya |= t), e);
        }
        function Lo(t, e, a, l, n) {
          var i = j.p;
          j.p = i !== 0 && 8 > i ? i : 8;
          var f = _.T,
            d = {};
          ((_.T = d), As(t, !1, e, a));
          try {
            var y = n(),
              E = _.S;
            if (
              (E !== null && E(d, y),
              y !== null && typeof y == 'object' && typeof y.then == 'function')
            ) {
              var R = Bg(y, l);
              on(t, e, R, me());
            } else on(t, e, l, me());
          } catch (U) {
            on(
              t,
              e,
              { then: function () {}, status: 'rejected', reason: U },
              me()
            );
          } finally {
            ((j.p = i), (_.T = f));
          }
        }
        function wg() {}
        function Ss(t, e, a, l) {
          if (t.tag !== 5) throw Error(s(476));
          var n = Ho(t).queue;
          Lo(
            t,
            n,
            e,
            V,
            a === null
              ? wg
              : function () {
                  return (Bo(t), a(l));
                }
          );
        }
        function Ho(t) {
          var e = t.memoizedState;
          if (e !== null) return e;
          e = {
            memoizedState: V,
            baseState: V,
            baseQueue: null,
            queue: {
              pending: null,
              lanes: 0,
              dispatch: null,
              lastRenderedReducer: $e,
              lastRenderedState: V,
            },
            next: null,
          };
          var a = {};
          return (
            (e.next = {
              memoizedState: a,
              baseState: a,
              baseQueue: null,
              queue: {
                pending: null,
                lanes: 0,
                dispatch: null,
                lastRenderedReducer: $e,
                lastRenderedState: a,
              },
              next: null,
            }),
            (t.memoizedState = e),
            (t = t.alternate),
            t !== null && (t.memoizedState = e),
            e
          );
        }
        function Bo(t) {
          var e = Ho(t).next.queue;
          on(t, e, {}, me());
        }
        function xs() {
          return Wt(Nn);
        }
        function qo() {
          return qt().memoizedState;
        }
        function Ko() {
          return qt().memoizedState;
        }
        function Vg(t) {
          for (var e = t.return; e !== null; ) {
            switch (e.tag) {
              case 24:
              case 3:
                var a = me();
                t = sa(a);
                var l = ca(e, t, a);
                (l !== null && (ye(l, e, a), ln(l, e, a)),
                  (e = { cache: Fu() }),
                  (t.payload = e));
                return;
            }
            e = e.return;
          }
        }
        function Xg(t, e, a) {
          var l = me();
          ((a = {
            lane: l,
            revertLane: 0,
            action: a,
            hasEagerState: !1,
            eagerState: null,
            next: null,
          }),
            bi(t)
              ? Go(e, a)
              : ((a = Gu(t, e, a, l)),
                a !== null && (ye(a, t, l), wo(a, e, l))));
        }
        function Yo(t, e, a) {
          var l = me();
          on(t, e, a, l);
        }
        function on(t, e, a, l) {
          var n = {
            lane: l,
            revertLane: 0,
            action: a,
            hasEagerState: !1,
            eagerState: null,
            next: null,
          };
          if (bi(t)) Go(e, n);
          else {
            var i = t.alternate;
            if (
              t.lanes === 0 &&
              (i === null || i.lanes === 0) &&
              ((i = e.lastRenderedReducer), i !== null)
            )
              try {
                var f = e.lastRenderedState,
                  d = i(f, a);
                if (((n.hasEagerState = !0), (n.eagerState = d), oe(d, f)))
                  return (ai(t, e, n, 0), xt === null && ei(), !1);
              } catch {
              } finally {
              }
            if (((a = Gu(t, e, n, l)), a !== null))
              return (ye(a, t, l), wo(a, e, l), !0);
          }
          return !1;
        }
        function As(t, e, a, l) {
          if (
            ((l = {
              lane: 2,
              revertLane: tc(),
              action: l,
              hasEagerState: !1,
              eagerState: null,
              next: null,
            }),
            bi(t))
          ) {
            if (e) throw Error(s(479));
          } else ((e = Gu(t, a, l, 2)), e !== null && ye(e, t, 2));
        }
        function bi(t) {
          var e = t.alternate;
          return t === at || (e !== null && e === at);
        }
        function Go(t, e) {
          gl = hi = !0;
          var a = t.pending;
          (a === null ? (e.next = e) : ((e.next = a.next), (a.next = e)),
            (t.pending = e));
        }
        function wo(t, e, a) {
          if ((a & 4194048) !== 0) {
            var l = e.lanes;
            ((l &= t.pendingLanes), (a |= l), (e.lanes = a), Jc(t, a));
          }
        }
        var Si = {
            readContext: Wt,
            use: mi,
            useCallback: Ct,
            useContext: Ct,
            useEffect: Ct,
            useImperativeHandle: Ct,
            useLayoutEffect: Ct,
            useInsertionEffect: Ct,
            useMemo: Ct,
            useReducer: Ct,
            useRef: Ct,
            useState: Ct,
            useDebugValue: Ct,
            useDeferredValue: Ct,
            useTransition: Ct,
            useSyncExternalStore: Ct,
            useId: Ct,
            useHostTransitionStatus: Ct,
            useFormState: Ct,
            useActionState: Ct,
            useOptimistic: Ct,
            useMemoCache: Ct,
            useCacheRefresh: Ct,
          },
          Vo = {
            readContext: Wt,
            use: mi,
            useCallback: function (t, e) {
              return ((le().memoizedState = [t, e === void 0 ? null : e]), t);
            },
            useContext: Wt,
            useEffect: Mo,
            useImperativeHandle: function (t, e, a) {
              ((a = a != null ? a.concat([t]) : null),
                vi(4194308, 4, zo.bind(null, e, t), a));
            },
            useLayoutEffect: function (t, e) {
              return vi(4194308, 4, t, e);
            },
            useInsertionEffect: function (t, e) {
              vi(4, 2, t, e);
            },
            useMemo: function (t, e) {
              var a = le();
              e = e === void 0 ? null : e;
              var l = t();
              if (Ka) {
                aa(!0);
                try {
                  t();
                } finally {
                  aa(!1);
                }
              }
              return ((a.memoizedState = [l, e]), l);
            },
            useReducer: function (t, e, a) {
              var l = le();
              if (a !== void 0) {
                var n = a(e);
                if (Ka) {
                  aa(!0);
                  try {
                    a(e);
                  } finally {
                    aa(!1);
                  }
                }
              } else n = e;
              return (
                (l.memoizedState = l.baseState = n),
                (t = {
                  pending: null,
                  lanes: 0,
                  dispatch: null,
                  lastRenderedReducer: t,
                  lastRenderedState: n,
                }),
                (l.queue = t),
                (t = t.dispatch = Xg.bind(null, at, t)),
                [l.memoizedState, t]
              );
            },
            useRef: function (t) {
              var e = le();
              return ((t = { current: t }), (e.memoizedState = t));
            },
            useState: function (t) {
              t = ys(t);
              var e = t.queue,
                a = Yo.bind(null, at, e);
              return ((e.dispatch = a), [t.memoizedState, a]);
            },
            useDebugValue: vs,
            useDeferredValue: function (t, e) {
              var a = le();
              return bs(a, t, e);
            },
            useTransition: function () {
              var t = ys(!1);
              return (
                (t = Lo.bind(null, at, t.queue, !0, !1)),
                (le().memoizedState = t),
                [!1, t]
              );
            },
            useSyncExternalStore: function (t, e, a) {
              var l = at,
                n = le();
              if (dt) {
                if (a === void 0) throw Error(s(407));
                a = a();
              } else {
                if (((a = e()), xt === null)) throw Error(s(349));
                (ct & 124) !== 0 || fo(l, e, a);
              }
              n.memoizedState = a;
              var i = { value: a, getSnapshot: e };
              return (
                (n.queue = i),
                Mo(ro.bind(null, l, i, t), [t]),
                (l.flags |= 2048),
                yl(9, pi(), oo.bind(null, l, i, a, e), null),
                a
              );
            },
            useId: function () {
              var t = le(),
                e = xt.identifierPrefix;
              if (dt) {
                var a = Xe,
                  l = Ve;
                ((a = (l & ~(1 << (32 - fe(l) - 1))).toString(32) + a),
                  (e = '«' + e + 'R' + a),
                  (a = gi++),
                  0 < a && (e += 'H' + a.toString(32)),
                  (e += '»'));
              } else ((a = qg++), (e = '«' + e + 'r' + a.toString(32) + '»'));
              return (t.memoizedState = e);
            },
            useHostTransitionStatus: xs,
            useFormState: xo,
            useActionState: xo,
            useOptimistic: function (t) {
              var e = le();
              e.memoizedState = e.baseState = t;
              var a = {
                pending: null,
                lanes: 0,
                dispatch: null,
                lastRenderedReducer: null,
                lastRenderedState: null,
              };
              return (
                (e.queue = a),
                (e = As.bind(null, at, !0, a)),
                (a.dispatch = e),
                [t, e]
              );
            },
            useMemoCache: hs,
            useCacheRefresh: function () {
              return (le().memoizedState = Vg.bind(null, at));
            },
          },
          Xo = {
            readContext: Wt,
            use: mi,
            useCallback: Co,
            useContext: Wt,
            useEffect: _o,
            useImperativeHandle: Do,
            useInsertionEffect: No,
            useLayoutEffect: Ro,
            useMemo: Uo,
            useReducer: yi,
            useRef: Oo,
            useState: function () {
              return yi($e);
            },
            useDebugValue: vs,
            useDeferredValue: function (t, e) {
              var a = qt();
              return jo(a, pt.memoizedState, t, e);
            },
            useTransition: function () {
              var t = yi($e)[0],
                e = qt().memoizedState;
              return [typeof t == 'boolean' ? t : cn(t), e];
            },
            useSyncExternalStore: co,
            useId: qo,
            useHostTransitionStatus: xs,
            useFormState: Ao,
            useActionState: Ao,
            useOptimistic: function (t, e) {
              var a = qt();
              return mo(a, pt, t, e);
            },
            useMemoCache: hs,
            useCacheRefresh: Ko,
          },
          Qg = {
            readContext: Wt,
            use: mi,
            useCallback: Co,
            useContext: Wt,
            useEffect: _o,
            useImperativeHandle: Do,
            useInsertionEffect: No,
            useLayoutEffect: Ro,
            useMemo: Uo,
            useReducer: ms,
            useRef: Oo,
            useState: function () {
              return ms($e);
            },
            useDebugValue: vs,
            useDeferredValue: function (t, e) {
              var a = qt();
              return pt === null ? bs(a, t, e) : jo(a, pt.memoizedState, t, e);
            },
            useTransition: function () {
              var t = ms($e)[0],
                e = qt().memoizedState;
              return [typeof t == 'boolean' ? t : cn(t), e];
            },
            useSyncExternalStore: co,
            useId: qo,
            useHostTransitionStatus: xs,
            useFormState: Eo,
            useActionState: Eo,
            useOptimistic: function (t, e) {
              var a = qt();
              return pt !== null
                ? mo(a, pt, t, e)
                : ((a.baseState = t), [t, a.queue.dispatch]);
            },
            useMemoCache: hs,
            useCacheRefresh: Ko,
          },
          pl = null,
          rn = 0;
        function xi(t) {
          var e = rn;
          return ((rn += 1), pl === null && (pl = []), to(pl, t, e));
        }
        function dn(t, e) {
          ((e = e.props.ref), (t.ref = e !== void 0 ? e : null));
        }
        function Ai(t, e) {
          throw e.$$typeof === N
            ? Error(s(525))
            : ((t = Object.prototype.toString.call(e)),
              Error(
                s(
                  31,
                  t === '[object Object]'
                    ? 'object with keys {' + Object.keys(e).join(', ') + '}'
                    : t
                )
              ));
        }
        function Qo(t) {
          var e = t._init;
          return e(t._payload);
        }
        function Zo(t) {
          function e(x, S) {
            if (t) {
              var T = x.deletions;
              T === null ? ((x.deletions = [S]), (x.flags |= 16)) : T.push(S);
            }
          }
          function a(x, S) {
            if (!t) return null;
            for (; S !== null; ) (e(x, S), (S = S.sibling));
            return null;
          }
          function l(x) {
            for (var S = new Map(); x !== null; )
              (x.key !== null ? S.set(x.key, x) : S.set(x.index, x),
                (x = x.sibling));
            return S;
          }
          function n(x, S) {
            return ((x = we(x, S)), (x.index = 0), (x.sibling = null), x);
          }
          function i(x, S, T) {
            return (
              (x.index = T),
              t
                ? ((T = x.alternate),
                  T !== null
                    ? ((T = T.index), T < S ? ((x.flags |= 67108866), S) : T)
                    : ((x.flags |= 67108866), S))
                : ((x.flags |= 1048576), S)
            );
          }
          function f(x) {
            return (t && x.alternate === null && (x.flags |= 67108866), x);
          }
          function d(x, S, T, z) {
            return S === null || S.tag !== 6
              ? ((S = Vu(T, x.mode, z)), (S.return = x), S)
              : ((S = n(S, T)), (S.return = x), S);
          }
          function y(x, S, T, z) {
            var Y = T.type;
            return Y === q
              ? R(x, S, T.props.children, z, T.key)
              : S !== null &&
                  (S.elementType === Y ||
                    (typeof Y == 'object' &&
                      Y !== null &&
                      Y.$$typeof === Mt &&
                      Qo(Y) === S.type))
                ? ((S = n(S, T.props)), dn(S, T), (S.return = x), S)
                : ((S = ni(T.type, T.key, T.props, null, x.mode, z)),
                  dn(S, T),
                  (S.return = x),
                  S);
          }
          function E(x, S, T, z) {
            return S === null ||
              S.tag !== 4 ||
              S.stateNode.containerInfo !== T.containerInfo ||
              S.stateNode.implementation !== T.implementation
              ? ((S = Xu(T, x.mode, z)), (S.return = x), S)
              : ((S = n(S, T.children || [])), (S.return = x), S);
          }
          function R(x, S, T, z, Y) {
            return S === null || S.tag !== 7
              ? ((S = Da(T, x.mode, z, Y)), (S.return = x), S)
              : ((S = n(S, T)), (S.return = x), S);
          }
          function U(x, S, T) {
            if (
              (typeof S == 'string' && S !== '') ||
              typeof S == 'number' ||
              typeof S == 'bigint'
            )
              return ((S = Vu('' + S, x.mode, T)), (S.return = x), S);
            if (typeof S == 'object' && S !== null) {
              switch (S.$$typeof) {
                case L:
                  return (
                    (T = ni(S.type, S.key, S.props, null, x.mode, T)),
                    dn(T, S),
                    (T.return = x),
                    T
                  );
                case K:
                  return ((S = Xu(S, x.mode, T)), (S.return = x), S);
                case Mt:
                  var z = S._init;
                  return ((S = z(S._payload)), U(x, S, T));
              }
              if (Dt(S) || Rt(S))
                return ((S = Da(S, x.mode, T, null)), (S.return = x), S);
              if (typeof S.then == 'function') return U(x, xi(S), T);
              if (S.$$typeof === W) return U(x, ci(x, S), T);
              Ai(x, S);
            }
            return null;
          }
          function O(x, S, T, z) {
            var Y = S !== null ? S.key : null;
            if (
              (typeof T == 'string' && T !== '') ||
              typeof T == 'number' ||
              typeof T == 'bigint'
            )
              return Y !== null ? null : d(x, S, '' + T, z);
            if (typeof T == 'object' && T !== null) {
              switch (T.$$typeof) {
                case L:
                  return T.key === Y ? y(x, S, T, z) : null;
                case K:
                  return T.key === Y ? E(x, S, T, z) : null;
                case Mt:
                  return ((Y = T._init), (T = Y(T._payload)), O(x, S, T, z));
              }
              if (Dt(T) || Rt(T))
                return Y !== null ? null : R(x, S, T, z, null);
              if (typeof T.then == 'function') return O(x, S, xi(T), z);
              if (T.$$typeof === W) return O(x, S, ci(x, T), z);
              Ai(x, T);
            }
            return null;
          }
          function M(x, S, T, z, Y) {
            if (
              (typeof z == 'string' && z !== '') ||
              typeof z == 'number' ||
              typeof z == 'bigint'
            )
              return ((x = x.get(T) || null), d(S, x, '' + z, Y));
            if (typeof z == 'object' && z !== null) {
              switch (z.$$typeof) {
                case L:
                  return (
                    (x = x.get(z.key === null ? T : z.key) || null),
                    y(S, x, z, Y)
                  );
                case K:
                  return (
                    (x = x.get(z.key === null ? T : z.key) || null),
                    E(S, x, z, Y)
                  );
                case Mt:
                  var lt = z._init;
                  return ((z = lt(z._payload)), M(x, S, T, z, Y));
              }
              if (Dt(z) || Rt(z))
                return ((x = x.get(T) || null), R(S, x, z, Y, null));
              if (typeof z.then == 'function') return M(x, S, T, xi(z), Y);
              if (z.$$typeof === W) return M(x, S, T, ci(S, z), Y);
              Ai(S, z);
            }
            return null;
          }
          function J(x, S, T, z) {
            for (
              var Y = null, lt = null, G = S, $ = (S = 0), Xt = null;
              G !== null && $ < T.length;
              $++
            ) {
              G.index > $ ? ((Xt = G), (G = null)) : (Xt = G.sibling);
              var rt = O(x, G, T[$], z);
              if (rt === null) {
                G === null && (G = Xt);
                break;
              }
              (t && G && rt.alternate === null && e(x, G),
                (S = i(rt, S, $)),
                lt === null ? (Y = rt) : (lt.sibling = rt),
                (lt = rt),
                (G = Xt));
            }
            if ($ === T.length) return (a(x, G), dt && Ua(x, $), Y);
            if (G === null) {
              for (; $ < T.length; $++)
                ((G = U(x, T[$], z)),
                  G !== null &&
                    ((S = i(G, S, $)),
                    lt === null ? (Y = G) : (lt.sibling = G),
                    (lt = G)));
              return (dt && Ua(x, $), Y);
            }
            for (G = l(G); $ < T.length; $++)
              ((Xt = M(G, x, $, T[$], z)),
                Xt !== null &&
                  (t &&
                    Xt.alternate !== null &&
                    G.delete(Xt.key === null ? $ : Xt.key),
                  (S = i(Xt, S, $)),
                  lt === null ? (Y = Xt) : (lt.sibling = Xt),
                  (lt = Xt)));
            return (
              t &&
                G.forEach(function (Oa) {
                  return e(x, Oa);
                }),
              dt && Ua(x, $),
              Y
            );
          }
          function Z(x, S, T, z) {
            if (T == null) throw Error(s(151));
            for (
              var Y = null,
                lt = null,
                G = S,
                $ = (S = 0),
                Xt = null,
                rt = T.next();
              G !== null && !rt.done;
              $++, rt = T.next()
            ) {
              G.index > $ ? ((Xt = G), (G = null)) : (Xt = G.sibling);
              var Oa = O(x, G, rt.value, z);
              if (Oa === null) {
                G === null && (G = Xt);
                break;
              }
              (t && G && Oa.alternate === null && e(x, G),
                (S = i(Oa, S, $)),
                lt === null ? (Y = Oa) : (lt.sibling = Oa),
                (lt = Oa),
                (G = Xt));
            }
            if (rt.done) return (a(x, G), dt && Ua(x, $), Y);
            if (G === null) {
              for (; !rt.done; $++, rt = T.next())
                ((rt = U(x, rt.value, z)),
                  rt !== null &&
                    ((S = i(rt, S, $)),
                    lt === null ? (Y = rt) : (lt.sibling = rt),
                    (lt = rt)));
              return (dt && Ua(x, $), Y);
            }
            for (G = l(G); !rt.done; $++, rt = T.next())
              ((rt = M(G, x, $, rt.value, z)),
                rt !== null &&
                  (t &&
                    rt.alternate !== null &&
                    G.delete(rt.key === null ? $ : rt.key),
                  (S = i(rt, S, $)),
                  lt === null ? (Y = rt) : (lt.sibling = rt),
                  (lt = rt)));
            return (
              t &&
                G.forEach(function (Zm) {
                  return e(x, Zm);
                }),
              dt && Ua(x, $),
              Y
            );
          }
          function bt(x, S, T, z) {
            if (
              (typeof T == 'object' &&
                T !== null &&
                T.type === q &&
                T.key === null &&
                (T = T.props.children),
              typeof T == 'object' && T !== null)
            ) {
              switch (T.$$typeof) {
                case L:
                  t: {
                    for (var Y = T.key; S !== null; ) {
                      if (S.key === Y) {
                        if (((Y = T.type), Y === q)) {
                          if (S.tag === 7) {
                            (a(x, S.sibling),
                              (z = n(S, T.props.children)),
                              (z.return = x),
                              (x = z));
                            break t;
                          }
                        } else if (
                          S.elementType === Y ||
                          (typeof Y == 'object' &&
                            Y !== null &&
                            Y.$$typeof === Mt &&
                            Qo(Y) === S.type)
                        ) {
                          (a(x, S.sibling),
                            (z = n(S, T.props)),
                            dn(z, T),
                            (z.return = x),
                            (x = z));
                          break t;
                        }
                        a(x, S);
                        break;
                      } else e(x, S);
                      S = S.sibling;
                    }
                    T.type === q
                      ? ((z = Da(T.props.children, x.mode, z, T.key)),
                        (z.return = x),
                        (x = z))
                      : ((z = ni(T.type, T.key, T.props, null, x.mode, z)),
                        dn(z, T),
                        (z.return = x),
                        (x = z));
                  }
                  return f(x);
                case K:
                  t: {
                    for (Y = T.key; S !== null; ) {
                      if (S.key === Y)
                        if (
                          S.tag === 4 &&
                          S.stateNode.containerInfo === T.containerInfo &&
                          S.stateNode.implementation === T.implementation
                        ) {
                          (a(x, S.sibling),
                            (z = n(S, T.children || [])),
                            (z.return = x),
                            (x = z));
                          break t;
                        } else {
                          a(x, S);
                          break;
                        }
                      else e(x, S);
                      S = S.sibling;
                    }
                    ((z = Xu(T, x.mode, z)), (z.return = x), (x = z));
                  }
                  return f(x);
                case Mt:
                  return ((Y = T._init), (T = Y(T._payload)), bt(x, S, T, z));
              }
              if (Dt(T)) return J(x, S, T, z);
              if (Rt(T)) {
                if (((Y = Rt(T)), typeof Y != 'function')) throw Error(s(150));
                return ((T = Y.call(T)), Z(x, S, T, z));
              }
              if (typeof T.then == 'function') return bt(x, S, xi(T), z);
              if (T.$$typeof === W) return bt(x, S, ci(x, T), z);
              Ai(x, T);
            }
            return (typeof T == 'string' && T !== '') ||
              typeof T == 'number' ||
              typeof T == 'bigint'
              ? ((T = '' + T),
                S !== null && S.tag === 6
                  ? (a(x, S.sibling), (z = n(S, T)), (z.return = x), (x = z))
                  : (a(x, S), (z = Vu(T, x.mode, z)), (z.return = x), (x = z)),
                f(x))
              : a(x, S);
          }
          return function (x, S, T, z) {
            try {
              rn = 0;
              var Y = bt(x, S, T, z);
              return ((pl = null), Y);
            } catch (G) {
              if (G === en || G === oi) throw G;
              var lt = re(29, G, null, x.mode);
              return ((lt.lanes = z), (lt.return = x), lt);
            } finally {
            }
          };
        }
        var vl = Zo(!0),
          $o = Zo(!1),
          Te = D(null),
          Le = null;
        function oa(t) {
          var e = t.alternate;
          (H(Yt, Yt.current & 1),
            H(Te, t),
            Le === null &&
              (e === null || hl.current !== null || e.memoizedState !== null) &&
              (Le = t));
        }
        function Jo(t) {
          if (t.tag === 22) {
            if ((H(Yt, Yt.current), H(Te, t), Le === null)) {
              var e = t.alternate;
              e !== null && e.memoizedState !== null && (Le = t);
            }
          } else ra();
        }
        function ra() {
          (H(Yt, Yt.current), H(Te, Te.current));
        }
        function Je(t) {
          (B(Te), Le === t && (Le = null), B(Yt));
        }
        var Yt = D(0);
        function Ti(t) {
          for (var e = t; e !== null; ) {
            if (e.tag === 13) {
              var a = e.memoizedState;
              if (
                a !== null &&
                ((a = a.dehydrated), a === null || a.data === '$?' || dc(a))
              )
                return e;
            } else if (e.tag === 19 && e.memoizedProps.revealOrder !== void 0) {
              if ((e.flags & 128) !== 0) return e;
            } else if (e.child !== null) {
              ((e.child.return = e), (e = e.child));
              continue;
            }
            if (e === t) break;
            for (; e.sibling === null; ) {
              if (e.return === null || e.return === t) return null;
              e = e.return;
            }
            ((e.sibling.return = e.return), (e = e.sibling));
          }
          return null;
        }
        function Ts(t, e, a, l) {
          ((e = t.memoizedState),
            (a = a(l, e)),
            (a = a == null ? e : A({}, e, a)),
            (t.memoizedState = a),
            t.lanes === 0 && (t.updateQueue.baseState = a));
        }
        var Es = {
          enqueueSetState: function (t, e, a) {
            t = t._reactInternals;
            var l = me(),
              n = sa(l);
            ((n.payload = e),
              a != null && (n.callback = a),
              (e = ca(t, n, l)),
              e !== null && (ye(e, t, l), ln(e, t, l)));
          },
          enqueueReplaceState: function (t, e, a) {
            t = t._reactInternals;
            var l = me(),
              n = sa(l);
            ((n.tag = 1),
              (n.payload = e),
              a != null && (n.callback = a),
              (e = ca(t, n, l)),
              e !== null && (ye(e, t, l), ln(e, t, l)));
          },
          enqueueForceUpdate: function (t, e) {
            t = t._reactInternals;
            var a = me(),
              l = sa(a);
            ((l.tag = 2),
              e != null && (l.callback = e),
              (e = ca(t, l, a)),
              e !== null && (ye(e, t, a), ln(e, t, a)));
          },
        };
        function ko(t, e, a, l, n, i, f) {
          return (
            (t = t.stateNode),
            typeof t.shouldComponentUpdate == 'function'
              ? t.shouldComponentUpdate(l, i, f)
              : e.prototype && e.prototype.isPureReactComponent
                ? !$l(a, l) || !$l(n, i)
                : !0
          );
        }
        function Wo(t, e, a, l) {
          ((t = e.state),
            typeof e.componentWillReceiveProps == 'function' &&
              e.componentWillReceiveProps(a, l),
            typeof e.UNSAFE_componentWillReceiveProps == 'function' &&
              e.UNSAFE_componentWillReceiveProps(a, l),
            e.state !== t && Es.enqueueReplaceState(e, e.state, null));
        }
        function Ya(t, e) {
          var a = e;
          if ('ref' in e) {
            a = {};
            for (var l in e) l !== 'ref' && (a[l] = e[l]);
          }
          if ((t = t.defaultProps)) {
            a === e && (a = A({}, a));
            for (var n in t) a[n] === void 0 && (a[n] = t[n]);
          }
          return a;
        }
        var Ei =
          typeof reportError == 'function'
            ? reportError
            : function (t) {
                if (
                  typeof window == 'object' &&
                  typeof window.ErrorEvent == 'function'
                ) {
                  var e = new window.ErrorEvent('error', {
                    bubbles: !0,
                    cancelable: !0,
                    message:
                      typeof t == 'object' &&
                      t !== null &&
                      typeof t.message == 'string'
                        ? String(t.message)
                        : String(t),
                    error: t,
                  });
                  if (!window.dispatchEvent(e)) return;
                } else if (
                  typeof process == 'object' &&
                  typeof process.emit == 'function'
                ) {
                  process.emit('uncaughtException', t);
                  return;
                }
                console.error(t);
              };
        function Fo(t) {
          Ei(t);
        }
        function Po(t) {
          console.error(t);
        }
        function Io(t) {
          Ei(t);
        }
        function Oi(t, e) {
          try {
            var a = t.onUncaughtError;
            a(e.value, { componentStack: e.stack });
          } catch (l) {
            setTimeout(function () {
              throw l;
            });
          }
        }
        function tr(t, e, a) {
          try {
            var l = t.onCaughtError;
            l(a.value, {
              componentStack: a.stack,
              errorBoundary: e.tag === 1 ? e.stateNode : null,
            });
          } catch (n) {
            setTimeout(function () {
              throw n;
            });
          }
        }
        function Os(t, e, a) {
          return (
            (a = sa(a)),
            (a.tag = 3),
            (a.payload = { element: null }),
            (a.callback = function () {
              Oi(t, e);
            }),
            a
          );
        }
        function er(t) {
          return ((t = sa(t)), (t.tag = 3), t);
        }
        function ar(t, e, a, l) {
          var n = a.type.getDerivedStateFromError;
          if (typeof n == 'function') {
            var i = l.value;
            ((t.payload = function () {
              return n(i);
            }),
              (t.callback = function () {
                tr(e, a, l);
              }));
          }
          var f = a.stateNode;
          f !== null &&
            typeof f.componentDidCatch == 'function' &&
            (t.callback = function () {
              (tr(e, a, l),
                typeof n != 'function' &&
                  (pa === null ? (pa = new Set([this])) : pa.add(this)));
              var d = l.stack;
              this.componentDidCatch(l.value, {
                componentStack: d !== null ? d : '',
              });
            });
        }
        function Zg(t, e, a, l, n) {
          if (
            ((a.flags |= 32768),
            l !== null && typeof l == 'object' && typeof l.then == 'function')
          ) {
            if (
              ((e = a.alternate),
              e !== null && Pl(e, a, n, !0),
              (a = Te.current),
              a !== null)
            ) {
              switch (a.tag) {
                case 13:
                  return (
                    Le === null
                      ? ks()
                      : a.alternate === null && Nt === 0 && (Nt = 3),
                    (a.flags &= -257),
                    (a.flags |= 65536),
                    (a.lanes = n),
                    l === ts
                      ? (a.flags |= 16384)
                      : ((e = a.updateQueue),
                        e === null ? (a.updateQueue = new Set([l])) : e.add(l),
                        Fs(t, l, n)),
                    !1
                  );
                case 22:
                  return (
                    (a.flags |= 65536),
                    l === ts
                      ? (a.flags |= 16384)
                      : ((e = a.updateQueue),
                        e === null
                          ? ((e = {
                              transitions: null,
                              markerInstances: null,
                              retryQueue: new Set([l]),
                            }),
                            (a.updateQueue = e))
                          : ((a = e.retryQueue),
                            a === null
                              ? (e.retryQueue = new Set([l]))
                              : a.add(l)),
                        Fs(t, l, n)),
                    !1
                  );
              }
              throw Error(s(435, a.tag));
            }
            return (Fs(t, l, n), ks(), !1);
          }
          if (dt)
            return (
              (e = Te.current),
              e !== null
                ? ((e.flags & 65536) === 0 && (e.flags |= 256),
                  (e.flags |= 65536),
                  (e.lanes = n),
                  l !== $u && ((t = Error(s(422), { cause: l })), Fl(be(t, a))))
                : (l !== $u &&
                    ((e = Error(s(423), { cause: l })), Fl(be(e, a))),
                  (t = t.current.alternate),
                  (t.flags |= 65536),
                  (n &= -n),
                  (t.lanes |= n),
                  (l = be(l, a)),
                  (n = Os(t.stateNode, l, n)),
                  ls(t, n),
                  Nt !== 4 && (Nt = 2)),
              !1
            );
          var i = Error(s(520), { cause: l });
          if (
            ((i = be(i, a)),
            bn === null ? (bn = [i]) : bn.push(i),
            Nt !== 4 && (Nt = 2),
            e === null)
          )
            return !0;
          ((l = be(l, a)), (a = e));
          do {
            switch (a.tag) {
              case 3:
                return (
                  (a.flags |= 65536),
                  (t = n & -n),
                  (a.lanes |= t),
                  (t = Os(a.stateNode, l, t)),
                  ls(a, t),
                  !1
                );
              case 1:
                if (
                  ((e = a.type),
                  (i = a.stateNode),
                  (a.flags & 128) === 0 &&
                    (typeof e.getDerivedStateFromError == 'function' ||
                      (i !== null &&
                        typeof i.componentDidCatch == 'function' &&
                        (pa === null || !pa.has(i)))))
                )
                  return (
                    (a.flags |= 65536),
                    (n &= -n),
                    (a.lanes |= n),
                    (n = er(n)),
                    ar(n, t, a, l),
                    ls(a, n),
                    !1
                  );
            }
            a = a.return;
          } while (a !== null);
          return !1;
        }
        var lr = Error(s(461)),
          wt = !1;
        function Zt(t, e, a, l) {
          e.child = t === null ? $o(e, null, a, l) : vl(e, t.child, a, l);
        }
        function nr(t, e, a, l, n) {
          a = a.render;
          var i = e.ref;
          if ('ref' in l) {
            var f = {};
            for (var d in l) d !== 'ref' && (f[d] = l[d]);
          } else f = l;
          return (
            Ba(e),
            (l = cs(t, e, a, f, i, n)),
            (d = fs()),
            t !== null && !wt
              ? (os(t, e, n), ke(t, e, n))
              : (dt && d && Qu(e), (e.flags |= 1), Zt(t, e, l, n), e.child)
          );
        }
        function ir(t, e, a, l, n) {
          if (t === null) {
            var i = a.type;
            return typeof i == 'function' &&
              !wu(i) &&
              i.defaultProps === void 0 &&
              a.compare === null
              ? ((e.tag = 15), (e.type = i), ur(t, e, i, l, n))
              : ((t = ni(a.type, null, l, e, e.mode, n)),
                (t.ref = e.ref),
                (t.return = e),
                (e.child = t));
          }
          if (((i = t.child), !Us(t, n))) {
            var f = i.memoizedProps;
            if (
              ((a = a.compare),
              (a = a !== null ? a : $l),
              a(f, l) && t.ref === e.ref)
            )
              return ke(t, e, n);
          }
          return (
            (e.flags |= 1),
            (t = we(i, l)),
            (t.ref = e.ref),
            (t.return = e),
            (e.child = t)
          );
        }
        function ur(t, e, a, l, n) {
          if (t !== null) {
            var i = t.memoizedProps;
            if ($l(i, l) && t.ref === e.ref)
              if (((wt = !1), (e.pendingProps = l = i), Us(t, n)))
                (t.flags & 131072) !== 0 && (wt = !0);
              else return ((e.lanes = t.lanes), ke(t, e, n));
          }
          return Ms(t, e, a, l, n);
        }
        function sr(t, e, a) {
          var l = e.pendingProps,
            n = l.children,
            i = t !== null ? t.memoizedState : null;
          if (l.mode === 'hidden') {
            if ((e.flags & 128) !== 0) {
              if (((l = i !== null ? i.baseLanes | a : a), t !== null)) {
                for (n = e.child = t.child, i = 0; n !== null; )
                  ((i = i | n.lanes | n.childLanes), (n = n.sibling));
                e.childLanes = i & ~l;
              } else ((e.childLanes = 0), (e.child = null));
              return cr(t, e, l, a);
            }
            if ((a & 536870912) !== 0)
              ((e.memoizedState = { baseLanes: 0, cachePool: null }),
                t !== null && fi(e, i !== null ? i.cachePool : null),
                i !== null ? io(e, i) : is(),
                Jo(e));
            else
              return (
                (e.lanes = e.childLanes = 536870912),
                cr(t, e, i !== null ? i.baseLanes | a : a, a)
              );
          } else
            i !== null
              ? (fi(e, i.cachePool), io(e, i), ra(), (e.memoizedState = null))
              : (t !== null && fi(e, null), is(), ra());
          return (Zt(t, e, n, a), e.child);
        }
        function cr(t, e, a, l) {
          var n = Iu();
          return (
            (n = n === null ? null : { parent: Kt._currentValue, pool: n }),
            (e.memoizedState = { baseLanes: a, cachePool: n }),
            t !== null && fi(e, null),
            is(),
            Jo(e),
            t !== null && Pl(t, e, l, !0),
            null
          );
        }
        function Mi(t, e) {
          var a = e.ref;
          if (a === null) t !== null && t.ref !== null && (e.flags |= 4194816);
          else {
            if (typeof a != 'function' && typeof a != 'object')
              throw Error(s(284));
            (t === null || t.ref !== a) && (e.flags |= 4194816);
          }
        }
        function Ms(t, e, a, l, n) {
          return (
            Ba(e),
            (a = cs(t, e, a, l, void 0, n)),
            (l = fs()),
            t !== null && !wt
              ? (os(t, e, n), ke(t, e, n))
              : (dt && l && Qu(e), (e.flags |= 1), Zt(t, e, a, n), e.child)
          );
        }
        function fr(t, e, a, l, n, i) {
          return (
            Ba(e),
            (e.updateQueue = null),
            (a = so(e, l, a, n)),
            uo(t),
            (l = fs()),
            t !== null && !wt
              ? (os(t, e, i), ke(t, e, i))
              : (dt && l && Qu(e), (e.flags |= 1), Zt(t, e, a, i), e.child)
          );
        }
        function or(t, e, a, l, n) {
          if ((Ba(e), e.stateNode === null)) {
            var i = cl,
              f = a.contextType;
            (typeof f == 'object' && f !== null && (i = Wt(f)),
              (i = new a(l, i)),
              (e.memoizedState =
                i.state !== null && i.state !== void 0 ? i.state : null),
              (i.updater = Es),
              (e.stateNode = i),
              (i._reactInternals = e),
              (i = e.stateNode),
              (i.props = l),
              (i.state = e.memoizedState),
              (i.refs = {}),
              es(e),
              (f = a.contextType),
              (i.context = typeof f == 'object' && f !== null ? Wt(f) : cl),
              (i.state = e.memoizedState),
              (f = a.getDerivedStateFromProps),
              typeof f == 'function' &&
                (Ts(e, a, f, l), (i.state = e.memoizedState)),
              typeof a.getDerivedStateFromProps == 'function' ||
                typeof i.getSnapshotBeforeUpdate == 'function' ||
                (typeof i.UNSAFE_componentWillMount != 'function' &&
                  typeof i.componentWillMount != 'function') ||
                ((f = i.state),
                typeof i.componentWillMount == 'function' &&
                  i.componentWillMount(),
                typeof i.UNSAFE_componentWillMount == 'function' &&
                  i.UNSAFE_componentWillMount(),
                f !== i.state && Es.enqueueReplaceState(i, i.state, null),
                un(e, l, i, n),
                nn(),
                (i.state = e.memoizedState)),
              typeof i.componentDidMount == 'function' && (e.flags |= 4194308),
              (l = !0));
          } else if (t === null) {
            i = e.stateNode;
            var d = e.memoizedProps,
              y = Ya(a, d);
            i.props = y;
            var E = i.context,
              R = a.contextType;
            ((f = cl), typeof R == 'object' && R !== null && (f = Wt(R)));
            var U = a.getDerivedStateFromProps;
            ((R =
              typeof U == 'function' ||
              typeof i.getSnapshotBeforeUpdate == 'function'),
              (d = e.pendingProps !== d),
              R ||
                (typeof i.UNSAFE_componentWillReceiveProps != 'function' &&
                  typeof i.componentWillReceiveProps != 'function') ||
                ((d || E !== f) && Wo(e, i, l, f)),
              (ua = !1));
            var O = e.memoizedState;
            ((i.state = O),
              un(e, l, i, n),
              nn(),
              (E = e.memoizedState),
              d || O !== E || ua
                ? (typeof U == 'function' &&
                    (Ts(e, a, U, l), (E = e.memoizedState)),
                  (y = ua || ko(e, a, y, l, O, E, f))
                    ? (R ||
                        (typeof i.UNSAFE_componentWillMount != 'function' &&
                          typeof i.componentWillMount != 'function') ||
                        (typeof i.componentWillMount == 'function' &&
                          i.componentWillMount(),
                        typeof i.UNSAFE_componentWillMount == 'function' &&
                          i.UNSAFE_componentWillMount()),
                      typeof i.componentDidMount == 'function' &&
                        (e.flags |= 4194308))
                    : (typeof i.componentDidMount == 'function' &&
                        (e.flags |= 4194308),
                      (e.memoizedProps = l),
                      (e.memoizedState = E)),
                  (i.props = l),
                  (i.state = E),
                  (i.context = f),
                  (l = y))
                : (typeof i.componentDidMount == 'function' &&
                    (e.flags |= 4194308),
                  (l = !1)));
          } else {
            ((i = e.stateNode),
              as(t, e),
              (f = e.memoizedProps),
              (R = Ya(a, f)),
              (i.props = R),
              (U = e.pendingProps),
              (O = i.context),
              (E = a.contextType),
              (y = cl),
              typeof E == 'object' && E !== null && (y = Wt(E)),
              (d = a.getDerivedStateFromProps),
              (E =
                typeof d == 'function' ||
                typeof i.getSnapshotBeforeUpdate == 'function') ||
                (typeof i.UNSAFE_componentWillReceiveProps != 'function' &&
                  typeof i.componentWillReceiveProps != 'function') ||
                ((f !== U || O !== y) && Wo(e, i, l, y)),
              (ua = !1),
              (O = e.memoizedState),
              (i.state = O),
              un(e, l, i, n),
              nn());
            var M = e.memoizedState;
            f !== U ||
            O !== M ||
            ua ||
            (t !== null && t.dependencies !== null && si(t.dependencies))
              ? (typeof d == 'function' &&
                  (Ts(e, a, d, l), (M = e.memoizedState)),
                (R =
                  ua ||
                  ko(e, a, R, l, O, M, y) ||
                  (t !== null && t.dependencies !== null && si(t.dependencies)))
                  ? (E ||
                      (typeof i.UNSAFE_componentWillUpdate != 'function' &&
                        typeof i.componentWillUpdate != 'function') ||
                      (typeof i.componentWillUpdate == 'function' &&
                        i.componentWillUpdate(l, M, y),
                      typeof i.UNSAFE_componentWillUpdate == 'function' &&
                        i.UNSAFE_componentWillUpdate(l, M, y)),
                    typeof i.componentDidUpdate == 'function' && (e.flags |= 4),
                    typeof i.getSnapshotBeforeUpdate == 'function' &&
                      (e.flags |= 1024))
                  : (typeof i.componentDidUpdate != 'function' ||
                      (f === t.memoizedProps && O === t.memoizedState) ||
                      (e.flags |= 4),
                    typeof i.getSnapshotBeforeUpdate != 'function' ||
                      (f === t.memoizedProps && O === t.memoizedState) ||
                      (e.flags |= 1024),
                    (e.memoizedProps = l),
                    (e.memoizedState = M)),
                (i.props = l),
                (i.state = M),
                (i.context = y),
                (l = R))
              : (typeof i.componentDidUpdate != 'function' ||
                  (f === t.memoizedProps && O === t.memoizedState) ||
                  (e.flags |= 4),
                typeof i.getSnapshotBeforeUpdate != 'function' ||
                  (f === t.memoizedProps && O === t.memoizedState) ||
                  (e.flags |= 1024),
                (l = !1));
          }
          return (
            (i = l),
            Mi(t, e),
            (l = (e.flags & 128) !== 0),
            i || l
              ? ((i = e.stateNode),
                (a =
                  l && typeof a.getDerivedStateFromError != 'function'
                    ? null
                    : i.render()),
                (e.flags |= 1),
                t !== null && l
                  ? ((e.child = vl(e, t.child, null, n)),
                    (e.child = vl(e, null, a, n)))
                  : Zt(t, e, a, n),
                (e.memoizedState = i.state),
                (t = e.child))
              : (t = ke(t, e, n)),
            t
          );
        }
        function rr(t, e, a, l) {
          return (Wl(), (e.flags |= 256), Zt(t, e, a, l), e.child);
        }
        var _s = {
          dehydrated: null,
          treeContext: null,
          retryLane: 0,
          hydrationErrors: null,
        };
        function Ns(t) {
          return { baseLanes: t, cachePool: Ff() };
        }
        function Rs(t, e, a) {
          return ((t = t !== null ? t.childLanes & ~a : 0), e && (t |= Ee), t);
        }
        function dr(t, e, a) {
          var l = e.pendingProps,
            n = !1,
            i = (e.flags & 128) !== 0,
            f;
          if (
            ((f = i) ||
              (f =
                t !== null && t.memoizedState === null
                  ? !1
                  : (Yt.current & 2) !== 0),
            f && ((n = !0), (e.flags &= -129)),
            (f = (e.flags & 32) !== 0),
            (e.flags &= -33),
            t === null)
          ) {
            if (dt) {
              if ((n ? oa(e) : ra(), dt)) {
                var d = _t,
                  y;
                if ((y = d)) {
                  t: {
                    for (y = d, d = je; y.nodeType !== 8; ) {
                      if (!d) {
                        d = null;
                        break t;
                      }
                      if (((y = De(y.nextSibling)), y === null)) {
                        d = null;
                        break t;
                      }
                    }
                    d = y;
                  }
                  d !== null
                    ? ((e.memoizedState = {
                        dehydrated: d,
                        treeContext:
                          Ca !== null ? { id: Ve, overflow: Xe } : null,
                        retryLane: 536870912,
                        hydrationErrors: null,
                      }),
                      (y = re(18, null, null, 0)),
                      (y.stateNode = d),
                      (y.return = e),
                      (e.child = y),
                      (Pt = e),
                      (_t = null),
                      (y = !0))
                    : (y = !1);
                }
                y || La(e);
              }
              if (
                ((d = e.memoizedState),
                d !== null && ((d = d.dehydrated), d !== null))
              )
                return (dc(d) ? (e.lanes = 32) : (e.lanes = 536870912), null);
              Je(e);
            }
            return (
              (d = l.children),
              (l = l.fallback),
              n
                ? (ra(),
                  (n = e.mode),
                  (d = _i({ mode: 'hidden', children: d }, n)),
                  (l = Da(l, n, a, null)),
                  (d.return = e),
                  (l.return = e),
                  (d.sibling = l),
                  (e.child = d),
                  (n = e.child),
                  (n.memoizedState = Ns(a)),
                  (n.childLanes = Rs(t, f, a)),
                  (e.memoizedState = _s),
                  l)
                : (oa(e), zs(e, d))
            );
          }
          if (
            ((y = t.memoizedState),
            y !== null && ((d = y.dehydrated), d !== null))
          ) {
            if (i)
              e.flags & 256
                ? (oa(e), (e.flags &= -257), (e = Ds(t, e, a)))
                : e.memoizedState !== null
                  ? (ra(), (e.child = t.child), (e.flags |= 128), (e = null))
                  : (ra(),
                    (n = l.fallback),
                    (d = e.mode),
                    (l = _i({ mode: 'visible', children: l.children }, d)),
                    (n = Da(n, d, a, null)),
                    (n.flags |= 2),
                    (l.return = e),
                    (n.return = e),
                    (l.sibling = n),
                    (e.child = l),
                    vl(e, t.child, null, a),
                    (l = e.child),
                    (l.memoizedState = Ns(a)),
                    (l.childLanes = Rs(t, f, a)),
                    (e.memoizedState = _s),
                    (e = n));
            else if ((oa(e), dc(d))) {
              if (((f = d.nextSibling && d.nextSibling.dataset), f))
                var E = f.dgst;
              ((f = E),
                (l = Error(s(419))),
                (l.stack = ''),
                (l.digest = f),
                Fl({ value: l, source: null, stack: null }),
                (e = Ds(t, e, a)));
            } else if (
              (wt || Pl(t, e, a, !1), (f = (a & t.childLanes) !== 0), wt || f)
            ) {
              if (
                ((f = xt),
                f !== null &&
                  ((l = a & -a),
                  (l = (l & 42) !== 0 ? 1 : hu(l)),
                  (l = (l & (f.suspendedLanes | a)) !== 0 ? 0 : l),
                  l !== 0 && l !== y.retryLane))
              )
                throw ((y.retryLane = l), sl(t, l), ye(f, t, l), lr);
              (d.data === '$?' || ks(), (e = Ds(t, e, a)));
            } else
              d.data === '$?'
                ? ((e.flags |= 192), (e.child = t.child), (e = null))
                : ((t = y.treeContext),
                  (_t = De(d.nextSibling)),
                  (Pt = e),
                  (dt = !0),
                  (ja = null),
                  (je = !1),
                  t !== null &&
                    ((xe[Ae++] = Ve),
                    (xe[Ae++] = Xe),
                    (xe[Ae++] = Ca),
                    (Ve = t.id),
                    (Xe = t.overflow),
                    (Ca = e)),
                  (e = zs(e, l.children)),
                  (e.flags |= 4096));
            return e;
          }
          return n
            ? (ra(),
              (n = l.fallback),
              (d = e.mode),
              (y = t.child),
              (E = y.sibling),
              (l = we(y, { mode: 'hidden', children: l.children })),
              (l.subtreeFlags = y.subtreeFlags & 65011712),
              E !== null
                ? (n = we(E, n))
                : ((n = Da(n, d, a, null)), (n.flags |= 2)),
              (n.return = e),
              (l.return = e),
              (l.sibling = n),
              (e.child = l),
              (l = n),
              (n = e.child),
              (d = t.child.memoizedState),
              d === null
                ? (d = Ns(a))
                : ((y = d.cachePool),
                  y !== null
                    ? ((E = Kt._currentValue),
                      (y = y.parent !== E ? { parent: E, pool: E } : y))
                    : (y = Ff()),
                  (d = { baseLanes: d.baseLanes | a, cachePool: y })),
              (n.memoizedState = d),
              (n.childLanes = Rs(t, f, a)),
              (e.memoizedState = _s),
              l)
            : (oa(e),
              (a = t.child),
              (t = a.sibling),
              (a = we(a, { mode: 'visible', children: l.children })),
              (a.return = e),
              (a.sibling = null),
              t !== null &&
                ((f = e.deletions),
                f === null
                  ? ((e.deletions = [t]), (e.flags |= 16))
                  : f.push(t)),
              (e.child = a),
              (e.memoizedState = null),
              a);
        }
        function zs(t, e) {
          return (
            (e = _i({ mode: 'visible', children: e }, t.mode)),
            (e.return = t),
            (t.child = e)
          );
        }
        function _i(t, e) {
          return (
            (t = re(22, t, null, e)),
            (t.lanes = 0),
            (t.stateNode = {
              _visibility: 1,
              _pendingMarkers: null,
              _retryCache: null,
              _transitions: null,
            }),
            t
          );
        }
        function Ds(t, e, a) {
          return (
            vl(e, t.child, null, a),
            (t = zs(e, e.pendingProps.children)),
            (t.flags |= 2),
            (e.memoizedState = null),
            t
          );
        }
        function hr(t, e, a) {
          t.lanes |= e;
          var l = t.alternate;
          (l !== null && (l.lanes |= e), ku(t.return, e, a));
        }
        function Cs(t, e, a, l, n) {
          var i = t.memoizedState;
          i === null
            ? (t.memoizedState = {
                isBackwards: e,
                rendering: null,
                renderingStartTime: 0,
                last: l,
                tail: a,
                tailMode: n,
              })
            : ((i.isBackwards = e),
              (i.rendering = null),
              (i.renderingStartTime = 0),
              (i.last = l),
              (i.tail = a),
              (i.tailMode = n));
        }
        function gr(t, e, a) {
          var l = e.pendingProps,
            n = l.revealOrder,
            i = l.tail;
          if ((Zt(t, e, l.children, a), (l = Yt.current), (l & 2) !== 0))
            ((l = (l & 1) | 2), (e.flags |= 128));
          else {
            if (t !== null && (t.flags & 128) !== 0)
              t: for (t = e.child; t !== null; ) {
                if (t.tag === 13) t.memoizedState !== null && hr(t, a, e);
                else if (t.tag === 19) hr(t, a, e);
                else if (t.child !== null) {
                  ((t.child.return = t), (t = t.child));
                  continue;
                }
                if (t === e) break t;
                for (; t.sibling === null; ) {
                  if (t.return === null || t.return === e) break t;
                  t = t.return;
                }
                ((t.sibling.return = t.return), (t = t.sibling));
              }
            l &= 1;
          }
          switch ((H(Yt, l), n)) {
            case 'forwards':
              for (a = e.child, n = null; a !== null; )
                ((t = a.alternate),
                  t !== null && Ti(t) === null && (n = a),
                  (a = a.sibling));
              ((a = n),
                a === null
                  ? ((n = e.child), (e.child = null))
                  : ((n = a.sibling), (a.sibling = null)),
                Cs(e, !1, n, a, i));
              break;
            case 'backwards':
              for (a = null, n = e.child, e.child = null; n !== null; ) {
                if (((t = n.alternate), t !== null && Ti(t) === null)) {
                  e.child = n;
                  break;
                }
                ((t = n.sibling), (n.sibling = a), (a = n), (n = t));
              }
              Cs(e, !0, a, null, i);
              break;
            case 'together':
              Cs(e, !1, null, null, void 0);
              break;
            default:
              e.memoizedState = null;
          }
          return e.child;
        }
        function ke(t, e, a) {
          if (
            (t !== null && (e.dependencies = t.dependencies),
            (ya |= e.lanes),
            (a & e.childLanes) === 0)
          )
            if (t !== null) {
              if ((Pl(t, e, a, !1), (a & e.childLanes) === 0)) return null;
            } else return null;
          if (t !== null && e.child !== t.child) throw Error(s(153));
          if (e.child !== null) {
            for (
              t = e.child, a = we(t, t.pendingProps), e.child = a, a.return = e;
              t.sibling !== null;
            )
              ((t = t.sibling),
                (a = a.sibling = we(t, t.pendingProps)),
                (a.return = e));
            a.sibling = null;
          }
          return e.child;
        }
        function Us(t, e) {
          return (t.lanes & e) !== 0
            ? !0
            : ((t = t.dependencies), !!(t !== null && si(t)));
        }
        function $g(t, e, a) {
          switch (e.tag) {
            case 3:
              (At(e, e.stateNode.containerInfo),
                ia(e, Kt, t.memoizedState.cache),
                Wl());
              break;
            case 27:
            case 5:
              cu(e);
              break;
            case 4:
              At(e, e.stateNode.containerInfo);
              break;
            case 10:
              ia(e, e.type, e.memoizedProps.value);
              break;
            case 13:
              var l = e.memoizedState;
              if (l !== null)
                return l.dehydrated !== null
                  ? (oa(e), (e.flags |= 128), null)
                  : (a & e.child.childLanes) !== 0
                    ? dr(t, e, a)
                    : (oa(e), (t = ke(t, e, a)), t !== null ? t.sibling : null);
              oa(e);
              break;
            case 19:
              var n = (t.flags & 128) !== 0;
              if (
                ((l = (a & e.childLanes) !== 0),
                l || (Pl(t, e, a, !1), (l = (a & e.childLanes) !== 0)),
                n)
              ) {
                if (l) return gr(t, e, a);
                e.flags |= 128;
              }
              if (
                ((n = e.memoizedState),
                n !== null &&
                  ((n.rendering = null),
                  (n.tail = null),
                  (n.lastEffect = null)),
                H(Yt, Yt.current),
                l)
              )
                break;
              return null;
            case 22:
            case 23:
              return ((e.lanes = 0), sr(t, e, a));
            case 24:
              ia(e, Kt, t.memoizedState.cache);
          }
          return ke(t, e, a);
        }
        function mr(t, e, a) {
          if (t !== null)
            if (t.memoizedProps !== e.pendingProps) wt = !0;
            else {
              if (!Us(t, a) && (e.flags & 128) === 0)
                return ((wt = !1), $g(t, e, a));
              wt = (t.flags & 131072) !== 0;
            }
          else
            ((wt = !1), dt && (e.flags & 1048576) !== 0 && Xf(e, ui, e.index));
          switch (((e.lanes = 0), e.tag)) {
            case 16:
              t: {
                t = e.pendingProps;
                var l = e.elementType,
                  n = l._init;
                if (((l = n(l._payload)), (e.type = l), typeof l == 'function'))
                  wu(l)
                    ? ((t = Ya(l, t)), (e.tag = 1), (e = or(null, e, l, t, a)))
                    : ((e.tag = 0), (e = Ms(null, e, l, t, a)));
                else {
                  if (l != null) {
                    if (((n = l.$$typeof), n === I)) {
                      ((e.tag = 11), (e = nr(null, e, l, t, a)));
                      break t;
                    } else if (n === ut) {
                      ((e.tag = 14), (e = ir(null, e, l, t, a)));
                      break t;
                    }
                  }
                  throw ((e = Ht(l) || l), Error(s(306, e, '')));
                }
              }
              return e;
            case 0:
              return Ms(t, e, e.type, e.pendingProps, a);
            case 1:
              return (
                (l = e.type),
                (n = Ya(l, e.pendingProps)),
                or(t, e, l, n, a)
              );
            case 3:
              t: {
                if ((At(e, e.stateNode.containerInfo), t === null))
                  throw Error(s(387));
                l = e.pendingProps;
                var i = e.memoizedState;
                ((n = i.element), as(t, e), un(e, l, null, a));
                var f = e.memoizedState;
                if (
                  ((l = f.cache),
                  ia(e, Kt, l),
                  l !== i.cache && Wu(e, [Kt], a, !0),
                  nn(),
                  (l = f.element),
                  i.isDehydrated)
                )
                  if (
                    ((i = { element: l, isDehydrated: !1, cache: f.cache }),
                    (e.updateQueue.baseState = i),
                    (e.memoizedState = i),
                    e.flags & 256)
                  ) {
                    e = rr(t, e, l, a);
                    break t;
                  } else if (l !== n) {
                    ((n = be(Error(s(424)), e)), Fl(n), (e = rr(t, e, l, a)));
                    break t;
                  } else {
                    switch (((t = e.stateNode.containerInfo), t.nodeType)) {
                      case 9:
                        t = t.body;
                        break;
                      default:
                        t = t.nodeName === 'HTML' ? t.ownerDocument.body : t;
                    }
                    for (
                      _t = De(t.firstChild),
                        Pt = e,
                        dt = !0,
                        ja = null,
                        je = !0,
                        a = $o(e, null, l, a),
                        e.child = a;
                      a;
                    )
                      ((a.flags = (a.flags & -3) | 4096), (a = a.sibling));
                  }
                else {
                  if ((Wl(), l === n)) {
                    e = ke(t, e, a);
                    break t;
                  }
                  Zt(t, e, l, a);
                }
                e = e.child;
              }
              return e;
            case 26:
              return (
                Mi(t, e),
                t === null
                  ? (a = bd(e.type, null, e.pendingProps, null))
                    ? (e.memoizedState = a)
                    : dt ||
                      ((a = e.type),
                      (t = e.pendingProps),
                      (l = Gi(F.current).createElement(a)),
                      (l[kt] = e),
                      (l[ee] = t),
                      Jt(l, a, t),
                      Gt(l),
                      (e.stateNode = l))
                  : (e.memoizedState = bd(
                      e.type,
                      t.memoizedProps,
                      e.pendingProps,
                      t.memoizedState
                    )),
                null
              );
            case 27:
              return (
                cu(e),
                t === null &&
                  dt &&
                  ((l = e.stateNode = yd(e.type, e.pendingProps, F.current)),
                  (Pt = e),
                  (je = !0),
                  (n = _t),
                  Sa(e.type) ? ((hc = n), (_t = De(l.firstChild))) : (_t = n)),
                Zt(t, e, e.pendingProps.children, a),
                Mi(t, e),
                t === null && (e.flags |= 4194304),
                e.child
              );
            case 5:
              return (
                t === null &&
                  dt &&
                  ((n = l = _t) &&
                    ((l = xm(l, e.type, e.pendingProps, je)),
                    l !== null
                      ? ((e.stateNode = l),
                        (Pt = e),
                        (_t = De(l.firstChild)),
                        (je = !1),
                        (n = !0))
                      : (n = !1)),
                  n || La(e)),
                cu(e),
                (n = e.type),
                (i = e.pendingProps),
                (f = t !== null ? t.memoizedProps : null),
                (l = i.children),
                fc(n, i)
                  ? (l = null)
                  : f !== null && fc(n, f) && (e.flags |= 32),
                e.memoizedState !== null &&
                  ((n = cs(t, e, Kg, null, null, a)), (Nn._currentValue = n)),
                Mi(t, e),
                Zt(t, e, l, a),
                e.child
              );
            case 6:
              return (
                t === null &&
                  dt &&
                  ((t = a = _t) &&
                    ((a = Am(a, e.pendingProps, je)),
                    a !== null
                      ? ((e.stateNode = a), (Pt = e), (_t = null), (t = !0))
                      : (t = !1)),
                  t || La(e)),
                null
              );
            case 13:
              return dr(t, e, a);
            case 4:
              return (
                At(e, e.stateNode.containerInfo),
                (l = e.pendingProps),
                t === null ? (e.child = vl(e, null, l, a)) : Zt(t, e, l, a),
                e.child
              );
            case 11:
              return nr(t, e, e.type, e.pendingProps, a);
            case 7:
              return (Zt(t, e, e.pendingProps, a), e.child);
            case 8:
              return (Zt(t, e, e.pendingProps.children, a), e.child);
            case 12:
              return (Zt(t, e, e.pendingProps.children, a), e.child);
            case 10:
              return (
                (l = e.pendingProps),
                ia(e, e.type, l.value),
                Zt(t, e, l.children, a),
                e.child
              );
            case 9:
              return (
                (n = e.type._context),
                (l = e.pendingProps.children),
                Ba(e),
                (n = Wt(n)),
                (l = l(n)),
                (e.flags |= 1),
                Zt(t, e, l, a),
                e.child
              );
            case 14:
              return ir(t, e, e.type, e.pendingProps, a);
            case 15:
              return ur(t, e, e.type, e.pendingProps, a);
            case 19:
              return gr(t, e, a);
            case 31:
              return (
                (l = e.pendingProps),
                (a = e.mode),
                (l = { mode: l.mode, children: l.children }),
                t === null
                  ? ((a = _i(l, a)),
                    (a.ref = e.ref),
                    (e.child = a),
                    (a.return = e),
                    (e = a))
                  : ((a = we(t.child, l)),
                    (a.ref = e.ref),
                    (e.child = a),
                    (a.return = e),
                    (e = a)),
                e
              );
            case 22:
              return sr(t, e, a);
            case 24:
              return (
                Ba(e),
                (l = Wt(Kt)),
                t === null
                  ? ((n = Iu()),
                    n === null &&
                      ((n = xt),
                      (i = Fu()),
                      (n.pooledCache = i),
                      i.refCount++,
                      i !== null && (n.pooledCacheLanes |= a),
                      (n = i)),
                    (e.memoizedState = { parent: l, cache: n }),
                    es(e),
                    ia(e, Kt, n))
                  : ((t.lanes & a) !== 0 &&
                      (as(t, e), un(e, null, null, a), nn()),
                    (n = t.memoizedState),
                    (i = e.memoizedState),
                    n.parent !== l
                      ? ((n = { parent: l, cache: l }),
                        (e.memoizedState = n),
                        e.lanes === 0 &&
                          (e.memoizedState = e.updateQueue.baseState = n),
                        ia(e, Kt, l))
                      : ((l = i.cache),
                        ia(e, Kt, l),
                        l !== n.cache && Wu(e, [Kt], a, !0))),
                Zt(t, e, e.pendingProps.children, a),
                e.child
              );
            case 29:
              throw e.pendingProps;
          }
          throw Error(s(156, e.tag));
        }
        function We(t) {
          t.flags |= 4;
        }
        function yr(t, e) {
          if (e.type !== 'stylesheet' || (e.state.loading & 4) !== 0)
            t.flags &= -16777217;
          else if (((t.flags |= 16777216), !Ed(e))) {
            if (
              ((e = Te.current),
              e !== null &&
                ((ct & 4194048) === ct
                  ? Le !== null
                  : ((ct & 62914560) !== ct && (ct & 536870912) === 0) ||
                    e !== Le))
            )
              throw ((an = ts), Pf);
            t.flags |= 8192;
          }
        }
        function Ni(t, e) {
          (e !== null && (t.flags |= 4),
            t.flags & 16384 &&
              ((e = t.tag !== 22 ? Zc() : 536870912),
              (t.lanes |= e),
              (Al |= e)));
        }
        function hn(t, e) {
          if (!dt)
            switch (t.tailMode) {
              case 'hidden':
                e = t.tail;
                for (var a = null; e !== null; )
                  (e.alternate !== null && (a = e), (e = e.sibling));
                a === null ? (t.tail = null) : (a.sibling = null);
                break;
              case 'collapsed':
                a = t.tail;
                for (var l = null; a !== null; )
                  (a.alternate !== null && (l = a), (a = a.sibling));
                l === null
                  ? e || t.tail === null
                    ? (t.tail = null)
                    : (t.tail.sibling = null)
                  : (l.sibling = null);
            }
        }
        function Ot(t) {
          var e = t.alternate !== null && t.alternate.child === t.child,
            a = 0,
            l = 0;
          if (e)
            for (var n = t.child; n !== null; )
              ((a |= n.lanes | n.childLanes),
                (l |= n.subtreeFlags & 65011712),
                (l |= n.flags & 65011712),
                (n.return = t),
                (n = n.sibling));
          else
            for (n = t.child; n !== null; )
              ((a |= n.lanes | n.childLanes),
                (l |= n.subtreeFlags),
                (l |= n.flags),
                (n.return = t),
                (n = n.sibling));
          return ((t.subtreeFlags |= l), (t.childLanes = a), e);
        }
        function Jg(t, e, a) {
          var l = e.pendingProps;
          switch ((Zu(e), e.tag)) {
            case 31:
            case 16:
            case 15:
            case 0:
            case 11:
            case 7:
            case 8:
            case 12:
            case 9:
            case 14:
              return (Ot(e), null);
            case 1:
              return (Ot(e), null);
            case 3:
              return (
                (a = e.stateNode),
                (l = null),
                t !== null && (l = t.memoizedState.cache),
                e.memoizedState.cache !== l && (e.flags |= 2048),
                Ze(Kt),
                ea(),
                a.pendingContext &&
                  ((a.context = a.pendingContext), (a.pendingContext = null)),
                (t === null || t.child === null) &&
                  (kl(e)
                    ? We(e)
                    : t === null ||
                      (t.memoizedState.isDehydrated && (e.flags & 256) === 0) ||
                      ((e.flags |= 1024), $f())),
                Ot(e),
                null
              );
            case 26:
              return (
                (a = e.memoizedState),
                t === null
                  ? (We(e),
                    a !== null
                      ? (Ot(e), yr(e, a))
                      : (Ot(e), (e.flags &= -16777217)))
                  : a
                    ? a !== t.memoizedState
                      ? (We(e), Ot(e), yr(e, a))
                      : (Ot(e), (e.flags &= -16777217))
                    : (t.memoizedProps !== l && We(e),
                      Ot(e),
                      (e.flags &= -16777217)),
                null
              );
            case 27:
              (Kn(e), (a = F.current));
              var n = e.type;
              if (t !== null && e.stateNode != null)
                t.memoizedProps !== l && We(e);
              else {
                if (!l) {
                  if (e.stateNode === null) throw Error(s(166));
                  return (Ot(e), null);
                }
                ((t = X.current),
                  kl(e)
                    ? Qf(e)
                    : ((t = yd(n, l, a)), (e.stateNode = t), We(e)));
              }
              return (Ot(e), null);
            case 5:
              if ((Kn(e), (a = e.type), t !== null && e.stateNode != null))
                t.memoizedProps !== l && We(e);
              else {
                if (!l) {
                  if (e.stateNode === null) throw Error(s(166));
                  return (Ot(e), null);
                }
                if (((t = X.current), kl(e))) Qf(e);
                else {
                  switch (((n = Gi(F.current)), t)) {
                    case 1:
                      t = n.createElementNS('http://www.w3.org/2000/svg', a);
                      break;
                    case 2:
                      t = n.createElementNS(
                        'http://www.w3.org/1998/Math/MathML',
                        a
                      );
                      break;
                    default:
                      switch (a) {
                        case 'svg':
                          t = n.createElementNS(
                            'http://www.w3.org/2000/svg',
                            a
                          );
                          break;
                        case 'math':
                          t = n.createElementNS(
                            'http://www.w3.org/1998/Math/MathML',
                            a
                          );
                          break;
                        case 'script':
                          ((t = n.createElement('div')),
                            (t.innerHTML = '<script><\/script>'),
                            (t = t.removeChild(t.firstChild)));
                          break;
                        case 'select':
                          ((t =
                            typeof l.is == 'string'
                              ? n.createElement('select', { is: l.is })
                              : n.createElement('select')),
                            l.multiple
                              ? (t.multiple = !0)
                              : l.size && (t.size = l.size));
                          break;
                        default:
                          t =
                            typeof l.is == 'string'
                              ? n.createElement(a, { is: l.is })
                              : n.createElement(a);
                      }
                  }
                  ((t[kt] = e), (t[ee] = l));
                  t: for (n = e.child; n !== null; ) {
                    if (n.tag === 5 || n.tag === 6) t.appendChild(n.stateNode);
                    else if (n.tag !== 4 && n.tag !== 27 && n.child !== null) {
                      ((n.child.return = n), (n = n.child));
                      continue;
                    }
                    if (n === e) break t;
                    for (; n.sibling === null; ) {
                      if (n.return === null || n.return === e) break t;
                      n = n.return;
                    }
                    ((n.sibling.return = n.return), (n = n.sibling));
                  }
                  e.stateNode = t;
                  t: switch ((Jt(t, a, l), a)) {
                    case 'button':
                    case 'input':
                    case 'select':
                    case 'textarea':
                      t = !!l.autoFocus;
                      break t;
                    case 'img':
                      t = !0;
                      break t;
                    default:
                      t = !1;
                  }
                  t && We(e);
                }
              }
              return (Ot(e), (e.flags &= -16777217), null);
            case 6:
              if (t && e.stateNode != null) t.memoizedProps !== l && We(e);
              else {
                if (typeof l != 'string' && e.stateNode === null)
                  throw Error(s(166));
                if (((t = F.current), kl(e))) {
                  if (
                    ((t = e.stateNode),
                    (a = e.memoizedProps),
                    (l = null),
                    (n = Pt),
                    n !== null)
                  )
                    switch (n.tag) {
                      case 27:
                      case 5:
                        l = n.memoizedProps;
                    }
                  ((t[kt] = e),
                    (t = !!(
                      t.nodeValue === a ||
                      (l !== null && l.suppressHydrationWarning === !0) ||
                      fd(t.nodeValue, a)
                    )),
                    t || La(e));
                } else
                  ((t = Gi(t).createTextNode(l)),
                    (t[kt] = e),
                    (e.stateNode = t));
              }
              return (Ot(e), null);
            case 13:
              if (
                ((l = e.memoizedState),
                t === null ||
                  (t.memoizedState !== null &&
                    t.memoizedState.dehydrated !== null))
              ) {
                if (((n = kl(e)), l !== null && l.dehydrated !== null)) {
                  if (t === null) {
                    if (!n) throw Error(s(318));
                    if (
                      ((n = e.memoizedState),
                      (n = n !== null ? n.dehydrated : null),
                      !n)
                    )
                      throw Error(s(317));
                    n[kt] = e;
                  } else
                    (Wl(),
                      (e.flags & 128) === 0 && (e.memoizedState = null),
                      (e.flags |= 4));
                  (Ot(e), (n = !1));
                } else
                  ((n = $f()),
                    t !== null &&
                      t.memoizedState !== null &&
                      (t.memoizedState.hydrationErrors = n),
                    (n = !0));
                if (!n) return e.flags & 256 ? (Je(e), e) : (Je(e), null);
              }
              if ((Je(e), (e.flags & 128) !== 0)) return ((e.lanes = a), e);
              if (
                ((a = l !== null),
                (t = t !== null && t.memoizedState !== null),
                a)
              ) {
                ((l = e.child),
                  (n = null),
                  l.alternate !== null &&
                    l.alternate.memoizedState !== null &&
                    l.alternate.memoizedState.cachePool !== null &&
                    (n = l.alternate.memoizedState.cachePool.pool));
                var i = null;
                (l.memoizedState !== null &&
                  l.memoizedState.cachePool !== null &&
                  (i = l.memoizedState.cachePool.pool),
                  i !== n && (l.flags |= 2048));
              }
              return (
                a !== t && a && (e.child.flags |= 8192),
                Ni(e, e.updateQueue),
                Ot(e),
                null
              );
            case 4:
              return (
                ea(),
                t === null && nc(e.stateNode.containerInfo),
                Ot(e),
                null
              );
            case 10:
              return (Ze(e.type), Ot(e), null);
            case 19:
              if ((B(Yt), (n = e.memoizedState), n === null))
                return (Ot(e), null);
              if (((l = (e.flags & 128) !== 0), (i = n.rendering), i === null))
                if (l) hn(n, !1);
                else {
                  if (Nt !== 0 || (t !== null && (t.flags & 128) !== 0))
                    for (t = e.child; t !== null; ) {
                      if (((i = Ti(t)), i !== null)) {
                        for (
                          e.flags |= 128,
                            hn(n, !1),
                            t = i.updateQueue,
                            e.updateQueue = t,
                            Ni(e, t),
                            e.subtreeFlags = 0,
                            t = a,
                            a = e.child;
                          a !== null;
                        )
                          (Vf(a, t), (a = a.sibling));
                        return (H(Yt, (Yt.current & 1) | 2), e.child);
                      }
                      t = t.sibling;
                    }
                  n.tail !== null &&
                    Ue() > Di &&
                    ((e.flags |= 128),
                    (l = !0),
                    hn(n, !1),
                    (e.lanes = 4194304));
                }
              else {
                if (!l)
                  if (((t = Ti(i)), t !== null)) {
                    if (
                      ((e.flags |= 128),
                      (l = !0),
                      (t = t.updateQueue),
                      (e.updateQueue = t),
                      Ni(e, t),
                      hn(n, !0),
                      n.tail === null &&
                        n.tailMode === 'hidden' &&
                        !i.alternate &&
                        !dt)
                    )
                      return (Ot(e), null);
                  } else
                    2 * Ue() - n.renderingStartTime > Di &&
                      a !== 536870912 &&
                      ((e.flags |= 128),
                      (l = !0),
                      hn(n, !1),
                      (e.lanes = 4194304));
                n.isBackwards
                  ? ((i.sibling = e.child), (e.child = i))
                  : ((t = n.last),
                    t !== null ? (t.sibling = i) : (e.child = i),
                    (n.last = i));
              }
              return n.tail !== null
                ? ((e = n.tail),
                  (n.rendering = e),
                  (n.tail = e.sibling),
                  (n.renderingStartTime = Ue()),
                  (e.sibling = null),
                  (t = Yt.current),
                  H(Yt, l ? (t & 1) | 2 : t & 1),
                  e)
                : (Ot(e), null);
            case 22:
            case 23:
              return (
                Je(e),
                us(),
                (l = e.memoizedState !== null),
                t !== null
                  ? (t.memoizedState !== null) !== l && (e.flags |= 8192)
                  : l && (e.flags |= 8192),
                l
                  ? (a & 536870912) !== 0 &&
                    (e.flags & 128) === 0 &&
                    (Ot(e), e.subtreeFlags & 6 && (e.flags |= 8192))
                  : Ot(e),
                (a = e.updateQueue),
                a !== null && Ni(e, a.retryQueue),
                (a = null),
                t !== null &&
                  t.memoizedState !== null &&
                  t.memoizedState.cachePool !== null &&
                  (a = t.memoizedState.cachePool.pool),
                (l = null),
                e.memoizedState !== null &&
                  e.memoizedState.cachePool !== null &&
                  (l = e.memoizedState.cachePool.pool),
                l !== a && (e.flags |= 2048),
                t !== null && B(qa),
                null
              );
            case 24:
              return (
                (a = null),
                t !== null && (a = t.memoizedState.cache),
                e.memoizedState.cache !== a && (e.flags |= 2048),
                Ze(Kt),
                Ot(e),
                null
              );
            case 25:
              return null;
            case 30:
              return null;
          }
          throw Error(s(156, e.tag));
        }
        function kg(t, e) {
          switch ((Zu(e), e.tag)) {
            case 1:
              return (
                (t = e.flags),
                t & 65536 ? ((e.flags = (t & -65537) | 128), e) : null
              );
            case 3:
              return (
                Ze(Kt),
                ea(),
                (t = e.flags),
                (t & 65536) !== 0 && (t & 128) === 0
                  ? ((e.flags = (t & -65537) | 128), e)
                  : null
              );
            case 26:
            case 27:
            case 5:
              return (Kn(e), null);
            case 13:
              if (
                (Je(e),
                (t = e.memoizedState),
                t !== null && t.dehydrated !== null)
              ) {
                if (e.alternate === null) throw Error(s(340));
                Wl();
              }
              return (
                (t = e.flags),
                t & 65536 ? ((e.flags = (t & -65537) | 128), e) : null
              );
            case 19:
              return (B(Yt), null);
            case 4:
              return (ea(), null);
            case 10:
              return (Ze(e.type), null);
            case 22:
            case 23:
              return (
                Je(e),
                us(),
                t !== null && B(qa),
                (t = e.flags),
                t & 65536 ? ((e.flags = (t & -65537) | 128), e) : null
              );
            case 24:
              return (Ze(Kt), null);
            case 25:
              return null;
            default:
              return null;
          }
        }
        function pr(t, e) {
          switch ((Zu(e), e.tag)) {
            case 3:
              (Ze(Kt), ea());
              break;
            case 26:
            case 27:
            case 5:
              Kn(e);
              break;
            case 4:
              ea();
              break;
            case 13:
              Je(e);
              break;
            case 19:
              B(Yt);
              break;
            case 10:
              Ze(e.type);
              break;
            case 22:
            case 23:
              (Je(e), us(), t !== null && B(qa));
              break;
            case 24:
              Ze(Kt);
          }
        }
        function gn(t, e) {
          try {
            var a = e.updateQueue,
              l = a !== null ? a.lastEffect : null;
            if (l !== null) {
              var n = l.next;
              a = n;
              do {
                if ((a.tag & t) === t) {
                  l = void 0;
                  var i = a.create,
                    f = a.inst;
                  ((l = i()), (f.destroy = l));
                }
                a = a.next;
              } while (a !== n);
            }
          } catch (d) {
            St(e, e.return, d);
          }
        }
        function da(t, e, a) {
          try {
            var l = e.updateQueue,
              n = l !== null ? l.lastEffect : null;
            if (n !== null) {
              var i = n.next;
              l = i;
              do {
                if ((l.tag & t) === t) {
                  var f = l.inst,
                    d = f.destroy;
                  if (d !== void 0) {
                    ((f.destroy = void 0), (n = e));
                    var y = a,
                      E = d;
                    try {
                      E();
                    } catch (R) {
                      St(n, y, R);
                    }
                  }
                }
                l = l.next;
              } while (l !== i);
            }
          } catch (R) {
            St(e, e.return, R);
          }
        }
        function vr(t) {
          var e = t.updateQueue;
          if (e !== null) {
            var a = t.stateNode;
            try {
              no(e, a);
            } catch (l) {
              St(t, t.return, l);
            }
          }
        }
        function br(t, e, a) {
          ((a.props = Ya(t.type, t.memoizedProps)),
            (a.state = t.memoizedState));
          try {
            a.componentWillUnmount();
          } catch (l) {
            St(t, e, l);
          }
        }
        function mn(t, e) {
          try {
            var a = t.ref;
            if (a !== null) {
              switch (t.tag) {
                case 26:
                case 27:
                case 5:
                  var l = t.stateNode;
                  break;
                case 30:
                  l = t.stateNode;
                  break;
                default:
                  l = t.stateNode;
              }
              typeof a == 'function' ? (t.refCleanup = a(l)) : (a.current = l);
            }
          } catch (n) {
            St(t, e, n);
          }
        }
        function He(t, e) {
          var a = t.ref,
            l = t.refCleanup;
          if (a !== null)
            if (typeof l == 'function')
              try {
                l();
              } catch (n) {
                St(t, e, n);
              } finally {
                ((t.refCleanup = null),
                  (t = t.alternate),
                  t != null && (t.refCleanup = null));
              }
            else if (typeof a == 'function')
              try {
                a(null);
              } catch (n) {
                St(t, e, n);
              }
            else a.current = null;
        }
        function Sr(t) {
          var e = t.type,
            a = t.memoizedProps,
            l = t.stateNode;
          try {
            t: switch (e) {
              case 'button':
              case 'input':
              case 'select':
              case 'textarea':
                a.autoFocus && l.focus();
                break t;
              case 'img':
                a.src ? (l.src = a.src) : a.srcSet && (l.srcset = a.srcSet);
            }
          } catch (n) {
            St(t, t.return, n);
          }
        }
        function js(t, e, a) {
          try {
            var l = t.stateNode;
            (ym(l, t.type, a, e), (l[ee] = e));
          } catch (n) {
            St(t, t.return, n);
          }
        }
        function xr(t) {
          return (
            t.tag === 5 ||
            t.tag === 3 ||
            t.tag === 26 ||
            (t.tag === 27 && Sa(t.type)) ||
            t.tag === 4
          );
        }
        function Ls(t) {
          t: for (;;) {
            for (; t.sibling === null; ) {
              if (t.return === null || xr(t.return)) return null;
              t = t.return;
            }
            for (
              t.sibling.return = t.return, t = t.sibling;
              t.tag !== 5 && t.tag !== 6 && t.tag !== 18;
            ) {
              if (
                (t.tag === 27 && Sa(t.type)) ||
                t.flags & 2 ||
                t.child === null ||
                t.tag === 4
              )
                continue t;
              ((t.child.return = t), (t = t.child));
            }
            if (!(t.flags & 2)) return t.stateNode;
          }
        }
        function Hs(t, e, a) {
          var l = t.tag;
          if (l === 5 || l === 6)
            ((t = t.stateNode),
              e
                ? (a.nodeType === 9
                    ? a.body
                    : a.nodeName === 'HTML'
                      ? a.ownerDocument.body
                      : a
                  ).insertBefore(t, e)
                : ((e =
                    a.nodeType === 9
                      ? a.body
                      : a.nodeName === 'HTML'
                        ? a.ownerDocument.body
                        : a),
                  e.appendChild(t),
                  (a = a._reactRootContainer),
                  a != null || e.onclick !== null || (e.onclick = Yi)));
          else if (
            l !== 4 &&
            (l === 27 && Sa(t.type) && ((a = t.stateNode), (e = null)),
            (t = t.child),
            t !== null)
          )
            for (Hs(t, e, a), t = t.sibling; t !== null; )
              (Hs(t, e, a), (t = t.sibling));
        }
        function Ri(t, e, a) {
          var l = t.tag;
          if (l === 5 || l === 6)
            ((t = t.stateNode), e ? a.insertBefore(t, e) : a.appendChild(t));
          else if (
            l !== 4 &&
            (l === 27 && Sa(t.type) && (a = t.stateNode),
            (t = t.child),
            t !== null)
          )
            for (Ri(t, e, a), t = t.sibling; t !== null; )
              (Ri(t, e, a), (t = t.sibling));
        }
        function Ar(t) {
          var e = t.stateNode,
            a = t.memoizedProps;
          try {
            for (var l = t.type, n = e.attributes; n.length; )
              e.removeAttributeNode(n[0]);
            (Jt(e, l, a), (e[kt] = t), (e[ee] = a));
          } catch (i) {
            St(t, t.return, i);
          }
        }
        var Fe = !1,
          Ut = !1,
          Bs = !1,
          Tr = typeof WeakSet == 'function' ? WeakSet : Set,
          Vt = null;
        function Wg(t, e) {
          if (((t = t.containerInfo), (sc = $i), (t = Uf(t)), Lu(t))) {
            if ('selectionStart' in t)
              var a = { start: t.selectionStart, end: t.selectionEnd };
            else {
              a = ((a = t.ownerDocument) && a.defaultView) || window;
              var l = a.getSelection && a.getSelection();
              if (l && l.rangeCount !== 0) {
                a = l.anchorNode;
                var n = l.anchorOffset,
                  i = l.focusNode;
                l = l.focusOffset;
                var f = 0,
                  d = -1,
                  y = -1,
                  E = 0,
                  R = 0,
                  U = t,
                  O = null;
                t: for (;;) {
                  for (
                    var M;
                    U !== a || (n !== 0 && U.nodeType !== 3) || (d = f + n),
                      U !== i || (l !== 0 && U.nodeType !== 3) || (y = f + l),
                      U.nodeType === 3 && (f += U.nodeValue.length),
                      (M = U.firstChild) !== null;
                  )
                    ((O = U), (U = M));
                  for (;;) {
                    if (U === t) break t;
                    if (
                      (O === a && ++E === n && (d = f),
                      O === i && ++R === l && (y = f),
                      (M = U.nextSibling) !== null)
                    )
                      break;
                    ((U = O), (O = U.parentNode));
                  }
                  U = M;
                }
                a = d === -1 || y === -1 ? null : { start: d, end: y };
              } else a = null;
            }
            a = a || { start: 0, end: 0 };
          } else a = null;
          for (
            cc = { focusedElem: t, selectionRange: a }, $i = !1, Vt = e;
            Vt !== null;
          )
            if (
              ((e = Vt),
              (t = e.child),
              (e.subtreeFlags & 1024) !== 0 && t !== null)
            )
              ((t.return = e), (Vt = t));
            else
              for (; Vt !== null; ) {
                switch (((e = Vt), (i = e.alternate), (t = e.flags), e.tag)) {
                  case 0:
                    break;
                  case 11:
                  case 15:
                    break;
                  case 1:
                    if ((t & 1024) !== 0 && i !== null) {
                      ((t = void 0),
                        (a = e),
                        (n = i.memoizedProps),
                        (i = i.memoizedState),
                        (l = a.stateNode));
                      try {
                        var J = Ya(a.type, n);
                        ((t = l.getSnapshotBeforeUpdate(J, i)),
                          (l.__reactInternalSnapshotBeforeUpdate = t));
                      } catch (Z) {
                        St(a, a.return, Z);
                      }
                    }
                    break;
                  case 3:
                    if ((t & 1024) !== 0) {
                      if (
                        ((t = e.stateNode.containerInfo),
                        (a = t.nodeType),
                        a === 9)
                      )
                        rc(t);
                      else if (a === 1)
                        switch (t.nodeName) {
                          case 'HEAD':
                          case 'HTML':
                          case 'BODY':
                            rc(t);
                            break;
                          default:
                            t.textContent = '';
                        }
                    }
                    break;
                  case 5:
                  case 26:
                  case 27:
                  case 6:
                  case 4:
                  case 17:
                    break;
                  default:
                    if ((t & 1024) !== 0) throw Error(s(163));
                }
                if (((t = e.sibling), t !== null)) {
                  ((t.return = e.return), (Vt = t));
                  break;
                }
                Vt = e.return;
              }
        }
        function Er(t, e, a) {
          var l = a.flags;
          switch (a.tag) {
            case 0:
            case 11:
            case 15:
              (ha(t, a), l & 4 && gn(5, a));
              break;
            case 1:
              if ((ha(t, a), l & 4))
                if (((t = a.stateNode), e === null))
                  try {
                    t.componentDidMount();
                  } catch (f) {
                    St(a, a.return, f);
                  }
                else {
                  var n = Ya(a.type, e.memoizedProps);
                  e = e.memoizedState;
                  try {
                    t.componentDidUpdate(
                      n,
                      e,
                      t.__reactInternalSnapshotBeforeUpdate
                    );
                  } catch (f) {
                    St(a, a.return, f);
                  }
                }
              (l & 64 && vr(a), l & 512 && mn(a, a.return));
              break;
            case 3:
              if ((ha(t, a), l & 64 && ((t = a.updateQueue), t !== null))) {
                if (((e = null), a.child !== null))
                  switch (a.child.tag) {
                    case 27:
                    case 5:
                      e = a.child.stateNode;
                      break;
                    case 1:
                      e = a.child.stateNode;
                  }
                try {
                  no(t, e);
                } catch (f) {
                  St(a, a.return, f);
                }
              }
              break;
            case 27:
              e === null && l & 4 && Ar(a);
            case 26:
            case 5:
              (ha(t, a),
                e === null && l & 4 && Sr(a),
                l & 512 && mn(a, a.return));
              break;
            case 12:
              ha(t, a);
              break;
            case 13:
              (ha(t, a),
                l & 4 && _r(t, a),
                l & 64 &&
                  ((t = a.memoizedState),
                  t !== null &&
                    ((t = t.dehydrated),
                    t !== null && ((a = im.bind(null, a)), Tm(t, a)))));
              break;
            case 22:
              if (((l = a.memoizedState !== null || Fe), !l)) {
                ((e = (e !== null && e.memoizedState !== null) || Ut),
                  (n = Fe));
                var i = Ut;
                ((Fe = l),
                  (Ut = e) && !i
                    ? ga(t, a, (a.subtreeFlags & 8772) !== 0)
                    : ha(t, a),
                  (Fe = n),
                  (Ut = i));
              }
              break;
            case 30:
              break;
            default:
              ha(t, a);
          }
        }
        function Or(t) {
          var e = t.alternate;
          (e !== null && ((t.alternate = null), Or(e)),
            (t.child = null),
            (t.deletions = null),
            (t.sibling = null),
            t.tag === 5 && ((e = t.stateNode), e !== null && yu(e)),
            (t.stateNode = null),
            (t.return = null),
            (t.dependencies = null),
            (t.memoizedProps = null),
            (t.memoizedState = null),
            (t.pendingProps = null),
            (t.stateNode = null),
            (t.updateQueue = null));
        }
        var Tt = null,
          ne = !1;
        function Pe(t, e, a) {
          for (a = a.child; a !== null; ) (Mr(t, e, a), (a = a.sibling));
        }
        function Mr(t, e, a) {
          if (ce && typeof ce.onCommitFiberUnmount == 'function')
            try {
              ce.onCommitFiberUnmount(Ll, a);
            } catch {}
          switch (a.tag) {
            case 26:
              (Ut || He(a, e),
                Pe(t, e, a),
                a.memoizedState
                  ? a.memoizedState.count--
                  : a.stateNode &&
                    ((a = a.stateNode), a.parentNode.removeChild(a)));
              break;
            case 27:
              Ut || He(a, e);
              var l = Tt,
                n = ne;
              (Sa(a.type) && ((Tt = a.stateNode), (ne = !1)),
                Pe(t, e, a),
                En(a.stateNode),
                (Tt = l),
                (ne = n));
              break;
            case 5:
              Ut || He(a, e);
            case 6:
              if (
                ((l = Tt),
                (n = ne),
                (Tt = null),
                Pe(t, e, a),
                (Tt = l),
                (ne = n),
                Tt !== null)
              )
                if (ne)
                  try {
                    (Tt.nodeType === 9
                      ? Tt.body
                      : Tt.nodeName === 'HTML'
                        ? Tt.ownerDocument.body
                        : Tt
                    ).removeChild(a.stateNode);
                  } catch (i) {
                    St(a, e, i);
                  }
                else
                  try {
                    Tt.removeChild(a.stateNode);
                  } catch (i) {
                    St(a, e, i);
                  }
              break;
            case 18:
              Tt !== null &&
                (ne
                  ? ((t = Tt),
                    gd(
                      t.nodeType === 9
                        ? t.body
                        : t.nodeName === 'HTML'
                          ? t.ownerDocument.body
                          : t,
                      a.stateNode
                    ),
                    Cn(t))
                  : gd(Tt, a.stateNode));
              break;
            case 4:
              ((l = Tt),
                (n = ne),
                (Tt = a.stateNode.containerInfo),
                (ne = !0),
                Pe(t, e, a),
                (Tt = l),
                (ne = n));
              break;
            case 0:
            case 11:
            case 14:
            case 15:
              (Ut || da(2, a, e), Ut || da(4, a, e), Pe(t, e, a));
              break;
            case 1:
              (Ut ||
                (He(a, e),
                (l = a.stateNode),
                typeof l.componentWillUnmount == 'function' && br(a, e, l)),
                Pe(t, e, a));
              break;
            case 21:
              Pe(t, e, a);
              break;
            case 22:
              ((Ut = (l = Ut) || a.memoizedState !== null),
                Pe(t, e, a),
                (Ut = l));
              break;
            default:
              Pe(t, e, a);
          }
        }
        function _r(t, e) {
          if (
            e.memoizedState === null &&
            ((t = e.alternate),
            t !== null &&
              ((t = t.memoizedState),
              t !== null && ((t = t.dehydrated), t !== null)))
          )
            try {
              Cn(t);
            } catch (a) {
              St(e, e.return, a);
            }
        }
        function Fg(t) {
          switch (t.tag) {
            case 13:
            case 19:
              var e = t.stateNode;
              return (e === null && (e = t.stateNode = new Tr()), e);
            case 22:
              return (
                (t = t.stateNode),
                (e = t._retryCache),
                e === null && (e = t._retryCache = new Tr()),
                e
              );
            default:
              throw Error(s(435, t.tag));
          }
        }
        function qs(t, e) {
          var a = Fg(t);
          e.forEach(function (l) {
            var n = um.bind(null, t, l);
            a.has(l) || (a.add(l), l.then(n, n));
          });
        }
        function de(t, e) {
          var a = e.deletions;
          if (a !== null)
            for (var l = 0; l < a.length; l++) {
              var n = a[l],
                i = t,
                f = e,
                d = f;
              t: for (; d !== null; ) {
                switch (d.tag) {
                  case 27:
                    if (Sa(d.type)) {
                      ((Tt = d.stateNode), (ne = !1));
                      break t;
                    }
                    break;
                  case 5:
                    ((Tt = d.stateNode), (ne = !1));
                    break t;
                  case 3:
                  case 4:
                    ((Tt = d.stateNode.containerInfo), (ne = !0));
                    break t;
                }
                d = d.return;
              }
              if (Tt === null) throw Error(s(160));
              (Mr(i, f, n),
                (Tt = null),
                (ne = !1),
                (i = n.alternate),
                i !== null && (i.return = null),
                (n.return = null));
            }
          if (e.subtreeFlags & 13878)
            for (e = e.child; e !== null; ) (Nr(e, t), (e = e.sibling));
        }
        var ze = null;
        function Nr(t, e) {
          var a = t.alternate,
            l = t.flags;
          switch (t.tag) {
            case 0:
            case 11:
            case 14:
            case 15:
              (de(e, t),
                he(t),
                l & 4 && (da(3, t, t.return), gn(3, t), da(5, t, t.return)));
              break;
            case 1:
              (de(e, t),
                he(t),
                l & 512 && (Ut || a === null || He(a, a.return)),
                l & 64 &&
                  Fe &&
                  ((t = t.updateQueue),
                  t !== null &&
                    ((l = t.callbacks),
                    l !== null &&
                      ((a = t.shared.hiddenCallbacks),
                      (t.shared.hiddenCallbacks =
                        a === null ? l : a.concat(l))))));
              break;
            case 26:
              var n = ze;
              if (
                (de(e, t),
                he(t),
                l & 512 && (Ut || a === null || He(a, a.return)),
                l & 4)
              ) {
                var i = a !== null ? a.memoizedState : null;
                if (((l = t.memoizedState), a === null))
                  if (l === null)
                    if (t.stateNode === null) {
                      t: {
                        ((l = t.type),
                          (a = t.memoizedProps),
                          (n = n.ownerDocument || n));
                        e: switch (l) {
                          case 'title':
                            ((i = n.getElementsByTagName('title')[0]),
                              (!i ||
                                i[ql] ||
                                i[kt] ||
                                i.namespaceURI ===
                                  'http://www.w3.org/2000/svg' ||
                                i.hasAttribute('itemprop')) &&
                                ((i = n.createElement(l)),
                                n.head.insertBefore(
                                  i,
                                  n.querySelector('head > title')
                                )),
                              Jt(i, l, a),
                              (i[kt] = t),
                              Gt(i),
                              (l = i));
                            break t;
                          case 'link':
                            var f = Ad('link', 'href', n).get(
                              l + (a.href || '')
                            );
                            if (f) {
                              for (var d = 0; d < f.length; d++)
                                if (
                                  ((i = f[d]),
                                  i.getAttribute('href') ===
                                    (a.href == null || a.href === ''
                                      ? null
                                      : a.href) &&
                                    i.getAttribute('rel') ===
                                      (a.rel == null ? null : a.rel) &&
                                    i.getAttribute('title') ===
                                      (a.title == null ? null : a.title) &&
                                    i.getAttribute('crossorigin') ===
                                      (a.crossOrigin == null
                                        ? null
                                        : a.crossOrigin))
                                ) {
                                  f.splice(d, 1);
                                  break e;
                                }
                            }
                            ((i = n.createElement(l)),
                              Jt(i, l, a),
                              n.head.appendChild(i));
                            break;
                          case 'meta':
                            if (
                              (f = Ad('meta', 'content', n).get(
                                l + (a.content || '')
                              ))
                            ) {
                              for (d = 0; d < f.length; d++)
                                if (
                                  ((i = f[d]),
                                  i.getAttribute('content') ===
                                    (a.content == null
                                      ? null
                                      : '' + a.content) &&
                                    i.getAttribute('name') ===
                                      (a.name == null ? null : a.name) &&
                                    i.getAttribute('property') ===
                                      (a.property == null
                                        ? null
                                        : a.property) &&
                                    i.getAttribute('http-equiv') ===
                                      (a.httpEquiv == null
                                        ? null
                                        : a.httpEquiv) &&
                                    i.getAttribute('charset') ===
                                      (a.charSet == null ? null : a.charSet))
                                ) {
                                  f.splice(d, 1);
                                  break e;
                                }
                            }
                            ((i = n.createElement(l)),
                              Jt(i, l, a),
                              n.head.appendChild(i));
                            break;
                          default:
                            throw Error(s(468, l));
                        }
                        ((i[kt] = t), Gt(i), (l = i));
                      }
                      t.stateNode = l;
                    } else Td(n, t.type, t.stateNode);
                  else t.stateNode = xd(n, l, t.memoizedProps);
                else
                  i !== l
                    ? (i === null
                        ? a.stateNode !== null &&
                          ((a = a.stateNode), a.parentNode.removeChild(a))
                        : i.count--,
                      l === null
                        ? Td(n, t.type, t.stateNode)
                        : xd(n, l, t.memoizedProps))
                    : l === null &&
                      t.stateNode !== null &&
                      js(t, t.memoizedProps, a.memoizedProps);
              }
              break;
            case 27:
              (de(e, t),
                he(t),
                l & 512 && (Ut || a === null || He(a, a.return)),
                a !== null && l & 4 && js(t, t.memoizedProps, a.memoizedProps));
              break;
            case 5:
              if (
                (de(e, t),
                he(t),
                l & 512 && (Ut || a === null || He(a, a.return)),
                t.flags & 32)
              ) {
                n = t.stateNode;
                try {
                  tl(n, '');
                } catch (M) {
                  St(t, t.return, M);
                }
              }
              (l & 4 &&
                t.stateNode != null &&
                ((n = t.memoizedProps),
                js(t, n, a !== null ? a.memoizedProps : n)),
                l & 1024 && (Bs = !0));
              break;
            case 6:
              if ((de(e, t), he(t), l & 4)) {
                if (t.stateNode === null) throw Error(s(162));
                ((l = t.memoizedProps), (a = t.stateNode));
                try {
                  a.nodeValue = l;
                } catch (M) {
                  St(t, t.return, M);
                }
              }
              break;
            case 3:
              if (
                ((Xi = null),
                (n = ze),
                (ze = wi(e.containerInfo)),
                de(e, t),
                (ze = n),
                he(t),
                l & 4 && a !== null && a.memoizedState.isDehydrated)
              )
                try {
                  Cn(e.containerInfo);
                } catch (M) {
                  St(t, t.return, M);
                }
              Bs && ((Bs = !1), Rr(t));
              break;
            case 4:
              ((l = ze),
                (ze = wi(t.stateNode.containerInfo)),
                de(e, t),
                he(t),
                (ze = l));
              break;
            case 12:
              (de(e, t), he(t));
              break;
            case 13:
              (de(e, t),
                he(t),
                t.child.flags & 8192 &&
                  (t.memoizedState !== null) !=
                    (a !== null && a.memoizedState !== null) &&
                  (Xs = Ue()),
                l & 4 &&
                  ((l = t.updateQueue),
                  l !== null && ((t.updateQueue = null), qs(t, l))));
              break;
            case 22:
              n = t.memoizedState !== null;
              var y = a !== null && a.memoizedState !== null,
                E = Fe,
                R = Ut;
              if (
                ((Fe = E || n),
                (Ut = R || y),
                de(e, t),
                (Ut = R),
                (Fe = E),
                he(t),
                l & 8192)
              )
                t: for (
                  e = t.stateNode,
                    e._visibility = n ? e._visibility & -2 : e._visibility | 1,
                    n && (a === null || y || Fe || Ut || Ga(t)),
                    a = null,
                    e = t;
                  ;
                ) {
                  if (e.tag === 5 || e.tag === 26) {
                    if (a === null) {
                      y = a = e;
                      try {
                        if (((i = y.stateNode), n))
                          ((f = i.style),
                            typeof f.setProperty == 'function'
                              ? f.setProperty('display', 'none', 'important')
                              : (f.display = 'none'));
                        else {
                          d = y.stateNode;
                          var U = y.memoizedProps.style,
                            O =
                              U != null && U.hasOwnProperty('display')
                                ? U.display
                                : null;
                          d.style.display =
                            O == null || typeof O == 'boolean'
                              ? ''
                              : ('' + O).trim();
                        }
                      } catch (M) {
                        St(y, y.return, M);
                      }
                    }
                  } else if (e.tag === 6) {
                    if (a === null) {
                      y = e;
                      try {
                        y.stateNode.nodeValue = n ? '' : y.memoizedProps;
                      } catch (M) {
                        St(y, y.return, M);
                      }
                    }
                  } else if (
                    ((e.tag !== 22 && e.tag !== 23) ||
                      e.memoizedState === null ||
                      e === t) &&
                    e.child !== null
                  ) {
                    ((e.child.return = e), (e = e.child));
                    continue;
                  }
                  if (e === t) break t;
                  for (; e.sibling === null; ) {
                    if (e.return === null || e.return === t) break t;
                    (a === e && (a = null), (e = e.return));
                  }
                  (a === e && (a = null),
                    (e.sibling.return = e.return),
                    (e = e.sibling));
                }
              l & 4 &&
                ((l = t.updateQueue),
                l !== null &&
                  ((a = l.retryQueue),
                  a !== null && ((l.retryQueue = null), qs(t, a))));
              break;
            case 19:
              (de(e, t),
                he(t),
                l & 4 &&
                  ((l = t.updateQueue),
                  l !== null && ((t.updateQueue = null), qs(t, l))));
              break;
            case 30:
              break;
            case 21:
              break;
            default:
              (de(e, t), he(t));
          }
        }
        function he(t) {
          var e = t.flags;
          if (e & 2) {
            try {
              for (var a, l = t.return; l !== null; ) {
                if (xr(l)) {
                  a = l;
                  break;
                }
                l = l.return;
              }
              if (a == null) throw Error(s(160));
              switch (a.tag) {
                case 27:
                  var n = a.stateNode,
                    i = Ls(t);
                  Ri(t, i, n);
                  break;
                case 5:
                  var f = a.stateNode;
                  a.flags & 32 && (tl(f, ''), (a.flags &= -33));
                  var d = Ls(t);
                  Ri(t, d, f);
                  break;
                case 3:
                case 4:
                  var y = a.stateNode.containerInfo,
                    E = Ls(t);
                  Hs(t, E, y);
                  break;
                default:
                  throw Error(s(161));
              }
            } catch (R) {
              St(t, t.return, R);
            }
            t.flags &= -3;
          }
          e & 4096 && (t.flags &= -4097);
        }
        function Rr(t) {
          if (t.subtreeFlags & 1024)
            for (t = t.child; t !== null; ) {
              var e = t;
              (Rr(e),
                e.tag === 5 && e.flags & 1024 && e.stateNode.reset(),
                (t = t.sibling));
            }
        }
        function ha(t, e) {
          if (e.subtreeFlags & 8772)
            for (e = e.child; e !== null; )
              (Er(t, e.alternate, e), (e = e.sibling));
        }
        function Ga(t) {
          for (t = t.child; t !== null; ) {
            var e = t;
            switch (e.tag) {
              case 0:
              case 11:
              case 14:
              case 15:
                (da(4, e, e.return), Ga(e));
                break;
              case 1:
                He(e, e.return);
                var a = e.stateNode;
                (typeof a.componentWillUnmount == 'function' &&
                  br(e, e.return, a),
                  Ga(e));
                break;
              case 27:
                En(e.stateNode);
              case 26:
              case 5:
                (He(e, e.return), Ga(e));
                break;
              case 22:
                e.memoizedState === null && Ga(e);
                break;
              case 30:
                Ga(e);
                break;
              default:
                Ga(e);
            }
            t = t.sibling;
          }
        }
        function ga(t, e, a) {
          for (
            a = a && (e.subtreeFlags & 8772) !== 0, e = e.child;
            e !== null;
          ) {
            var l = e.alternate,
              n = t,
              i = e,
              f = i.flags;
            switch (i.tag) {
              case 0:
              case 11:
              case 15:
                (ga(n, i, a), gn(4, i));
                break;
              case 1:
                if (
                  (ga(n, i, a),
                  (l = i),
                  (n = l.stateNode),
                  typeof n.componentDidMount == 'function')
                )
                  try {
                    n.componentDidMount();
                  } catch (E) {
                    St(l, l.return, E);
                  }
                if (((l = i), (n = l.updateQueue), n !== null)) {
                  var d = l.stateNode;
                  try {
                    var y = n.shared.hiddenCallbacks;
                    if (y !== null)
                      for (
                        n.shared.hiddenCallbacks = null, n = 0;
                        n < y.length;
                        n++
                      )
                        lo(y[n], d);
                  } catch (E) {
                    St(l, l.return, E);
                  }
                }
                (a && f & 64 && vr(i), mn(i, i.return));
                break;
              case 27:
                Ar(i);
              case 26:
              case 5:
                (ga(n, i, a),
                  a && l === null && f & 4 && Sr(i),
                  mn(i, i.return));
                break;
              case 12:
                ga(n, i, a);
                break;
              case 13:
                (ga(n, i, a), a && f & 4 && _r(n, i));
                break;
              case 22:
                (i.memoizedState === null && ga(n, i, a), mn(i, i.return));
                break;
              case 30:
                break;
              default:
                ga(n, i, a);
            }
            e = e.sibling;
          }
        }
        function Ks(t, e) {
          var a = null;
          (t !== null &&
            t.memoizedState !== null &&
            t.memoizedState.cachePool !== null &&
            (a = t.memoizedState.cachePool.pool),
            (t = null),
            e.memoizedState !== null &&
              e.memoizedState.cachePool !== null &&
              (t = e.memoizedState.cachePool.pool),
            t !== a && (t != null && t.refCount++, a != null && Il(a)));
        }
        function Ys(t, e) {
          ((t = null),
            e.alternate !== null && (t = e.alternate.memoizedState.cache),
            (e = e.memoizedState.cache),
            e !== t && (e.refCount++, t != null && Il(t)));
        }
        function Be(t, e, a, l) {
          if (e.subtreeFlags & 10256)
            for (e = e.child; e !== null; ) (zr(t, e, a, l), (e = e.sibling));
        }
        function zr(t, e, a, l) {
          var n = e.flags;
          switch (e.tag) {
            case 0:
            case 11:
            case 15:
              (Be(t, e, a, l), n & 2048 && gn(9, e));
              break;
            case 1:
              Be(t, e, a, l);
              break;
            case 3:
              (Be(t, e, a, l),
                n & 2048 &&
                  ((t = null),
                  e.alternate !== null && (t = e.alternate.memoizedState.cache),
                  (e = e.memoizedState.cache),
                  e !== t && (e.refCount++, t != null && Il(t))));
              break;
            case 12:
              if (n & 2048) {
                (Be(t, e, a, l), (t = e.stateNode));
                try {
                  var i = e.memoizedProps,
                    f = i.id,
                    d = i.onPostCommit;
                  typeof d == 'function' &&
                    d(
                      f,
                      e.alternate === null ? 'mount' : 'update',
                      t.passiveEffectDuration,
                      -0
                    );
                } catch (y) {
                  St(e, e.return, y);
                }
              } else Be(t, e, a, l);
              break;
            case 13:
              Be(t, e, a, l);
              break;
            case 23:
              break;
            case 22:
              ((i = e.stateNode),
                (f = e.alternate),
                e.memoizedState !== null
                  ? i._visibility & 2
                    ? Be(t, e, a, l)
                    : yn(t, e)
                  : i._visibility & 2
                    ? Be(t, e, a, l)
                    : ((i._visibility |= 2),
                      bl(t, e, a, l, (e.subtreeFlags & 10256) !== 0)),
                n & 2048 && Ks(f, e));
              break;
            case 24:
              (Be(t, e, a, l), n & 2048 && Ys(e.alternate, e));
              break;
            default:
              Be(t, e, a, l);
          }
        }
        function bl(t, e, a, l, n) {
          for (
            n = n && (e.subtreeFlags & 10256) !== 0, e = e.child;
            e !== null;
          ) {
            var i = t,
              f = e,
              d = a,
              y = l,
              E = f.flags;
            switch (f.tag) {
              case 0:
              case 11:
              case 15:
                (bl(i, f, d, y, n), gn(8, f));
                break;
              case 23:
                break;
              case 22:
                var R = f.stateNode;
                (f.memoizedState !== null
                  ? R._visibility & 2
                    ? bl(i, f, d, y, n)
                    : yn(i, f)
                  : ((R._visibility |= 2), bl(i, f, d, y, n)),
                  n && E & 2048 && Ks(f.alternate, f));
                break;
              case 24:
                (bl(i, f, d, y, n), n && E & 2048 && Ys(f.alternate, f));
                break;
              default:
                bl(i, f, d, y, n);
            }
            e = e.sibling;
          }
        }
        function yn(t, e) {
          if (e.subtreeFlags & 10256)
            for (e = e.child; e !== null; ) {
              var a = t,
                l = e,
                n = l.flags;
              switch (l.tag) {
                case 22:
                  (yn(a, l), n & 2048 && Ks(l.alternate, l));
                  break;
                case 24:
                  (yn(a, l), n & 2048 && Ys(l.alternate, l));
                  break;
                default:
                  yn(a, l);
              }
              e = e.sibling;
            }
        }
        var pn = 8192;
        function Sl(t) {
          if (t.subtreeFlags & pn)
            for (t = t.child; t !== null; ) (Dr(t), (t = t.sibling));
        }
        function Dr(t) {
          switch (t.tag) {
            case 26:
              (Sl(t),
                t.flags & pn &&
                  t.memoizedState !== null &&
                  Hm(ze, t.memoizedState, t.memoizedProps));
              break;
            case 5:
              Sl(t);
              break;
            case 3:
            case 4:
              var e = ze;
              ((ze = wi(t.stateNode.containerInfo)), Sl(t), (ze = e));
              break;
            case 22:
              t.memoizedState === null &&
                ((e = t.alternate),
                e !== null && e.memoizedState !== null
                  ? ((e = pn), (pn = 16777216), Sl(t), (pn = e))
                  : Sl(t));
              break;
            default:
              Sl(t);
          }
        }
        function Cr(t) {
          var e = t.alternate;
          if (e !== null && ((t = e.child), t !== null)) {
            e.child = null;
            do ((e = t.sibling), (t.sibling = null), (t = e));
            while (t !== null);
          }
        }
        function vn(t) {
          var e = t.deletions;
          if ((t.flags & 16) !== 0) {
            if (e !== null)
              for (var a = 0; a < e.length; a++) {
                var l = e[a];
                ((Vt = l), jr(l, t));
              }
            Cr(t);
          }
          if (t.subtreeFlags & 10256)
            for (t = t.child; t !== null; ) (Ur(t), (t = t.sibling));
        }
        function Ur(t) {
          switch (t.tag) {
            case 0:
            case 11:
            case 15:
              (vn(t), t.flags & 2048 && da(9, t, t.return));
              break;
            case 3:
              vn(t);
              break;
            case 12:
              vn(t);
              break;
            case 22:
              var e = t.stateNode;
              t.memoizedState !== null &&
              e._visibility & 2 &&
              (t.return === null || t.return.tag !== 13)
                ? ((e._visibility &= -3), zi(t))
                : vn(t);
              break;
            default:
              vn(t);
          }
        }
        function zi(t) {
          var e = t.deletions;
          if ((t.flags & 16) !== 0) {
            if (e !== null)
              for (var a = 0; a < e.length; a++) {
                var l = e[a];
                ((Vt = l), jr(l, t));
              }
            Cr(t);
          }
          for (t = t.child; t !== null; ) {
            switch (((e = t), e.tag)) {
              case 0:
              case 11:
              case 15:
                (da(8, e, e.return), zi(e));
                break;
              case 22:
                ((a = e.stateNode),
                  a._visibility & 2 && ((a._visibility &= -3), zi(e)));
                break;
              default:
                zi(e);
            }
            t = t.sibling;
          }
        }
        function jr(t, e) {
          for (; Vt !== null; ) {
            var a = Vt;
            switch (a.tag) {
              case 0:
              case 11:
              case 15:
                da(8, a, e);
                break;
              case 23:
              case 22:
                if (
                  a.memoizedState !== null &&
                  a.memoizedState.cachePool !== null
                ) {
                  var l = a.memoizedState.cachePool.pool;
                  l != null && l.refCount++;
                }
                break;
              case 24:
                Il(a.memoizedState.cache);
            }
            if (((l = a.child), l !== null)) ((l.return = a), (Vt = l));
            else
              t: for (a = t; Vt !== null; ) {
                l = Vt;
                var n = l.sibling,
                  i = l.return;
                if ((Or(l), l === a)) {
                  Vt = null;
                  break t;
                }
                if (n !== null) {
                  ((n.return = i), (Vt = n));
                  break t;
                }
                Vt = i;
              }
          }
        }
        var Pg = {
            getCacheForType: function (t) {
              var e = Wt(Kt),
                a = e.data.get(t);
              return (a === void 0 && ((a = t()), e.data.set(t, a)), a);
            },
          },
          Ig = typeof WeakMap == 'function' ? WeakMap : Map,
          gt = 0,
          xt = null,
          nt = null,
          ct = 0,
          mt = 0,
          ge = null,
          ma = !1,
          xl = !1,
          Gs = !1,
          Ie = 0,
          Nt = 0,
          ya = 0,
          wa = 0,
          ws = 0,
          Ee = 0,
          Al = 0,
          bn = null,
          ie = null,
          Vs = !1,
          Xs = 0,
          Di = 1 / 0,
          Ci = null,
          pa = null,
          $t = 0,
          va = null,
          Tl = null,
          El = 0,
          Qs = 0,
          Zs = null,
          Lr = null,
          Sn = 0,
          $s = null;
        function me() {
          if ((gt & 2) !== 0 && ct !== 0) return ct & -ct;
          if (_.T !== null) {
            var t = rl;
            return t !== 0 ? t : tc();
          }
          return kc();
        }
        function Hr() {
          Ee === 0 && (Ee = (ct & 536870912) === 0 || dt ? Qc() : 536870912);
          var t = Te.current;
          return (t !== null && (t.flags |= 32), Ee);
        }
        function ye(t, e, a) {
          (((t === xt && (mt === 2 || mt === 9)) ||
            t.cancelPendingCommit !== null) &&
            (Ol(t, 0), ba(t, ct, Ee, !1)),
            Bl(t, a),
            ((gt & 2) === 0 || t !== xt) &&
              (t === xt &&
                ((gt & 2) === 0 && (wa |= a), Nt === 4 && ba(t, ct, Ee, !1)),
              qe(t)));
        }
        function Br(t, e, a) {
          if ((gt & 6) !== 0) throw Error(s(327));
          var l =
              (!a && (e & 124) === 0 && (e & t.expiredLanes) === 0) || Hl(t, e),
            n = l ? am(t, e) : Ws(t, e, !0),
            i = l;
          do {
            if (n === 0) {
              xl && !l && ba(t, e, 0, !1);
              break;
            } else {
              if (((a = t.current.alternate), i && !tm(a))) {
                ((n = Ws(t, e, !1)), (i = !1));
                continue;
              }
              if (n === 2) {
                if (((i = e), t.errorRecoveryDisabledLanes & i)) var f = 0;
                else
                  ((f = t.pendingLanes & -536870913),
                    (f = f !== 0 ? f : f & 536870912 ? 536870912 : 0));
                if (f !== 0) {
                  e = f;
                  t: {
                    var d = t;
                    n = bn;
                    var y = d.current.memoizedState.isDehydrated;
                    if (
                      (y && (Ol(d, f).flags |= 256),
                      (f = Ws(d, f, !1)),
                      f !== 2)
                    ) {
                      if (Gs && !y) {
                        ((d.errorRecoveryDisabledLanes |= i),
                          (wa |= i),
                          (n = 4));
                        break t;
                      }
                      ((i = ie),
                        (ie = n),
                        i !== null &&
                          (ie === null ? (ie = i) : ie.push.apply(ie, i)));
                    }
                    n = f;
                  }
                  if (((i = !1), n !== 2)) continue;
                }
              }
              if (n === 1) {
                (Ol(t, 0), ba(t, e, 0, !0));
                break;
              }
              t: {
                switch (((l = t), (i = n), i)) {
                  case 0:
                  case 1:
                    throw Error(s(345));
                  case 4:
                    if ((e & 4194048) !== e) break;
                  case 6:
                    ba(l, e, Ee, !ma);
                    break t;
                  case 2:
                    ie = null;
                    break;
                  case 3:
                  case 5:
                    break;
                  default:
                    throw Error(s(329));
                }
                if ((e & 62914560) === e && ((n = Xs + 300 - Ue()), 10 < n)) {
                  if ((ba(l, e, Ee, !ma), Vn(l, 0, !0) !== 0)) break t;
                  l.timeoutHandle = dd(
                    qr.bind(
                      null,
                      l,
                      a,
                      ie,
                      Ci,
                      Vs,
                      e,
                      Ee,
                      wa,
                      Al,
                      ma,
                      i,
                      2,
                      -0,
                      0
                    ),
                    n
                  );
                  break t;
                }
                qr(l, a, ie, Ci, Vs, e, Ee, wa, Al, ma, i, 0, -0, 0);
              }
            }
            break;
          } while (!0);
          qe(t);
        }
        function qr(t, e, a, l, n, i, f, d, y, E, R, U, O, M) {
          if (
            ((t.timeoutHandle = -1),
            (U = e.subtreeFlags),
            (U & 8192 || (U & 16785408) === 16785408) &&
              ((_n = { stylesheets: null, count: 0, unsuspend: Lm }),
              Dr(e),
              (U = Bm()),
              U !== null))
          ) {
            ((t.cancelPendingCommit = U(
              Qr.bind(null, t, e, i, a, l, n, f, d, y, R, 1, O, M)
            )),
              ba(t, i, f, !E));
            return;
          }
          Qr(t, e, i, a, l, n, f, d, y);
        }
        function tm(t) {
          for (var e = t; ; ) {
            var a = e.tag;
            if (
              (a === 0 || a === 11 || a === 15) &&
              e.flags & 16384 &&
              ((a = e.updateQueue), a !== null && ((a = a.stores), a !== null))
            )
              for (var l = 0; l < a.length; l++) {
                var n = a[l],
                  i = n.getSnapshot;
                n = n.value;
                try {
                  if (!oe(i(), n)) return !1;
                } catch {
                  return !1;
                }
              }
            if (((a = e.child), e.subtreeFlags & 16384 && a !== null))
              ((a.return = e), (e = a));
            else {
              if (e === t) break;
              for (; e.sibling === null; ) {
                if (e.return === null || e.return === t) return !0;
                e = e.return;
              }
              ((e.sibling.return = e.return), (e = e.sibling));
            }
          }
          return !0;
        }
        function ba(t, e, a, l) {
          ((e &= ~ws),
            (e &= ~wa),
            (t.suspendedLanes |= e),
            (t.pingedLanes &= ~e),
            l && (t.warmLanes |= e),
            (l = t.expirationTimes));
          for (var n = e; 0 < n; ) {
            var i = 31 - fe(n),
              f = 1 << i;
            ((l[i] = -1), (n &= ~f));
          }
          a !== 0 && $c(t, a, e);
        }
        function Ui() {
          return (gt & 6) === 0 ? (xn(0), !1) : !0;
        }
        function Js() {
          if (nt !== null) {
            if (mt === 0) var t = nt.return;
            else
              ((t = nt),
                (Qe = Ha = null),
                rs(t),
                (pl = null),
                (rn = 0),
                (t = nt));
            for (; t !== null; ) (pr(t.alternate, t), (t = t.return));
            nt = null;
          }
        }
        function Ol(t, e) {
          var a = t.timeoutHandle;
          (a !== -1 && ((t.timeoutHandle = -1), vm(a)),
            (a = t.cancelPendingCommit),
            a !== null && ((t.cancelPendingCommit = null), a()),
            Js(),
            (xt = t),
            (nt = a = we(t.current, null)),
            (ct = e),
            (mt = 0),
            (ge = null),
            (ma = !1),
            (xl = Hl(t, e)),
            (Gs = !1),
            (Al = Ee = ws = wa = ya = Nt = 0),
            (ie = bn = null),
            (Vs = !1),
            (e & 8) !== 0 && (e |= e & 32));
          var l = t.entangledLanes;
          if (l !== 0)
            for (t = t.entanglements, l &= e; 0 < l; ) {
              var n = 31 - fe(l),
                i = 1 << n;
              ((e |= t[n]), (l &= ~i));
            }
          return ((Ie = e), ei(), a);
        }
        function Kr(t, e) {
          ((at = null),
            (_.H = Si),
            e === en || e === oi
              ? ((e = eo()), (mt = 3))
              : e === Pf
                ? ((e = eo()), (mt = 4))
                : (mt =
                    e === lr
                      ? 8
                      : e !== null &&
                          typeof e == 'object' &&
                          typeof e.then == 'function'
                        ? 6
                        : 1),
            (ge = e),
            nt === null && ((Nt = 1), Oi(t, be(e, t.current))));
        }
        function Yr() {
          var t = _.H;
          return ((_.H = Si), t === null ? Si : t);
        }
        function Gr() {
          var t = _.A;
          return ((_.A = Pg), t);
        }
        function ks() {
          ((Nt = 4),
            ma || ((ct & 4194048) !== ct && Te.current !== null) || (xl = !0),
            ((ya & 134217727) === 0 && (wa & 134217727) === 0) ||
              xt === null ||
              ba(xt, ct, Ee, !1));
        }
        function Ws(t, e, a) {
          var l = gt;
          gt |= 2;
          var n = Yr(),
            i = Gr();
          ((xt !== t || ct !== e) && ((Ci = null), Ol(t, e)), (e = !1));
          var f = Nt;
          t: do
            try {
              if (mt !== 0 && nt !== null) {
                var d = nt,
                  y = ge;
                switch (mt) {
                  case 8:
                    (Js(), (f = 6));
                    break t;
                  case 3:
                  case 2:
                  case 9:
                  case 6:
                    Te.current === null && (e = !0);
                    var E = mt;
                    if (((mt = 0), (ge = null), Ml(t, d, y, E), a && xl)) {
                      f = 0;
                      break t;
                    }
                    break;
                  default:
                    ((E = mt), (mt = 0), (ge = null), Ml(t, d, y, E));
                }
              }
              (em(), (f = Nt));
              break;
            } catch (R) {
              Kr(t, R);
            }
          while (!0);
          return (
            e && t.shellSuspendCounter++,
            (Qe = Ha = null),
            (gt = l),
            (_.H = n),
            (_.A = i),
            nt === null && ((xt = null), (ct = 0), ei()),
            f
          );
        }
        function em() {
          for (; nt !== null; ) wr(nt);
        }
        function am(t, e) {
          var a = gt;
          gt |= 2;
          var l = Yr(),
            n = Gr();
          xt !== t || ct !== e
            ? ((Ci = null), (Di = Ue() + 500), Ol(t, e))
            : (xl = Hl(t, e));
          t: do
            try {
              if (mt !== 0 && nt !== null) {
                e = nt;
                var i = ge;
                e: switch (mt) {
                  case 1:
                    ((mt = 0), (ge = null), Ml(t, e, i, 1));
                    break;
                  case 2:
                  case 9:
                    if (If(i)) {
                      ((mt = 0), (ge = null), Vr(e));
                      break;
                    }
                    ((e = function () {
                      ((mt !== 2 && mt !== 9) || xt !== t || (mt = 7), qe(t));
                    }),
                      i.then(e, e));
                    break t;
                  case 3:
                    mt = 7;
                    break t;
                  case 4:
                    mt = 5;
                    break t;
                  case 7:
                    If(i)
                      ? ((mt = 0), (ge = null), Vr(e))
                      : ((mt = 0), (ge = null), Ml(t, e, i, 7));
                    break;
                  case 5:
                    var f = null;
                    switch (nt.tag) {
                      case 26:
                        f = nt.memoizedState;
                      case 5:
                      case 27:
                        var d = nt;
                        if (!f || Ed(f)) {
                          ((mt = 0), (ge = null));
                          var y = d.sibling;
                          if (y !== null) nt = y;
                          else {
                            var E = d.return;
                            E !== null ? ((nt = E), ji(E)) : (nt = null);
                          }
                          break e;
                        }
                    }
                    ((mt = 0), (ge = null), Ml(t, e, i, 5));
                    break;
                  case 6:
                    ((mt = 0), (ge = null), Ml(t, e, i, 6));
                    break;
                  case 8:
                    (Js(), (Nt = 6));
                    break t;
                  default:
                    throw Error(s(462));
                }
              }
              lm();
              break;
            } catch (R) {
              Kr(t, R);
            }
          while (!0);
          return (
            (Qe = Ha = null),
            (_.H = l),
            (_.A = n),
            (gt = a),
            nt !== null ? 0 : ((xt = null), (ct = 0), ei(), Nt)
          );
        }
        function lm() {
          for (; nt !== null && !Oh(); ) wr(nt);
        }
        function wr(t) {
          var e = mr(t.alternate, t, Ie);
          ((t.memoizedProps = t.pendingProps), e === null ? ji(t) : (nt = e));
        }
        function Vr(t) {
          var e = t,
            a = e.alternate;
          switch (e.tag) {
            case 15:
            case 0:
              e = fr(a, e, e.pendingProps, e.type, void 0, ct);
              break;
            case 11:
              e = fr(a, e, e.pendingProps, e.type.render, e.ref, ct);
              break;
            case 5:
              rs(e);
            default:
              (pr(a, e), (e = nt = Vf(e, Ie)), (e = mr(a, e, Ie)));
          }
          ((t.memoizedProps = t.pendingProps), e === null ? ji(t) : (nt = e));
        }
        function Ml(t, e, a, l) {
          ((Qe = Ha = null), rs(e), (pl = null), (rn = 0));
          var n = e.return;
          try {
            if (Zg(t, n, e, a, ct)) {
              ((Nt = 1), Oi(t, be(a, t.current)), (nt = null));
              return;
            }
          } catch (i) {
            if (n !== null) throw ((nt = n), i);
            ((Nt = 1), Oi(t, be(a, t.current)), (nt = null));
            return;
          }
          e.flags & 32768
            ? (dt || l === 1
                ? (t = !0)
                : xl || (ct & 536870912) !== 0
                  ? (t = !1)
                  : ((ma = t = !0),
                    (l === 2 || l === 9 || l === 3 || l === 6) &&
                      ((l = Te.current),
                      l !== null && l.tag === 13 && (l.flags |= 16384))),
              Xr(e, t))
            : ji(e);
        }
        function ji(t) {
          var e = t;
          do {
            if ((e.flags & 32768) !== 0) {
              Xr(e, ma);
              return;
            }
            t = e.return;
            var a = Jg(e.alternate, e, Ie);
            if (a !== null) {
              nt = a;
              return;
            }
            if (((e = e.sibling), e !== null)) {
              nt = e;
              return;
            }
            nt = e = t;
          } while (e !== null);
          Nt === 0 && (Nt = 5);
        }
        function Xr(t, e) {
          do {
            var a = kg(t.alternate, t);
            if (a !== null) {
              ((a.flags &= 32767), (nt = a));
              return;
            }
            if (
              ((a = t.return),
              a !== null &&
                ((a.flags |= 32768),
                (a.subtreeFlags = 0),
                (a.deletions = null)),
              !e && ((t = t.sibling), t !== null))
            ) {
              nt = t;
              return;
            }
            nt = t = a;
          } while (t !== null);
          ((Nt = 6), (nt = null));
        }
        function Qr(t, e, a, l, n, i, f, d, y) {
          t.cancelPendingCommit = null;
          do Li();
          while ($t !== 0);
          if ((gt & 6) !== 0) throw Error(s(327));
          if (e !== null) {
            if (e === t.current) throw Error(s(177));
            if (
              ((i = e.lanes | e.childLanes),
              (i |= Yu),
              Lh(t, a, i, f, d, y),
              t === xt && ((nt = xt = null), (ct = 0)),
              (Tl = e),
              (va = t),
              (El = a),
              (Qs = i),
              (Zs = n),
              (Lr = l),
              (e.subtreeFlags & 10256) !== 0 || (e.flags & 10256) !== 0
                ? ((t.callbackNode = null),
                  (t.callbackPriority = 0),
                  sm(Yn, function () {
                    return (Wr(), null);
                  }))
                : ((t.callbackNode = null), (t.callbackPriority = 0)),
              (l = (e.flags & 13878) !== 0),
              (e.subtreeFlags & 13878) !== 0 || l)
            ) {
              ((l = _.T),
                (_.T = null),
                (n = j.p),
                (j.p = 2),
                (f = gt),
                (gt |= 4));
              try {
                Wg(t, e);
              } finally {
                ((gt = f), (j.p = n), (_.T = l));
              }
            }
            (($t = 1), Zr(), $r(), Jr());
          }
        }
        function Zr() {
          if ($t === 1) {
            $t = 0;
            var t = va,
              e = Tl,
              a = (e.flags & 13878) !== 0;
            if ((e.subtreeFlags & 13878) !== 0 || a) {
              ((a = _.T), (_.T = null));
              var l = j.p;
              j.p = 2;
              var n = gt;
              gt |= 4;
              try {
                Nr(e, t);
                var i = cc,
                  f = Uf(t.containerInfo),
                  d = i.focusedElem,
                  y = i.selectionRange;
                if (
                  f !== d &&
                  d &&
                  d.ownerDocument &&
                  Cf(d.ownerDocument.documentElement, d)
                ) {
                  if (y !== null && Lu(d)) {
                    var E = y.start,
                      R = y.end;
                    if ((R === void 0 && (R = E), 'selectionStart' in d))
                      ((d.selectionStart = E),
                        (d.selectionEnd = Math.min(R, d.value.length)));
                    else {
                      var U = d.ownerDocument || document,
                        O = (U && U.defaultView) || window;
                      if (O.getSelection) {
                        var M = O.getSelection(),
                          J = d.textContent.length,
                          Z = Math.min(y.start, J),
                          bt = y.end === void 0 ? Z : Math.min(y.end, J);
                        !M.extend && Z > bt && ((f = bt), (bt = Z), (Z = f));
                        var x = Df(d, Z),
                          S = Df(d, bt);
                        if (
                          x &&
                          S &&
                          (M.rangeCount !== 1 ||
                            M.anchorNode !== x.node ||
                            M.anchorOffset !== x.offset ||
                            M.focusNode !== S.node ||
                            M.focusOffset !== S.offset)
                        ) {
                          var T = U.createRange();
                          (T.setStart(x.node, x.offset),
                            M.removeAllRanges(),
                            Z > bt
                              ? (M.addRange(T), M.extend(S.node, S.offset))
                              : (T.setEnd(S.node, S.offset), M.addRange(T)));
                        }
                      }
                    }
                  }
                  for (U = [], M = d; (M = M.parentNode); )
                    M.nodeType === 1 &&
                      U.push({
                        element: M,
                        left: M.scrollLeft,
                        top: M.scrollTop,
                      });
                  for (
                    typeof d.focus == 'function' && d.focus(), d = 0;
                    d < U.length;
                    d++
                  ) {
                    var z = U[d];
                    ((z.element.scrollLeft = z.left),
                      (z.element.scrollTop = z.top));
                  }
                }
                (($i = !!sc), (cc = sc = null));
              } finally {
                ((gt = n), (j.p = l), (_.T = a));
              }
            }
            ((t.current = e), ($t = 2));
          }
        }
        function $r() {
          if ($t === 2) {
            $t = 0;
            var t = va,
              e = Tl,
              a = (e.flags & 8772) !== 0;
            if ((e.subtreeFlags & 8772) !== 0 || a) {
              ((a = _.T), (_.T = null));
              var l = j.p;
              j.p = 2;
              var n = gt;
              gt |= 4;
              try {
                Er(t, e.alternate, e);
              } finally {
                ((gt = n), (j.p = l), (_.T = a));
              }
            }
            $t = 3;
          }
        }
        function Jr() {
          if ($t === 4 || $t === 3) {
            (($t = 0), Mh());
            var t = va,
              e = Tl,
              a = El,
              l = Lr;
            (e.subtreeFlags & 10256) !== 0 || (e.flags & 10256) !== 0
              ? ($t = 5)
              : (($t = 0), (Tl = va = null), kr(t, t.pendingLanes));
            var n = t.pendingLanes;
            if (
              (n === 0 && (pa = null),
              gu(a),
              (e = e.stateNode),
              ce && typeof ce.onCommitFiberRoot == 'function')
            )
              try {
                ce.onCommitFiberRoot(
                  Ll,
                  e,
                  void 0,
                  (e.current.flags & 128) === 128
                );
              } catch {}
            if (l !== null) {
              ((e = _.T), (n = j.p), (j.p = 2), (_.T = null));
              try {
                for (var i = t.onRecoverableError, f = 0; f < l.length; f++) {
                  var d = l[f];
                  i(d.value, { componentStack: d.stack });
                }
              } finally {
                ((_.T = e), (j.p = n));
              }
            }
            ((El & 3) !== 0 && Li(),
              qe(t),
              (n = t.pendingLanes),
              (a & 4194090) !== 0 && (n & 42) !== 0
                ? t === $s
                  ? Sn++
                  : ((Sn = 0), ($s = t))
                : (Sn = 0),
              xn(0));
          }
        }
        function kr(t, e) {
          (t.pooledCacheLanes &= e) === 0 &&
            ((e = t.pooledCache), e != null && ((t.pooledCache = null), Il(e)));
        }
        function Li(t) {
          return (Zr(), $r(), Jr(), Wr());
        }
        function Wr() {
          if ($t !== 5) return !1;
          var t = va,
            e = Qs;
          Qs = 0;
          var a = gu(El),
            l = _.T,
            n = j.p;
          try {
            ((j.p = 32 > a ? 32 : a), (_.T = null), (a = Zs), (Zs = null));
            var i = va,
              f = El;
            if ((($t = 0), (Tl = va = null), (El = 0), (gt & 6) !== 0))
              throw Error(s(331));
            var d = gt;
            if (
              ((gt |= 4),
              Ur(i.current),
              zr(i, i.current, f, a),
              (gt = d),
              xn(0),
              ce && typeof ce.onPostCommitFiberRoot == 'function')
            )
              try {
                ce.onPostCommitFiberRoot(Ll, i);
              } catch {}
            return !0;
          } finally {
            ((j.p = n), (_.T = l), kr(t, e));
          }
        }
        function Fr(t, e, a) {
          ((e = be(a, e)),
            (e = Os(t.stateNode, e, 2)),
            (t = ca(t, e, 2)),
            t !== null && (Bl(t, 2), qe(t)));
        }
        function St(t, e, a) {
          if (t.tag === 3) Fr(t, t, a);
          else
            for (; e !== null; ) {
              if (e.tag === 3) {
                Fr(e, t, a);
                break;
              } else if (e.tag === 1) {
                var l = e.stateNode;
                if (
                  typeof e.type.getDerivedStateFromError == 'function' ||
                  (typeof l.componentDidCatch == 'function' &&
                    (pa === null || !pa.has(l)))
                ) {
                  ((t = be(a, t)),
                    (a = er(2)),
                    (l = ca(e, a, 2)),
                    l !== null && (ar(a, l, e, t), Bl(l, 2), qe(l)));
                  break;
                }
              }
              e = e.return;
            }
        }
        function Fs(t, e, a) {
          var l = t.pingCache;
          if (l === null) {
            l = t.pingCache = new Ig();
            var n = new Set();
            l.set(e, n);
          } else
            ((n = l.get(e)), n === void 0 && ((n = new Set()), l.set(e, n)));
          n.has(a) ||
            ((Gs = !0), n.add(a), (t = nm.bind(null, t, e, a)), e.then(t, t));
        }
        function nm(t, e, a) {
          var l = t.pingCache;
          (l !== null && l.delete(e),
            (t.pingedLanes |= t.suspendedLanes & a),
            (t.warmLanes &= ~a),
            xt === t &&
              (ct & a) === a &&
              (Nt === 4 ||
              (Nt === 3 && (ct & 62914560) === ct && 300 > Ue() - Xs)
                ? (gt & 2) === 0 && Ol(t, 0)
                : (ws |= a),
              Al === ct && (Al = 0)),
            qe(t));
        }
        function Pr(t, e) {
          (e === 0 && (e = Zc()),
            (t = sl(t, e)),
            t !== null && (Bl(t, e), qe(t)));
        }
        function im(t) {
          var e = t.memoizedState,
            a = 0;
          (e !== null && (a = e.retryLane), Pr(t, a));
        }
        function um(t, e) {
          var a = 0;
          switch (t.tag) {
            case 13:
              var l = t.stateNode,
                n = t.memoizedState;
              n !== null && (a = n.retryLane);
              break;
            case 19:
              l = t.stateNode;
              break;
            case 22:
              l = t.stateNode._retryCache;
              break;
            default:
              throw Error(s(314));
          }
          (l !== null && l.delete(e), Pr(t, a));
        }
        function sm(t, e) {
          return ou(t, e);
        }
        var Hi = null,
          _l = null,
          Ps = !1,
          Bi = !1,
          Is = !1,
          Va = 0;
        function qe(t) {
          (t !== _l &&
            t.next === null &&
            (_l === null ? (Hi = _l = t) : (_l = _l.next = t)),
            (Bi = !0),
            Ps || ((Ps = !0), fm()));
        }
        function xn(t, e) {
          if (!Is && Bi) {
            Is = !0;
            do
              for (var a = !1, l = Hi; l !== null; ) {
                if (t !== 0) {
                  var n = l.pendingLanes;
                  if (n === 0) var i = 0;
                  else {
                    var f = l.suspendedLanes,
                      d = l.pingedLanes;
                    ((i = (1 << (31 - fe(42 | t) + 1)) - 1),
                      (i &= n & ~(f & ~d)),
                      (i =
                        i & 201326741 ? (i & 201326741) | 1 : i ? i | 2 : 0));
                  }
                  i !== 0 && ((a = !0), ad(l, i));
                } else
                  ((i = ct),
                    (i = Vn(
                      l,
                      l === xt ? i : 0,
                      l.cancelPendingCommit !== null || l.timeoutHandle !== -1
                    )),
                    (i & 3) === 0 || Hl(l, i) || ((a = !0), ad(l, i)));
                l = l.next;
              }
            while (a);
            Is = !1;
          }
        }
        function cm() {
          Ir();
        }
        function Ir() {
          Bi = Ps = !1;
          var t = 0;
          Va !== 0 && (pm() && (t = Va), (Va = 0));
          for (var e = Ue(), a = null, l = Hi; l !== null; ) {
            var n = l.next,
              i = td(l, e);
            (i === 0
              ? ((l.next = null),
                a === null ? (Hi = n) : (a.next = n),
                n === null && (_l = a))
              : ((a = l), (t !== 0 || (i & 3) !== 0) && (Bi = !0)),
              (l = n));
          }
          xn(t);
        }
        function td(t, e) {
          for (
            var a = t.suspendedLanes,
              l = t.pingedLanes,
              n = t.expirationTimes,
              i = t.pendingLanes & -62914561;
            0 < i;
          ) {
            var f = 31 - fe(i),
              d = 1 << f,
              y = n[f];
            (y === -1
              ? ((d & a) === 0 || (d & l) !== 0) && (n[f] = jh(d, e))
              : y <= e && (t.expiredLanes |= d),
              (i &= ~d));
          }
          if (
            ((e = xt),
            (a = ct),
            (a = Vn(
              t,
              t === e ? a : 0,
              t.cancelPendingCommit !== null || t.timeoutHandle !== -1
            )),
            (l = t.callbackNode),
            a === 0 ||
              (t === e && (mt === 2 || mt === 9)) ||
              t.cancelPendingCommit !== null)
          )
            return (
              l !== null && l !== null && ru(l),
              (t.callbackNode = null),
              (t.callbackPriority = 0)
            );
          if ((a & 3) === 0 || Hl(t, a)) {
            if (((e = a & -a), e === t.callbackPriority)) return e;
            switch ((l !== null && ru(l), gu(a))) {
              case 2:
              case 8:
                a = Vc;
                break;
              case 32:
                a = Yn;
                break;
              case 268435456:
                a = Xc;
                break;
              default:
                a = Yn;
            }
            return (
              (l = ed.bind(null, t)),
              (a = ou(a, l)),
              (t.callbackPriority = e),
              (t.callbackNode = a),
              e
            );
          }
          return (
            l !== null && l !== null && ru(l),
            (t.callbackPriority = 2),
            (t.callbackNode = null),
            2
          );
        }
        function ed(t, e) {
          if ($t !== 0 && $t !== 5)
            return ((t.callbackNode = null), (t.callbackPriority = 0), null);
          var a = t.callbackNode;
          if (Li() && t.callbackNode !== a) return null;
          var l = ct;
          return (
            (l = Vn(
              t,
              t === xt ? l : 0,
              t.cancelPendingCommit !== null || t.timeoutHandle !== -1
            )),
            l === 0
              ? null
              : (Br(t, l, e),
                td(t, Ue()),
                t.callbackNode != null && t.callbackNode === a
                  ? ed.bind(null, t)
                  : null)
          );
        }
        function ad(t, e) {
          if (Li()) return null;
          Br(t, e, !0);
        }
        function fm() {
          bm(function () {
            (gt & 6) !== 0 ? ou(wc, cm) : Ir();
          });
        }
        function tc() {
          return (Va === 0 && (Va = Qc()), Va);
        }
        function ld(t) {
          return t == null || typeof t == 'symbol' || typeof t == 'boolean'
            ? null
            : typeof t == 'function'
              ? t
              : Jn('' + t);
        }
        function nd(t, e) {
          var a = e.ownerDocument.createElement('input');
          return (
            (a.name = e.name),
            (a.value = e.value),
            t.id && a.setAttribute('form', t.id),
            e.parentNode.insertBefore(a, e),
            (t = new FormData(t)),
            a.parentNode.removeChild(a),
            t
          );
        }
        function om(t, e, a, l, n) {
          if (e === 'submit' && a && a.stateNode === n) {
            var i = ld((n[ee] || null).action),
              f = l.submitter;
            f &&
              ((e = (e = f[ee] || null)
                ? ld(e.formAction)
                : f.getAttribute('formAction')),
              e !== null && ((i = e), (f = null)));
            var d = new Pn('action', 'action', null, l, n);
            t.push({
              event: d,
              listeners: [
                {
                  instance: null,
                  listener: function () {
                    if (l.defaultPrevented) {
                      if (Va !== 0) {
                        var y = f ? nd(n, f) : new FormData(n);
                        Ss(
                          a,
                          { pending: !0, data: y, method: n.method, action: i },
                          null,
                          y
                        );
                      }
                    } else
                      typeof i == 'function' &&
                        (d.preventDefault(),
                        (y = f ? nd(n, f) : new FormData(n)),
                        Ss(
                          a,
                          { pending: !0, data: y, method: n.method, action: i },
                          i,
                          y
                        ));
                  },
                  currentTarget: n,
                },
              ],
            });
          }
        }
        for (var ec = 0; ec < Ku.length; ec++) {
          var ac = Ku[ec],
            rm = ac.toLowerCase(),
            dm = ac[0].toUpperCase() + ac.slice(1);
          Re(rm, 'on' + dm);
        }
        (Re(Hf, 'onAnimationEnd'),
          Re(Bf, 'onAnimationIteration'),
          Re(qf, 'onAnimationStart'),
          Re('dblclick', 'onDoubleClick'),
          Re('focusin', 'onFocus'),
          Re('focusout', 'onBlur'),
          Re(Rg, 'onTransitionRun'),
          Re(zg, 'onTransitionStart'),
          Re(Dg, 'onTransitionCancel'),
          Re(Kf, 'onTransitionEnd'),
          Fa('onMouseEnter', ['mouseout', 'mouseover']),
          Fa('onMouseLeave', ['mouseout', 'mouseover']),
          Fa('onPointerEnter', ['pointerout', 'pointerover']),
          Fa('onPointerLeave', ['pointerout', 'pointerover']),
          _a(
            'onChange',
            'change click focusin focusout input keydown keyup selectionchange'.split(
              ' '
            )
          ),
          _a(
            'onSelect',
            'focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange'.split(
              ' '
            )
          ),
          _a('onBeforeInput', [
            'compositionend',
            'keypress',
            'textInput',
            'paste',
          ]),
          _a(
            'onCompositionEnd',
            'compositionend focusout keydown keypress keyup mousedown'.split(
              ' '
            )
          ),
          _a(
            'onCompositionStart',
            'compositionstart focusout keydown keypress keyup mousedown'.split(
              ' '
            )
          ),
          _a(
            'onCompositionUpdate',
            'compositionupdate focusout keydown keypress keyup mousedown'.split(
              ' '
            )
          ));
        var An =
            'abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting'.split(
              ' '
            ),
          hm = new Set(
            'beforetoggle cancel close invalid load scroll scrollend toggle'
              .split(' ')
              .concat(An)
          );
        function id(t, e) {
          e = (e & 4) !== 0;
          for (var a = 0; a < t.length; a++) {
            var l = t[a],
              n = l.event;
            l = l.listeners;
            t: {
              var i = void 0;
              if (e)
                for (var f = l.length - 1; 0 <= f; f--) {
                  var d = l[f],
                    y = d.instance,
                    E = d.currentTarget;
                  if (((d = d.listener), y !== i && n.isPropagationStopped()))
                    break t;
                  ((i = d), (n.currentTarget = E));
                  try {
                    i(n);
                  } catch (R) {
                    Ei(R);
                  }
                  ((n.currentTarget = null), (i = y));
                }
              else
                for (f = 0; f < l.length; f++) {
                  if (
                    ((d = l[f]),
                    (y = d.instance),
                    (E = d.currentTarget),
                    (d = d.listener),
                    y !== i && n.isPropagationStopped())
                  )
                    break t;
                  ((i = d), (n.currentTarget = E));
                  try {
                    i(n);
                  } catch (R) {
                    Ei(R);
                  }
                  ((n.currentTarget = null), (i = y));
                }
            }
          }
        }
        function it(t, e) {
          var a = e[mu];
          a === void 0 && (a = e[mu] = new Set());
          var l = t + '__bubble';
          a.has(l) || (ud(e, t, 2, !1), a.add(l));
        }
        function lc(t, e, a) {
          var l = 0;
          (e && (l |= 4), ud(a, t, l, e));
        }
        var qi = '_reactListening' + Math.random().toString(36).slice(2);
        function nc(t) {
          if (!t[qi]) {
            ((t[qi] = !0),
              Fc.forEach(function (a) {
                a !== 'selectionchange' &&
                  (hm.has(a) || lc(a, !1, t), lc(a, !0, t));
              }));
            var e = t.nodeType === 9 ? t : t.ownerDocument;
            e === null || e[qi] || ((e[qi] = !0), lc('selectionchange', !1, e));
          }
        }
        function ud(t, e, a, l) {
          switch (zd(e)) {
            case 2:
              var n = Ym;
              break;
            case 8:
              n = Gm;
              break;
            default:
              n = vc;
          }
          ((a = n.bind(null, e, a, t)),
            (n = void 0),
            !Mu ||
              (e !== 'touchstart' && e !== 'touchmove' && e !== 'wheel') ||
              (n = !0),
            l
              ? n !== void 0
                ? t.addEventListener(e, a, { capture: !0, passive: n })
                : t.addEventListener(e, a, !0)
              : n !== void 0
                ? t.addEventListener(e, a, { passive: n })
                : t.addEventListener(e, a, !1));
        }
        function ic(t, e, a, l, n) {
          var i = l;
          if ((e & 1) === 0 && (e & 2) === 0 && l !== null)
            t: for (;;) {
              if (l === null) return;
              var f = l.tag;
              if (f === 3 || f === 4) {
                var d = l.stateNode.containerInfo;
                if (d === n) break;
                if (f === 4)
                  for (f = l.return; f !== null; ) {
                    var y = f.tag;
                    if ((y === 3 || y === 4) && f.stateNode.containerInfo === n)
                      return;
                    f = f.return;
                  }
                for (; d !== null; ) {
                  if (((f = Ja(d)), f === null)) return;
                  if (
                    ((y = f.tag), y === 5 || y === 6 || y === 26 || y === 27)
                  ) {
                    l = i = f;
                    continue t;
                  }
                  d = d.parentNode;
                }
              }
              l = l.return;
            }
          df(function () {
            var E = i,
              R = Eu(a),
              U = [];
            t: {
              var O = Yf.get(t);
              if (O !== void 0) {
                var M = Pn,
                  J = t;
                switch (t) {
                  case 'keypress':
                    if (Wn(a) === 0) break t;
                  case 'keydown':
                  case 'keyup':
                    M = sg;
                    break;
                  case 'focusin':
                    ((J = 'focus'), (M = zu));
                    break;
                  case 'focusout':
                    ((J = 'blur'), (M = zu));
                    break;
                  case 'beforeblur':
                  case 'afterblur':
                    M = zu;
                    break;
                  case 'click':
                    if (a.button === 2) break t;
                  case 'auxclick':
                  case 'dblclick':
                  case 'mousedown':
                  case 'mousemove':
                  case 'mouseup':
                  case 'mouseout':
                  case 'mouseover':
                  case 'contextmenu':
                    M = mf;
                    break;
                  case 'drag':
                  case 'dragend':
                  case 'dragenter':
                  case 'dragexit':
                  case 'dragleave':
                  case 'dragover':
                  case 'dragstart':
                  case 'drop':
                    M = kh;
                    break;
                  case 'touchcancel':
                  case 'touchend':
                  case 'touchmove':
                  case 'touchstart':
                    M = og;
                    break;
                  case Hf:
                  case Bf:
                  case qf:
                    M = Ph;
                    break;
                  case Kf:
                    M = dg;
                    break;
                  case 'scroll':
                  case 'scrollend':
                    M = $h;
                    break;
                  case 'wheel':
                    M = gg;
                    break;
                  case 'copy':
                  case 'cut':
                  case 'paste':
                    M = tg;
                    break;
                  case 'gotpointercapture':
                  case 'lostpointercapture':
                  case 'pointercancel':
                  case 'pointerdown':
                  case 'pointermove':
                  case 'pointerout':
                  case 'pointerover':
                  case 'pointerup':
                    M = pf;
                    break;
                  case 'toggle':
                  case 'beforetoggle':
                    M = yg;
                }
                var Z = (e & 4) !== 0,
                  bt = !Z && (t === 'scroll' || t === 'scrollend'),
                  x = Z ? (O !== null ? O + 'Capture' : null) : O;
                Z = [];
                for (var S = E, T; S !== null; ) {
                  var z = S;
                  if (
                    ((T = z.stateNode),
                    (z = z.tag),
                    (z !== 5 && z !== 26 && z !== 27) ||
                      T === null ||
                      x === null ||
                      ((z = Yl(S, x)), z != null && Z.push(Tn(S, z, T))),
                    bt)
                  )
                    break;
                  S = S.return;
                }
                0 < Z.length &&
                  ((O = new M(O, J, null, a, R)),
                  U.push({ event: O, listeners: Z }));
              }
            }
            if ((e & 7) === 0) {
              t: {
                if (
                  ((O = t === 'mouseover' || t === 'pointerover'),
                  (M = t === 'mouseout' || t === 'pointerout'),
                  O &&
                    a !== Tu &&
                    (J = a.relatedTarget || a.fromElement) &&
                    (Ja(J) || J[$a]))
                )
                  break t;
                if (
                  (M || O) &&
                  ((O =
                    R.window === R
                      ? R
                      : (O = R.ownerDocument)
                        ? O.defaultView || O.parentWindow
                        : window),
                  M
                    ? ((J = a.relatedTarget || a.toElement),
                      (M = E),
                      (J = J ? Ja(J) : null),
                      J !== null &&
                        ((bt = h(J)),
                        (Z = J.tag),
                        J !== bt || (Z !== 5 && Z !== 27 && Z !== 6)) &&
                        (J = null))
                    : ((M = null), (J = E)),
                  M !== J)
                ) {
                  if (
                    ((Z = mf),
                    (z = 'onMouseLeave'),
                    (x = 'onMouseEnter'),
                    (S = 'mouse'),
                    (t === 'pointerout' || t === 'pointerover') &&
                      ((Z = pf),
                      (z = 'onPointerLeave'),
                      (x = 'onPointerEnter'),
                      (S = 'pointer')),
                    (bt = M == null ? O : Kl(M)),
                    (T = J == null ? O : Kl(J)),
                    (O = new Z(z, S + 'leave', M, a, R)),
                    (O.target = bt),
                    (O.relatedTarget = T),
                    (z = null),
                    Ja(R) === E &&
                      ((Z = new Z(x, S + 'enter', J, a, R)),
                      (Z.target = T),
                      (Z.relatedTarget = bt),
                      (z = Z)),
                    (bt = z),
                    M && J)
                  )
                    e: {
                      for (Z = M, x = J, S = 0, T = Z; T; T = Nl(T)) S++;
                      for (T = 0, z = x; z; z = Nl(z)) T++;
                      for (; 0 < S - T; ) ((Z = Nl(Z)), S--);
                      for (; 0 < T - S; ) ((x = Nl(x)), T--);
                      for (; S--; ) {
                        if (Z === x || (x !== null && Z === x.alternate))
                          break e;
                        ((Z = Nl(Z)), (x = Nl(x)));
                      }
                      Z = null;
                    }
                  else Z = null;
                  (M !== null && sd(U, O, M, Z, !1),
                    J !== null && bt !== null && sd(U, bt, J, Z, !0));
                }
              }
              t: {
                if (
                  ((O = E ? Kl(E) : window),
                  (M = O.nodeName && O.nodeName.toLowerCase()),
                  M === 'select' || (M === 'input' && O.type === 'file'))
                )
                  var Y = Of;
                else if (Tf(O))
                  if (Mf) Y = Mg;
                  else {
                    Y = Eg;
                    var lt = Tg;
                  }
                else
                  ((M = O.nodeName),
                    !M ||
                    M.toLowerCase() !== 'input' ||
                    (O.type !== 'checkbox' && O.type !== 'radio')
                      ? E && Au(E.elementType) && (Y = Of)
                      : (Y = Og));
                if (Y && (Y = Y(t, E))) {
                  Ef(U, Y, a, R);
                  break t;
                }
                (lt && lt(t, O, E),
                  t === 'focusout' &&
                    E &&
                    O.type === 'number' &&
                    E.memoizedProps.value != null &&
                    xu(O, 'number', O.value));
              }
              switch (((lt = E ? Kl(E) : window), t)) {
                case 'focusin':
                  (Tf(lt) || lt.contentEditable === 'true') &&
                    ((nl = lt), (Hu = E), (Jl = null));
                  break;
                case 'focusout':
                  Jl = Hu = nl = null;
                  break;
                case 'mousedown':
                  Bu = !0;
                  break;
                case 'contextmenu':
                case 'mouseup':
                case 'dragend':
                  ((Bu = !1), jf(U, a, R));
                  break;
                case 'selectionchange':
                  if (Ng) break;
                case 'keydown':
                case 'keyup':
                  jf(U, a, R);
              }
              var G;
              if (Cu)
                t: {
                  switch (t) {
                    case 'compositionstart':
                      var $ = 'onCompositionStart';
                      break t;
                    case 'compositionend':
                      $ = 'onCompositionEnd';
                      break t;
                    case 'compositionupdate':
                      $ = 'onCompositionUpdate';
                      break t;
                  }
                  $ = void 0;
                }
              else
                ll
                  ? xf(t, a) && ($ = 'onCompositionEnd')
                  : t === 'keydown' &&
                    a.keyCode === 229 &&
                    ($ = 'onCompositionStart');
              ($ &&
                (vf &&
                  a.locale !== 'ko' &&
                  (ll || $ !== 'onCompositionStart'
                    ? $ === 'onCompositionEnd' && ll && (G = hf())
                    : ((na = R),
                      (_u = 'value' in na ? na.value : na.textContent),
                      (ll = !0))),
                (lt = Ki(E, $)),
                0 < lt.length &&
                  (($ = new yf($, t, null, a, R)),
                  U.push({ event: $, listeners: lt }),
                  G
                    ? ($.data = G)
                    : ((G = Af(a)), G !== null && ($.data = G)))),
                (G = vg ? bg(t, a) : Sg(t, a)) &&
                  (($ = Ki(E, 'onBeforeInput')),
                  0 < $.length &&
                    ((lt = new yf('onBeforeInput', 'beforeinput', null, a, R)),
                    U.push({ event: lt, listeners: $ }),
                    (lt.data = G))),
                om(U, t, E, a, R));
            }
            id(U, e);
          });
        }
        function Tn(t, e, a) {
          return { instance: t, listener: e, currentTarget: a };
        }
        function Ki(t, e) {
          for (var a = e + 'Capture', l = []; t !== null; ) {
            var n = t,
              i = n.stateNode;
            if (
              ((n = n.tag),
              (n !== 5 && n !== 26 && n !== 27) ||
                i === null ||
                ((n = Yl(t, a)),
                n != null && l.unshift(Tn(t, n, i)),
                (n = Yl(t, e)),
                n != null && l.push(Tn(t, n, i))),
              t.tag === 3)
            )
              return l;
            t = t.return;
          }
          return [];
        }
        function Nl(t) {
          if (t === null) return null;
          do t = t.return;
          while (t && t.tag !== 5 && t.tag !== 27);
          return t || null;
        }
        function sd(t, e, a, l, n) {
          for (var i = e._reactName, f = []; a !== null && a !== l; ) {
            var d = a,
              y = d.alternate,
              E = d.stateNode;
            if (((d = d.tag), y !== null && y === l)) break;
            ((d !== 5 && d !== 26 && d !== 27) ||
              E === null ||
              ((y = E),
              n
                ? ((E = Yl(a, i)), E != null && f.unshift(Tn(a, E, y)))
                : n || ((E = Yl(a, i)), E != null && f.push(Tn(a, E, y)))),
              (a = a.return));
          }
          f.length !== 0 && t.push({ event: e, listeners: f });
        }
        var gm = /\r\n?/g,
          mm = /\u0000|\uFFFD/g;
        function cd(t) {
          return (typeof t == 'string' ? t : '' + t)
            .replace(
              gm,
              `
`
            )
            .replace(mm, '');
        }
        function fd(t, e) {
          return ((e = cd(e)), cd(t) === e);
        }
        function Yi() {}
        function vt(t, e, a, l, n, i) {
          switch (a) {
            case 'children':
              typeof l == 'string'
                ? e === 'body' || (e === 'textarea' && l === '') || tl(t, l)
                : (typeof l == 'number' || typeof l == 'bigint') &&
                  e !== 'body' &&
                  tl(t, '' + l);
              break;
            case 'className':
              Qn(t, 'class', l);
              break;
            case 'tabIndex':
              Qn(t, 'tabindex', l);
              break;
            case 'dir':
            case 'role':
            case 'viewBox':
            case 'width':
            case 'height':
              Qn(t, a, l);
              break;
            case 'style':
              of(t, l, i);
              break;
            case 'data':
              if (e !== 'object') {
                Qn(t, 'data', l);
                break;
              }
            case 'src':
            case 'href':
              if (l === '' && (e !== 'a' || a !== 'href')) {
                t.removeAttribute(a);
                break;
              }
              if (
                l == null ||
                typeof l == 'function' ||
                typeof l == 'symbol' ||
                typeof l == 'boolean'
              ) {
                t.removeAttribute(a);
                break;
              }
              ((l = Jn('' + l)), t.setAttribute(a, l));
              break;
            case 'action':
            case 'formAction':
              if (typeof l == 'function') {
                t.setAttribute(
                  a,
                  "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')"
                );
                break;
              } else
                typeof i == 'function' &&
                  (a === 'formAction'
                    ? (e !== 'input' && vt(t, e, 'name', n.name, n, null),
                      vt(t, e, 'formEncType', n.formEncType, n, null),
                      vt(t, e, 'formMethod', n.formMethod, n, null),
                      vt(t, e, 'formTarget', n.formTarget, n, null))
                    : (vt(t, e, 'encType', n.encType, n, null),
                      vt(t, e, 'method', n.method, n, null),
                      vt(t, e, 'target', n.target, n, null)));
              if (l == null || typeof l == 'symbol' || typeof l == 'boolean') {
                t.removeAttribute(a);
                break;
              }
              ((l = Jn('' + l)), t.setAttribute(a, l));
              break;
            case 'onClick':
              l != null && (t.onclick = Yi);
              break;
            case 'onScroll':
              l != null && it('scroll', t);
              break;
            case 'onScrollEnd':
              l != null && it('scrollend', t);
              break;
            case 'dangerouslySetInnerHTML':
              if (l != null) {
                if (typeof l != 'object' || !('__html' in l))
                  throw Error(s(61));
                if (((a = l.__html), a != null)) {
                  if (n.children != null) throw Error(s(60));
                  t.innerHTML = a;
                }
              }
              break;
            case 'multiple':
              t.multiple = l && typeof l != 'function' && typeof l != 'symbol';
              break;
            case 'muted':
              t.muted = l && typeof l != 'function' && typeof l != 'symbol';
              break;
            case 'suppressContentEditableWarning':
            case 'suppressHydrationWarning':
            case 'defaultValue':
            case 'defaultChecked':
            case 'innerHTML':
            case 'ref':
              break;
            case 'autoFocus':
              break;
            case 'xlinkHref':
              if (
                l == null ||
                typeof l == 'function' ||
                typeof l == 'boolean' ||
                typeof l == 'symbol'
              ) {
                t.removeAttribute('xlink:href');
                break;
              }
              ((a = Jn('' + l)),
                t.setAttributeNS(
                  'http://www.w3.org/1999/xlink',
                  'xlink:href',
                  a
                ));
              break;
            case 'contentEditable':
            case 'spellCheck':
            case 'draggable':
            case 'value':
            case 'autoReverse':
            case 'externalResourcesRequired':
            case 'focusable':
            case 'preserveAlpha':
              l != null && typeof l != 'function' && typeof l != 'symbol'
                ? t.setAttribute(a, '' + l)
                : t.removeAttribute(a);
              break;
            case 'inert':
            case 'allowFullScreen':
            case 'async':
            case 'autoPlay':
            case 'controls':
            case 'default':
            case 'defer':
            case 'disabled':
            case 'disablePictureInPicture':
            case 'disableRemotePlayback':
            case 'formNoValidate':
            case 'hidden':
            case 'loop':
            case 'noModule':
            case 'noValidate':
            case 'open':
            case 'playsInline':
            case 'readOnly':
            case 'required':
            case 'reversed':
            case 'scoped':
            case 'seamless':
            case 'itemScope':
              l && typeof l != 'function' && typeof l != 'symbol'
                ? t.setAttribute(a, '')
                : t.removeAttribute(a);
              break;
            case 'capture':
            case 'download':
              l === !0
                ? t.setAttribute(a, '')
                : l !== !1 &&
                    l != null &&
                    typeof l != 'function' &&
                    typeof l != 'symbol'
                  ? t.setAttribute(a, l)
                  : t.removeAttribute(a);
              break;
            case 'cols':
            case 'rows':
            case 'size':
            case 'span':
              l != null &&
              typeof l != 'function' &&
              typeof l != 'symbol' &&
              !isNaN(l) &&
              1 <= l
                ? t.setAttribute(a, l)
                : t.removeAttribute(a);
              break;
            case 'rowSpan':
            case 'start':
              l == null ||
              typeof l == 'function' ||
              typeof l == 'symbol' ||
              isNaN(l)
                ? t.removeAttribute(a)
                : t.setAttribute(a, l);
              break;
            case 'popover':
              (it('beforetoggle', t), it('toggle', t), Xn(t, 'popover', l));
              break;
            case 'xlinkActuate':
              Ye(t, 'http://www.w3.org/1999/xlink', 'xlink:actuate', l);
              break;
            case 'xlinkArcrole':
              Ye(t, 'http://www.w3.org/1999/xlink', 'xlink:arcrole', l);
              break;
            case 'xlinkRole':
              Ye(t, 'http://www.w3.org/1999/xlink', 'xlink:role', l);
              break;
            case 'xlinkShow':
              Ye(t, 'http://www.w3.org/1999/xlink', 'xlink:show', l);
              break;
            case 'xlinkTitle':
              Ye(t, 'http://www.w3.org/1999/xlink', 'xlink:title', l);
              break;
            case 'xlinkType':
              Ye(t, 'http://www.w3.org/1999/xlink', 'xlink:type', l);
              break;
            case 'xmlBase':
              Ye(t, 'http://www.w3.org/XML/1998/namespace', 'xml:base', l);
              break;
            case 'xmlLang':
              Ye(t, 'http://www.w3.org/XML/1998/namespace', 'xml:lang', l);
              break;
            case 'xmlSpace':
              Ye(t, 'http://www.w3.org/XML/1998/namespace', 'xml:space', l);
              break;
            case 'is':
              Xn(t, 'is', l);
              break;
            case 'innerText':
            case 'textContent':
              break;
            default:
              (!(2 < a.length) ||
                (a[0] !== 'o' && a[0] !== 'O') ||
                (a[1] !== 'n' && a[1] !== 'N')) &&
                ((a = Qh.get(a) || a), Xn(t, a, l));
          }
        }
        function uc(t, e, a, l, n, i) {
          switch (a) {
            case 'style':
              of(t, l, i);
              break;
            case 'dangerouslySetInnerHTML':
              if (l != null) {
                if (typeof l != 'object' || !('__html' in l))
                  throw Error(s(61));
                if (((a = l.__html), a != null)) {
                  if (n.children != null) throw Error(s(60));
                  t.innerHTML = a;
                }
              }
              break;
            case 'children':
              typeof l == 'string'
                ? tl(t, l)
                : (typeof l == 'number' || typeof l == 'bigint') &&
                  tl(t, '' + l);
              break;
            case 'onScroll':
              l != null && it('scroll', t);
              break;
            case 'onScrollEnd':
              l != null && it('scrollend', t);
              break;
            case 'onClick':
              l != null && (t.onclick = Yi);
              break;
            case 'suppressContentEditableWarning':
            case 'suppressHydrationWarning':
            case 'innerHTML':
            case 'ref':
              break;
            case 'innerText':
            case 'textContent':
              break;
            default:
              if (!Pc.hasOwnProperty(a))
                t: {
                  if (
                    a[0] === 'o' &&
                    a[1] === 'n' &&
                    ((n = a.endsWith('Capture')),
                    (e = a.slice(2, n ? a.length - 7 : void 0)),
                    (i = t[ee] || null),
                    (i = i != null ? i[a] : null),
                    typeof i == 'function' && t.removeEventListener(e, i, n),
                    typeof l == 'function')
                  ) {
                    (typeof i != 'function' &&
                      i !== null &&
                      (a in t
                        ? (t[a] = null)
                        : t.hasAttribute(a) && t.removeAttribute(a)),
                      t.addEventListener(e, l, n));
                    break t;
                  }
                  a in t
                    ? (t[a] = l)
                    : l === !0
                      ? t.setAttribute(a, '')
                      : Xn(t, a, l);
                }
          }
        }
        function Jt(t, e, a) {
          switch (e) {
            case 'div':
            case 'span':
            case 'svg':
            case 'path':
            case 'a':
            case 'g':
            case 'p':
            case 'li':
              break;
            case 'img':
              (it('error', t), it('load', t));
              var l = !1,
                n = !1,
                i;
              for (i in a)
                if (a.hasOwnProperty(i)) {
                  var f = a[i];
                  if (f != null)
                    switch (i) {
                      case 'src':
                        l = !0;
                        break;
                      case 'srcSet':
                        n = !0;
                        break;
                      case 'children':
                      case 'dangerouslySetInnerHTML':
                        throw Error(s(137, e));
                      default:
                        vt(t, e, i, f, a, null);
                    }
                }
              (n && vt(t, e, 'srcSet', a.srcSet, a, null),
                l && vt(t, e, 'src', a.src, a, null));
              return;
            case 'input':
              it('invalid', t);
              var d = (i = f = n = null),
                y = null,
                E = null;
              for (l in a)
                if (a.hasOwnProperty(l)) {
                  var R = a[l];
                  if (R != null)
                    switch (l) {
                      case 'name':
                        n = R;
                        break;
                      case 'type':
                        f = R;
                        break;
                      case 'checked':
                        y = R;
                        break;
                      case 'defaultChecked':
                        E = R;
                        break;
                      case 'value':
                        i = R;
                        break;
                      case 'defaultValue':
                        d = R;
                        break;
                      case 'children':
                      case 'dangerouslySetInnerHTML':
                        if (R != null) throw Error(s(137, e));
                        break;
                      default:
                        vt(t, e, l, R, a, null);
                    }
                }
              (uf(t, i, d, y, E, f, n, !1), Zn(t));
              return;
            case 'select':
              (it('invalid', t), (l = f = i = null));
              for (n in a)
                if (a.hasOwnProperty(n) && ((d = a[n]), d != null))
                  switch (n) {
                    case 'value':
                      i = d;
                      break;
                    case 'defaultValue':
                      f = d;
                      break;
                    case 'multiple':
                      l = d;
                    default:
                      vt(t, e, n, d, a, null);
                  }
              ((e = i),
                (a = f),
                (t.multiple = !!l),
                e != null ? Ia(t, !!l, e, !1) : a != null && Ia(t, !!l, a, !0));
              return;
            case 'textarea':
              (it('invalid', t), (i = n = l = null));
              for (f in a)
                if (a.hasOwnProperty(f) && ((d = a[f]), d != null))
                  switch (f) {
                    case 'value':
                      l = d;
                      break;
                    case 'defaultValue':
                      n = d;
                      break;
                    case 'children':
                      i = d;
                      break;
                    case 'dangerouslySetInnerHTML':
                      if (d != null) throw Error(s(91));
                      break;
                    default:
                      vt(t, e, f, d, a, null);
                  }
              (cf(t, l, n, i), Zn(t));
              return;
            case 'option':
              for (y in a)
                if (a.hasOwnProperty(y) && ((l = a[y]), l != null))
                  switch (y) {
                    case 'selected':
                      t.selected =
                        l && typeof l != 'function' && typeof l != 'symbol';
                      break;
                    default:
                      vt(t, e, y, l, a, null);
                  }
              return;
            case 'dialog':
              (it('beforetoggle', t),
                it('toggle', t),
                it('cancel', t),
                it('close', t));
              break;
            case 'iframe':
            case 'object':
              it('load', t);
              break;
            case 'video':
            case 'audio':
              for (l = 0; l < An.length; l++) it(An[l], t);
              break;
            case 'image':
              (it('error', t), it('load', t));
              break;
            case 'details':
              it('toggle', t);
              break;
            case 'embed':
            case 'source':
            case 'link':
              (it('error', t), it('load', t));
            case 'area':
            case 'base':
            case 'br':
            case 'col':
            case 'hr':
            case 'keygen':
            case 'meta':
            case 'param':
            case 'track':
            case 'wbr':
            case 'menuitem':
              for (E in a)
                if (a.hasOwnProperty(E) && ((l = a[E]), l != null))
                  switch (E) {
                    case 'children':
                    case 'dangerouslySetInnerHTML':
                      throw Error(s(137, e));
                    default:
                      vt(t, e, E, l, a, null);
                  }
              return;
            default:
              if (Au(e)) {
                for (R in a)
                  a.hasOwnProperty(R) &&
                    ((l = a[R]), l !== void 0 && uc(t, e, R, l, a, void 0));
                return;
              }
          }
          for (d in a)
            a.hasOwnProperty(d) &&
              ((l = a[d]), l != null && vt(t, e, d, l, a, null));
        }
        function ym(t, e, a, l) {
          switch (e) {
            case 'div':
            case 'span':
            case 'svg':
            case 'path':
            case 'a':
            case 'g':
            case 'p':
            case 'li':
              break;
            case 'input':
              var n = null,
                i = null,
                f = null,
                d = null,
                y = null,
                E = null,
                R = null;
              for (M in a) {
                var U = a[M];
                if (a.hasOwnProperty(M) && U != null)
                  switch (M) {
                    case 'checked':
                      break;
                    case 'value':
                      break;
                    case 'defaultValue':
                      y = U;
                    default:
                      l.hasOwnProperty(M) || vt(t, e, M, null, l, U);
                  }
              }
              for (var O in l) {
                var M = l[O];
                if (
                  ((U = a[O]), l.hasOwnProperty(O) && (M != null || U != null))
                )
                  switch (O) {
                    case 'type':
                      i = M;
                      break;
                    case 'name':
                      n = M;
                      break;
                    case 'checked':
                      E = M;
                      break;
                    case 'defaultChecked':
                      R = M;
                      break;
                    case 'value':
                      f = M;
                      break;
                    case 'defaultValue':
                      d = M;
                      break;
                    case 'children':
                    case 'dangerouslySetInnerHTML':
                      if (M != null) throw Error(s(137, e));
                      break;
                    default:
                      M !== U && vt(t, e, O, M, l, U);
                  }
              }
              Su(t, f, d, y, E, R, i, n);
              return;
            case 'select':
              M = f = d = O = null;
              for (i in a)
                if (((y = a[i]), a.hasOwnProperty(i) && y != null))
                  switch (i) {
                    case 'value':
                      break;
                    case 'multiple':
                      M = y;
                    default:
                      l.hasOwnProperty(i) || vt(t, e, i, null, l, y);
                  }
              for (n in l)
                if (
                  ((i = l[n]),
                  (y = a[n]),
                  l.hasOwnProperty(n) && (i != null || y != null))
                )
                  switch (n) {
                    case 'value':
                      O = i;
                      break;
                    case 'defaultValue':
                      d = i;
                      break;
                    case 'multiple':
                      f = i;
                    default:
                      i !== y && vt(t, e, n, i, l, y);
                  }
              ((e = d),
                (a = f),
                (l = M),
                O != null
                  ? Ia(t, !!a, O, !1)
                  : !!l != !!a &&
                    (e != null
                      ? Ia(t, !!a, e, !0)
                      : Ia(t, !!a, a ? [] : '', !1)));
              return;
            case 'textarea':
              M = O = null;
              for (d in a)
                if (
                  ((n = a[d]),
                  a.hasOwnProperty(d) && n != null && !l.hasOwnProperty(d))
                )
                  switch (d) {
                    case 'value':
                      break;
                    case 'children':
                      break;
                    default:
                      vt(t, e, d, null, l, n);
                  }
              for (f in l)
                if (
                  ((n = l[f]),
                  (i = a[f]),
                  l.hasOwnProperty(f) && (n != null || i != null))
                )
                  switch (f) {
                    case 'value':
                      O = n;
                      break;
                    case 'defaultValue':
                      M = n;
                      break;
                    case 'children':
                      break;
                    case 'dangerouslySetInnerHTML':
                      if (n != null) throw Error(s(91));
                      break;
                    default:
                      n !== i && vt(t, e, f, n, l, i);
                  }
              sf(t, O, M);
              return;
            case 'option':
              for (var J in a)
                if (
                  ((O = a[J]),
                  a.hasOwnProperty(J) && O != null && !l.hasOwnProperty(J))
                )
                  switch (J) {
                    case 'selected':
                      t.selected = !1;
                      break;
                    default:
                      vt(t, e, J, null, l, O);
                  }
              for (y in l)
                if (
                  ((O = l[y]),
                  (M = a[y]),
                  l.hasOwnProperty(y) && O !== M && (O != null || M != null))
                )
                  switch (y) {
                    case 'selected':
                      t.selected =
                        O && typeof O != 'function' && typeof O != 'symbol';
                      break;
                    default:
                      vt(t, e, y, O, l, M);
                  }
              return;
            case 'img':
            case 'link':
            case 'area':
            case 'base':
            case 'br':
            case 'col':
            case 'embed':
            case 'hr':
            case 'keygen':
            case 'meta':
            case 'param':
            case 'source':
            case 'track':
            case 'wbr':
            case 'menuitem':
              for (var Z in a)
                ((O = a[Z]),
                  a.hasOwnProperty(Z) &&
                    O != null &&
                    !l.hasOwnProperty(Z) &&
                    vt(t, e, Z, null, l, O));
              for (E in l)
                if (
                  ((O = l[E]),
                  (M = a[E]),
                  l.hasOwnProperty(E) && O !== M && (O != null || M != null))
                )
                  switch (E) {
                    case 'children':
                    case 'dangerouslySetInnerHTML':
                      if (O != null) throw Error(s(137, e));
                      break;
                    default:
                      vt(t, e, E, O, l, M);
                  }
              return;
            default:
              if (Au(e)) {
                for (var bt in a)
                  ((O = a[bt]),
                    a.hasOwnProperty(bt) &&
                      O !== void 0 &&
                      !l.hasOwnProperty(bt) &&
                      uc(t, e, bt, void 0, l, O));
                for (R in l)
                  ((O = l[R]),
                    (M = a[R]),
                    !l.hasOwnProperty(R) ||
                      O === M ||
                      (O === void 0 && M === void 0) ||
                      uc(t, e, R, O, l, M));
                return;
              }
          }
          for (var x in a)
            ((O = a[x]),
              a.hasOwnProperty(x) &&
                O != null &&
                !l.hasOwnProperty(x) &&
                vt(t, e, x, null, l, O));
          for (U in l)
            ((O = l[U]),
              (M = a[U]),
              !l.hasOwnProperty(U) ||
                O === M ||
                (O == null && M == null) ||
                vt(t, e, U, O, l, M));
        }
        var sc = null,
          cc = null;
        function Gi(t) {
          return t.nodeType === 9 ? t : t.ownerDocument;
        }
        function od(t) {
          switch (t) {
            case 'http://www.w3.org/2000/svg':
              return 1;
            case 'http://www.w3.org/1998/Math/MathML':
              return 2;
            default:
              return 0;
          }
        }
        function rd(t, e) {
          if (t === 0)
            switch (e) {
              case 'svg':
                return 1;
              case 'math':
                return 2;
              default:
                return 0;
            }
          return t === 1 && e === 'foreignObject' ? 0 : t;
        }
        function fc(t, e) {
          return (
            t === 'textarea' ||
            t === 'noscript' ||
            typeof e.children == 'string' ||
            typeof e.children == 'number' ||
            typeof e.children == 'bigint' ||
            (typeof e.dangerouslySetInnerHTML == 'object' &&
              e.dangerouslySetInnerHTML !== null &&
              e.dangerouslySetInnerHTML.__html != null)
          );
        }
        var oc = null;
        function pm() {
          var t = window.event;
          return t && t.type === 'popstate'
            ? t === oc
              ? !1
              : ((oc = t), !0)
            : ((oc = null), !1);
        }
        var dd = typeof setTimeout == 'function' ? setTimeout : void 0,
          vm = typeof clearTimeout == 'function' ? clearTimeout : void 0,
          hd = typeof Promise == 'function' ? Promise : void 0,
          bm =
            typeof queueMicrotask == 'function'
              ? queueMicrotask
              : typeof hd < 'u'
                ? function (t) {
                    return hd.resolve(null).then(t).catch(Sm);
                  }
                : dd;
        function Sm(t) {
          setTimeout(function () {
            throw t;
          });
        }
        function Sa(t) {
          return t === 'head';
        }
        function gd(t, e) {
          var a = e,
            l = 0,
            n = 0;
          do {
            var i = a.nextSibling;
            if ((t.removeChild(a), i && i.nodeType === 8))
              if (((a = i.data), a === '/$')) {
                if (0 < l && 8 > l) {
                  a = l;
                  var f = t.ownerDocument;
                  if (
                    (a & 1 && En(f.documentElement), a & 2 && En(f.body), a & 4)
                  )
                    for (a = f.head, En(a), f = a.firstChild; f; ) {
                      var d = f.nextSibling,
                        y = f.nodeName;
                      (f[ql] ||
                        y === 'SCRIPT' ||
                        y === 'STYLE' ||
                        (y === 'LINK' &&
                          f.rel.toLowerCase() === 'stylesheet') ||
                        a.removeChild(f),
                        (f = d));
                    }
                }
                if (n === 0) {
                  (t.removeChild(i), Cn(e));
                  return;
                }
                n--;
              } else
                a === '$' || a === '$?' || a === '$!'
                  ? n++
                  : (l = a.charCodeAt(0) - 48);
            else l = 0;
            a = i;
          } while (a);
          Cn(e);
        }
        function rc(t) {
          var e = t.firstChild;
          for (e && e.nodeType === 10 && (e = e.nextSibling); e; ) {
            var a = e;
            switch (((e = e.nextSibling), a.nodeName)) {
              case 'HTML':
              case 'HEAD':
              case 'BODY':
                (rc(a), yu(a));
                continue;
              case 'SCRIPT':
              case 'STYLE':
                continue;
              case 'LINK':
                if (a.rel.toLowerCase() === 'stylesheet') continue;
            }
            t.removeChild(a);
          }
        }
        function xm(t, e, a, l) {
          for (; t.nodeType === 1; ) {
            var n = a;
            if (t.nodeName.toLowerCase() !== e.toLowerCase()) {
              if (!l && (t.nodeName !== 'INPUT' || t.type !== 'hidden')) break;
            } else if (l) {
              if (!t[ql])
                switch (e) {
                  case 'meta':
                    if (!t.hasAttribute('itemprop')) break;
                    return t;
                  case 'link':
                    if (
                      ((i = t.getAttribute('rel')),
                      i === 'stylesheet' && t.hasAttribute('data-precedence'))
                    )
                      break;
                    if (
                      i !== n.rel ||
                      t.getAttribute('href') !==
                        (n.href == null || n.href === '' ? null : n.href) ||
                      t.getAttribute('crossorigin') !==
                        (n.crossOrigin == null ? null : n.crossOrigin) ||
                      t.getAttribute('title') !==
                        (n.title == null ? null : n.title)
                    )
                      break;
                    return t;
                  case 'style':
                    if (t.hasAttribute('data-precedence')) break;
                    return t;
                  case 'script':
                    if (
                      ((i = t.getAttribute('src')),
                      (i !== (n.src == null ? null : n.src) ||
                        t.getAttribute('type') !==
                          (n.type == null ? null : n.type) ||
                        t.getAttribute('crossorigin') !==
                          (n.crossOrigin == null ? null : n.crossOrigin)) &&
                        i &&
                        t.hasAttribute('async') &&
                        !t.hasAttribute('itemprop'))
                    )
                      break;
                    return t;
                  default:
                    return t;
                }
            } else if (e === 'input' && t.type === 'hidden') {
              var i = n.name == null ? null : '' + n.name;
              if (n.type === 'hidden' && t.getAttribute('name') === i) return t;
            } else return t;
            if (((t = De(t.nextSibling)), t === null)) break;
          }
          return null;
        }
        function Am(t, e, a) {
          if (e === '') return null;
          for (; t.nodeType !== 3; )
            if (
              ((t.nodeType !== 1 ||
                t.nodeName !== 'INPUT' ||
                t.type !== 'hidden') &&
                !a) ||
              ((t = De(t.nextSibling)), t === null)
            )
              return null;
          return t;
        }
        function dc(t) {
          return (
            t.data === '$!' ||
            (t.data === '$?' && t.ownerDocument.readyState === 'complete')
          );
        }
        function Tm(t, e) {
          var a = t.ownerDocument;
          if (t.data !== '$?' || a.readyState === 'complete') e();
          else {
            var l = function () {
              (e(), a.removeEventListener('DOMContentLoaded', l));
            };
            (a.addEventListener('DOMContentLoaded', l), (t._reactRetry = l));
          }
        }
        function De(t) {
          for (; t != null; t = t.nextSibling) {
            var e = t.nodeType;
            if (e === 1 || e === 3) break;
            if (e === 8) {
              if (
                ((e = t.data),
                e === '$' ||
                  e === '$!' ||
                  e === '$?' ||
                  e === 'F!' ||
                  e === 'F')
              )
                break;
              if (e === '/$') return null;
            }
          }
          return t;
        }
        var hc = null;
        function md(t) {
          t = t.previousSibling;
          for (var e = 0; t; ) {
            if (t.nodeType === 8) {
              var a = t.data;
              if (a === '$' || a === '$!' || a === '$?') {
                if (e === 0) return t;
                e--;
              } else a === '/$' && e++;
            }
            t = t.previousSibling;
          }
          return null;
        }
        function yd(t, e, a) {
          switch (((e = Gi(a)), t)) {
            case 'html':
              if (((t = e.documentElement), !t)) throw Error(s(452));
              return t;
            case 'head':
              if (((t = e.head), !t)) throw Error(s(453));
              return t;
            case 'body':
              if (((t = e.body), !t)) throw Error(s(454));
              return t;
            default:
              throw Error(s(451));
          }
        }
        function En(t) {
          for (var e = t.attributes; e.length; ) t.removeAttributeNode(e[0]);
          yu(t);
        }
        var Oe = new Map(),
          pd = new Set();
        function wi(t) {
          return typeof t.getRootNode == 'function'
            ? t.getRootNode()
            : t.nodeType === 9
              ? t
              : t.ownerDocument;
        }
        var ta = j.d;
        j.d = { f: Em, r: Om, D: Mm, C: _m, L: Nm, m: Rm, X: Dm, S: zm, M: Cm };
        function Em() {
          var t = ta.f(),
            e = Ui();
          return t || e;
        }
        function Om(t) {
          var e = ka(t);
          e !== null && e.tag === 5 && e.type === 'form' ? Bo(e) : ta.r(t);
        }
        var Rl = typeof document > 'u' ? null : document;
        function vd(t, e, a) {
          var l = Rl;
          if (l && typeof e == 'string' && e) {
            var n = ve(e);
            ((n = 'link[rel="' + t + '"][href="' + n + '"]'),
              typeof a == 'string' && (n += '[crossorigin="' + a + '"]'),
              pd.has(n) ||
                (pd.add(n),
                (t = { rel: t, crossOrigin: a, href: e }),
                l.querySelector(n) === null &&
                  ((e = l.createElement('link')),
                  Jt(e, 'link', t),
                  Gt(e),
                  l.head.appendChild(e))));
          }
        }
        function Mm(t) {
          (ta.D(t), vd('dns-prefetch', t, null));
        }
        function _m(t, e) {
          (ta.C(t, e), vd('preconnect', t, e));
        }
        function Nm(t, e, a) {
          ta.L(t, e, a);
          var l = Rl;
          if (l && t && e) {
            var n = 'link[rel="preload"][as="' + ve(e) + '"]';
            e === 'image' && a && a.imageSrcSet
              ? ((n += '[imagesrcset="' + ve(a.imageSrcSet) + '"]'),
                typeof a.imageSizes == 'string' &&
                  (n += '[imagesizes="' + ve(a.imageSizes) + '"]'))
              : (n += '[href="' + ve(t) + '"]');
            var i = n;
            switch (e) {
              case 'style':
                i = zl(t);
                break;
              case 'script':
                i = Dl(t);
            }
            Oe.has(i) ||
              ((t = A(
                {
                  rel: 'preload',
                  href: e === 'image' && a && a.imageSrcSet ? void 0 : t,
                  as: e,
                },
                a
              )),
              Oe.set(i, t),
              l.querySelector(n) !== null ||
                (e === 'style' && l.querySelector(On(i))) ||
                (e === 'script' && l.querySelector(Mn(i))) ||
                ((e = l.createElement('link')),
                Jt(e, 'link', t),
                Gt(e),
                l.head.appendChild(e)));
          }
        }
        function Rm(t, e) {
          ta.m(t, e);
          var a = Rl;
          if (a && t) {
            var l = e && typeof e.as == 'string' ? e.as : 'script',
              n =
                'link[rel="modulepreload"][as="' +
                ve(l) +
                '"][href="' +
                ve(t) +
                '"]',
              i = n;
            switch (l) {
              case 'audioworklet':
              case 'paintworklet':
              case 'serviceworker':
              case 'sharedworker':
              case 'worker':
              case 'script':
                i = Dl(t);
            }
            if (
              !Oe.has(i) &&
              ((t = A({ rel: 'modulepreload', href: t }, e)),
              Oe.set(i, t),
              a.querySelector(n) === null)
            ) {
              switch (l) {
                case 'audioworklet':
                case 'paintworklet':
                case 'serviceworker':
                case 'sharedworker':
                case 'worker':
                case 'script':
                  if (a.querySelector(Mn(i))) return;
              }
              ((l = a.createElement('link')),
                Jt(l, 'link', t),
                Gt(l),
                a.head.appendChild(l));
            }
          }
        }
        function zm(t, e, a) {
          ta.S(t, e, a);
          var l = Rl;
          if (l && t) {
            var n = Wa(l).hoistableStyles,
              i = zl(t);
            e = e || 'default';
            var f = n.get(i);
            if (!f) {
              var d = { loading: 0, preload: null };
              if ((f = l.querySelector(On(i)))) d.loading = 5;
              else {
                ((t = A(
                  { rel: 'stylesheet', href: t, 'data-precedence': e },
                  a
                )),
                  (a = Oe.get(i)) && gc(t, a));
                var y = (f = l.createElement('link'));
                (Gt(y),
                  Jt(y, 'link', t),
                  (y._p = new Promise(function (E, R) {
                    ((y.onload = E), (y.onerror = R));
                  })),
                  y.addEventListener('load', function () {
                    d.loading |= 1;
                  }),
                  y.addEventListener('error', function () {
                    d.loading |= 2;
                  }),
                  (d.loading |= 4),
                  Vi(f, e, l));
              }
              ((f = { type: 'stylesheet', instance: f, count: 1, state: d }),
                n.set(i, f));
            }
          }
        }
        function Dm(t, e) {
          ta.X(t, e);
          var a = Rl;
          if (a && t) {
            var l = Wa(a).hoistableScripts,
              n = Dl(t),
              i = l.get(n);
            i ||
              ((i = a.querySelector(Mn(n))),
              i ||
                ((t = A({ src: t, async: !0 }, e)),
                (e = Oe.get(n)) && mc(t, e),
                (i = a.createElement('script')),
                Gt(i),
                Jt(i, 'link', t),
                a.head.appendChild(i)),
              (i = { type: 'script', instance: i, count: 1, state: null }),
              l.set(n, i));
          }
        }
        function Cm(t, e) {
          ta.M(t, e);
          var a = Rl;
          if (a && t) {
            var l = Wa(a).hoistableScripts,
              n = Dl(t),
              i = l.get(n);
            i ||
              ((i = a.querySelector(Mn(n))),
              i ||
                ((t = A({ src: t, async: !0, type: 'module' }, e)),
                (e = Oe.get(n)) && mc(t, e),
                (i = a.createElement('script')),
                Gt(i),
                Jt(i, 'link', t),
                a.head.appendChild(i)),
              (i = { type: 'script', instance: i, count: 1, state: null }),
              l.set(n, i));
          }
        }
        function bd(t, e, a, l) {
          var n = (n = F.current) ? wi(n) : null;
          if (!n) throw Error(s(446));
          switch (t) {
            case 'meta':
            case 'title':
              return null;
            case 'style':
              return typeof a.precedence == 'string' &&
                typeof a.href == 'string'
                ? ((e = zl(a.href)),
                  (a = Wa(n).hoistableStyles),
                  (l = a.get(e)),
                  l ||
                    ((l = {
                      type: 'style',
                      instance: null,
                      count: 0,
                      state: null,
                    }),
                    a.set(e, l)),
                  l)
                : { type: 'void', instance: null, count: 0, state: null };
            case 'link':
              if (
                a.rel === 'stylesheet' &&
                typeof a.href == 'string' &&
                typeof a.precedence == 'string'
              ) {
                t = zl(a.href);
                var i = Wa(n).hoistableStyles,
                  f = i.get(t);
                if (
                  (f ||
                    ((n = n.ownerDocument || n),
                    (f = {
                      type: 'stylesheet',
                      instance: null,
                      count: 0,
                      state: { loading: 0, preload: null },
                    }),
                    i.set(t, f),
                    (i = n.querySelector(On(t))) &&
                      !i._p &&
                      ((f.instance = i), (f.state.loading = 5)),
                    Oe.has(t) ||
                      ((a = {
                        rel: 'preload',
                        as: 'style',
                        href: a.href,
                        crossOrigin: a.crossOrigin,
                        integrity: a.integrity,
                        media: a.media,
                        hrefLang: a.hrefLang,
                        referrerPolicy: a.referrerPolicy,
                      }),
                      Oe.set(t, a),
                      i || Um(n, t, a, f.state))),
                  e && l === null)
                )
                  throw Error(s(528, ''));
                return f;
              }
              if (e && l !== null) throw Error(s(529, ''));
              return null;
            case 'script':
              return (
                (e = a.async),
                (a = a.src),
                typeof a == 'string' &&
                e &&
                typeof e != 'function' &&
                typeof e != 'symbol'
                  ? ((e = Dl(a)),
                    (a = Wa(n).hoistableScripts),
                    (l = a.get(e)),
                    l ||
                      ((l = {
                        type: 'script',
                        instance: null,
                        count: 0,
                        state: null,
                      }),
                      a.set(e, l)),
                    l)
                  : { type: 'void', instance: null, count: 0, state: null }
              );
            default:
              throw Error(s(444, t));
          }
        }
        function zl(t) {
          return 'href="' + ve(t) + '"';
        }
        function On(t) {
          return 'link[rel="stylesheet"][' + t + ']';
        }
        function Sd(t) {
          return A({}, t, {
            'data-precedence': t.precedence,
            precedence: null,
          });
        }
        function Um(t, e, a, l) {
          t.querySelector('link[rel="preload"][as="style"][' + e + ']')
            ? (l.loading = 1)
            : ((e = t.createElement('link')),
              (l.preload = e),
              e.addEventListener('load', function () {
                return (l.loading |= 1);
              }),
              e.addEventListener('error', function () {
                return (l.loading |= 2);
              }),
              Jt(e, 'link', a),
              Gt(e),
              t.head.appendChild(e));
        }
        function Dl(t) {
          return '[src="' + ve(t) + '"]';
        }
        function Mn(t) {
          return 'script[async]' + t;
        }
        function xd(t, e, a) {
          if ((e.count++, e.instance === null))
            switch (e.type) {
              case 'style':
                var l = t.querySelector(
                  'style[data-href~="' + ve(a.href) + '"]'
                );
                if (l) return ((e.instance = l), Gt(l), l);
                var n = A({}, a, {
                  'data-href': a.href,
                  'data-precedence': a.precedence,
                  href: null,
                  precedence: null,
                });
                return (
                  (l = (t.ownerDocument || t).createElement('style')),
                  Gt(l),
                  Jt(l, 'style', n),
                  Vi(l, a.precedence, t),
                  (e.instance = l)
                );
              case 'stylesheet':
                n = zl(a.href);
                var i = t.querySelector(On(n));
                if (i)
                  return ((e.state.loading |= 4), (e.instance = i), Gt(i), i);
                ((l = Sd(a)),
                  (n = Oe.get(n)) && gc(l, n),
                  (i = (t.ownerDocument || t).createElement('link')),
                  Gt(i));
                var f = i;
                return (
                  (f._p = new Promise(function (d, y) {
                    ((f.onload = d), (f.onerror = y));
                  })),
                  Jt(i, 'link', l),
                  (e.state.loading |= 4),
                  Vi(i, a.precedence, t),
                  (e.instance = i)
                );
              case 'script':
                return (
                  (i = Dl(a.src)),
                  (n = t.querySelector(Mn(i)))
                    ? ((e.instance = n), Gt(n), n)
                    : ((l = a),
                      (n = Oe.get(i)) && ((l = A({}, a)), mc(l, n)),
                      (t = t.ownerDocument || t),
                      (n = t.createElement('script')),
                      Gt(n),
                      Jt(n, 'link', l),
                      t.head.appendChild(n),
                      (e.instance = n))
                );
              case 'void':
                return null;
              default:
                throw Error(s(443, e.type));
            }
          else
            e.type === 'stylesheet' &&
              (e.state.loading & 4) === 0 &&
              ((l = e.instance),
              (e.state.loading |= 4),
              Vi(l, a.precedence, t));
          return e.instance;
        }
        function Vi(t, e, a) {
          for (
            var l = a.querySelectorAll(
                'link[rel="stylesheet"][data-precedence],style[data-precedence]'
              ),
              n = l.length ? l[l.length - 1] : null,
              i = n,
              f = 0;
            f < l.length;
            f++
          ) {
            var d = l[f];
            if (d.dataset.precedence === e) i = d;
            else if (i !== n) break;
          }
          i
            ? i.parentNode.insertBefore(t, i.nextSibling)
            : ((e = a.nodeType === 9 ? a.head : a),
              e.insertBefore(t, e.firstChild));
        }
        function gc(t, e) {
          (t.crossOrigin == null && (t.crossOrigin = e.crossOrigin),
            t.referrerPolicy == null && (t.referrerPolicy = e.referrerPolicy),
            t.title == null && (t.title = e.title));
        }
        function mc(t, e) {
          (t.crossOrigin == null && (t.crossOrigin = e.crossOrigin),
            t.referrerPolicy == null && (t.referrerPolicy = e.referrerPolicy),
            t.integrity == null && (t.integrity = e.integrity));
        }
        var Xi = null;
        function Ad(t, e, a) {
          if (Xi === null) {
            var l = new Map(),
              n = (Xi = new Map());
            n.set(a, l);
          } else
            ((n = Xi), (l = n.get(a)), l || ((l = new Map()), n.set(a, l)));
          if (l.has(t)) return l;
          for (
            l.set(t, null), a = a.getElementsByTagName(t), n = 0;
            n < a.length;
            n++
          ) {
            var i = a[n];
            if (
              !(
                i[ql] ||
                i[kt] ||
                (t === 'link' && i.getAttribute('rel') === 'stylesheet')
              ) &&
              i.namespaceURI !== 'http://www.w3.org/2000/svg'
            ) {
              var f = i.getAttribute(e) || '';
              f = t + f;
              var d = l.get(f);
              d ? d.push(i) : l.set(f, [i]);
            }
          }
          return l;
        }
        function Td(t, e, a) {
          ((t = t.ownerDocument || t),
            t.head.insertBefore(
              a,
              e === 'title' ? t.querySelector('head > title') : null
            ));
        }
        function jm(t, e, a) {
          if (a === 1 || e.itemProp != null) return !1;
          switch (t) {
            case 'meta':
            case 'title':
              return !0;
            case 'style':
              if (
                typeof e.precedence != 'string' ||
                typeof e.href != 'string' ||
                e.href === ''
              )
                break;
              return !0;
            case 'link':
              if (
                typeof e.rel != 'string' ||
                typeof e.href != 'string' ||
                e.href === '' ||
                e.onLoad ||
                e.onError
              )
                break;
              switch (e.rel) {
                case 'stylesheet':
                  return (
                    (t = e.disabled),
                    typeof e.precedence == 'string' && t == null
                  );
                default:
                  return !0;
              }
            case 'script':
              if (
                e.async &&
                typeof e.async != 'function' &&
                typeof e.async != 'symbol' &&
                !e.onLoad &&
                !e.onError &&
                e.src &&
                typeof e.src == 'string'
              )
                return !0;
          }
          return !1;
        }
        function Ed(t) {
          return !(t.type === 'stylesheet' && (t.state.loading & 3) === 0);
        }
        var _n = null;
        function Lm() {}
        function Hm(t, e, a) {
          if (_n === null) throw Error(s(475));
          var l = _n;
          if (
            e.type === 'stylesheet' &&
            (typeof a.media != 'string' ||
              matchMedia(a.media).matches !== !1) &&
            (e.state.loading & 4) === 0
          ) {
            if (e.instance === null) {
              var n = zl(a.href),
                i = t.querySelector(On(n));
              if (i) {
                ((t = i._p),
                  t !== null &&
                    typeof t == 'object' &&
                    typeof t.then == 'function' &&
                    (l.count++, (l = Qi.bind(l)), t.then(l, l)),
                  (e.state.loading |= 4),
                  (e.instance = i),
                  Gt(i));
                return;
              }
              ((i = t.ownerDocument || t),
                (a = Sd(a)),
                (n = Oe.get(n)) && gc(a, n),
                (i = i.createElement('link')),
                Gt(i));
              var f = i;
              ((f._p = new Promise(function (d, y) {
                ((f.onload = d), (f.onerror = y));
              })),
                Jt(i, 'link', a),
                (e.instance = i));
            }
            (l.stylesheets === null && (l.stylesheets = new Map()),
              l.stylesheets.set(e, t),
              (t = e.state.preload) &&
                (e.state.loading & 3) === 0 &&
                (l.count++,
                (e = Qi.bind(l)),
                t.addEventListener('load', e),
                t.addEventListener('error', e)));
          }
        }
        function Bm() {
          if (_n === null) throw Error(s(475));
          var t = _n;
          return (
            t.stylesheets && t.count === 0 && yc(t, t.stylesheets),
            0 < t.count
              ? function (e) {
                  var a = setTimeout(function () {
                    if ((t.stylesheets && yc(t, t.stylesheets), t.unsuspend)) {
                      var l = t.unsuspend;
                      ((t.unsuspend = null), l());
                    }
                  }, 6e4);
                  return (
                    (t.unsuspend = e),
                    function () {
                      ((t.unsuspend = null), clearTimeout(a));
                    }
                  );
                }
              : null
          );
        }
        function Qi() {
          if ((this.count--, this.count === 0)) {
            if (this.stylesheets) yc(this, this.stylesheets);
            else if (this.unsuspend) {
              var t = this.unsuspend;
              ((this.unsuspend = null), t());
            }
          }
        }
        var Zi = null;
        function yc(t, e) {
          ((t.stylesheets = null),
            t.unsuspend !== null &&
              (t.count++,
              (Zi = new Map()),
              e.forEach(qm, t),
              (Zi = null),
              Qi.call(t)));
        }
        function qm(t, e) {
          if (!(e.state.loading & 4)) {
            var a = Zi.get(t);
            if (a) var l = a.get(null);
            else {
              ((a = new Map()), Zi.set(t, a));
              for (
                var n = t.querySelectorAll(
                    'link[data-precedence],style[data-precedence]'
                  ),
                  i = 0;
                i < n.length;
                i++
              ) {
                var f = n[i];
                (f.nodeName === 'LINK' ||
                  f.getAttribute('media') !== 'not all') &&
                  (a.set(f.dataset.precedence, f), (l = f));
              }
              l && a.set(null, l);
            }
            ((n = e.instance),
              (f = n.getAttribute('data-precedence')),
              (i = a.get(f) || l),
              i === l && a.set(null, n),
              a.set(f, n),
              this.count++,
              (l = Qi.bind(this)),
              n.addEventListener('load', l),
              n.addEventListener('error', l),
              i
                ? i.parentNode.insertBefore(n, i.nextSibling)
                : ((t = t.nodeType === 9 ? t.head : t),
                  t.insertBefore(n, t.firstChild)),
              (e.state.loading |= 4));
          }
        }
        var Nn = {
          $$typeof: W,
          Provider: null,
          Consumer: null,
          _currentValue: V,
          _currentValue2: V,
          _threadCount: 0,
        };
        function Km(t, e, a, l, n, i, f, d) {
          ((this.tag = 1),
            (this.containerInfo = t),
            (this.pingCache = this.current = this.pendingChildren = null),
            (this.timeoutHandle = -1),
            (this.callbackNode =
              this.next =
              this.pendingContext =
              this.context =
              this.cancelPendingCommit =
                null),
            (this.callbackPriority = 0),
            (this.expirationTimes = du(-1)),
            (this.entangledLanes =
              this.shellSuspendCounter =
              this.errorRecoveryDisabledLanes =
              this.expiredLanes =
              this.warmLanes =
              this.pingedLanes =
              this.suspendedLanes =
              this.pendingLanes =
                0),
            (this.entanglements = du(0)),
            (this.hiddenUpdates = du(null)),
            (this.identifierPrefix = l),
            (this.onUncaughtError = n),
            (this.onCaughtError = i),
            (this.onRecoverableError = f),
            (this.pooledCache = null),
            (this.pooledCacheLanes = 0),
            (this.formState = d),
            (this.incompleteTransitions = new Map()));
        }
        function Od(t, e, a, l, n, i, f, d, y, E, R, U) {
          return (
            (t = new Km(t, e, a, f, d, y, E, U)),
            (e = 1),
            i === !0 && (e |= 24),
            (i = re(3, null, null, e)),
            (t.current = i),
            (i.stateNode = t),
            (e = Fu()),
            e.refCount++,
            (t.pooledCache = e),
            e.refCount++,
            (i.memoizedState = { element: l, isDehydrated: a, cache: e }),
            es(i),
            t
          );
        }
        function Md(t) {
          return t ? ((t = cl), t) : cl;
        }
        function _d(t, e, a, l, n, i) {
          ((n = Md(n)),
            l.context === null ? (l.context = n) : (l.pendingContext = n),
            (l = sa(e)),
            (l.payload = { element: a }),
            (i = i === void 0 ? null : i),
            i !== null && (l.callback = i),
            (a = ca(t, l, e)),
            a !== null && (ye(a, t, e), ln(a, t, e)));
        }
        function Nd(t, e) {
          if (((t = t.memoizedState), t !== null && t.dehydrated !== null)) {
            var a = t.retryLane;
            t.retryLane = a !== 0 && a < e ? a : e;
          }
        }
        function pc(t, e) {
          (Nd(t, e), (t = t.alternate) && Nd(t, e));
        }
        function Rd(t) {
          if (t.tag === 13) {
            var e = sl(t, 67108864);
            (e !== null && ye(e, t, 67108864), pc(t, 67108864));
          }
        }
        var $i = !0;
        function Ym(t, e, a, l) {
          var n = _.T;
          _.T = null;
          var i = j.p;
          try {
            ((j.p = 2), vc(t, e, a, l));
          } finally {
            ((j.p = i), (_.T = n));
          }
        }
        function Gm(t, e, a, l) {
          var n = _.T;
          _.T = null;
          var i = j.p;
          try {
            ((j.p = 8), vc(t, e, a, l));
          } finally {
            ((j.p = i), (_.T = n));
          }
        }
        function vc(t, e, a, l) {
          if ($i) {
            var n = bc(l);
            if (n === null) (ic(t, e, l, Ji, a), Dd(t, l));
            else if (Vm(n, t, e, a, l)) l.stopPropagation();
            else if ((Dd(t, l), e & 4 && -1 < wm.indexOf(t))) {
              for (; n !== null; ) {
                var i = ka(n);
                if (i !== null)
                  switch (i.tag) {
                    case 3:
                      if (
                        ((i = i.stateNode),
                        i.current.memoizedState.isDehydrated)
                      ) {
                        var f = Ma(i.pendingLanes);
                        if (f !== 0) {
                          var d = i;
                          for (
                            d.pendingLanes |= 2, d.entangledLanes |= 2;
                            f;
                          ) {
                            var y = 1 << (31 - fe(f));
                            ((d.entanglements[1] |= y), (f &= ~y));
                          }
                          (qe(i), (gt & 6) === 0 && ((Di = Ue() + 500), xn(0)));
                        }
                      }
                      break;
                    case 13:
                      ((d = sl(i, 2)),
                        d !== null && ye(d, i, 2),
                        Ui(),
                        pc(i, 2));
                  }
                if (((i = bc(l)), i === null && ic(t, e, l, Ji, a), i === n))
                  break;
                n = i;
              }
              n !== null && l.stopPropagation();
            } else ic(t, e, l, null, a);
          }
        }
        function bc(t) {
          return ((t = Eu(t)), Sc(t));
        }
        var Ji = null;
        function Sc(t) {
          if (((Ji = null), (t = Ja(t)), t !== null)) {
            var e = h(t);
            if (e === null) t = null;
            else {
              var a = e.tag;
              if (a === 13) {
                if (((t = m(e)), t !== null)) return t;
                t = null;
              } else if (a === 3) {
                if (e.stateNode.current.memoizedState.isDehydrated)
                  return e.tag === 3 ? e.stateNode.containerInfo : null;
                t = null;
              } else e !== t && (t = null);
            }
          }
          return ((Ji = t), null);
        }
        function zd(t) {
          switch (t) {
            case 'beforetoggle':
            case 'cancel':
            case 'click':
            case 'close':
            case 'contextmenu':
            case 'copy':
            case 'cut':
            case 'auxclick':
            case 'dblclick':
            case 'dragend':
            case 'dragstart':
            case 'drop':
            case 'focusin':
            case 'focusout':
            case 'input':
            case 'invalid':
            case 'keydown':
            case 'keypress':
            case 'keyup':
            case 'mousedown':
            case 'mouseup':
            case 'paste':
            case 'pause':
            case 'play':
            case 'pointercancel':
            case 'pointerdown':
            case 'pointerup':
            case 'ratechange':
            case 'reset':
            case 'resize':
            case 'seeked':
            case 'submit':
            case 'toggle':
            case 'touchcancel':
            case 'touchend':
            case 'touchstart':
            case 'volumechange':
            case 'change':
            case 'selectionchange':
            case 'textInput':
            case 'compositionstart':
            case 'compositionend':
            case 'compositionupdate':
            case 'beforeblur':
            case 'afterblur':
            case 'beforeinput':
            case 'blur':
            case 'fullscreenchange':
            case 'focus':
            case 'hashchange':
            case 'popstate':
            case 'select':
            case 'selectstart':
              return 2;
            case 'drag':
            case 'dragenter':
            case 'dragexit':
            case 'dragleave':
            case 'dragover':
            case 'mousemove':
            case 'mouseout':
            case 'mouseover':
            case 'pointermove':
            case 'pointerout':
            case 'pointerover':
            case 'scroll':
            case 'touchmove':
            case 'wheel':
            case 'mouseenter':
            case 'mouseleave':
            case 'pointerenter':
            case 'pointerleave':
              return 8;
            case 'message':
              switch (_h()) {
                case wc:
                  return 2;
                case Vc:
                  return 8;
                case Yn:
                case Nh:
                  return 32;
                case Xc:
                  return 268435456;
                default:
                  return 32;
              }
            default:
              return 32;
          }
        }
        var xc = !1,
          xa = null,
          Aa = null,
          Ta = null,
          Rn = new Map(),
          zn = new Map(),
          Ea = [],
          wm =
            'mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset'.split(
              ' '
            );
        function Dd(t, e) {
          switch (t) {
            case 'focusin':
            case 'focusout':
              xa = null;
              break;
            case 'dragenter':
            case 'dragleave':
              Aa = null;
              break;
            case 'mouseover':
            case 'mouseout':
              Ta = null;
              break;
            case 'pointerover':
            case 'pointerout':
              Rn.delete(e.pointerId);
              break;
            case 'gotpointercapture':
            case 'lostpointercapture':
              zn.delete(e.pointerId);
          }
        }
        function Dn(t, e, a, l, n, i) {
          return t === null || t.nativeEvent !== i
            ? ((t = {
                blockedOn: e,
                domEventName: a,
                eventSystemFlags: l,
                nativeEvent: i,
                targetContainers: [n],
              }),
              e !== null && ((e = ka(e)), e !== null && Rd(e)),
              t)
            : ((t.eventSystemFlags |= l),
              (e = t.targetContainers),
              n !== null && e.indexOf(n) === -1 && e.push(n),
              t);
        }
        function Vm(t, e, a, l, n) {
          switch (e) {
            case 'focusin':
              return ((xa = Dn(xa, t, e, a, l, n)), !0);
            case 'dragenter':
              return ((Aa = Dn(Aa, t, e, a, l, n)), !0);
            case 'mouseover':
              return ((Ta = Dn(Ta, t, e, a, l, n)), !0);
            case 'pointerover':
              var i = n.pointerId;
              return (Rn.set(i, Dn(Rn.get(i) || null, t, e, a, l, n)), !0);
            case 'gotpointercapture':
              return (
                (i = n.pointerId),
                zn.set(i, Dn(zn.get(i) || null, t, e, a, l, n)),
                !0
              );
          }
          return !1;
        }
        function Cd(t) {
          var e = Ja(t.target);
          if (e !== null) {
            var a = h(e);
            if (a !== null) {
              if (((e = a.tag), e === 13)) {
                if (((e = m(a)), e !== null)) {
                  ((t.blockedOn = e),
                    Hh(t.priority, function () {
                      if (a.tag === 13) {
                        var l = me();
                        l = hu(l);
                        var n = sl(a, l);
                        (n !== null && ye(n, a, l), pc(a, l));
                      }
                    }));
                  return;
                }
              } else if (
                e === 3 &&
                a.stateNode.current.memoizedState.isDehydrated
              ) {
                t.blockedOn = a.tag === 3 ? a.stateNode.containerInfo : null;
                return;
              }
            }
          }
          t.blockedOn = null;
        }
        function ki(t) {
          if (t.blockedOn !== null) return !1;
          for (var e = t.targetContainers; 0 < e.length; ) {
            var a = bc(t.nativeEvent);
            if (a === null) {
              a = t.nativeEvent;
              var l = new a.constructor(a.type, a);
              ((Tu = l), a.target.dispatchEvent(l), (Tu = null));
            } else
              return ((e = ka(a)), e !== null && Rd(e), (t.blockedOn = a), !1);
            e.shift();
          }
          return !0;
        }
        function Ud(t, e, a) {
          ki(t) && a.delete(e);
        }
        function Xm() {
          ((xc = !1),
            xa !== null && ki(xa) && (xa = null),
            Aa !== null && ki(Aa) && (Aa = null),
            Ta !== null && ki(Ta) && (Ta = null),
            Rn.forEach(Ud),
            zn.forEach(Ud));
        }
        function Wi(t, e) {
          t.blockedOn === e &&
            ((t.blockedOn = null),
            xc ||
              ((xc = !0),
              r.unstable_scheduleCallback(r.unstable_NormalPriority, Xm)));
        }
        var Fi = null;
        function jd(t) {
          Fi !== t &&
            ((Fi = t),
            r.unstable_scheduleCallback(r.unstable_NormalPriority, function () {
              Fi === t && (Fi = null);
              for (var e = 0; e < t.length; e += 3) {
                var a = t[e],
                  l = t[e + 1],
                  n = t[e + 2];
                if (typeof l != 'function') {
                  if (Sc(l || a) === null) continue;
                  break;
                }
                var i = ka(a);
                i !== null &&
                  (t.splice(e, 3),
                  (e -= 3),
                  Ss(
                    i,
                    { pending: !0, data: n, method: a.method, action: l },
                    l,
                    n
                  ));
              }
            }));
        }
        function Cn(t) {
          function e(y) {
            return Wi(y, t);
          }
          (xa !== null && Wi(xa, t),
            Aa !== null && Wi(Aa, t),
            Ta !== null && Wi(Ta, t),
            Rn.forEach(e),
            zn.forEach(e));
          for (var a = 0; a < Ea.length; a++) {
            var l = Ea[a];
            l.blockedOn === t && (l.blockedOn = null);
          }
          for (; 0 < Ea.length && ((a = Ea[0]), a.blockedOn === null); )
            (Cd(a), a.blockedOn === null && Ea.shift());
          if (((a = (t.ownerDocument || t).$$reactFormReplay), a != null))
            for (l = 0; l < a.length; l += 3) {
              var n = a[l],
                i = a[l + 1],
                f = n[ee] || null;
              if (typeof i == 'function') f || jd(a);
              else if (f) {
                var d = null;
                if (i && i.hasAttribute('formAction')) {
                  if (((n = i), (f = i[ee] || null))) d = f.formAction;
                  else if (Sc(n) !== null) continue;
                } else d = f.action;
                (typeof d == 'function'
                  ? (a[l + 1] = d)
                  : (a.splice(l, 3), (l -= 3)),
                  jd(a));
              }
            }
        }
        function Ac(t) {
          this._internalRoot = t;
        }
        ((Pi.prototype.render = Ac.prototype.render =
          function (t) {
            var e = this._internalRoot;
            if (e === null) throw Error(s(409));
            var a = e.current,
              l = me();
            _d(a, l, t, e, null, null);
          }),
          (Pi.prototype.unmount = Ac.prototype.unmount =
            function () {
              var t = this._internalRoot;
              if (t !== null) {
                this._internalRoot = null;
                var e = t.containerInfo;
                (_d(t.current, 2, null, t, null, null), Ui(), (e[$a] = null));
              }
            }));
        function Pi(t) {
          this._internalRoot = t;
        }
        Pi.prototype.unstable_scheduleHydration = function (t) {
          if (t) {
            var e = kc();
            t = { blockedOn: null, target: t, priority: e };
            for (
              var a = 0;
              a < Ea.length && e !== 0 && e < Ea[a].priority;
              a++
            );
            (Ea.splice(a, 0, t), a === 0 && Cd(t));
          }
        };
        var Ld = u.version;
        if (Ld !== '19.1.1') throw Error(s(527, Ld, '19.1.1'));
        j.findDOMNode = function (t) {
          var e = t._reactInternals;
          if (e === void 0)
            throw typeof t.render == 'function'
              ? Error(s(188))
              : ((t = Object.keys(t).join(',')), Error(s(268, t)));
          return (
            (t = b(e)),
            (t = t !== null ? g(t) : null),
            (t = t === null ? null : t.stateNode),
            t
          );
        };
        var Qm = {
          bundleType: 0,
          version: '19.1.1',
          rendererPackageName: 'react-dom',
          currentDispatcherRef: _,
          reconcilerVersion: '19.1.1',
        };
        if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < 'u') {
          var Ii = __REACT_DEVTOOLS_GLOBAL_HOOK__;
          if (!Ii.isDisabled && Ii.supportsFiber)
            try {
              ((Ll = Ii.inject(Qm)), (ce = Ii));
            } catch {}
        }
        return (
          (jn.createRoot = function (t, e) {
            if (!o(t)) throw Error(s(299));
            var a = !1,
              l = '',
              n = Fo,
              i = Po,
              f = Io,
              d = null;
            return (
              e != null &&
                (e.unstable_strictMode === !0 && (a = !0),
                e.identifierPrefix !== void 0 && (l = e.identifierPrefix),
                e.onUncaughtError !== void 0 && (n = e.onUncaughtError),
                e.onCaughtError !== void 0 && (i = e.onCaughtError),
                e.onRecoverableError !== void 0 && (f = e.onRecoverableError),
                e.unstable_transitionCallbacks !== void 0 &&
                  (d = e.unstable_transitionCallbacks)),
              (e = Od(t, 1, !1, null, null, a, l, n, i, f, d, null)),
              (t[$a] = e.current),
              nc(t),
              new Ac(e)
            );
          }),
          (jn.hydrateRoot = function (t, e, a) {
            if (!o(t)) throw Error(s(299));
            var l = !1,
              n = '',
              i = Fo,
              f = Po,
              d = Io,
              y = null,
              E = null;
            return (
              a != null &&
                (a.unstable_strictMode === !0 && (l = !0),
                a.identifierPrefix !== void 0 && (n = a.identifierPrefix),
                a.onUncaughtError !== void 0 && (i = a.onUncaughtError),
                a.onCaughtError !== void 0 && (f = a.onCaughtError),
                a.onRecoverableError !== void 0 && (d = a.onRecoverableError),
                a.unstable_transitionCallbacks !== void 0 &&
                  (y = a.unstable_transitionCallbacks),
                a.formState !== void 0 && (E = a.formState)),
              (e = Od(t, 1, !0, e, a ?? null, l, n, i, f, d, y, E)),
              (e.context = Md(null)),
              (a = e.current),
              (l = me()),
              (l = hu(l)),
              (n = sa(l)),
              (n.callback = null),
              ca(a, n, l),
              (a = l),
              (e.current.lanes = a),
              Bl(e, a),
              qe(e),
              (t[$a] = e.current),
              nc(t),
              new Pi(e)
            );
          }),
          (jn.version = '19.1.1'),
          jn
        );
      }
      var Qd;
      function ey() {
        if (Qd) return Ec.exports;
        Qd = 1;
        function r() {
          if (
            !(
              typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > 'u' ||
              typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != 'function'
            )
          )
            try {
              __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(r);
            } catch (u) {
              console.error(u);
            }
        }
        return (r(), (Ec.exports = ty()), Ec.exports);
      }
      var ay = ey(),
        yt = Kc();
      const k = r => typeof r == 'string',
        Ln = () => {
          let r, u;
          const c = new Promise((s, o) => {
            ((r = s), (u = o));
          });
          return ((c.resolve = r), (c.reject = u), c);
        },
        Zd = r => (r == null ? '' : '' + r),
        ly = (r, u, c) => {
          r.forEach(s => {
            u[s] && (c[s] = u[s]);
          });
        },
        ny = /###/g,
        $d = r => (r && r.indexOf('###') > -1 ? r.replace(ny, '.') : r),
        Jd = r => !r || k(r),
        Hn = (r, u, c) => {
          const s = k(u) ? u.split('.') : u;
          let o = 0;
          for (; o < s.length - 1; ) {
            if (Jd(r)) return {};
            const h = $d(s[o]);
            (!r[h] && c && (r[h] = new c()),
              Object.prototype.hasOwnProperty.call(r, h)
                ? (r = r[h])
                : (r = {}),
              ++o);
          }
          return Jd(r) ? {} : { obj: r, k: $d(s[o]) };
        },
        kd = (r, u, c) => {
          const { obj: s, k: o } = Hn(r, u, Object);
          if (s !== void 0 || u.length === 1) {
            s[o] = c;
            return;
          }
          let h = u[u.length - 1],
            m = u.slice(0, u.length - 1),
            p = Hn(r, m, Object);
          for (; p.obj === void 0 && m.length; )
            ((h = `${m[m.length - 1]}.${h}`),
              (m = m.slice(0, m.length - 1)),
              (p = Hn(r, m, Object)),
              p?.obj && typeof p.obj[`${p.k}.${h}`] < 'u' && (p.obj = void 0));
          p.obj[`${p.k}.${h}`] = c;
        },
        iy = (r, u, c, s) => {
          const { obj: o, k: h } = Hn(r, u, Object);
          ((o[h] = o[h] || []), o[h].push(c));
        },
        nu = (r, u) => {
          const { obj: c, k: s } = Hn(r, u);
          if (c && Object.prototype.hasOwnProperty.call(c, s)) return c[s];
        },
        uy = (r, u, c) => {
          const s = nu(r, c);
          return s !== void 0 ? s : nu(u, c);
        },
        hh = (r, u, c) => {
          for (const s in u)
            s !== '__proto__' &&
              s !== 'constructor' &&
              (s in r
                ? k(r[s]) ||
                  r[s] instanceof String ||
                  k(u[s]) ||
                  u[s] instanceof String
                  ? c && (r[s] = u[s])
                  : hh(r[s], u[s], c)
                : (r[s] = u[s]));
          return r;
        },
        Cl = r => r.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
      var sy = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;',
        '/': '&#x2F;',
      };
      const cy = r => (k(r) ? r.replace(/[&<>"'\/]/g, u => sy[u]) : r);
      class fy {
        constructor(u) {
          ((this.capacity = u),
            (this.regExpMap = new Map()),
            (this.regExpQueue = []));
        }
        getRegExp(u) {
          const c = this.regExpMap.get(u);
          if (c !== void 0) return c;
          const s = new RegExp(u);
          return (
            this.regExpQueue.length === this.capacity &&
              this.regExpMap.delete(this.regExpQueue.shift()),
            this.regExpMap.set(u, s),
            this.regExpQueue.push(u),
            s
          );
        }
      }
      const oy = [' ', ',', '?', '!', ';'],
        ry = new fy(20),
        dy = (r, u, c) => {
          ((u = u || ''), (c = c || ''));
          const s = oy.filter(m => u.indexOf(m) < 0 && c.indexOf(m) < 0);
          if (s.length === 0) return !0;
          const o = ry.getRegExp(
            `(${s.map(m => (m === '?' ? '\\?' : m)).join('|')})`
          );
          let h = !o.test(r);
          if (!h) {
            const m = r.indexOf(c);
            m > 0 && !o.test(r.substring(0, m)) && (h = !0);
          }
          return h;
        },
        Cc = (r, u, c = '.') => {
          if (!r) return;
          if (r[u])
            return Object.prototype.hasOwnProperty.call(r, u) ? r[u] : void 0;
          const s = u.split(c);
          let o = r;
          for (let h = 0; h < s.length; ) {
            if (!o || typeof o != 'object') return;
            let m,
              p = '';
            for (let b = h; b < s.length; ++b)
              if (
                (b !== h && (p += c), (p += s[b]), (m = o[p]), m !== void 0)
              ) {
                if (
                  ['string', 'number', 'boolean'].indexOf(typeof m) > -1 &&
                  b < s.length - 1
                )
                  continue;
                h += b - h + 1;
                break;
              }
            o = m;
          }
          return o;
        },
        Bn = r => r?.replace('_', '-'),
        hy = {
          type: 'logger',
          log(r) {
            this.output('log', r);
          },
          warn(r) {
            this.output('warn', r);
          },
          error(r) {
            this.output('error', r);
          },
          output(r, u) {
            console?.[r]?.apply?.(console, u);
          },
        };
      class iu {
        constructor(u, c = {}) {
          this.init(u, c);
        }
        init(u, c = {}) {
          ((this.prefix = c.prefix || 'i18next:'),
            (this.logger = u || hy),
            (this.options = c),
            (this.debug = c.debug));
        }
        log(...u) {
          return this.forward(u, 'log', '', !0);
        }
        warn(...u) {
          return this.forward(u, 'warn', '', !0);
        }
        error(...u) {
          return this.forward(u, 'error', '');
        }
        deprecate(...u) {
          return this.forward(u, 'warn', 'WARNING DEPRECATED: ', !0);
        }
        forward(u, c, s, o) {
          return o && !this.debug
            ? null
            : (k(u[0]) && (u[0] = `${s}${this.prefix} ${u[0]}`),
              this.logger[c](u));
        }
        create(u) {
          return new iu(this.logger, {
            prefix: `${this.prefix}:${u}:`,
            ...this.options,
          });
        }
        clone(u) {
          return (
            (u = u || this.options),
            (u.prefix = u.prefix || this.prefix),
            new iu(this.logger, u)
          );
        }
      }
      var Ke = new iu();
      class su {
        constructor() {
          this.observers = {};
        }
        on(u, c) {
          return (
            u.split(' ').forEach(s => {
              this.observers[s] || (this.observers[s] = new Map());
              const o = this.observers[s].get(c) || 0;
              this.observers[s].set(c, o + 1);
            }),
            this
          );
        }
        off(u, c) {
          if (this.observers[u]) {
            if (!c) {
              delete this.observers[u];
              return;
            }
            this.observers[u].delete(c);
          }
        }
        emit(u, ...c) {
          (this.observers[u] &&
            Array.from(this.observers[u].entries()).forEach(([o, h]) => {
              for (let m = 0; m < h; m++) o(...c);
            }),
            this.observers['*'] &&
              Array.from(this.observers['*'].entries()).forEach(([o, h]) => {
                for (let m = 0; m < h; m++) o.apply(o, [u, ...c]);
              }));
        }
      }
      class Wd extends su {
        constructor(u, c = { ns: ['translation'], defaultNS: 'translation' }) {
          (super(),
            (this.data = u || {}),
            (this.options = c),
            this.options.keySeparator === void 0 &&
              (this.options.keySeparator = '.'),
            this.options.ignoreJSONStructure === void 0 &&
              (this.options.ignoreJSONStructure = !0));
        }
        addNamespaces(u) {
          this.options.ns.indexOf(u) < 0 && this.options.ns.push(u);
        }
        removeNamespaces(u) {
          const c = this.options.ns.indexOf(u);
          c > -1 && this.options.ns.splice(c, 1);
        }
        getResource(u, c, s, o = {}) {
          const h =
              o.keySeparator !== void 0
                ? o.keySeparator
                : this.options.keySeparator,
            m =
              o.ignoreJSONStructure !== void 0
                ? o.ignoreJSONStructure
                : this.options.ignoreJSONStructure;
          let p;
          u.indexOf('.') > -1
            ? (p = u.split('.'))
            : ((p = [u, c]),
              s &&
                (Array.isArray(s)
                  ? p.push(...s)
                  : k(s) && h
                    ? p.push(...s.split(h))
                    : p.push(s)));
          const b = nu(this.data, p);
          return (
            !b &&
              !c &&
              !s &&
              u.indexOf('.') > -1 &&
              ((u = p[0]), (c = p[1]), (s = p.slice(2).join('.'))),
            b || !m || !k(s) ? b : Cc(this.data?.[u]?.[c], s, h)
          );
        }
        addResource(u, c, s, o, h = { silent: !1 }) {
          const m =
            h.keySeparator !== void 0
              ? h.keySeparator
              : this.options.keySeparator;
          let p = [u, c];
          (s && (p = p.concat(m ? s.split(m) : s)),
            u.indexOf('.') > -1 && ((p = u.split('.')), (o = c), (c = p[1])),
            this.addNamespaces(c),
            kd(this.data, p, o),
            h.silent || this.emit('added', u, c, s, o));
        }
        addResources(u, c, s, o = { silent: !1 }) {
          for (const h in s)
            (k(s[h]) || Array.isArray(s[h])) &&
              this.addResource(u, c, h, s[h], { silent: !0 });
          o.silent || this.emit('added', u, c, s);
        }
        addResourceBundle(u, c, s, o, h, m = { silent: !1, skipCopy: !1 }) {
          let p = [u, c];
          (u.indexOf('.') > -1 &&
            ((p = u.split('.')), (o = s), (s = c), (c = p[1])),
            this.addNamespaces(c));
          let b = nu(this.data, p) || {};
          (m.skipCopy || (s = JSON.parse(JSON.stringify(s))),
            o ? hh(b, s, h) : (b = { ...b, ...s }),
            kd(this.data, p, b),
            m.silent || this.emit('added', u, c, s));
        }
        removeResourceBundle(u, c) {
          (this.hasResourceBundle(u, c) && delete this.data[u][c],
            this.removeNamespaces(c),
            this.emit('removed', u, c));
        }
        hasResourceBundle(u, c) {
          return this.getResource(u, c) !== void 0;
        }
        getResourceBundle(u, c) {
          return (c || (c = this.options.defaultNS), this.getResource(u, c));
        }
        getDataByLanguage(u) {
          return this.data[u];
        }
        hasLanguageSomeTranslations(u) {
          const c = this.getDataByLanguage(u);
          return !!((c && Object.keys(c)) || []).find(
            o => c[o] && Object.keys(c[o]).length > 0
          );
        }
        toJSON() {
          return this.data;
        }
      }
      var gh = {
        processors: {},
        addPostProcessor(r) {
          this.processors[r.name] = r;
        },
        handle(r, u, c, s, o) {
          return (
            r.forEach(h => {
              u = this.processors[h]?.process(u, c, s, o) ?? u;
            }),
            u
          );
        },
      };
      const mh = Symbol('i18next/PATH_KEY');
      function gy() {
        const r = [],
          u = Object.create(null);
        let c;
        return (
          (u.get = (s, o) => (
            c?.revoke?.(),
            o === mh ? r : (r.push(o), (c = Proxy.revocable(s, u)), c.proxy)
          )),
          Proxy.revocable(Object.create(null), u).proxy
        );
      }
      function Uc(r, u) {
        const { [mh]: c } = r(gy());
        return c.join(u?.keySeparator ?? '.');
      }
      const Fd = {},
        Rc = r => !k(r) && typeof r != 'boolean' && typeof r != 'number';
      class uu extends su {
        constructor(u, c = {}) {
          (super(),
            ly(
              [
                'resourceStore',
                'languageUtils',
                'pluralResolver',
                'interpolator',
                'backendConnector',
                'i18nFormat',
                'utils',
              ],
              u,
              this
            ),
            (this.options = c),
            this.options.keySeparator === void 0 &&
              (this.options.keySeparator = '.'),
            (this.logger = Ke.create('translator')));
        }
        changeLanguage(u) {
          u && (this.language = u);
        }
        exists(u, c = { interpolation: {} }) {
          const s = { ...c };
          if (u == null) return !1;
          const o = this.resolve(u, s);
          if (o?.res === void 0) return !1;
          const h = Rc(o.res);
          return !(s.returnObjects === !1 && h);
        }
        extractFromKey(u, c) {
          let s =
            c.nsSeparator !== void 0 ? c.nsSeparator : this.options.nsSeparator;
          s === void 0 && (s = ':');
          const o =
            c.keySeparator !== void 0
              ? c.keySeparator
              : this.options.keySeparator;
          let h = c.ns || this.options.defaultNS || [];
          const m = s && u.indexOf(s) > -1,
            p =
              !this.options.userDefinedKeySeparator &&
              !c.keySeparator &&
              !this.options.userDefinedNsSeparator &&
              !c.nsSeparator &&
              !dy(u, s, o);
          if (m && !p) {
            const b = u.match(this.interpolator.nestingRegexp);
            if (b && b.length > 0)
              return { key: u, namespaces: k(h) ? [h] : h };
            const g = u.split(s);
            ((s !== o || (s === o && this.options.ns.indexOf(g[0]) > -1)) &&
              (h = g.shift()),
              (u = g.join(o)));
          }
          return { key: u, namespaces: k(h) ? [h] : h };
        }
        translate(u, c, s) {
          let o = typeof c == 'object' ? { ...c } : c;
          if (
            (typeof o != 'object' &&
              this.options.overloadTranslationOptionHandler &&
              (o = this.options.overloadTranslationOptionHandler(arguments)),
            typeof o == 'object' && (o = { ...o }),
            o || (o = {}),
            u == null)
          )
            return '';
          (typeof u == 'function' && (u = Uc(u, { ...this.options, ...o })),
            Array.isArray(u) || (u = [String(u)]));
          const h =
              o.returnDetails !== void 0
                ? o.returnDetails
                : this.options.returnDetails,
            m =
              o.keySeparator !== void 0
                ? o.keySeparator
                : this.options.keySeparator,
            { key: p, namespaces: b } = this.extractFromKey(u[u.length - 1], o),
            g = b[b.length - 1];
          let A =
            o.nsSeparator !== void 0 ? o.nsSeparator : this.options.nsSeparator;
          A === void 0 && (A = ':');
          const N = o.lng || this.language,
            L =
              o.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
          if (N?.toLowerCase() === 'cimode')
            return L
              ? h
                ? {
                    res: `${g}${A}${p}`,
                    usedKey: p,
                    exactUsedKey: p,
                    usedLng: N,
                    usedNS: g,
                    usedParams: this.getUsedParamsDetails(o),
                  }
                : `${g}${A}${p}`
              : h
                ? {
                    res: p,
                    usedKey: p,
                    exactUsedKey: p,
                    usedLng: N,
                    usedNS: g,
                    usedParams: this.getUsedParamsDetails(o),
                  }
                : p;
          const K = this.resolve(u, o);
          let q = K?.res;
          const Q = K?.usedKey || p,
            P = K?.exactUsedKey || p,
            ht = ['[object Number]', '[object Function]', '[object RegExp]'],
            tt =
              o.joinArrays !== void 0 ? o.joinArrays : this.options.joinArrays,
            W = !this.i18nFormat || this.i18nFormat.handleAsObject,
            I = o.count !== void 0 && !k(o.count),
            w = uu.hasDefaultValue(o),
            st = I ? this.pluralResolver.getSuffix(N, o.count, o) : '',
            ut =
              o.ordinal && I
                ? this.pluralResolver.getSuffix(N, o.count, { ordinal: !1 })
                : '',
            Mt = I && !o.ordinal && o.count === 0,
            Et =
              (Mt && o[`defaultValue${this.options.pluralSeparator}zero`]) ||
              o[`defaultValue${st}`] ||
              o[`defaultValue${ut}`] ||
              o.defaultValue;
          let Lt = q;
          W && !q && w && (Lt = Et);
          const te = Rc(Lt),
            Rt = Object.prototype.toString.apply(Lt);
          if (
            W &&
            Lt &&
            te &&
            ht.indexOf(Rt) < 0 &&
            !(k(tt) && Array.isArray(Lt))
          ) {
            if (!o.returnObjects && !this.options.returnObjects) {
              this.options.returnedObjectHandler ||
                this.logger.warn(
                  'accessing an object - but returnObjects options is not enabled!'
                );
              const zt = this.options.returnedObjectHandler
                ? this.options.returnedObjectHandler(Q, Lt, { ...o, ns: b })
                : `key '${p} (${this.language})' returned an object instead of string.`;
              return h
                ? ((K.res = zt),
                  (K.usedParams = this.getUsedParamsDetails(o)),
                  K)
                : zt;
            }
            if (m) {
              const zt = Array.isArray(Lt),
                Ht = zt ? [] : {},
                Dt = zt ? P : Q;
              for (const _ in Lt)
                if (Object.prototype.hasOwnProperty.call(Lt, _)) {
                  const j = `${Dt}${m}${_}`;
                  (w && !q
                    ? (Ht[_] = this.translate(j, {
                        ...o,
                        defaultValue: Rc(Et) ? Et[_] : void 0,
                        joinArrays: !1,
                        ns: b,
                      }))
                    : (Ht[_] = this.translate(j, {
                        ...o,
                        joinArrays: !1,
                        ns: b,
                      })),
                    Ht[_] === j && (Ht[_] = Lt[_]));
                }
              q = Ht;
            }
          } else if (W && k(tt) && Array.isArray(q))
            ((q = q.join(tt)), q && (q = this.extendTranslation(q, u, o, s)));
          else {
            let zt = !1,
              Ht = !1;
            (!this.isValidLookup(q) && w && ((zt = !0), (q = Et)),
              this.isValidLookup(q) || ((Ht = !0), (q = p)));
            const _ =
                (o.missingKeyNoValueFallbackToKey ||
                  this.options.missingKeyNoValueFallbackToKey) &&
                Ht
                  ? void 0
                  : q,
              j = w && Et !== q && this.options.updateMissing;
            if (Ht || zt || j) {
              if (
                (this.logger.log(
                  j ? 'updateKey' : 'missingKey',
                  N,
                  g,
                  p,
                  j ? Et : q
                ),
                m)
              ) {
                const D = this.resolve(p, { ...o, keySeparator: !1 });
                D &&
                  D.res &&
                  this.logger.warn(
                    'Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.'
                  );
              }
              let V = [];
              const ft = this.languageUtils.getFallbackCodes(
                this.options.fallbackLng,
                o.lng || this.language
              );
              if (this.options.saveMissingTo === 'fallback' && ft && ft[0])
                for (let D = 0; D < ft.length; D++) V.push(ft[D]);
              else
                this.options.saveMissingTo === 'all'
                  ? (V = this.languageUtils.toResolveHierarchy(
                      o.lng || this.language
                    ))
                  : V.push(o.lng || this.language);
              const v = (D, B, H) => {
                const X = w && H !== q ? H : _;
                (this.options.missingKeyHandler
                  ? this.options.missingKeyHandler(D, g, B, X, j, o)
                  : this.backendConnector?.saveMissing &&
                    this.backendConnector.saveMissing(D, g, B, X, j, o),
                  this.emit('missingKey', D, g, B, q));
              };
              this.options.saveMissing &&
                (this.options.saveMissingPlurals && I
                  ? V.forEach(D => {
                      const B = this.pluralResolver.getSuffixes(D, o);
                      (Mt &&
                        o[`defaultValue${this.options.pluralSeparator}zero`] &&
                        B.indexOf(`${this.options.pluralSeparator}zero`) < 0 &&
                        B.push(`${this.options.pluralSeparator}zero`),
                        B.forEach(H => {
                          v([D], p + H, o[`defaultValue${H}`] || Et);
                        }));
                    })
                  : v(V, p, Et));
            }
            ((q = this.extendTranslation(q, u, o, K, s)),
              Ht &&
                q === p &&
                this.options.appendNamespaceToMissingKey &&
                (q = `${g}${A}${p}`),
              (Ht || zt) &&
                this.options.parseMissingKeyHandler &&
                (q = this.options.parseMissingKeyHandler(
                  this.options.appendNamespaceToMissingKey ? `${g}${A}${p}` : p,
                  zt ? q : void 0,
                  o
                )));
          }
          return h
            ? ((K.res = q), (K.usedParams = this.getUsedParamsDetails(o)), K)
            : q;
        }
        extendTranslation(u, c, s, o, h) {
          if (this.i18nFormat?.parse)
            u = this.i18nFormat.parse(
              u,
              { ...this.options.interpolation.defaultVariables, ...s },
              s.lng || this.language || o.usedLng,
              o.usedNS,
              o.usedKey,
              { resolved: o }
            );
          else if (!s.skipInterpolation) {
            s.interpolation &&
              this.interpolator.init({
                ...s,
                interpolation: {
                  ...this.options.interpolation,
                  ...s.interpolation,
                },
              });
            const b =
              k(u) &&
              (s?.interpolation?.skipOnVariables !== void 0
                ? s.interpolation.skipOnVariables
                : this.options.interpolation.skipOnVariables);
            let g;
            if (b) {
              const N = u.match(this.interpolator.nestingRegexp);
              g = N && N.length;
            }
            let A = s.replace && !k(s.replace) ? s.replace : s;
            if (
              (this.options.interpolation.defaultVariables &&
                (A = { ...this.options.interpolation.defaultVariables, ...A }),
              (u = this.interpolator.interpolate(
                u,
                A,
                s.lng || this.language || o.usedLng,
                s
              )),
              b)
            ) {
              const N = u.match(this.interpolator.nestingRegexp),
                L = N && N.length;
              g < L && (s.nest = !1);
            }
            (!s.lng && o && o.res && (s.lng = this.language || o.usedLng),
              s.nest !== !1 &&
                (u = this.interpolator.nest(
                  u,
                  (...N) =>
                    h?.[0] === N[0] && !s.context
                      ? (this.logger.warn(
                          `It seems you are nesting recursively key: ${N[0]} in key: ${c[0]}`
                        ),
                        null)
                      : this.translate(...N, c),
                  s
                )),
              s.interpolation && this.interpolator.reset());
          }
          const m = s.postProcess || this.options.postProcess,
            p = k(m) ? [m] : m;
          return (
            u != null &&
              p?.length &&
              s.applyPostProcessor !== !1 &&
              (u = gh.handle(
                p,
                u,
                c,
                this.options && this.options.postProcessPassResolved
                  ? {
                      i18nResolved: {
                        ...o,
                        usedParams: this.getUsedParamsDetails(s),
                      },
                      ...s,
                    }
                  : s,
                this
              )),
            u
          );
        }
        resolve(u, c = {}) {
          let s, o, h, m, p;
          return (
            k(u) && (u = [u]),
            u.forEach(b => {
              if (this.isValidLookup(s)) return;
              const g = this.extractFromKey(b, c),
                A = g.key;
              o = A;
              let N = g.namespaces;
              this.options.fallbackNS &&
                (N = N.concat(this.options.fallbackNS));
              const L = c.count !== void 0 && !k(c.count),
                K = L && !c.ordinal && c.count === 0,
                q =
                  c.context !== void 0 &&
                  (k(c.context) || typeof c.context == 'number') &&
                  c.context !== '',
                Q = c.lngs
                  ? c.lngs
                  : this.languageUtils.toResolveHierarchy(
                      c.lng || this.language,
                      c.fallbackLng
                    );
              N.forEach(P => {
                this.isValidLookup(s) ||
                  ((p = P),
                  !Fd[`${Q[0]}-${P}`] &&
                    this.utils?.hasLoadedNamespace &&
                    !this.utils?.hasLoadedNamespace(p) &&
                    ((Fd[`${Q[0]}-${P}`] = !0),
                    this.logger.warn(
                      `key "${o}" for languages "${Q.join(', ')}" won't get resolved as namespace "${p}" was not yet loaded`,
                      'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!'
                    )),
                  Q.forEach(ht => {
                    if (this.isValidLookup(s)) return;
                    m = ht;
                    const tt = [A];
                    if (this.i18nFormat?.addLookupKeys)
                      this.i18nFormat.addLookupKeys(tt, A, ht, P, c);
                    else {
                      let I;
                      L && (I = this.pluralResolver.getSuffix(ht, c.count, c));
                      const w = `${this.options.pluralSeparator}zero`,
                        st = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
                      if (
                        (L &&
                          (c.ordinal &&
                            I.indexOf(st) === 0 &&
                            tt.push(
                              A + I.replace(st, this.options.pluralSeparator)
                            ),
                          tt.push(A + I),
                          K && tt.push(A + w)),
                        q)
                      ) {
                        const ut = `${A}${this.options.contextSeparator || '_'}${c.context}`;
                        (tt.push(ut),
                          L &&
                            (c.ordinal &&
                              I.indexOf(st) === 0 &&
                              tt.push(
                                ut + I.replace(st, this.options.pluralSeparator)
                              ),
                            tt.push(ut + I),
                            K && tt.push(ut + w)));
                      }
                    }
                    let W;
                    for (; (W = tt.pop()); )
                      this.isValidLookup(s) ||
                        ((h = W), (s = this.getResource(ht, P, W, c)));
                  }));
              });
            }),
            { res: s, usedKey: o, exactUsedKey: h, usedLng: m, usedNS: p }
          );
        }
        isValidLookup(u) {
          return (
            u !== void 0 &&
            !(!this.options.returnNull && u === null) &&
            !(!this.options.returnEmptyString && u === '')
          );
        }
        getResource(u, c, s, o = {}) {
          return this.i18nFormat?.getResource
            ? this.i18nFormat.getResource(u, c, s, o)
            : this.resourceStore.getResource(u, c, s, o);
        }
        getUsedParamsDetails(u = {}) {
          const c = [
              'defaultValue',
              'ordinal',
              'context',
              'replace',
              'lng',
              'lngs',
              'fallbackLng',
              'ns',
              'keySeparator',
              'nsSeparator',
              'returnObjects',
              'returnDetails',
              'joinArrays',
              'postProcess',
              'interpolation',
            ],
            s = u.replace && !k(u.replace);
          let o = s ? u.replace : u;
          if (
            (s && typeof u.count < 'u' && (o.count = u.count),
            this.options.interpolation.defaultVariables &&
              (o = { ...this.options.interpolation.defaultVariables, ...o }),
            !s)
          ) {
            o = { ...o };
            for (const h of c) delete o[h];
          }
          return o;
        }
        static hasDefaultValue(u) {
          const c = 'defaultValue';
          for (const s in u)
            if (
              Object.prototype.hasOwnProperty.call(u, s) &&
              c === s.substring(0, c.length) &&
              u[s] !== void 0
            )
              return !0;
          return !1;
        }
      }
      class Pd {
        constructor(u) {
          ((this.options = u),
            (this.supportedLngs = this.options.supportedLngs || !1),
            (this.logger = Ke.create('languageUtils')));
        }
        getScriptPartFromCode(u) {
          if (((u = Bn(u)), !u || u.indexOf('-') < 0)) return null;
          const c = u.split('-');
          return c.length === 2 ||
            (c.pop(), c[c.length - 1].toLowerCase() === 'x')
            ? null
            : this.formatLanguageCode(c.join('-'));
        }
        getLanguagePartFromCode(u) {
          if (((u = Bn(u)), !u || u.indexOf('-') < 0)) return u;
          const c = u.split('-');
          return this.formatLanguageCode(c[0]);
        }
        formatLanguageCode(u) {
          if (k(u) && u.indexOf('-') > -1) {
            let c;
            try {
              c = Intl.getCanonicalLocales(u)[0];
            } catch {}
            return (
              c && this.options.lowerCaseLng && (c = c.toLowerCase()),
              c || (this.options.lowerCaseLng ? u.toLowerCase() : u)
            );
          }
          return this.options.cleanCode || this.options.lowerCaseLng
            ? u.toLowerCase()
            : u;
        }
        isSupportedCode(u) {
          return (
            (this.options.load === 'languageOnly' ||
              this.options.nonExplicitSupportedLngs) &&
              (u = this.getLanguagePartFromCode(u)),
            !this.supportedLngs ||
              !this.supportedLngs.length ||
              this.supportedLngs.indexOf(u) > -1
          );
        }
        getBestMatchFromCodes(u) {
          if (!u) return null;
          let c;
          return (
            u.forEach(s => {
              if (c) return;
              const o = this.formatLanguageCode(s);
              (!this.options.supportedLngs || this.isSupportedCode(o)) &&
                (c = o);
            }),
            !c &&
              this.options.supportedLngs &&
              u.forEach(s => {
                if (c) return;
                const o = this.getScriptPartFromCode(s);
                if (this.isSupportedCode(o)) return (c = o);
                const h = this.getLanguagePartFromCode(s);
                if (this.isSupportedCode(h)) return (c = h);
                c = this.options.supportedLngs.find(m => {
                  if (m === h) return m;
                  if (
                    !(m.indexOf('-') < 0 && h.indexOf('-') < 0) &&
                    ((m.indexOf('-') > 0 &&
                      h.indexOf('-') < 0 &&
                      m.substring(0, m.indexOf('-')) === h) ||
                      (m.indexOf(h) === 0 && h.length > 1))
                  )
                    return m;
                });
              }),
            c || (c = this.getFallbackCodes(this.options.fallbackLng)[0]),
            c
          );
        }
        getFallbackCodes(u, c) {
          if (!u) return [];
          if (
            (typeof u == 'function' && (u = u(c)),
            k(u) && (u = [u]),
            Array.isArray(u))
          )
            return u;
          if (!c) return u.default || [];
          let s = u[c];
          return (
            s || (s = u[this.getScriptPartFromCode(c)]),
            s || (s = u[this.formatLanguageCode(c)]),
            s || (s = u[this.getLanguagePartFromCode(c)]),
            s || (s = u.default),
            s || []
          );
        }
        toResolveHierarchy(u, c) {
          const s = this.getFallbackCodes(
              (c === !1 ? [] : c) || this.options.fallbackLng || [],
              u
            ),
            o = [],
            h = m => {
              m &&
                (this.isSupportedCode(m)
                  ? o.push(m)
                  : this.logger.warn(
                      `rejecting language code not found in supportedLngs: ${m}`
                    ));
            };
          return (
            k(u) && (u.indexOf('-') > -1 || u.indexOf('_') > -1)
              ? (this.options.load !== 'languageOnly' &&
                  h(this.formatLanguageCode(u)),
                this.options.load !== 'languageOnly' &&
                  this.options.load !== 'currentOnly' &&
                  h(this.getScriptPartFromCode(u)),
                this.options.load !== 'currentOnly' &&
                  h(this.getLanguagePartFromCode(u)))
              : k(u) && h(this.formatLanguageCode(u)),
            s.forEach(m => {
              o.indexOf(m) < 0 && h(this.formatLanguageCode(m));
            }),
            o
          );
        }
      }
      const Id = { zero: 0, one: 1, two: 2, few: 3, many: 4, other: 5 },
        th = {
          select: r => (r === 1 ? 'one' : 'other'),
          resolvedOptions: () => ({ pluralCategories: ['one', 'other'] }),
        };
      class my {
        constructor(u, c = {}) {
          ((this.languageUtils = u),
            (this.options = c),
            (this.logger = Ke.create('pluralResolver')),
            (this.pluralRulesCache = {}));
        }
        addRule(u, c) {
          this.rules[u] = c;
        }
        clearCache() {
          this.pluralRulesCache = {};
        }
        getRule(u, c = {}) {
          const s = Bn(u === 'dev' ? 'en' : u),
            o = c.ordinal ? 'ordinal' : 'cardinal',
            h = JSON.stringify({ cleanedCode: s, type: o });
          if (h in this.pluralRulesCache) return this.pluralRulesCache[h];
          let m;
          try {
            m = new Intl.PluralRules(s, { type: o });
          } catch {
            if (!Intl)
              return (
                this.logger.error(
                  'No Intl support, please use an Intl polyfill!'
                ),
                th
              );
            if (!u.match(/-|_/)) return th;
            const b = this.languageUtils.getLanguagePartFromCode(u);
            m = this.getRule(b, c);
          }
          return ((this.pluralRulesCache[h] = m), m);
        }
        needsPlural(u, c = {}) {
          let s = this.getRule(u, c);
          return (
            s || (s = this.getRule('dev', c)),
            s?.resolvedOptions().pluralCategories.length > 1
          );
        }
        getPluralFormsOfKey(u, c, s = {}) {
          return this.getSuffixes(u, s).map(o => `${c}${o}`);
        }
        getSuffixes(u, c = {}) {
          let s = this.getRule(u, c);
          return (
            s || (s = this.getRule('dev', c)),
            s
              ? s
                  .resolvedOptions()
                  .pluralCategories.sort((o, h) => Id[o] - Id[h])
                  .map(
                    o =>
                      `${this.options.prepend}${c.ordinal ? `ordinal${this.options.prepend}` : ''}${o}`
                  )
              : []
          );
        }
        getSuffix(u, c, s = {}) {
          const o = this.getRule(u, s);
          return o
            ? `${this.options.prepend}${s.ordinal ? `ordinal${this.options.prepend}` : ''}${o.select(c)}`
            : (this.logger.warn(`no plural rule found for: ${u}`),
              this.getSuffix('dev', c, s));
        }
      }
      const eh = (r, u, c, s = '.', o = !0) => {
          let h = uy(r, u, c);
          return (
            !h &&
              o &&
              k(c) &&
              ((h = Cc(r, c, s)), h === void 0 && (h = Cc(u, c, s))),
            h
          );
        },
        zc = r => r.replace(/\$/g, '$$$$');
      class yy {
        constructor(u = {}) {
          ((this.logger = Ke.create('interpolator')),
            (this.options = u),
            (this.format = u?.interpolation?.format || (c => c)),
            this.init(u));
        }
        init(u = {}) {
          u.interpolation || (u.interpolation = { escapeValue: !0 });
          const {
            escape: c,
            escapeValue: s,
            useRawValueToEscape: o,
            prefix: h,
            prefixEscaped: m,
            suffix: p,
            suffixEscaped: b,
            formatSeparator: g,
            unescapeSuffix: A,
            unescapePrefix: N,
            nestingPrefix: L,
            nestingPrefixEscaped: K,
            nestingSuffix: q,
            nestingSuffixEscaped: Q,
            nestingOptionsSeparator: P,
            maxReplaces: ht,
            alwaysFormat: tt,
          } = u.interpolation;
          ((this.escape = c !== void 0 ? c : cy),
            (this.escapeValue = s !== void 0 ? s : !0),
            (this.useRawValueToEscape = o !== void 0 ? o : !1),
            (this.prefix = h ? Cl(h) : m || '{{'),
            (this.suffix = p ? Cl(p) : b || '}}'),
            (this.formatSeparator = g || ','),
            (this.unescapePrefix = A ? '' : N || '-'),
            (this.unescapeSuffix = this.unescapePrefix ? '' : A || ''),
            (this.nestingPrefix = L ? Cl(L) : K || Cl('$t(')),
            (this.nestingSuffix = q ? Cl(q) : Q || Cl(')')),
            (this.nestingOptionsSeparator = P || ','),
            (this.maxReplaces = ht || 1e3),
            (this.alwaysFormat = tt !== void 0 ? tt : !1),
            this.resetRegExp());
        }
        reset() {
          this.options && this.init(this.options);
        }
        resetRegExp() {
          const u = (c, s) =>
            c?.source === s ? ((c.lastIndex = 0), c) : new RegExp(s, 'g');
          ((this.regexp = u(this.regexp, `${this.prefix}(.+?)${this.suffix}`)),
            (this.regexpUnescape = u(
              this.regexpUnescape,
              `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`
            )),
            (this.nestingRegexp = u(
              this.nestingRegexp,
              `${this.nestingPrefix}((?:[^()"']+|"[^"]*"|'[^']*'|\\((?:[^()]|"[^"]*"|'[^']*')*\\))*?)${this.nestingSuffix}`
            )));
        }
        interpolate(u, c, s, o) {
          let h, m, p;
          const b =
              (this.options &&
                this.options.interpolation &&
                this.options.interpolation.defaultVariables) ||
              {},
            g = K => {
              if (K.indexOf(this.formatSeparator) < 0) {
                const ht = eh(
                  c,
                  b,
                  K,
                  this.options.keySeparator,
                  this.options.ignoreJSONStructure
                );
                return this.alwaysFormat
                  ? this.format(ht, void 0, s, {
                      ...o,
                      ...c,
                      interpolationkey: K,
                    })
                  : ht;
              }
              const q = K.split(this.formatSeparator),
                Q = q.shift().trim(),
                P = q.join(this.formatSeparator).trim();
              return this.format(
                eh(
                  c,
                  b,
                  Q,
                  this.options.keySeparator,
                  this.options.ignoreJSONStructure
                ),
                P,
                s,
                { ...o, ...c, interpolationkey: Q }
              );
            };
          this.resetRegExp();
          const A =
              o?.missingInterpolationHandler ||
              this.options.missingInterpolationHandler,
            N =
              o?.interpolation?.skipOnVariables !== void 0
                ? o.interpolation.skipOnVariables
                : this.options.interpolation.skipOnVariables;
          return (
            [
              { regex: this.regexpUnescape, safeValue: K => zc(K) },
              {
                regex: this.regexp,
                safeValue: K => (this.escapeValue ? zc(this.escape(K)) : zc(K)),
              },
            ].forEach(K => {
              for (p = 0; (h = K.regex.exec(u)); ) {
                const q = h[1].trim();
                if (((m = g(q)), m === void 0))
                  if (typeof A == 'function') {
                    const P = A(u, h, o);
                    m = k(P) ? P : '';
                  } else if (o && Object.prototype.hasOwnProperty.call(o, q))
                    m = '';
                  else if (N) {
                    m = h[0];
                    continue;
                  } else
                    (this.logger.warn(
                      `missed to pass in variable ${q} for interpolating ${u}`
                    ),
                      (m = ''));
                else !k(m) && !this.useRawValueToEscape && (m = Zd(m));
                const Q = K.safeValue(m);
                if (
                  ((u = u.replace(h[0], Q)),
                  N
                    ? ((K.regex.lastIndex += m.length),
                      (K.regex.lastIndex -= h[0].length))
                    : (K.regex.lastIndex = 0),
                  p++,
                  p >= this.maxReplaces)
                )
                  break;
              }
            }),
            u
          );
        }
        nest(u, c, s = {}) {
          let o, h, m;
          const p = (b, g) => {
            const A = this.nestingOptionsSeparator;
            if (b.indexOf(A) < 0) return b;
            const N = b.split(new RegExp(`${A}[ ]*{`));
            let L = `{${N[1]}`;
            ((b = N[0]), (L = this.interpolate(L, m)));
            const K = L.match(/'/g),
              q = L.match(/"/g);
            (((K?.length ?? 0) % 2 === 0 && !q) || q.length % 2 !== 0) &&
              (L = L.replace(/'/g, '"'));
            try {
              ((m = JSON.parse(L)), g && (m = { ...g, ...m }));
            } catch (Q) {
              return (
                this.logger.warn(
                  `failed parsing options string in nesting for key ${b}`,
                  Q
                ),
                `${b}${A}${L}`
              );
            }
            return (
              m.defaultValue &&
                m.defaultValue.indexOf(this.prefix) > -1 &&
                delete m.defaultValue,
              b
            );
          };
          for (; (o = this.nestingRegexp.exec(u)); ) {
            let b = [];
            ((m = { ...s }),
              (m = m.replace && !k(m.replace) ? m.replace : m),
              (m.applyPostProcessor = !1),
              delete m.defaultValue);
            const g = /{.*}/.test(o[1])
              ? o[1].lastIndexOf('}') + 1
              : o[1].indexOf(this.formatSeparator);
            if (
              (g !== -1 &&
                ((b = o[1]
                  .slice(g)
                  .split(this.formatSeparator)
                  .map(A => A.trim())
                  .filter(Boolean)),
                (o[1] = o[1].slice(0, g))),
              (h = c(p.call(this, o[1].trim(), m), m)),
              h && o[0] === u && !k(h))
            )
              return h;
            (k(h) || (h = Zd(h)),
              h ||
                (this.logger.warn(`missed to resolve ${o[1]} for nesting ${u}`),
                (h = '')),
              b.length &&
                (h = b.reduce(
                  (A, N) =>
                    this.format(A, N, s.lng, {
                      ...s,
                      interpolationkey: o[1].trim(),
                    }),
                  h.trim()
                )),
              (u = u.replace(o[0], h)),
              (this.regexp.lastIndex = 0));
          }
          return u;
        }
      }
      const py = r => {
          let u = r.toLowerCase().trim();
          const c = {};
          if (r.indexOf('(') > -1) {
            const s = r.split('(');
            u = s[0].toLowerCase().trim();
            const o = s[1].substring(0, s[1].length - 1);
            u === 'currency' && o.indexOf(':') < 0
              ? c.currency || (c.currency = o.trim())
              : u === 'relativetime' && o.indexOf(':') < 0
                ? c.range || (c.range = o.trim())
                : o.split(';').forEach(m => {
                    if (m) {
                      const [p, ...b] = m.split(':'),
                        g = b
                          .join(':')
                          .trim()
                          .replace(/^'+|'+$/g, ''),
                        A = p.trim();
                      (c[A] || (c[A] = g),
                        g === 'false' && (c[A] = !1),
                        g === 'true' && (c[A] = !0),
                        isNaN(g) || (c[A] = parseInt(g, 10)));
                    }
                  });
          }
          return { formatName: u, formatOptions: c };
        },
        ah = r => {
          const u = {};
          return (c, s, o) => {
            let h = o;
            o &&
              o.interpolationkey &&
              o.formatParams &&
              o.formatParams[o.interpolationkey] &&
              o[o.interpolationkey] &&
              (h = { ...h, [o.interpolationkey]: void 0 });
            const m = s + JSON.stringify(h);
            let p = u[m];
            return (p || ((p = r(Bn(s), o)), (u[m] = p)), p(c));
          };
        },
        vy = r => (u, c, s) => r(Bn(c), s)(u);
      class by {
        constructor(u = {}) {
          ((this.logger = Ke.create('formatter')),
            (this.options = u),
            this.init(u));
        }
        init(u, c = { interpolation: {} }) {
          this.formatSeparator = c.interpolation.formatSeparator || ',';
          const s = c.cacheInBuiltFormats ? ah : vy;
          this.formats = {
            number: s((o, h) => {
              const m = new Intl.NumberFormat(o, { ...h });
              return p => m.format(p);
            }),
            currency: s((o, h) => {
              const m = new Intl.NumberFormat(o, { ...h, style: 'currency' });
              return p => m.format(p);
            }),
            datetime: s((o, h) => {
              const m = new Intl.DateTimeFormat(o, { ...h });
              return p => m.format(p);
            }),
            relativetime: s((o, h) => {
              const m = new Intl.RelativeTimeFormat(o, { ...h });
              return p => m.format(p, h.range || 'day');
            }),
            list: s((o, h) => {
              const m = new Intl.ListFormat(o, { ...h });
              return p => m.format(p);
            }),
          };
        }
        add(u, c) {
          this.formats[u.toLowerCase().trim()] = c;
        }
        addCached(u, c) {
          this.formats[u.toLowerCase().trim()] = ah(c);
        }
        format(u, c, s, o = {}) {
          const h = c.split(this.formatSeparator);
          if (
            h.length > 1 &&
            h[0].indexOf('(') > 1 &&
            h[0].indexOf(')') < 0 &&
            h.find(p => p.indexOf(')') > -1)
          ) {
            const p = h.findIndex(b => b.indexOf(')') > -1);
            h[0] = [h[0], ...h.splice(1, p)].join(this.formatSeparator);
          }
          return h.reduce((p, b) => {
            const { formatName: g, formatOptions: A } = py(b);
            if (this.formats[g]) {
              let N = p;
              try {
                const L = o?.formatParams?.[o.interpolationkey] || {},
                  K = L.locale || L.lng || o.locale || o.lng || s;
                N = this.formats[g](p, K, { ...A, ...o, ...L });
              } catch (L) {
                this.logger.warn(L);
              }
              return N;
            } else this.logger.warn(`there was no format function for ${g}`);
            return p;
          }, u);
        }
      }
      const Sy = (r, u) => {
        r.pending[u] !== void 0 && (delete r.pending[u], r.pendingCount--);
      };
      class xy extends su {
        constructor(u, c, s, o = {}) {
          (super(),
            (this.backend = u),
            (this.store = c),
            (this.services = s),
            (this.languageUtils = s.languageUtils),
            (this.options = o),
            (this.logger = Ke.create('backendConnector')),
            (this.waitingReads = []),
            (this.maxParallelReads = o.maxParallelReads || 10),
            (this.readingCalls = 0),
            (this.maxRetries = o.maxRetries >= 0 ? o.maxRetries : 5),
            (this.retryTimeout = o.retryTimeout >= 1 ? o.retryTimeout : 350),
            (this.state = {}),
            (this.queue = []),
            this.backend?.init?.(s, o.backend, o));
        }
        queueLoad(u, c, s, o) {
          const h = {},
            m = {},
            p = {},
            b = {};
          return (
            u.forEach(g => {
              let A = !0;
              (c.forEach(N => {
                const L = `${g}|${N}`;
                !s.reload && this.store.hasResourceBundle(g, N)
                  ? (this.state[L] = 2)
                  : this.state[L] < 0 ||
                    (this.state[L] === 1
                      ? m[L] === void 0 && (m[L] = !0)
                      : ((this.state[L] = 1),
                        (A = !1),
                        m[L] === void 0 && (m[L] = !0),
                        h[L] === void 0 && (h[L] = !0),
                        b[N] === void 0 && (b[N] = !0)));
              }),
                A || (p[g] = !0));
            }),
            (Object.keys(h).length || Object.keys(m).length) &&
              this.queue.push({
                pending: m,
                pendingCount: Object.keys(m).length,
                loaded: {},
                errors: [],
                callback: o,
              }),
            {
              toLoad: Object.keys(h),
              pending: Object.keys(m),
              toLoadLanguages: Object.keys(p),
              toLoadNamespaces: Object.keys(b),
            }
          );
        }
        loaded(u, c, s) {
          const o = u.split('|'),
            h = o[0],
            m = o[1];
          (c && this.emit('failedLoading', h, m, c),
            !c &&
              s &&
              this.store.addResourceBundle(h, m, s, void 0, void 0, {
                skipCopy: !0,
              }),
            (this.state[u] = c ? -1 : 2),
            c && s && (this.state[u] = 0));
          const p = {};
          (this.queue.forEach(b => {
            (iy(b.loaded, [h], m),
              Sy(b, u),
              c && b.errors.push(c),
              b.pendingCount === 0 &&
                !b.done &&
                (Object.keys(b.loaded).forEach(g => {
                  p[g] || (p[g] = {});
                  const A = b.loaded[g];
                  A.length &&
                    A.forEach(N => {
                      p[g][N] === void 0 && (p[g][N] = !0);
                    });
                }),
                (b.done = !0),
                b.errors.length ? b.callback(b.errors) : b.callback()));
          }),
            this.emit('loaded', p),
            (this.queue = this.queue.filter(b => !b.done)));
        }
        read(u, c, s, o = 0, h = this.retryTimeout, m) {
          if (!u.length) return m(null, {});
          if (this.readingCalls >= this.maxParallelReads) {
            this.waitingReads.push({
              lng: u,
              ns: c,
              fcName: s,
              tried: o,
              wait: h,
              callback: m,
            });
            return;
          }
          this.readingCalls++;
          const p = (g, A) => {
              if ((this.readingCalls--, this.waitingReads.length > 0)) {
                const N = this.waitingReads.shift();
                this.read(N.lng, N.ns, N.fcName, N.tried, N.wait, N.callback);
              }
              if (g && A && o < this.maxRetries) {
                setTimeout(() => {
                  this.read.call(this, u, c, s, o + 1, h * 2, m);
                }, h);
                return;
              }
              m(g, A);
            },
            b = this.backend[s].bind(this.backend);
          if (b.length === 2) {
            try {
              const g = b(u, c);
              g && typeof g.then == 'function'
                ? g.then(A => p(null, A)).catch(p)
                : p(null, g);
            } catch (g) {
              p(g);
            }
            return;
          }
          return b(u, c, p);
        }
        prepareLoading(u, c, s = {}, o) {
          if (!this.backend)
            return (
              this.logger.warn(
                'No backend was added via i18next.use. Will not load resources.'
              ),
              o && o()
            );
          (k(u) && (u = this.languageUtils.toResolveHierarchy(u)),
            k(c) && (c = [c]));
          const h = this.queueLoad(u, c, s, o);
          if (!h.toLoad.length) return (h.pending.length || o(), null);
          h.toLoad.forEach(m => {
            this.loadOne(m);
          });
        }
        load(u, c, s) {
          this.prepareLoading(u, c, {}, s);
        }
        reload(u, c, s) {
          this.prepareLoading(u, c, { reload: !0 }, s);
        }
        loadOne(u, c = '') {
          const s = u.split('|'),
            o = s[0],
            h = s[1];
          this.read(o, h, 'read', void 0, void 0, (m, p) => {
            (m &&
              this.logger.warn(
                `${c}loading namespace ${h} for language ${o} failed`,
                m
              ),
              !m &&
                p &&
                this.logger.log(
                  `${c}loaded namespace ${h} for language ${o}`,
                  p
                ),
              this.loaded(u, m, p));
          });
        }
        saveMissing(u, c, s, o, h, m = {}, p = () => {}) {
          if (
            this.services?.utils?.hasLoadedNamespace &&
            !this.services?.utils?.hasLoadedNamespace(c)
          ) {
            this.logger.warn(
              `did not save key "${s}" as the namespace "${c}" was not yet loaded`,
              'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!'
            );
            return;
          }
          if (!(s == null || s === '')) {
            if (this.backend?.create) {
              const b = { ...m, isUpdate: h },
                g = this.backend.create.bind(this.backend);
              if (g.length < 6)
                try {
                  let A;
                  (g.length === 5
                    ? (A = g(u, c, s, o, b))
                    : (A = g(u, c, s, o)),
                    A && typeof A.then == 'function'
                      ? A.then(N => p(null, N)).catch(p)
                      : p(null, A));
                } catch (A) {
                  p(A);
                }
              else g(u, c, s, o, p, b);
            }
            !u || !u[0] || this.store.addResource(u[0], c, s, o);
          }
        }
      }
      const lh = () => ({
          debug: !1,
          initAsync: !0,
          ns: ['translation'],
          defaultNS: ['translation'],
          fallbackLng: ['dev'],
          fallbackNS: !1,
          supportedLngs: !1,
          nonExplicitSupportedLngs: !1,
          load: 'all',
          preload: !1,
          simplifyPluralSuffix: !0,
          keySeparator: '.',
          nsSeparator: ':',
          pluralSeparator: '_',
          contextSeparator: '_',
          partialBundledLanguages: !1,
          saveMissing: !1,
          updateMissing: !1,
          saveMissingTo: 'fallback',
          saveMissingPlurals: !0,
          missingKeyHandler: !1,
          missingInterpolationHandler: !1,
          postProcess: !1,
          postProcessPassResolved: !1,
          returnNull: !1,
          returnEmptyString: !0,
          returnObjects: !1,
          joinArrays: !1,
          returnedObjectHandler: !1,
          parseMissingKeyHandler: !1,
          appendNamespaceToMissingKey: !1,
          appendNamespaceToCIMode: !1,
          overloadTranslationOptionHandler: r => {
            let u = {};
            if (
              (typeof r[1] == 'object' && (u = r[1]),
              k(r[1]) && (u.defaultValue = r[1]),
              k(r[2]) && (u.tDescription = r[2]),
              typeof r[2] == 'object' || typeof r[3] == 'object')
            ) {
              const c = r[3] || r[2];
              Object.keys(c).forEach(s => {
                u[s] = c[s];
              });
            }
            return u;
          },
          interpolation: {
            escapeValue: !0,
            format: r => r,
            prefix: '{{',
            suffix: '}}',
            formatSeparator: ',',
            unescapePrefix: '-',
            nestingPrefix: '$t(',
            nestingSuffix: ')',
            nestingOptionsSeparator: ',',
            maxReplaces: 1e3,
            skipOnVariables: !0,
          },
          cacheInBuiltFormats: !0,
        }),
        nh = r => (
          k(r.ns) && (r.ns = [r.ns]),
          k(r.fallbackLng) && (r.fallbackLng = [r.fallbackLng]),
          k(r.fallbackNS) && (r.fallbackNS = [r.fallbackNS]),
          r.supportedLngs?.indexOf?.('cimode') < 0 &&
            (r.supportedLngs = r.supportedLngs.concat(['cimode'])),
          typeof r.initImmediate == 'boolean' &&
            (r.initAsync = r.initImmediate),
          r
        ),
        tu = () => {},
        Ay = r => {
          Object.getOwnPropertyNames(Object.getPrototypeOf(r)).forEach(c => {
            typeof r[c] == 'function' && (r[c] = r[c].bind(r));
          });
        };
      class qn extends su {
        constructor(u = {}, c) {
          if (
            (super(),
            (this.options = nh(u)),
            (this.services = {}),
            (this.logger = Ke),
            (this.modules = { external: [] }),
            Ay(this),
            c && !this.isInitialized && !u.isClone)
          ) {
            if (!this.options.initAsync) return (this.init(u, c), this);
            setTimeout(() => {
              this.init(u, c);
            }, 0);
          }
        }
        init(u = {}, c) {
          ((this.isInitializing = !0),
            typeof u == 'function' && ((c = u), (u = {})),
            u.defaultNS == null &&
              u.ns &&
              (k(u.ns)
                ? (u.defaultNS = u.ns)
                : u.ns.indexOf('translation') < 0 && (u.defaultNS = u.ns[0])));
          const s = lh();
          ((this.options = { ...s, ...this.options, ...nh(u) }),
            (this.options.interpolation = {
              ...s.interpolation,
              ...this.options.interpolation,
            }),
            u.keySeparator !== void 0 &&
              (this.options.userDefinedKeySeparator = u.keySeparator),
            u.nsSeparator !== void 0 &&
              (this.options.userDefinedNsSeparator = u.nsSeparator));
          const o = g => (g ? (typeof g == 'function' ? new g() : g) : null);
          if (!this.options.isClone) {
            this.modules.logger
              ? Ke.init(o(this.modules.logger), this.options)
              : Ke.init(null, this.options);
            let g;
            this.modules.formatter ? (g = this.modules.formatter) : (g = by);
            const A = new Pd(this.options);
            this.store = new Wd(this.options.resources, this.options);
            const N = this.services;
            ((N.logger = Ke),
              (N.resourceStore = this.store),
              (N.languageUtils = A),
              (N.pluralResolver = new my(A, {
                prepend: this.options.pluralSeparator,
                simplifyPluralSuffix: this.options.simplifyPluralSuffix,
              })),
              this.options.interpolation.format &&
                this.options.interpolation.format !== s.interpolation.format &&
                this.logger.deprecate(
                  'init: you are still using the legacy format function, please use the new approach: https://www.i18next.com/translation-function/formatting'
                ),
              g &&
                (!this.options.interpolation.format ||
                  this.options.interpolation.format ===
                    s.interpolation.format) &&
                ((N.formatter = o(g)),
                N.formatter.init && N.formatter.init(N, this.options),
                (this.options.interpolation.format = N.formatter.format.bind(
                  N.formatter
                ))),
              (N.interpolator = new yy(this.options)),
              (N.utils = {
                hasLoadedNamespace: this.hasLoadedNamespace.bind(this),
              }),
              (N.backendConnector = new xy(
                o(this.modules.backend),
                N.resourceStore,
                N,
                this.options
              )),
              N.backendConnector.on('*', (K, ...q) => {
                this.emit(K, ...q);
              }),
              this.modules.languageDetector &&
                ((N.languageDetector = o(this.modules.languageDetector)),
                N.languageDetector.init &&
                  N.languageDetector.init(
                    N,
                    this.options.detection,
                    this.options
                  )),
              this.modules.i18nFormat &&
                ((N.i18nFormat = o(this.modules.i18nFormat)),
                N.i18nFormat.init && N.i18nFormat.init(this)),
              (this.translator = new uu(this.services, this.options)),
              this.translator.on('*', (K, ...q) => {
                this.emit(K, ...q);
              }),
              this.modules.external.forEach(K => {
                K.init && K.init(this);
              }));
          }
          if (
            ((this.format = this.options.interpolation.format),
            c || (c = tu),
            this.options.fallbackLng &&
              !this.services.languageDetector &&
              !this.options.lng)
          ) {
            const g = this.services.languageUtils.getFallbackCodes(
              this.options.fallbackLng
            );
            g.length > 0 && g[0] !== 'dev' && (this.options.lng = g[0]);
          }
          (!this.services.languageDetector &&
            !this.options.lng &&
            this.logger.warn(
              'init: no languageDetector is used and no lng is defined'
            ),
            [
              'getResource',
              'hasResourceBundle',
              'getResourceBundle',
              'getDataByLanguage',
            ].forEach(g => {
              this[g] = (...A) => this.store[g](...A);
            }),
            [
              'addResource',
              'addResources',
              'addResourceBundle',
              'removeResourceBundle',
            ].forEach(g => {
              this[g] = (...A) => (this.store[g](...A), this);
            }));
          const p = Ln(),
            b = () => {
              const g = (A, N) => {
                ((this.isInitializing = !1),
                  this.isInitialized &&
                    !this.initializedStoreOnce &&
                    this.logger.warn(
                      'init: i18next is already initialized. You should call init just once!'
                    ),
                  (this.isInitialized = !0),
                  this.options.isClone ||
                    this.logger.log('initialized', this.options),
                  this.emit('initialized', this.options),
                  p.resolve(N),
                  c(A, N));
              };
              if (this.languages && !this.isInitialized)
                return g(null, this.t.bind(this));
              this.changeLanguage(this.options.lng, g);
            };
          return (
            this.options.resources || !this.options.initAsync
              ? b()
              : setTimeout(b, 0),
            p
          );
        }
        loadResources(u, c = tu) {
          let s = c;
          const o = k(u) ? u : this.language;
          if (
            (typeof u == 'function' && (s = u),
            !this.options.resources || this.options.partialBundledLanguages)
          ) {
            if (
              o?.toLowerCase() === 'cimode' &&
              (!this.options.preload || this.options.preload.length === 0)
            )
              return s();
            const h = [],
              m = p => {
                if (!p || p === 'cimode') return;
                this.services.languageUtils.toResolveHierarchy(p).forEach(g => {
                  g !== 'cimode' && h.indexOf(g) < 0 && h.push(g);
                });
              };
            (o
              ? m(o)
              : this.services.languageUtils
                  .getFallbackCodes(this.options.fallbackLng)
                  .forEach(b => m(b)),
              this.options.preload?.forEach?.(p => m(p)),
              this.services.backendConnector.load(h, this.options.ns, p => {
                (!p &&
                  !this.resolvedLanguage &&
                  this.language &&
                  this.setResolvedLanguage(this.language),
                  s(p));
              }));
          } else s(null);
        }
        reloadResources(u, c, s) {
          const o = Ln();
          return (
            typeof u == 'function' && ((s = u), (u = void 0)),
            typeof c == 'function' && ((s = c), (c = void 0)),
            u || (u = this.languages),
            c || (c = this.options.ns),
            s || (s = tu),
            this.services.backendConnector.reload(u, c, h => {
              (o.resolve(), s(h));
            }),
            o
          );
        }
        use(u) {
          if (!u)
            throw new Error(
              'You are passing an undefined module! Please check the object you are passing to i18next.use()'
            );
          if (!u.type)
            throw new Error(
              'You are passing a wrong module! Please check the object you are passing to i18next.use()'
            );
          return (
            u.type === 'backend' && (this.modules.backend = u),
            (u.type === 'logger' || (u.log && u.warn && u.error)) &&
              (this.modules.logger = u),
            u.type === 'languageDetector' &&
              (this.modules.languageDetector = u),
            u.type === 'i18nFormat' && (this.modules.i18nFormat = u),
            u.type === 'postProcessor' && gh.addPostProcessor(u),
            u.type === 'formatter' && (this.modules.formatter = u),
            u.type === '3rdParty' && this.modules.external.push(u),
            this
          );
        }
        setResolvedLanguage(u) {
          if (
            !(!u || !this.languages) &&
            !(['cimode', 'dev'].indexOf(u) > -1)
          ) {
            for (let c = 0; c < this.languages.length; c++) {
              const s = this.languages[c];
              if (
                !(['cimode', 'dev'].indexOf(s) > -1) &&
                this.store.hasLanguageSomeTranslations(s)
              ) {
                this.resolvedLanguage = s;
                break;
              }
            }
            !this.resolvedLanguage &&
              this.languages.indexOf(u) < 0 &&
              this.store.hasLanguageSomeTranslations(u) &&
              ((this.resolvedLanguage = u), this.languages.unshift(u));
          }
        }
        changeLanguage(u, c) {
          this.isLanguageChangingTo = u;
          const s = Ln();
          this.emit('languageChanging', u);
          const o = p => {
              ((this.language = p),
                (this.languages =
                  this.services.languageUtils.toResolveHierarchy(p)),
                (this.resolvedLanguage = void 0),
                this.setResolvedLanguage(p));
            },
            h = (p, b) => {
              (b
                ? this.isLanguageChangingTo === u &&
                  (o(b),
                  this.translator.changeLanguage(b),
                  (this.isLanguageChangingTo = void 0),
                  this.emit('languageChanged', b),
                  this.logger.log('languageChanged', b))
                : (this.isLanguageChangingTo = void 0),
                s.resolve((...g) => this.t(...g)),
                c && c(p, (...g) => this.t(...g)));
            },
            m = p => {
              !u && !p && this.services.languageDetector && (p = []);
              const b = k(p) ? p : p && p[0],
                g = this.store.hasLanguageSomeTranslations(b)
                  ? b
                  : this.services.languageUtils.getBestMatchFromCodes(
                      k(p) ? [p] : p
                    );
              (g &&
                (this.language || o(g),
                this.translator.language || this.translator.changeLanguage(g),
                this.services.languageDetector?.cacheUserLanguage?.(g)),
                this.loadResources(g, A => {
                  h(A, g);
                }));
            };
          return (
            !u &&
            this.services.languageDetector &&
            !this.services.languageDetector.async
              ? m(this.services.languageDetector.detect())
              : !u &&
                  this.services.languageDetector &&
                  this.services.languageDetector.async
                ? this.services.languageDetector.detect.length === 0
                  ? this.services.languageDetector.detect().then(m)
                  : this.services.languageDetector.detect(m)
                : m(u),
            s
          );
        }
        getFixedT(u, c, s) {
          const o = (h, m, ...p) => {
            let b;
            (typeof m != 'object'
              ? (b = this.options.overloadTranslationOptionHandler(
                  [h, m].concat(p)
                ))
              : (b = { ...m }),
              (b.lng = b.lng || o.lng),
              (b.lngs = b.lngs || o.lngs),
              (b.ns = b.ns || o.ns),
              b.keyPrefix !== '' &&
                (b.keyPrefix = b.keyPrefix || s || o.keyPrefix));
            const g = this.options.keySeparator || '.';
            let A;
            return (
              b.keyPrefix && Array.isArray(h)
                ? (A = h.map(
                    N => (
                      typeof N == 'function' &&
                        (N = Uc(N, { ...this.options, ...m })),
                      `${b.keyPrefix}${g}${N}`
                    )
                  ))
                : (typeof h == 'function' &&
                    (h = Uc(h, { ...this.options, ...m })),
                  (A = b.keyPrefix ? `${b.keyPrefix}${g}${h}` : h)),
              this.t(A, b)
            );
          };
          return (
            k(u) ? (o.lng = u) : (o.lngs = u),
            (o.ns = c),
            (o.keyPrefix = s),
            o
          );
        }
        t(...u) {
          return this.translator?.translate(...u);
        }
        exists(...u) {
          return this.translator?.exists(...u);
        }
        setDefaultNamespace(u) {
          this.options.defaultNS = u;
        }
        hasLoadedNamespace(u, c = {}) {
          if (!this.isInitialized)
            return (
              this.logger.warn(
                'hasLoadedNamespace: i18next was not initialized',
                this.languages
              ),
              !1
            );
          if (!this.languages || !this.languages.length)
            return (
              this.logger.warn(
                'hasLoadedNamespace: i18n.languages were undefined or empty',
                this.languages
              ),
              !1
            );
          const s = c.lng || this.resolvedLanguage || this.languages[0],
            o = this.options ? this.options.fallbackLng : !1,
            h = this.languages[this.languages.length - 1];
          if (s.toLowerCase() === 'cimode') return !0;
          const m = (p, b) => {
            const g = this.services.backendConnector.state[`${p}|${b}`];
            return g === -1 || g === 0 || g === 2;
          };
          if (c.precheck) {
            const p = c.precheck(this, m);
            if (p !== void 0) return p;
          }
          return !!(
            this.hasResourceBundle(s, u) ||
            !this.services.backendConnector.backend ||
            (this.options.resources && !this.options.partialBundledLanguages) ||
            (m(s, u) && (!o || m(h, u)))
          );
        }
        loadNamespaces(u, c) {
          const s = Ln();
          return this.options.ns
            ? (k(u) && (u = [u]),
              u.forEach(o => {
                this.options.ns.indexOf(o) < 0 && this.options.ns.push(o);
              }),
              this.loadResources(o => {
                (s.resolve(), c && c(o));
              }),
              s)
            : (c && c(), Promise.resolve());
        }
        loadLanguages(u, c) {
          const s = Ln();
          k(u) && (u = [u]);
          const o = this.options.preload || [],
            h = u.filter(
              m =>
                o.indexOf(m) < 0 &&
                this.services.languageUtils.isSupportedCode(m)
            );
          return h.length
            ? ((this.options.preload = o.concat(h)),
              this.loadResources(m => {
                (s.resolve(), c && c(m));
              }),
              s)
            : (c && c(), Promise.resolve());
        }
        dir(u) {
          if (
            (u ||
              (u =
                this.resolvedLanguage ||
                (this.languages?.length > 0
                  ? this.languages[0]
                  : this.language)),
            !u)
          )
            return 'rtl';
          try {
            const o = new Intl.Locale(u);
            if (o && o.getTextInfo) {
              const h = o.getTextInfo();
              if (h && h.direction) return h.direction;
            }
          } catch {}
          const c = [
              'ar',
              'shu',
              'sqr',
              'ssh',
              'xaa',
              'yhd',
              'yud',
              'aao',
              'abh',
              'abv',
              'acm',
              'acq',
              'acw',
              'acx',
              'acy',
              'adf',
              'ads',
              'aeb',
              'aec',
              'afb',
              'ajp',
              'apc',
              'apd',
              'arb',
              'arq',
              'ars',
              'ary',
              'arz',
              'auz',
              'avl',
              'ayh',
              'ayl',
              'ayn',
              'ayp',
              'bbz',
              'pga',
              'he',
              'iw',
              'ps',
              'pbt',
              'pbu',
              'pst',
              'prp',
              'prd',
              'ug',
              'ur',
              'ydd',
              'yds',
              'yih',
              'ji',
              'yi',
              'hbo',
              'men',
              'xmn',
              'fa',
              'jpr',
              'peo',
              'pes',
              'prs',
              'dv',
              'sam',
              'ckb',
            ],
            s = this.services?.languageUtils || new Pd(lh());
          return u.toLowerCase().indexOf('-latn') > 1
            ? 'ltr'
            : c.indexOf(s.getLanguagePartFromCode(u)) > -1 ||
                u.toLowerCase().indexOf('-arab') > 1
              ? 'rtl'
              : 'ltr';
        }
        static createInstance(u = {}, c) {
          return new qn(u, c);
        }
        cloneInstance(u = {}, c = tu) {
          const s = u.forkResourceStore;
          s && delete u.forkResourceStore;
          const o = { ...this.options, ...u, isClone: !0 },
            h = new qn(o);
          if (
            ((u.debug !== void 0 || u.prefix !== void 0) &&
              (h.logger = h.logger.clone(u)),
            ['store', 'services', 'language'].forEach(p => {
              h[p] = this[p];
            }),
            (h.services = { ...this.services }),
            (h.services.utils = {
              hasLoadedNamespace: h.hasLoadedNamespace.bind(h),
            }),
            s)
          ) {
            const p = Object.keys(this.store.data).reduce(
              (b, g) => (
                (b[g] = { ...this.store.data[g] }),
                (b[g] = Object.keys(b[g]).reduce(
                  (A, N) => ((A[N] = { ...b[g][N] }), A),
                  b[g]
                )),
                b
              ),
              {}
            );
            ((h.store = new Wd(p, o)), (h.services.resourceStore = h.store));
          }
          return (
            (h.translator = new uu(h.services, o)),
            h.translator.on('*', (p, ...b) => {
              h.emit(p, ...b);
            }),
            h.init(o, c),
            (h.translator.options = o),
            (h.translator.backendConnector.services.utils = {
              hasLoadedNamespace: h.hasLoadedNamespace.bind(h),
            }),
            h
          );
        }
        toJSON() {
          return {
            options: this.options,
            store: this.store,
            language: this.language,
            languages: this.languages,
            resolvedLanguage: this.resolvedLanguage,
          };
        }
      }
      const Yc = qn.createInstance();
      Yc.createInstance = qn.createInstance;
      const Ty = (r, u, c, s) => {
          const o = [c, { code: u, ...(s || {}) }];
          if (r?.services?.logger?.forward)
            return r.services.logger.forward(o, 'warn', 'react-i18next::', !0);
          (Qa(o[0]) && (o[0] = `react-i18next:: ${o[0]}`),
            r?.services?.logger?.warn
              ? r.services.logger.warn(...o)
              : console?.warn && console.warn(...o));
        },
        ih = {},
        jc = (r, u, c, s) => {
          (Qa(c) && ih[c]) || (Qa(c) && (ih[c] = new Date()), Ty(r, u, c, s));
        },
        yh = (r, u) => () => {
          if (r.isInitialized) u();
          else {
            const c = () => {
              (setTimeout(() => {
                r.off('initialized', c);
              }, 0),
                u());
            };
            r.on('initialized', c);
          }
        },
        Lc = (r, u, c) => {
          r.loadNamespaces(u, yh(r, c));
        },
        uh = (r, u, c, s) => {
          if (
            (Qa(c) && (c = [c]),
            r.options.preload && r.options.preload.indexOf(u) > -1)
          )
            return Lc(r, c, s);
          (c.forEach(o => {
            r.options.ns.indexOf(o) < 0 && r.options.ns.push(o);
          }),
            r.loadLanguages(u, yh(r, s)));
        },
        Ey = (r, u, c = {}) =>
          !u.languages || !u.languages.length
            ? (jc(u, 'NO_LANGUAGES', 'i18n.languages were undefined or empty', {
                languages: u.languages,
              }),
              !0)
            : u.hasLoadedNamespace(r, {
                lng: c.lng,
                precheck: (s, o) => {
                  if (
                    c.bindI18n &&
                    c.bindI18n.indexOf('languageChanging') > -1 &&
                    s.services.backendConnector.backend &&
                    s.isLanguageChangingTo &&
                    !o(s.isLanguageChangingTo, r)
                  )
                    return !1;
                },
              }),
        Qa = r => typeof r == 'string',
        Oy = r => typeof r == 'object' && r !== null,
        My =
          /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g,
        _y = {
          '&amp;': '&',
          '&#38;': '&',
          '&lt;': '<',
          '&#60;': '<',
          '&gt;': '>',
          '&#62;': '>',
          '&apos;': "'",
          '&#39;': "'",
          '&quot;': '"',
          '&#34;': '"',
          '&nbsp;': ' ',
          '&#160;': ' ',
          '&copy;': '©',
          '&#169;': '©',
          '&reg;': '®',
          '&#174;': '®',
          '&hellip;': '…',
          '&#8230;': '…',
          '&#x2F;': '/',
          '&#47;': '/',
        },
        Ny = r => _y[r],
        Ry = r => r.replace(My, Ny);
      let Hc = {
        bindI18n: 'languageChanged',
        bindI18nStore: '',
        transEmptyNodeValue: '',
        transSupportBasicHtmlNodes: !0,
        transWrapTextNodes: '',
        transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'p'],
        useSuspense: !0,
        unescape: Ry,
      };
      const zy = (r = {}) => {
          Hc = { ...Hc, ...r };
        },
        Dy = () => Hc;
      let ph;
      const Cy = r => {
          ph = r;
        },
        Uy = () => ph,
        jy = {
          type: '3rdParty',
          init(r) {
            (zy(r.options.react), Cy(r));
          },
        },
        vh = yt.createContext();
      class Ly {
        constructor() {
          this.usedNamespaces = {};
        }
        addUsedNamespaces(u) {
          u.forEach(c => {
            this.usedNamespaces[c] || (this.usedNamespaces[c] = !0);
          });
        }
        getUsedNamespaces() {
          return Object.keys(this.usedNamespaces);
        }
      }
      const Hy = (r, u) => {
          const c = yt.useRef();
          return (
            yt.useEffect(() => {
              c.current = r;
            }, [r, u]),
            c.current
          );
        },
        bh = (r, u, c, s) => r.getFixedT(u, c, s),
        By = (r, u, c, s) => yt.useCallback(bh(r, u, c, s), [r, u, c, s]),
        ue = (r, u = {}) => {
          const { i18n: c } = u,
            { i18n: s, defaultNS: o } = yt.useContext(vh) || {},
            h = c || s || Uy();
          if (
            (h && !h.reportNamespaces && (h.reportNamespaces = new Ly()), !h)
          ) {
            jc(
              h,
              'NO_I18NEXT_INSTANCE',
              'useTranslation: You will need to pass in an i18next instance by using initReactI18next'
            );
            const I = (st, ut) =>
                Qa(ut)
                  ? ut
                  : Oy(ut) && Qa(ut.defaultValue)
                    ? ut.defaultValue
                    : Array.isArray(st)
                      ? st[st.length - 1]
                      : st,
              w = [I, {}, !1];
            return ((w.t = I), (w.i18n = {}), (w.ready = !1), w);
          }
          h.options.react?.wait &&
            jc(
              h,
              'DEPRECATED_OPTION',
              'useTranslation: It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.'
            );
          const m = { ...Dy(), ...h.options.react, ...u },
            { useSuspense: p, keyPrefix: b } = m;
          let g = r || o || h.options?.defaultNS;
          ((g = Qa(g) ? [g] : g || ['translation']),
            h.reportNamespaces.addUsedNamespaces?.(g));
          const A =
              (h.isInitialized || h.initializedStoreOnce) &&
              g.every(I => Ey(I, h, m)),
            N = By(h, u.lng || null, m.nsMode === 'fallback' ? g : g[0], b),
            L = () => N,
            K = () =>
              bh(h, u.lng || null, m.nsMode === 'fallback' ? g : g[0], b),
            [q, Q] = yt.useState(L);
          let P = g.join();
          u.lng && (P = `${u.lng}${P}`);
          const ht = Hy(P),
            tt = yt.useRef(!0);
          (yt.useEffect(() => {
            const { bindI18n: I, bindI18nStore: w } = m;
            ((tt.current = !0),
              !A &&
                !p &&
                (u.lng
                  ? uh(h, u.lng, g, () => {
                      tt.current && Q(K);
                    })
                  : Lc(h, g, () => {
                      tt.current && Q(K);
                    })),
              A && ht && ht !== P && tt.current && Q(K));
            const st = () => {
              tt.current && Q(K);
            };
            return (
              I && h?.on(I, st),
              w && h?.store.on(w, st),
              () => {
                ((tt.current = !1),
                  h && I && I?.split(' ').forEach(ut => h.off(ut, st)),
                  w && h && w.split(' ').forEach(ut => h.store.off(ut, st)));
              }
            );
          }, [h, P]),
            yt.useEffect(() => {
              tt.current && A && Q(L);
            }, [h, b, A]));
          const W = [q, h, A];
          if (((W.t = q), (W.i18n = h), (W.ready = A), A || (!A && !p)))
            return W;
          throw new Promise(I => {
            u.lng ? uh(h, u.lng, g, () => I()) : Lc(h, g, () => I());
          });
        };
      function qy({ i18n: r, defaultNS: u, children: c }) {
        const s = yt.useMemo(() => ({ i18n: r, defaultNS: u }), [r, u]);
        return yt.createElement(vh.Provider, { value: s }, c);
      }
      const Ky = 'page_x9M2h',
        Yy = { page: Ky },
        Gy = 'stack_gJsE8',
        wy = { stack: Gy };
      function Sh(r) {
        return r.replace(/\n/g, '<br />');
      }
      function It({ html: r, as: u = 'p', ...c }) {
        return r
          ? C.jsx(u, { ...c, dangerouslySetInnerHTML: { __html: Sh(r) } })
          : null;
      }
      /*! lozad.js - v1.16.0 - 2020-09-06
       * https://github.com/ApoorvSaxena/lozad.js
       * Copyright (c) 2020 Apoorv Saxena; Licensed MIT */ const Vy =
          typeof document < 'u' && document.documentMode,
        Xy = {
          rootMargin: '0px',
          threshold: 0,
          load(r) {
            if (r.nodeName.toLowerCase() === 'picture') {
              let c = r.querySelector('img'),
                s = !1;
              (c === null && ((c = document.createElement('img')), (s = !0)),
                Vy &&
                  r.getAttribute('data-iesrc') &&
                  (c.src = r.getAttribute('data-iesrc')),
                r.getAttribute('data-alt') &&
                  (c.alt = r.getAttribute('data-alt')),
                s && r.append(c));
            }
            if (
              r.nodeName.toLowerCase() === 'video' &&
              !r.getAttribute('data-src') &&
              r.children
            ) {
              const c = r.children;
              let s;
              for (let o = 0; o <= c.length - 1; o++)
                ((s = c[o].getAttribute('data-src')), s && (c[o].src = s));
              r.load();
            }
            (r.getAttribute('data-poster') &&
              (r.poster = r.getAttribute('data-poster')),
              r.getAttribute('data-src') &&
                (r.src = r.getAttribute('data-src')),
              r.getAttribute('data-srcset') &&
                r.setAttribute('srcset', r.getAttribute('data-srcset')));
            let u = ',';
            if (
              (r.getAttribute('data-background-delimiter') &&
                (u = r.getAttribute('data-background-delimiter')),
              r.getAttribute('data-background-image'))
            )
              r.style.backgroundImage = `url('${r.getAttribute('data-background-image').split(u).join("'),url('")}')`;
            else if (r.getAttribute('data-background-image-set')) {
              const c = r.getAttribute('data-background-image-set').split(u);
              let s = c[0].substr(0, c[0].indexOf(' ')) || c[0];
              ((s = s.indexOf('url(') === -1 ? `url(${s})` : s),
                c.length === 1
                  ? (r.style.backgroundImage = s)
                  : r.setAttribute(
                      'style',
                      (r.getAttribute('style') || '') +
                        `background-image: ${s}; background-image: -webkit-image-set(${c}); background-image: image-set(${c})`
                    ));
            }
            r.getAttribute('data-toggle-class') &&
              r.classList.toggle(r.getAttribute('data-toggle-class'));
          },
          loaded() {},
        };
      function Bc(r) {
        r.setAttribute('data-loaded', !0);
      }
      function Qy(r) {
        r.getAttribute('data-placeholder-background') &&
          (r.style.background = r.getAttribute('data-placeholder-background'));
      }
      const qc = r => r.getAttribute('data-loaded') === 'true',
        Zy = (r, u) => (c, s) => {
          c.forEach(o => {
            (o.intersectionRatio > 0 || o.isIntersecting) &&
              (s.unobserve(o.target),
              qc(o.target) || (r(o.target), Bc(o.target), u(o.target)));
          });
        },
        sh = (r, u = document) =>
          r instanceof Element
            ? [r]
            : r instanceof NodeList
              ? r
              : u.querySelectorAll(r);
      function $y(r = '.lozad', u = {}) {
        const {
          root: c,
          rootMargin: s,
          threshold: o,
          load: h,
          loaded: m,
        } = Object.assign({}, Xy, u);
        let p;
        typeof window < 'u' &&
          window.IntersectionObserver &&
          (p = new IntersectionObserver(Zy(h, m), {
            root: c,
            rootMargin: s,
            threshold: o,
          }));
        const b = sh(r, c);
        for (let g = 0; g < b.length; g++) Qy(b[g]);
        return {
          observe() {
            const g = sh(r, c);
            for (let A = 0; A < g.length; A++)
              if (!qc(g[A])) {
                if (p) {
                  p.observe(g[A]);
                  continue;
                }
                (h(g[A]), Bc(g[A]), m(g[A]));
              }
          },
          triggerLoad(g) {
            qc(g) || (h(g), Bc(g), m(g));
          },
          observer: p,
        };
      }
      const Jy = ({ name: r, className: u = '', style: c, size: s, ...o }) => {
        const h = { lineHeight: '1', fontSize: s, ...c };
        return C.jsx('i', {
          className: `creality-product-info-iconfont ${r} ${u}`,
          style: h,
          ...o,
        });
      };
      function xh(...r) {
        const u = [];
        for (const c of r)
          if (c) {
            if (typeof c == 'string' || typeof c == 'number') u.push(c);
            else if (Array.isArray(c)) {
              const s = xh(...c);
              s && u.push(s);
            } else if (typeof c == 'object')
              for (const s in c) c.hasOwnProperty(s) && c[s] && u.push(s);
          }
        return u.join(' ');
      }
      const ky = () => {
          if (typeof window > 'u') {
            const r = globalThis.__SSR_LANG__;
            if (r) return r;
          }
          return 'en';
        },
        Wy = 'mediaPicture_GEnv7',
        Fy = 'mediaImage_pGzlz',
        ch = { mediaPicture: Wy, mediaImage: Fy },
        Dc = '(max-width: 768px)';
      function fh(r) {
        return r
          ? Object.entries(r)
              .filter(([, u]) => u != null && u !== '')
              .map(([u, c]) => {
                const s = u.startsWith('--')
                    ? u
                    : u.replace(/[A-Z]/g, h => `-${h.toLowerCase()}`),
                  o =
                    typeof c == 'number' &&
                    !/^(zIndex|opacity|flex|order|lineHeight|fontWeight|zoom)$/.test(
                      u
                    )
                      ? `${c}px`
                      : String(c);
                return `${s}:${o} !important;`;
              })
              .join('')
          : '';
      }
      function oh(r) {
        if (typeof r != 'string') return;
        const u = r.trim();
        if (u !== '') return u.startsWith('//') ? `https:${u}` : u;
      }
      const Py = ({
          pcSrc: r,
          mobileSrc: u,
          style: c,
          pcAspectRatio: s,
          mobileAspectRatio: o,
          pcClassName: h,
          mobileClassName: m,
          pcStyle: p,
          mobileStyle: b,
          fallback: g,
          showFallbackText: A = !0,
          enableLazyLoad: N = !1,
          rootMargin: L = '400px',
          threshold: K = 0,
          alt: q = '',
          ...Q
        }) => {
          const [P, ht] = yt.useState(!1),
            [tt, W] = yt.useState(!1),
            I = yt.useRef(null),
            st = `mediaImage-${yt.useId().replace(/[^a-zA-Z0-9_-]/g, '')}`,
            ut = oh(r),
            Mt = oh(u),
            Et = ut ?? Mt;
          (yt.useEffect(() => {
            W(!0);
          }, []),
            yt.useEffect(() => {
              ht(!1);
            }, [ut, Mt]),
            yt.useEffect(() => {
              if (!N || !tt || !I.current) return;
              $y(I.current, {
                rootMargin: L,
                threshold: K,
                loaded: Dt => Dt.classList.add('lozad-loaded'),
              }).observe();
            }, [tt, N, L, K, ut, Mt]));
          const Lt = C.jsx('div', {
            style: {
              width: Q.width || '100%',
              height: Q.height || '100%',
              aspectRatio: s || o,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: 'rgba(243,244,246)',
              ...c,
            },
            children: C.jsx(Jy, {
              name: 'icon-zhanweifu',
              style: {
                fontSize: '36px',
                lineHeight: '40px',
                color: 'rgba(156,163,175)',
                opacity: 0.2,
              },
            }),
          });
          if (!Et)
            return g ? C.jsx(C.Fragment, { children: g }) : A ? Lt : null;
          if (tt && P)
            return g ? C.jsx(C.Fragment, { children: g }) : A ? Lt : null;
          const te = fh({ ...(s ? { aspectRatio: s } : {}), ...p }),
            Rt = fh({ ...(o ? { aspectRatio: o } : {}), ...b }),
            zt = [
              te ? `@media not all and ${Dc}{.${st}{${te}}}` : '',
              Rt ? `@media ${Dc}{.${st}{${Rt}}}` : '',
            ]
              .filter(Boolean)
              .join('');
          return C.jsxs(C.Fragment, {
            children: [
              zt && C.jsx('style', { dangerouslySetInnerHTML: { __html: zt } }),
              C.jsxs('picture', {
                className: ch.mediaPicture,
                children: [
                  Mt && C.jsx('source', { media: Dc, srcSet: Mt }),
                  ut && C.jsx('source', { srcSet: ut }),
                  C.jsx('img', {
                    loading: 'lazy',
                    ref: I,
                    'data-src': N ? Et : void 0,
                    src: N ? void 0 : Et,
                    alt: q,
                    onError: () => ht(!0),
                    ...Q,
                    className: xh(
                      'lozad',
                      ch.mediaImage,
                      st,
                      Q.className,
                      h,
                      m
                    ),
                    style: {
                      ...(Q.width ? { width: Q.width } : {}),
                      ...(Q.height ? { height: Q.height } : {}),
                      objectFit: 'cover',
                      display: 'block',
                      ...c,
                    },
                  }),
                ],
              }),
            ],
          });
        },
        Ah = yt.forwardRef(
          (
            {
              src: r,
              threshold: u = 0.2,
              rootMargin: c = '0px',
              onPlay: s,
              onPause: o,
              onIntersectionChange: h,
              paused: m = !1,
              ...p
            },
            b
          ) => {
            const g = yt.useRef(null),
              A = b || g;
            return (
              yt.useEffect(() => {
                const N = A.current;
                if (!N) return;
                if (m) {
                  N.pause();
                  return;
                }
                const L = new IntersectionObserver(
                  K => {
                    K.forEach(q => {
                      const Q = q.isIntersecting;
                      (h?.(Q),
                        Q
                          ? (N.play().catch(P => {
                              console.warn('视频自动播放失败:', P);
                            }),
                            s?.())
                          : (N.pause(), o?.()));
                    });
                  },
                  { threshold: u, rootMargin: c }
                );
                return (
                  L.observe(N),
                  () => {
                    (L.unobserve(N), L.disconnect());
                  }
                );
              }, [r, u, c, s, o, h, A, m]),
              C.jsx('video', { ref: A, src: r, muted: !0, autoPlay: !0, ...p })
            );
          }
        );
      Ah.displayName = 'AutoPlayVideo';
      const Th = (r, u, c = `${u}M`) => {
          const s = r(u),
            o = r(c) || s;
          return { pcSrc: s, mobileSrc: o };
        },
        Iy = 'media_RBtPk',
        tp = 'placeholder_HbeU5',
        rh = { media: Iy, placeholder: tp },
        ep = /\.(mp4|webm|ogg|mov)(\?|#|$)/i;
      function Za({
        imageKey: r,
        mobileImageKey: u,
        className: c,
        eager: s = !1,
        pcAspectRatio: o,
        mobileAspectRatio: h,
        alt: m = '',
        variant: p = 'pc',
        kind: b = 'image',
        active: g,
        loop: A = !0,
        onEnded: N,
      }) {
        const { t: L } = ue('imageUrl'),
          { pcSrc: K, mobileSrc: q } = Th(L, r, u),
          Q = p === 'mb' ? q : K,
          P = yt.useRef(null);
        yt.useEffect(() => {
          if (A || g === !1) return;
          const W = P.current;
          if (
            !W ||
            !(
              W.ended ||
              (Number.isFinite(W.duration) &&
                W.duration > 0 &&
                W.currentTime >= W.duration - 0.05)
            )
          )
            return;
          const w = () => {
            (W.removeEventListener('seeked', w), W.play().catch(() => {}));
          };
          return (
            W.addEventListener('seeked', w),
            (W.currentTime = 0),
            () => W.removeEventListener('seeked', w)
          );
        }, [g, A, Q]);
        const ht = `${rh.media} ${c ?? ''}`,
          tt = C.jsx('div', {
            className: `${ht} ${rh.placeholder}`,
            style: { '--t1-media-pc-ar': o, '--t1-media-mb-ar': h },
            'aria-hidden': 'true',
          });
        if (b === 'video') {
          if (!Q) return tt;
          if (ep.test(Q))
            return C.jsx(
              Ah,
              {
                ref: P,
                className: ht,
                src: Q,
                muted: !0,
                loop: A,
                playsInline: !0,
                preload: 'auto',
                paused: g === !1,
                onEnded: N,
              },
              Q
            );
        }
        return C.jsx(Py, {
          className: ht,
          fallback: tt,
          pcSrc: K,
          mobileSrc: q,
          pcAspectRatio: o,
          mobileAspectRatio: h,
          alt: m,
          loading: s ? 'eager' : 'lazy',
          fetchPriority: s ? 'high' : void 0,
          enableLazyLoad: !s,
        });
      }
      const ap = 'section_w49O3',
        lp = 'mbSection_Twnhv',
        np = 'bg_I7HYj',
        ip = 'content_PrSV9',
        up = 'title_QFwtU',
        sp = 'subtitle_5L3ZH',
        Ul = {
          section: ap,
          mbSection: lp,
          bg: np,
          content: ip,
          title: up,
          subtitle: sp,
        };
      function cp({ variant: r = 'pc' }) {
        const { t: u } = ue(),
          c = r === 'mb';
        return C.jsxs('section', {
          className: `${Ul.section} ${c ? Ul.mbSection : ''}`,
          children: [
            C.jsx(Za, {
              className: Ul.bg,
              imageKey: 'section1Bg',
              pcAspectRatio: '2560/1442',
              mobileAspectRatio: '750/1000',
              eager: !0,
            }),
            C.jsxs('div', {
              className: Ul.content,
              children: [
                C.jsx(It, {
                  as: 'h1',
                  className: Ul.title,
                  html: u('section1.title'),
                }),
                C.jsx(It, {
                  className: Ul.subtitle,
                  html: u('section1.subtitle'),
                }),
              ],
            }),
          ],
        });
      }
      function fp(r) {
        return `calc(${r} / 2560 * 100 * var(--t1-pc-vw, 1vw))`;
      }
      function op(r) {
        return `calc(${r} / 750 * 100vw)`;
      }
      const rp = 'section_-kEmh',
        dp = 'mbSection_AWxtG',
        hp = 'inner_0ADwR',
        gp = 'title_3s4PF',
        mp = 'grid_ahSKY',
        yp = 'micron_pXqTw',
        pp = 'galvoSpeed_rbV2W',
        vp = 'fiveLasers_-xEOi',
        bp = 'autoFocus_92xy-',
        Sp = 'touch_81etm',
        xp = 'galvoLight_R1Dad',
        Ap = 'conveyor_TTvJD',
        Tp = 'ai_vrYhm',
        Ep = 'class1_EwNDz',
        Op = 'card_P-1vE',
        Mp = 'cardMedia_KAjGW',
        _p = 'cardText_MJBq8',
        Np = 'mbList_APdFl',
        Rp = 'mbCard_weYHu',
        jt = {
          section: rp,
          mbSection: dp,
          inner: hp,
          title: gp,
          grid: mp,
          micron: yp,
          galvoSpeed: pp,
          fiveLasers: vp,
          autoFocus: bp,
          touch: Sp,
          galvoLight: xp,
          conveyor: Ap,
          ai: Tp,
          class1: Ep,
          card: Op,
          cardMedia: Mp,
          cardText: _p,
          mbList: Np,
          mbCard: Rp,
        },
        eu = (r, u, c) => {
          const s = `rgba(0, 0, 0, ${r})`;
          return `linear-gradient(180deg, ${u > 0 ? `${s} 0%, ${s} ${u}%` : `${s} 0%`}, rgba(0, 0, 0, 0) ${c}%)`;
        },
        Qt = {
          fiveLasers: {
            id: 'fiveLasers',
            textKey: 'fiveLasers',
            imageKey: 'section2FiveLasers',
            kind: 'video',
            textTop: 20,
            textTopMb: 29,
            mask: 'rgba(11, 11, 11, 0.71)',
            maskMb:
              'linear-gradient(180deg, #0b0b0b 0%, rgba(11, 11, 11, 0) 34%), rgba(11, 11, 11, 0.19)',
          },
          micron: {
            id: 'micron',
            textKey: 'micron',
            imageKey: 'section2Micron',
            textTop: 16,
            textTopMb: 67,
            mask: eu(1, 2, 45),
          },
          galvoSpeed: {
            id: 'galvoSpeed',
            textKey: 'galvoSpeed',
            imageKey: 'section2GalvoSpeed',
            textTop: 16,
            textTopMb: 58,
            mask: eu(1, 14, 54),
          },
          autoFocus: {
            id: 'autoFocus',
            textKey: 'autoFocus',
            mbTextKey: 'autoFocusMb',
            imageKey: 'section2AutoFocus',
            textTop: 16,
            textTopMb: 60,
            mask: `${eu(0.88, 0, 63)}, linear-gradient(0deg, rgba(0, 0, 0, 0.24) 0%, rgba(0, 0, 0, 0) 37%)`,
          },
          touch: {
            id: 'touch',
            textKey: 'touch',
            imageKey: 'section2Touch',
            textTop: 16,
            textTopMb: 58,
          },
          galvoLight: {
            id: 'galvoLight',
            textKey: 'galvoLight',
            imageKey: 'section2GalvoLight',
            kind: 'video',
            textTop: 20,
            textTopMb: 39,
            mask: 'rgba(0, 0, 0, 0.64)',
          },
          class1: {
            id: 'class1',
            textKey: 'class1',
            imageKey: 'section2Class1',
            kind: 'video',
            textTop: 20,
            textTopMb: 39,
            mask: 'rgba(0, 0, 0, 0.65)',
          },
          conveyor: {
            id: 'conveyor',
            textKey: 'conveyor',
            imageKey: 'section2Conveyor',
            textTop: 16,
            textTopMb: 56,
          },
          ai: {
            id: 'ai',
            textKey: 'ai',
            imageKey: 'section2Ai',
            textTop: 16,
            textTopMb: 39,
            mask: eu(0.91, 0, 63),
          },
        },
        zp = [
          { card: Qt.micron, className: jt.micron },
          { card: Qt.fiveLasers, className: jt.fiveLasers },
          { card: Qt.autoFocus, className: jt.autoFocus },
          { card: Qt.galvoSpeed, className: jt.galvoSpeed },
          { card: Qt.touch, className: jt.touch },
          { card: Qt.galvoLight, className: jt.galvoLight },
          { card: Qt.conveyor, className: jt.conveyor },
          { card: Qt.class1, className: jt.class1 },
          { card: Qt.ai, className: jt.ai },
        ],
        Dp = [
          Qt.galvoSpeed,
          Qt.micron,
          Qt.fiveLasers,
          Qt.autoFocus,
          Qt.touch,
          Qt.galvoLight,
          Qt.class1,
          Qt.conveyor,
          Qt.ai,
        ];
      function Eh({ card: r, className: u, mb: c = !1 }) {
        const { t: s } = ue(),
          o = c && r.mbTextKey ? r.mbTextKey : r.textKey;
        return C.jsxs('div', {
          className: `${jt.card} ${u ?? ''}`,
          children: [
            C.jsx(Za, {
              className: jt.cardMedia,
              imageKey: r.imageKey,
              variant: c ? 'mb' : 'pc',
              kind: r.kind,
            }),
            C.jsx(It, {
              className: jt.cardText,
              style: {
                '--t1-card-text-top': c ? op(r.textTopMb) : fp(r.textTop),
              },
              html: s(`section2.${o}`),
            }),
          ],
        });
      }
      function Cp() {
        const { t: r } = ue();
        return C.jsx('section', {
          className: jt.section,
          children: C.jsxs('div', {
            className: jt.inner,
            children: [
              C.jsx(It, {
                as: 'h2',
                className: jt.title,
                html: r('section2.title'),
              }),
              C.jsx('div', {
                className: jt.grid,
                children: zp.map(({ card: u, className: c }) =>
                  C.jsx(Eh, { card: u, className: c }, u.id)
                ),
              }),
            ],
          }),
        });
      }
      function Up() {
        const { t: r } = ue();
        return C.jsxs('section', {
          className: `${jt.section} ${jt.mbSection}`,
          children: [
            C.jsx(It, {
              as: 'h2',
              className: jt.title,
              html: r('section2.title'),
            }),
            C.jsx('div', {
              className: jt.mbList,
              children: Dp.map(u =>
                C.jsx(Eh, { card: u, className: jt.mbCard, mb: !0 }, u.id)
              ),
            }),
          ],
        });
      }
      function jp({ variant: r = 'pc' }) {
        return r === 'mb' ? C.jsx(Up, {}) : C.jsx(Cp, {});
      }
      const Lp = 'section_CRs3B',
        Hp = 'mbSection_UKmBi',
        Bp = 'content_0XWB3',
        qp = 'title_pAFeH',
        Kp = 'media_vXYqs',
        Yp = 'video_2jZlU',
        jl = {
          section: Lp,
          mbSection: Hp,
          content: Bp,
          title: qp,
          media: Kp,
          video: Yp,
        };
      function Gp({ variant: r = 'pc' }) {
        const { t: u } = ue(),
          c = r === 'mb';
        return C.jsxs('section', {
          className: `${jl.section} ${c ? jl.mbSection : ''}`,
          children: [
            C.jsx('div', {
              className: jl.content,
              children: C.jsx(It, {
                as: 'h2',
                className: jl.title,
                html: u('section3.title'),
              }),
            }),
            C.jsx('div', {
              className: jl.media,
              children: C.jsx(Za, {
                className: jl.video,
                imageKey: 'section3Bg',
                variant: r,
                kind: 'video',
                pcAspectRatio: '2560/1200',
                mobileAspectRatio: '750/1000',
              }),
            }),
          ],
        });
      }
      const wp = 'section_S21VC',
        Vp = 'mbSection_qqsSF',
        Xp = 'head_fNwBL',
        Qp = 'title_WNUR6',
        Zp = 'list_IGW-S',
        $p = 'row_b9r-G',
        Jp = 'rowReversed_kSp34',
        kp = 'card_eX1Qh',
        Wp = 'cardMedia_ZUH1j',
        Fp = 'copy_ERZJY',
        Pp = 'name_b2eBA',
        Ip = 'body_d2CeT',
        Me = {
          section: wp,
          mbSection: Vp,
          head: Xp,
          title: Qp,
          list: Zp,
          row: $p,
          rowReversed: Jp,
          card: kp,
          cardMedia: Wp,
          copy: Fp,
          name: Pp,
          body: Ip,
        },
        t0 = [
          'section4Slide1',
          'section4Slide2',
          'section4Slide3',
          'section4Slide4',
          'section4Slide5',
        ];
      function e0({ variant: r = 'pc' }) {
        const { t: u } = ue(),
          c = r === 'mb',
          s = u('section4.slides', { returnObjects: !0 }) ?? [];
        return C.jsxs('section', {
          className: `${Me.section} ${c ? Me.mbSection : ''}`,
          children: [
            C.jsx('div', {
              className: Me.head,
              children: C.jsx(It, {
                as: 'h2',
                className: Me.title,
                html: u('section4.title'),
              }),
            }),
            C.jsx('div', {
              className: Me.list,
              children: t0.map((o, h) => {
                const m = Array.isArray(s) ? s[h] : void 0;
                return C.jsxs(
                  'div',
                  {
                    className: `${Me.row} ${h % 2 === 1 ? Me.rowReversed : ''}`,
                    children: [
                      C.jsx('div', {
                        className: Me.card,
                        children: C.jsx(Za, {
                          className: Me.cardMedia,
                          imageKey: o,
                          variant: r,
                          kind: 'video',
                          pcAspectRatio: '16/10',
                          mobileAspectRatio: '16/10',
                        }),
                      }),
                      C.jsxs('div', {
                        className: Me.copy,
                        children: [
                          C.jsx(It, { className: Me.name, html: m?.name }),
                          C.jsx(It, { className: Me.body, html: m?.body }),
                        ],
                      }),
                    ],
                  },
                  o
                );
              }),
            }),
          ],
        });
      }
      const a0 = 'section_TKGPN',
        l0 = 'mbSection_YIZZk',
        n0 = 'inner_xAVlY',
        i0 = 'title_kEO-c',
        u0 = 'gallery_L4Su7',
        s0 = 'media_ZwE3i',
        c0 = 'tabs_98heV',
        f0 = 'indicator_nFI8A',
        o0 = 'tab_hQHtz',
        r0 = 'cta_LoX1V',
        Ce = {
          section: a0,
          mbSection: l0,
          inner: n0,
          title: i0,
          gallery: u0,
          media: s0,
          tabs: c0,
          indicator: f0,
          tab: o0,
          cta: r0,
        },
        au = [
          { id: 'wood', imageKey: 'section5Wood' },
          { id: 'leather', imageKey: 'section5Leather' },
          { id: 'glass', imageKey: 'section5Glass' },
          { id: 'metal', imageKey: 'section5Metal' },
          { id: 'ceramics', imageKey: 'section5Ceramics' },
        ];
      function d0({ variant: r = 'pc' }) {
        const { t: u } = ue(),
          [c, s] = yt.useState('wood'),
          o = r === 'mb',
          h = au.find(m => m.id === c) ?? au[0];
        return C.jsx('section', {
          className: `${Ce.section} ${o ? Ce.mbSection : ''}`,
          children: C.jsxs('div', {
            className: Ce.inner,
            children: [
              C.jsx(It, {
                as: 'h2',
                className: Ce.title,
                html: u('section5.title'),
              }),
              C.jsx('div', {
                className: Ce.gallery,
                children: C.jsx(Za, {
                  className: Ce.media,
                  imageKey: h.imageKey,
                  variant: r,
                  alt: u(`section5.tabs.${h.id}`),
                }),
              }),
              C.jsxs('div', {
                className: Ce.tabs,
                role: 'tablist',
                style: { '--tab-index': au.findIndex(m => m.id === c) },
                children: [
                  C.jsx('span', { className: Ce.indicator, 'aria-hidden': !0 }),
                  au.map(m =>
                    C.jsx(
                      'button',
                      {
                        type: 'button',
                        role: 'tab',
                        'aria-selected': m.id === c,
                        className: `${Ce.tab} ${m.id === c ? Ce.tabActive : ''}`,
                        onClick: () => s(m.id),
                        children: u(`section5.tabs.${m.id}`),
                      },
                      m.id
                    )
                  ),
                ],
              }),
              C.jsx('a', {
                className: Ce.cta,
                href: u('section5.learnLink'),
                target: '_blank',
                children: u('section5.learnMore'),
              }),
            ],
          }),
        });
      }
      const h0 = 'section_hUyDe',
        g0 = 'mbSection_L9aes',
        m0 = 'inner_NbjJG',
        y0 = 'title_RPSUc',
        p0 = 'grid_XZ62J',
        v0 = 'card_N-2Er',
        b0 = 'cardVertical_-iNUk',
        S0 = 'copy_oJesj',
        x0 = 'name_IyTqB',
        A0 = 'body_DFLjy',
        T0 = 'mediaWrap_SH6-X',
        E0 = 'media_SRJxy',
        _e = {
          section: h0,
          mbSection: g0,
          inner: m0,
          title: y0,
          grid: p0,
          card: v0,
          cardVertical: b0,
          copy: S0,
          name: x0,
          body: A0,
          mediaWrap: T0,
          media: E0,
        },
        O0 = [
          { id: 'purifier', imageKey: 'section6Purifier' },
          { id: 'rotary', imageKey: 'section6Rotary' },
          { id: 'riser', imageKey: 'section6Riser' },
          { id: 'blade', imageKey: 'section6Blade' },
          { id: 'conveyor', imageKey: 'section6Conveyor', vertical: !0 },
          { id: 'fixture', imageKey: 'section6Fixture', vertical: !0 },
          { id: 'module', imageKey: 'section6Module', vertical: !0 },
        ];
      function M0({ variant: r = 'pc' }) {
        const { t: u } = ue(),
          c = r === 'mb',
          s = u('section6.cards', { returnObjects: !0 }) ?? [];
        return C.jsx('section', {
          className: `${_e.section} ${c ? _e.mbSection : ''}`,
          children: C.jsxs('div', {
            className: _e.inner,
            children: [
              C.jsx(It, {
                as: 'h2',
                className: _e.title,
                html: u('section6.title'),
              }),
              C.jsx('div', {
                className: _e.grid,
                children: O0.map((o, h) => {
                  const m = Array.isArray(s) ? s[h] : void 0;
                  return C.jsxs(
                    'article',
                    {
                      className: `${_e.card} ${o.vertical ? _e.cardVertical : ''}`,
                      children: [
                        C.jsxs('div', {
                          className: _e.copy,
                          children: [
                            C.jsx(It, {
                              as: 'h3',
                              className: _e.name,
                              html: m?.name,
                            }),
                            C.jsx(It, { className: _e.body, html: m?.body }),
                          ],
                        }),
                        C.jsx('div', {
                          className: _e.mediaWrap,
                          children: C.jsx(Za, {
                            className: _e.media,
                            imageKey: o.imageKey,
                            variant: r,
                            alt: m?.name ?? '',
                          }),
                        }),
                      ],
                    },
                    o.id
                  );
                }),
              }),
            ],
          }),
        });
      }
      const _0 = 'section_6fGkV',
        N0 = 'mbSection_pC6A9',
        R0 = 'inner_nXZyt',
        z0 = 'toggle_2-8AH',
        D0 = 'toggleText_htRHk',
        C0 = 'chevron_tMWz2',
        U0 = 'chevronOpen_K6svG',
        j0 = 'grid_-tvf9',
        L0 = 'item_06OJ8',
        H0 = 'mediaWrap_H3oHW',
        B0 = 'media_WxrNN',
        q0 = 'label_163ix',
        Ne = {
          section: _0,
          mbSection: N0,
          inner: R0,
          toggle: z0,
          toggleText: D0,
          chevron: C0,
          chevronOpen: U0,
          grid: j0,
          item: L0,
          mediaWrap: H0,
          media: B0,
          label: q0,
        },
        dh = [
          { id: 'cutter', imageKey: 'section7Cutter' },
          { id: 'module', imageKey: 'section7Module' },
          { id: 'screen', imageKey: 'section7Screen' },
          { id: 'adapter', imageKey: 'section7Adapter' },
          { id: 'cord', imageKey: 'section7Cord' },
          { id: 'exhaust', imageKey: 'section7Exhaust' },
          { id: 'cable', imageKey: 'section7Cable' },
          { id: 'panel', imageKey: 'section7Panel' },
          { id: 'block', imageKey: 'section7Block' },
          { id: 'hexKey', imageKey: 'section7HexKey' },
          { id: 'wrench', imageKey: 'section7Wrench' },
          { id: 'usbAdapter', imageKey: 'section7UsbAdapter' },
          { id: 'laserCard', imageKey: 'section7LaserCard' },
          { id: 'cameraCard', imageKey: 'section7CameraCard' },
          { id: 'clamp', imageKey: 'section7Clamp' },
          { id: 'lensCard', imageKey: 'section7LensCard' },
          { id: 'safetyKey', imageKey: 'section7SafetyKey' },
          { id: 'blower', imageKey: 'section7Blower' },
          { id: 'pack', imageKey: 'section7Pack' },
          { id: 'cloth', imageKey: 'section7Cloth' },
          { id: 'brush', imageKey: 'section7Brush' },
          { id: 'guide', imageKey: 'section7Guide' },
          { id: 'safety', imageKey: 'section7Safety' },
          { id: 'ftheta', imageKey: 'section7Ftheta' },
          { id: 'stand', imageKey: 'section7Stand' },
        ];
      function K0({ variant: r = 'pc' }) {
        const { t: u } = ue(),
          [c, s] = yt.useState(!1),
          o = r === 'mb',
          h = u('section7.items', { returnObjects: !0 }) ?? [],
          m = o ? 3 : 5,
          p = c ? dh : dh.slice(0, m);
        return C.jsx('section', {
          className: `${Ne.section} ${o ? Ne.mbSection : ''}`,
          children: C.jsxs('div', {
            className: Ne.inner,
            children: [
              C.jsxs('button', {
                type: 'button',
                className: Ne.toggle,
                'aria-expanded': c,
                onClick: () => s(b => !b),
                children: [
                  C.jsx('span', {
                    className: Ne.toggleText,
                    children: u('section7.title'),
                  }),
                  C.jsx('svg', {
                    xmlns: 'http://www.w3.org/2000/svg',
                    className: `${Ne.chevron} ${c ? Ne.chevronOpen : ''}`,
                    width: '53',
                    height: '33',
                    viewBox: '0 0 53 33',
                    fill: 'none',
                    'aria-hidden': 'true',
                    children: C.jsx('path', {
                      d: 'M1.85156 1.67969L26.3516 28.6797L50.8516 1.67969',
                      stroke: 'black',
                      strokeWidth: '5',
                    }),
                  }),
                ],
              }),
              C.jsx('div', {
                className: Ne.grid,
                children: p.map((b, g) => {
                  const A = Array.isArray(h) ? h[g] : void 0;
                  return C.jsxs(
                    'article',
                    {
                      className: Ne.item,
                      children: [
                        C.jsx('div', {
                          className: Ne.mediaWrap,
                          children: C.jsx(Za, {
                            className: Ne.media,
                            imageKey: b.imageKey,
                            variant: r,
                            alt: A ?? '',
                          }),
                        }),
                        A
                          ? C.jsx('span', { className: Ne.label, children: A })
                          : null,
                      ],
                    },
                    b.id
                  );
                }),
              }),
            ],
          }),
        });
      }
      const Y0 = 'section_-KKQo',
        G0 = 'mbSection_POzSB',
        w0 = 'inner_JNqvc',
        V0 = 'title_iiNfK',
        X0 = 'tableWrap_8k2Tz',
        Q0 = 'table_5vsab',
        Z0 = 'colLabel_VIFi7',
        Xa = {
          section: Y0,
          mbSection: G0,
          inner: w0,
          title: V0,
          tableWrap: X0,
          table: Q0,
          colLabel: Z0,
        };
      function $0(r) {
        return r <= 1
          ? [5]
          : r === 2
            ? [4, 1]
            : Array.from({ length: r }, () => 1);
      }
      function J0({ variant: r = 'pc' }) {
        const { t: u } = ue(),
          c = r === 'mb',
          s = u('section8.headers', { returnObjects: !0 }) ?? [],
          o = u('section8.rows', { returnObjects: !0 }) ?? [];
        return C.jsx('section', {
          className: `${Xa.section} ${c ? Xa.mbSection : ''}`,
          children: C.jsxs('div', {
            className: Xa.inner,
            children: [
              C.jsx(It, {
                as: 'h2',
                className: Xa.title,
                html: u('section8.title'),
              }),
              C.jsx('div', {
                className: Xa.tableWrap,
                children: C.jsxs('table', {
                  className: Xa.table,
                  children: [
                    C.jsxs('colgroup', {
                      children: [
                        C.jsx('col', { className: Xa.colLabel }),
                        C.jsx('col', {}),
                        C.jsx('col', {}),
                        C.jsx('col', {}),
                        C.jsx('col', {}),
                        C.jsx('col', {}),
                      ],
                    }),
                    C.jsx('thead', {
                      children: C.jsx('tr', {
                        children: (Array.isArray(s) ? s : []).map(h =>
                          C.jsx('th', { children: h }, h)
                        ),
                      }),
                    }),
                    C.jsx('tbody', {
                      children: (Array.isArray(o) ? o : []).map(h => {
                        const m = h.values ?? [],
                          p = $0(m.length);
                        return C.jsxs(
                          'tr',
                          {
                            children: [
                              C.jsx('th', { children: h.label }),
                              m.map((b, g) =>
                                C.jsx(
                                  'td',
                                  {
                                    colSpan: p[g],
                                    dangerouslySetInnerHTML: { __html: Sh(b) },
                                  },
                                  `${h.label}-${g}`
                                )
                              ),
                            ],
                          },
                          h.label
                        );
                      }),
                    }),
                  ],
                }),
              }),
            ],
          }),
        });
      }
      const k0 = 'section_ocqJv',
        W0 = 'mbSection_uyfZ0',
        F0 = 'list_-pqry',
        P0 = 'item_G4djm',
        lu = { section: k0, mbSection: W0, list: F0, item: P0 };
      function I0({ variant: r = 'pc' }) {
        const { t: u } = ue(),
          c = r === 'mb',
          s = u('section9.items', { returnObjects: !0 }) ?? [];
        return C.jsx('section', {
          className: `${lu.section} ${c ? lu.mbSection : ''}`,
          children: C.jsx('div', {
            className: lu.list,
            children: (Array.isArray(s) ? s : []).map((o, h) =>
              C.jsx(It, { className: lu.item, html: o }, h)
            ),
          }),
        });
      }
      const t1 = [cp, jp, Gp, e0, d0, M0, K0, J0, I0];
      function e1({ variant: r = 'pc' }) {
        return C.jsx('div', {
          className: wy.stack,
          children: t1.map((u, c) => C.jsx(u, { variant: r }, c)),
        });
      }
      const Gc = '(max-width: 768px)';
      function a1() {
        const [r, u] = yt.useState(null);
        return (
          yt.useLayoutEffect(() => {
            const c = window.matchMedia(Gc),
              s = () => u(c.matches ? 'mb' : 'pc');
            return (
              s(),
              c.addEventListener('change', s),
              () => c.removeEventListener('change', s)
            );
          }, []),
          r
        );
      }
      const l1 = `not all and ${Gc}`;
      function n1() {
        const { i18n: r } = ue(),
          { t: u } = ue('imageUrl'),
          s = a1() ?? 'pc',
          { pcSrc: o, mobileSrc: h } = Th(u, 'section1Bg'),
          m = yt.useRef(null);
        return (
          yt.useLayoutEffect(() => {
            const p = m.current;
            if (!p) return;
            const b = () => {
              p.style.setProperty('--t1-pc-vw', `${p.clientWidth / 100}px`);
            };
            b();
            const g = new ResizeObserver(b);
            return (
              g.observe(p),
              window.addEventListener('resize', b),
              () => {
                (g.disconnect(), window.removeEventListener('resize', b));
              }
            );
          }, []),
          C.jsxs('div', {
            ref: m,
            className: `t1-page ${Yy.page}`,
            'data-lang': r.language,
            children: [
              o
                ? C.jsx('link', {
                    rel: 'preload',
                    as: 'image',
                    href: o,
                    media: l1,
                    fetchPriority: 'high',
                  })
                : null,
              h
                ? C.jsx('link', {
                    rel: 'preload',
                    as: 'image',
                    href: h,
                    media: Gc,
                    fetchPriority: 'high',
                  })
                : null,
              C.jsx(e1, { variant: s }),
            ],
          })
        );
      }
      const i1 = {
          title: 'Creality Falcon T1',
          description: 'Five Lasers.Create Faster, Smarter. Grow Further.',
          section1: {
            title: 'Creality Falcon T1',
            subtitle: 'Five Lasers.Create Faster, Smarter. Grow Further.',
            shopNow: 'Shop Now',
          },
          section2: {
            title: 'Why Choose Creality Falcon T1',
            fiveLasers:
              '<em class="blue">Five Laser Modules </em><br />Infinite Possibilities<sup class="fn">[1]</sup>',
            micron: 'Micron Precision Fine Detail',
            galvoSpeed:
              '<em class="blue">High-Speed</em> Galvo Faster Creation',
            autoFocus:
              'Autofocus in Seconds<sup class="fn">[2]</sup>',
            autoFocusMb:
              'Autofocus in Seconds<sup class="fn">[2]</sup>',
            touch: 'Touch. Control. Create',
            galvoLight:
              '<em class="blue">Galvo-Controlled</em> Light<br />Precision in Motion',
            class1:
              '<em class="blue">Class 1</em> Protection<br />Create with Confidence',
            conveyor: 'Continuous Batch Processing',
            ai: '<em class="blue">AI-Assisted</em> Creation<sup class="fn">[3]</sup>',
          },
          section3: {
            title:
              'How seamless can switching <br class="br_pc" />between modules be?',
          },
          section4: {
            title: 'Five Moduless <sup class="fn">[1]</sup> Endless Horizons',
            body: 'Unlock wood, leather, metal, crystal, and vibrant steel coloring. Recombine 5 professional <br class="br_pc" />light sources to switchwavelengths and redefine your making boundaries.',
            slides: [
              {
                name: 'Diode 20W',
                body: 'Cut and deep-engrave wood, leather, and acrylic in a single pass.',
              },
              {
                name: 'Diode 40W',
                body: 'Double the power for fast, efficient cutting through thick materials.',
              },
              {
                name: 'Fiber 20W',
                body: 'High-precision marking on metals and plastics with razor-sharp details.',
              },
              {
                name: 'MOPA 60W',
                body: 'Smart, multi-color engraving on stainless steel and titanium—no post-coloring required.<sup class="fn">[5]</sup>',
              },
              {
                name: 'UV 5W',
                body: 'Precise 3D internal engraving in compatible crystal and glass.<sup class="fn">[6]</sup>',
              },
            ],
          },
          section5: {
            title: 'More Materials, One Machine<sup class="fn">[7]</sup>',
            tabs: {
              wood: 'Wood',
              leather: 'Leather',
              glass: 'Glass',
              metal: 'Metal',
              ceramics: 'Ceramics',
            },
            learnMore: 'Learn more',
            learnLink:
              'https://www.crealityfalcon.com/pages/creality-falcon-t1-launch?view=t1-page',
          },
          section6: {
            title:
              'Adapt to Every Job. Master Every Object.<sup class="fn">[8]</sup>',
            cards: [
              {
                name: 'Creality Purifier AP1 Mini',
                body: 'Perfect for homes, studios, and shops, allowing you to engrave anytime with clean, safe air.',
              },
              {
                name: 'Rotary Attachment Kit',
                body: 'Featuring an innovative 4-in-1 rotary axis, T1 supports engraving on most common cylindrical and spherical objects - including tumblers, mugs, ornamentballs, rings, and more with ease⁴.',
              },
              {
                name: 'UV Inner-Engraving Riser',
                body: 'Provides extended focal distance for UV engraving, compatible with taller and thicker glass, crystal, and transparent materials.',
              },
              {
                name: 'Falcon T1 Knife Blade Bed',
                body: 'Knife strip design improves airflow, for cleaner, smoother cutting edges.',
              },
              {
                name: 'Falcon Conveyor TC1',
                body: 'Precision Batch Processing with Smart Fill Tech Larger working area ensures stable, continuous, and repeatable automated production⁴.',
              },
              {
                name: 'Flexible Fixture',
                body: 'Adapts to irregular shapes and secures objects at any angle.',
              },
              {
                name: 'Falcon T1 Module',
                body: 'Five optional modules: 20W diode module, 40W diode module, 20W fiber module, 60W MOPA module, and 5W UV module.',
              },
            ],
          },
          section7: {
            title: 'In the Box',
            items: [
              'Laser Cutter and Engraver',
              'Laser Module',
              'Interactive Screen',
              'Power Adapter',
              'Power Cord',
              'Exhaust Pipe',
              'Type-A to Type-C Cable',
              'Slotted Panel',
              'L-shaped Locating Block',
              'Hex Key',
              'Hex Cross Wrench',
              'Type-A to Type-C Adapter',
              'Laser Calibration Card',
              'Camera Calibration Card',
              'Hose Clamp',
              'Field Lens Calibration Card',
              'Safety Key',
              'Rubber Air Blower',
              'Materials Pack',
              'Dust-free Cloth',
              'Lint-free Brush',
              'Quick Start Guide',
              'Safety Instructions',
              'Internal Engraving F-Theta Lens³',
              'Internal Engraved Stand³',
            ],
          },
          section8: {
            title: 'T1 Specs',
            headers: [
              'Category',
              'Blue Laser (Diode) 20W',
              'Blue Laser (Diode) 40W',
              'Infrared Laser (Fiber) 20W',
              'MOPA 60W',
              'UV Laser 5W',
            ],
            rows: [
              {
                label: 'Wavelength',
                values: [
                  '445nm±15nm',
                  '445nm±15nm',
                  '1064nm±5nm',
                  '1064nm±5nm',
                  '355nm±2nm',
                ],
              },
              {
                label: 'Compatible Materials',
                values: [
                  'Wood, acrylic, PU leather, MDF, dark glass, ceramics, coated metals, stainless steel, bamboo',
                  'Wood, acrylic, PU leather, MDF, dark glass, ceramics, coated metals, stainless steel, bamboo',
                  'Stainless steel, titanium alloy, gold, silver, brass, copper, iron, aluminum, plastic, shale',
                  'Stainless steel, titanium alloy, gold, silver, brass, copper, iron, aluminum, plastic, shale',
                  'Acrylic, plastic, glass, ceramics, crystal, PU leather, cardboard',
                ],
              },
              {
                label: 'Engraving Modes',
                values: [
                  'Flat engraving, relief, deep engraving, 3D curved engraving',
                  'Flat engraving, relief, deep engraving, 3D internal engraving, internal engraving',
                ],
              },
              {
                label: 'Working Area',
                values: [
                  '175*175mm',
                  '175*175mm<br>(Internal engraving area: 70 × 70 mm)',
                ],
              },
              {
                label: 'Spot Size',
                values: [
                  '0.12mm×0.14mm',
                  '0.14mm×0.18mm',
                  '0.05mm',
                  '0.05mm',
                  '0.014mm',
                ],
              },
              { label: 'Processing Accuracy', values: ['≤ 0.01mm'] },
              { label: 'Positioning Accuracy', values: ['±0.01mm'] },
              { label: 'Max Working Speed', values: ['10000 mm/s'] },
              { label: 'Product Dimensions', values: ['464×312×509mm'] },
              {
                label: 'Software Support',
                values: ['Falcon Design Space、（LightBurn）'],
              },
              { label: 'Operating System', values: ['Windows/MacOS'] },
              {
                label: 'Supported File Formats',
                values: [
                  'jpeg,jpg, png, bmp, svg, dxf,pdf,etc.<br>3D: glb obj fbx stl ply',
                ],
              },
              { label: 'Safety Class', values: ['class 1'] },
              { label: 'Input Voltage', values: ['100-240V~ 50-60Hz'] },
            ],
          },
          section9: {
            items: [
              '1. The five laser modules are Diode 20W, Diode 40W, Fiber 20W, MOPA 60W, and UV 5W. Module configurations, sales options, and regional availability may vary. Refer to the local sales page for details.',
              '2. The autofocus-in-seconds figure is based on internal testing using production hardware, final firmware, and the standard test procedure. Actual focusing time may vary with the laser module, material height, calibration status, and operating environment.',
              '3. AI feature availability may vary by software or app version, device configuration, laser module, and region. Some features may require an internet connection and account sign-in. AI-generated or processed results may vary with the source content.',
              '4. Class 1 applies when the machine is fully enclosed, the lid is properly closed, and the product is operated as instructed. In specific open-cover workflows, including conveyor and rotary modes, the product does not meet Class 1 requirements. Follow the safety instructions, use additional safeguards, and wear appropriate personal protective equipment. The protective window is designed for the product’s 355 nm, 455 nm, and 1064 nm laser wavelengths.',
              '5. Metal color engraving requires the MOPA 60W module. Colors and effects vary with metal type, surface condition, processing parameters, and operating environment. Actual results may differ by material.',
              '6. 3D internal engraving requires the UV 5W module, the matching internal-engraving F-theta lens, and the 3D Engraving Riser. It is intended for compatible transparent materials. Refer to the actual package list for included components.',
              '7.  Material compatibility and processing results vary with composition, color, surface finish, thickness, moisture content, and parameter settings. Project images and videos are for illustrative purposes only, and actual results may vary. Test the material before processing.',
              '8. The automatic conveyor, flexible fixture, rotary kit, 3D Engraving Riser, knife blade bed, and air purifier are sold separately unless expressly included in the selected bundle. Compatibility and availability may vary by module, processing method, and region.',
            ],
          },
        },
        u1 = {
          section1Bg:
            'https://compress-file.creality.com/images/Agent/ec98c2ff-09e9-45d4-874a-40f1cf1711f4.webp',
          section1BgM:
            'https://compress-file.creality.com/images/Agent/0477228c-aad9-4062-9ff9-6fa5e32598ca.webp',
          section2FiveLasers:
            'https://cdn.creality.com/ow/t1-page/52bc0212-0731-4a9b-a11c-1f0b8d176039.mp4',
          section2FiveLasersM: '',
          section2Micron:
            'https://compress-file.creality.com/images/Agent/0b2051b3-ccc9-4447-b77b-ca8267d904f7.webp',
          section2MicronM:
            'https://compress-file.creality.com/images/Agent/371f95ee-8f06-41b9-aa1b-27e7efc92f2d.webp',
          section2GalvoSpeed:
            'https://compress-file.creality.com/images/Agent/187178dc-6c5b-4d9e-8f73-d1992558a0ae.webp',
          section2GalvoSpeedM: '',
          section2AutoFocus:
            'https://compress-file.creality.com/images/Agent/f5c6ebad-faf2-4e3a-852d-4de1a9ae6f86.webp',
          section2AutoFocusM:
            'https://cdn.creality.com/ow/official/b1ad696c-b754-4d0b-ba12-3ac24d35881a.png',
          section2Touch:
            'https://cdn.creality.com/ow/official/26d6126a-88e3-40b6-9fe3-381c786d68fa.png',
          section2TouchM:
            'https://cdn.creality.com/ow/official/56841b60-e22d-4aab-be4d-1a0b63dd2345.png',
          section2GalvoLight:
            'https://compress-file.creality.com/videos/Agent/e9a92d27-b577-4b88-84ed-afa6a416589d.mp4',
          section2GalvoLightM: '',
          section2Class1:
            'https://compress-file.creality.com/videos/Agent/07741208-3b16-4b3e-9e00-ad20d4e544c5.mp4',
          section2Class1M: '',
          section2Conveyor:
            'https://compress-file.creality.com/images/Agent/bab58d7e-7afc-4844-8f74-6d1cb67fb5a4.webp',
          section2ConveyorM:
            'https://cdn.creality.com/ow/official/b430d735-d9ff-4c8b-8aa3-4a2f689f33cc.png',
          section2Ai:
            'https://compress-file.creality.com/images/Agent/b66022c9-2cdd-4d3d-9883-0f4191b24518.webp',
          section2AiM:
            'https://cdn.creality.com/ow/official/ed15ab97-df8e-4d77-962e-e4e8b0d0b657.png',
          section3Bg:
            'https://compress-file.creality.com/videos/suwei/b6fd86fa-9d34-4923-860f-3baf30b40446.mp4',
          section3BgM: '',
          section4Slide1:
            'https://compress-file.creality.com/videos/suwei/5b80920b-8ea7-436f-a43e-92b4fcbe55a1.mp4',
          section4Slide1M: '',
          section4Slide2:
            'https://compress-file.creality.com/videos/suwei/42f0c10b-7feb-4d6f-bffa-83c7f16a45b3.mp4',
          section4Slide2M: '',
          section4Slide3:
            'https://compress-file.creality.com/videos/suwei/09c6bc22-0d7d-42bb-8aee-0ff3bb5f5842.mp4',
          section4Slide3M: '',
          section4Slide4:
            'https://compress-file.creality.com/videos/suwei/f8d1ce23-a99c-45ca-88b2-8c84b77920a7.mp4',
          section4Slide4M: '',
          section4Slide5:
            'https://compress-file.creality.com/videos/suwei/79a94179-96d5-47cd-97a1-2ab4e1a70524.mp4',
          section4Slide5M: '',
          section5Wood:
            'https://compress-file.creality.com/images/Agent/50716ce7-ca9d-4c62-80a8-fe195b7db1e5.webp',
          section5WoodM:
            'https://compress-file.creality.com/images/Agent/09094a4d-8201-4168-bc34-f74eaf9899ad.webp',
          section5Leather:
            'https://compress-file.creality.com/images/Agent/ac9bdb92-6b81-40cb-997a-5e130b6119d3.webp',
          section5LeatherM:
            'https://compress-file.creality.com/images/Agent/c4be9a64-78e3-4ea2-aa20-dd5f457f73c1.webp',
          section5Glass:
            'https://compress-file.creality.com/images/Agent/b2811c7e-0e2f-496c-962e-504b7c9ce0fc.webp',
          section5GlassM:
            'https://compress-file.creality.com/images/Agent/ae9b95eb-1dcb-4e43-95a7-29738465a20c.webp',
          section5Metal:
            'https://compress-file.creality.com/images/Agent/86152b71-8ae0-4c56-847f-a3d45b49cdab.webp',
          section5MetalM:
            'https://compress-file.creality.com/images/Agent/abbaabc7-0410-4e43-9d6b-6cb64f968f10.webp',
          section5Ceramics:
            'https://compress-file.creality.com/images/Agent/593e69b3-da67-415e-b201-c9282f359b23.webp',
          section5CeramicsM:
            'https://compress-file.creality.com/images/Agent/0aee961a-29bb-47e9-b453-62746e63851b.webp',
          section6Purifier:
            'https://cdn.shopify.com/s/files/1/0850/5776/5681/files/1_2_c1b70ba7-df6a-49b2-94bc-4fc7b6ecc8a7.png?v=1776152780',
          section6PurifierM: '',
          section6Rotary:
            'https://cdn.shopify.com/s/files/1/0850/5776/5681/files/CMF01.png?v=1776152780',
          section6RotaryM: '',
          section6Riser:
            'https://cdn.shopify.com/s/files/1/0850/5776/5681/files/874.png?v=1776152780',
          section6RiserM: '',
          section6Blade:
            'https://cdn.shopify.com/s/files/1/0850/5776/5681/files/813.png?v=1776152780',
          section6BladeM: '',
          section6Conveyor:
            'https://cdn.shopify.com/s/files/1/0850/5776/5681/files/1_34f36611-5ab4-417d-9f06-8c220f7b6d87.png?v=1776326057',
          section6ConveyorM: '',
          section6Fixture:
            'https://cdn.shopify.com/s/files/1/0850/5776/5681/files/1_a61bbadc-1338-4ee7-a214-facba55acaeb.png?v=1776326058',
          section6FixtureM: '',
          section6Module:
            'https://cdn.shopify.com/s/files/1/0850/5776/5681/files/818_4.png?v=1776326057',
          section6ModuleM: '',
          section7Cutter:
            'https://cdn.shopify.com/s/files/1/0850/5776/5681/files/1-1.png?v=1777286772',
          section7CutterM: '',
          section7Module:
            'https://cdn.shopify.com/s/files/1/0850/5776/5681/files/img_v3_02tp_eaae26f0-4414-4169-a636-d3639ead9c5g-1.png?v=1776154578',
          section7ModuleM: '',
          section7Screen:
            'https://cdn.shopify.com/s/files/1/0850/5776/5681/files/815-1.png?v=1776154578',
          section7ScreenM: '',
          section7Adapter:
            'https://cdn.shopify.com/s/files/1/0850/5776/5681/files/2_e84d27e6-bee6-422e-961c-95acb6f6e9c8.png?v=1776154578',
          section7AdapterM: '',
          section7Cord:
            'https://cdn.shopify.com/s/files/1/0850/5776/5681/files/784-2.png?v=1776154578',
          section7CordM: '',
          section7Exhaust:
            'https://cdn.shopify.com/s/files/1/0850/5776/5681/files/865-1.png?v=1776154578',
          section7ExhaustM: '',
          section7Cable:
            'https://cdn.shopify.com/s/files/1/0850/5776/5681/files/784-3.png?v=1776154578',
          section7CableM: '',
          section7Panel:
            'https://cdn.shopify.com/s/files/1/0850/5776/5681/files/1_3-1.png?v=1776154578',
          section7PanelM: '',
          section7Block:
            'https://cdn.shopify.com/s/files/1/0850/5776/5681/files/785-3.png?v=1776154578',
          section7BlockM: '',
          section7HexKey:
            'https://cdn.shopify.com/s/files/1/0850/5776/5681/files/890-1.png?v=1776154578',
          section7HexKeyM: '',
          section7Wrench:
            'https://cdn.shopify.com/s/files/1/0850/5776/5681/files/3_a2ce5260-3c89-4fe2-91bd-cb0bd6df80c5.png?v=1776154578',
          section7WrenchM: '',
          section7UsbAdapter:
            'https://cdn.shopify.com/s/files/1/0850/5776/5681/files/785-4.png?v=1776154578',
          section7UsbAdapterM: '',
          section7LaserCard:
            'https://cdn.shopify.com/s/files/1/0850/5776/5681/files/785_-1.png?v=1776154578',
          section7LaserCardM: '',
          section7CameraCard:
            'https://cdn.shopify.com/s/files/1/0850/5776/5681/files/783-3.png?v=1776154578',
          section7CameraCardM: '',
          section7Clamp:
            'https://cdn.shopify.com/s/files/1/0850/5776/5681/files/867-1.png?v=1776154578',
          section7ClampM: '',
          section7LensCard:
            'https://cdn.shopify.com/s/files/1/0850/5776/5681/files/785-5.png?v=1776154578',
          section7LensCardM: '',
          section7SafetyKey:
            'https://cdn.shopify.com/s/files/1/0850/5776/5681/files/814-2.png?v=1776154578',
          section7SafetyKeyM: '',
          section7Blower:
            'https://cdn.shopify.com/s/files/1/0850/5776/5681/files/783-4.png?v=1776154578',
          section7BlowerM: '',
          section7Pack:
            'https://cdn.shopify.com/s/files/1/0850/5776/5681/files/783-5.png?v=1776154578',
          section7PackM: '',
          section7Cloth:
            'https://cdn.shopify.com/s/files/1/0850/5776/5681/files/812-1.png?v=1776154578',
          section7ClothM: '',
          section7Brush:
            'https://cdn.shopify.com/s/files/1/0850/5776/5681/files/817-1.png?v=1776154578',
          section7BrushM: '',
          section7Guide:
            'https://cdn.shopify.com/s/files/1/0850/5776/5681/files/782-2.png?v=1776154578',
          section7GuideM: '',
          section7Safety:
            'https://cdn.shopify.com/s/files/1/0850/5776/5681/files/782-3.png?v=1776154578',
          section7SafetyM: '',
          section7Ftheta:
            'https://cdn.shopify.com/s/files/1/0850/5776/5681/files/821.png?v=1776854953',
          section7FthetaM: '',
          section7Stand:
            'https://cdn.shopify.com/s/files/1/0850/5776/5681/files/822.png?v=1776854953',
          section7StandM: '',
        },
        s1 = { en: { translation: i1, imageUrl: u1 } };
      Yc.use(jy).init({
        resources: s1,
        lng: ky(),
        fallbackLng: 'en',
        interpolation: { escapeValue: !1 },
        initImmediate: !1,
      });
      const c1 = document.getElementById('product-detail-buy-t1-page'),
        f1 = C.jsx(qy, { i18n: Yc, children: C.jsx(n1, {}) });
      ay.createRoot(c1).render(f1);

})();